(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 93387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CacheProvider; },
  "E": function() { return /* binding */ Emotion; },
  "T": function() { return /* binding */ ThemeContext; },
  "_": function() { return /* binding */ __unsafe_useEmotionCache; },
  "a": function() { return /* binding */ ThemeProvider; },
  "b": function() { return /* binding */ withTheme; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ emotion_element_99289b21_browser_esm_hasOwnProperty; },
  "u": function() { return /* binding */ useTheme; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-cache-npm-11.5.0-713285e054-8b3fac281e.zip/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(26854);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(14986);
;// CONCATENATED MODULE: ../../.yarn/cache/@emotion-weak-memoize-npm-0.2.5-9f2e49e7c8-27d402b0c6.zip/node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var weak_memoize_browser_esm = (weakMemoize);

// EXTERNAL MODULE: ../../.yarn/cache/hoist-non-react-statics-npm-3.3.2-e7b709e6c1-b153827042.zip/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(26504);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/isolated-hoist-non-react-statics-do-not-use-this-in-your-code/dist/emotion-react-isolated-hoist-non-react-statics-do-not-use-this-in-your-code.browser.esm.js


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return hoist_non_react_statics_cjs_default()(targetComponent, sourceComponent);
});

/* harmony default export */ var emotion_react_isolated_hoist_non_react_statics_do_not_use_this_in_your_code_browser_esm = (hoistNonReactStatics);

// EXTERNAL MODULE: ../../.yarn/cache/@emotion-utils-npm-1.0.0-7f9809289c-3ce8048441.zip/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(59382);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-serialize-npm-1.0.2-a692afdb82-ff84fbe09e.zip/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(35605);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-element-99289b21.browser.esm.js








var emotion_element_99289b21_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return (0,react.useContext)(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return (0,react.useContext)(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weak_memoize_browser_esm(function (outerTheme) {
  return weak_memoize_browser_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = (0,react.useContext)(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = (0,react.useContext)(ThemeContext);
    return /*#__PURE__*/(0,react.createElement)(Component, (0,esm_extends/* default */.Z)({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/(0,react.forwardRef)(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return emotion_react_isolated_hoist_non_react_statics_do_not_use_this_in_your_code_browser_esm(WithTheme, Component);
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_99289b21_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (false) { var match, error; }

  return newProps;
};
var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(registeredStyles, undefined, (0,react.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  var rules = (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_99289b21_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);

  return ele;
});

if (false) {}




/***/ }),

/***/ 75537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CacheProvider": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.C; },
/* harmony export */   "ClassNames": function() { return /* binding */ ClassNames; },
/* harmony export */   "Global": function() { return /* binding */ Global; },
/* harmony export */   "ThemeContext": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.T; },
/* harmony export */   "ThemeProvider": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.a; },
/* harmony export */   "__unsafe_useEmotionCache": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__._; },
/* harmony export */   "createElement": function() { return /* binding */ jsx; },
/* harmony export */   "css": function() { return /* binding */ css; },
/* harmony export */   "jsx": function() { return /* binding */ jsx; },
/* harmony export */   "keyframes": function() { return /* binding */ keyframes; },
/* harmony export */   "useTheme": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.u; },
/* harmony export */   "withEmotionCache": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.w; },
/* harmony export */   "withTheme": function() { return /* reexport safe */ _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.b; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26854);
/* harmony import */ var _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93387);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26504);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59382);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35605);
/* harmony import */ var _emotion_sheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53656);












var pkg = {
	name: "@emotion/react",
	version: "11.5.0",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/cache": "^11.5.0",
		"@emotion/serialize": "^1.0.2",
		"@emotion/sheet": "^1.0.3",
		"@emotion/utils": "^1.0.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.5.0",
		"@emotion/css-prettifier": "1.0.0",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.3.0",
		"@types/react": "^16.9.11",
		dtslint: "^0.3.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.E;
  createElementArgArray[1] = (0,_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_4__/* .serializeStyles */ .O)([styles], undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    var key = cache.key + "-global";
    var sheet = new _emotion_sheet__WEBPACK_IMPORTED_MODULE_5__/* .StyleSheet */ .m({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .M)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_4__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .getRegisteredStyles */ .f)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = /* #__PURE__ */(0,_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.w)(function (props, cache) {
  var hasRendered = false;

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_4__/* .serializeStyles */ .O)(args, cache.registered);

    {
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .M)(cache, serialized, false);
    }

    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_99289b21_browser_esm_js__WEBPACK_IMPORTED_MODULE_2__.T)
  };
  var ele = props.children(content);
  hasRendered = true;

  return ele;
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 21483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ emotion_styled_browser_esm; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(14986);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-memoize-npm-0.7.5-e5e7e9eeca-83da8d4a76.zip/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
var emotion_memoize_browser_esm = __webpack_require__(1252);
;// CONCATENATED MODULE: ../../.yarn/cache/@emotion-is-prop-valid-npm-1.1.0-858a9fb5eb-87351133ad.zip/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-element-99289b21.browser.esm.js + 2 modules
var emotion_element_99289b21_browser_esm = __webpack_require__(93387);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-utils-npm-1.0.0-7f9809289c-3ce8048441.zip/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(59382);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-serialize-npm-1.0.2-a692afdb82-ff84fbe09e.zip/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(35605);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js







var testOmitPropsOnStringTag = emotion_is_prop_valid_browser_esm;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_99289b21_browser_esm.w)(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_99289b21_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/(0,react.createElement)(finalTag, newProps);

      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js








var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);


/***/ }),

/***/ 46295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ AuthContextProvider; },
  "a": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../packages/auth/dist/user.es.js
var user_es = __webpack_require__(99002);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/types.es.js
var Partner = /* @__PURE__ */ ((Partner2) => {
  Partner2[Partner2["IBANKING"] = 0] = "IBANKING";
  Partner2[Partner2["FEDERATION"] = 1] = "FEDERATION";
  Partner2[Partner2["CONSUMERAPP"] = 2] = "CONSUMERAPP";
  return Partner2;
})(Partner || {});



// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var index_es = __webpack_require__(31260);
// EXTERNAL MODULE: ../../packages/utils/dist/url.es.js
var url_es = __webpack_require__(87900);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(20577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(12450);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(4769);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = emotion_styled_browser_esm["default"].div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, BaseProps_index_es/* CommonStyles */.F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadValues({}, props), children);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/CheckOutlined.es.js
var CheckOutlined_es = __webpack_require__(43609);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/MinusOutlined.es.js
var MinusOutlined_es = __webpack_require__(69433);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Checkbox/Checkbox.es.js






var Checkbox_es_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Checkbox_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Checkbox_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Checkbox_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Checkbox_es_defNormalProp = (obj, key, value) => key in obj ? Checkbox_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Checkbox_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Checkbox_es_hasOwnProp.call(b, prop))
      Checkbox_es_defNormalProp(a, prop, b[prop]);
  if (Checkbox_es_getOwnPropSymbols)
    for (var prop of Checkbox_es_getOwnPropSymbols(b)) {
      if (Checkbox_es_propIsEnum.call(b, prop))
        Checkbox_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var Checkbox_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Checkbox_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Checkbox_es_getOwnPropSymbols)
    for (var prop of Checkbox_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Checkbox_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayColor = props.checked || props.partSelected;
  switch (type) {
    case "border": {
      if (props.disabled) {
        if (displayColor)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.divider;
      } else {
        if (displayColor)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.border;
      }
    }
    case "inner":
    default: {
      if (props.disabled) {
        if (displayColor)
          return (_e = props.theme) == null ? void 0 : _e.colors.primary100;
        return (_f = props.theme) == null ? void 0 : _f.colors.background;
      } else {
        if (displayColor)
          return (_g = props.theme) == null ? void 0 : _g.colors.primary500;
        return (_h = props.theme) == null ? void 0 : _h.colors.white;
      }
    }
  }
};
const Checkbox = (_a) => {
  var _b = _a, {
    checked = false,
    partSelected,
    disabled,
    onChange,
    children,
    className
  } = _b, rest = Checkbox_es_objRest(_b, [
    "checked",
    "partSelected",
    "disabled",
    "onChange",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react.createElement(CheckboxWrapper, __spreadProps(Checkbox_es_spreadValues({}, rest), {
    className: "check-box"
  }), /* @__PURE__ */ react.createElement(StyledCheckbox, null, /* @__PURE__ */ react.createElement(StyledInput, {
    type: "checkbox",
    checked,
    disabled,
    partSelected,
    onChange: () => !disabled && onChange && onChange(!checked),
    className
  }), /* @__PURE__ */ react.createElement(CheckboxInner, {
    checked,
    partSelected,
    disabled,
    className: "checkbox-inner"
  }, partSelected ? /* @__PURE__ */ react.createElement(StyledMinusIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }) : /* @__PURE__ */ react.createElement(StyledCheckIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }))), children && /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    line: 1,
    marginLeft: "s4",
    level: 1,
    weight: "regular",
    style: { flex: 1 },
    className: "checkbox-label"
  }, children));
};
const CheckboxWrapper = emotion_styled_browser_esm["default"].label`
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${BaseProps_index_es/* CommonStyles */.F}
`;
const StyledCheckIcon = (0,emotion_styled_browser_esm["default"])(CheckOutlined_es/* CheckOutlined */.b)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = (0,emotion_styled_browser_esm["default"])(MinusOutlined_es/* MinusOutlined */.l)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const StyledCheckbox = emotion_styled_browser_esm["default"].div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, "border")};
  border-radius: 2px;
  background-color: ${(p) => getColor(p, "inner")};
`;
const StyledInput = emotion_styled_browser_esm["default"].input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${(p) => !p.disabled && !p.checked && !p.partSelected ? `
      &:hover + .checkbox-inner {
        border-color: ${p.theme.colors.placeholder};
      }
    ` : ""}
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(10232);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-d2a5f90a4a/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(26759);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js



const Overlay = ({
  show,
  children,
  parent,
  onEscPressed,
  id
}) => {
  const elmRef = (0,react.useRef)();
  const [, setValue] = (0,react.useState)(0);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    if (id)
      elm.id = id;
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1051";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    parentElement == null ? void 0 : parentElement.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      parentElement == null ? void 0 : parentElement.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  };
  (0,react.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom.createPortal(children, elmRef.current);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(55878);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(85212);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/helpers/utils.es.js





var utils_es_defProp = Object.defineProperty;
var utils_es_defProps = Object.defineProperties;
var utils_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var utils_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var utils_es_hasOwnProp = Object.prototype.hasOwnProperty;
var utils_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var utils_es_defNormalProp = (obj, key, value) => key in obj ? utils_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var utils_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (utils_es_hasOwnProp.call(b, prop))
      utils_es_defNormalProp(a, prop, b[prop]);
  if (utils_es_getOwnPropSymbols)
    for (var prop of utils_es_getOwnPropSymbols(b)) {
      if (utils_es_propIsEnum.call(b, prop))
        utils_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var utils_es_spreadProps = (a, b) => utils_es_defProps(a, utils_es_getOwnPropDescs(b));
const formatDateTime = (date, type) => {
  const dateStr = date.toLocaleDateString("en-GB");
  const timeStr = date.toLocaleTimeString("vi-VN").slice(0, 5);
  switch (type) {
    case "date":
      return dateStr;
    case "time":
      return timeStr;
    default:
      return `${dateStr} ${timeStr}`;
  }
};
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const refs = Array.isArray(ref) ? ref : [ref];
      if (!refs.some((ref2) => ref2.current) || refs.some((e) => {
        var _a;
        return (_a = e.current) == null ? void 0 : _a.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    document.addEventListener("click", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};
const generateTheme = (baseColor) => {
  return utils_es_spreadProps(utils_es_spreadValues({}, defaultTheme), {
    colors: utils_es_spreadValues(utils_es_spreadValues(utils_es_spreadValues(utils_es_spreadValues({}, themeColor), generate(baseColor.primary, "primary")), generate(baseColor.secondary, "secondary")), baseColor.link && generate(baseColor.link, "link"))
  });
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const getScrollbarWidth = () => {
  var _a;
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    (_a = outer.parentNode) == null ? void 0 : _a.removeChild(outer);
  }
  return width;
};
const toArray = (candidate) => {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
  const clone = utils_es_spreadValues({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach((key) => {
      delete clone[key];
    });
  }
  return clone;
};
const mergeCls = (...cls) => {
  return cls.filter(Boolean).join(" ");
};
const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const isNotNullOrUndefinedElement = (val) => !!val;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Modal/OldModal.es.js






var OldModal_es_defProp = Object.defineProperty;
var OldModal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var OldModal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var OldModal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var OldModal_es_defNormalProp = (obj, key, value) => key in obj ? OldModal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var OldModal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (OldModal_es_hasOwnProp.call(b, prop))
      OldModal_es_defNormalProp(a, prop, b[prop]);
  if (OldModal_es_getOwnPropSymbols)
    for (var prop of OldModal_es_getOwnPropSymbols(b)) {
      if (OldModal_es_propIsEnum.call(b, prop))
        OldModal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var OldModal_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (OldModal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && OldModal_es_getOwnPropSymbols)
    for (var prop of OldModal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && OldModal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    show,
    onHide,
    children,
    size = ds_index_es/* SizeEnum.m */.mO.m,
    backDropStyle,
    parent
  } = _b, props = OldModal_es_objRest(_b, [
    "show",
    "onHide",
    "children",
    "size",
    "backDropStyle",
    "parent"
  ]);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!parentElement || !show) {
      return;
    }
    parentElement.style.overflow = "hidden";
    parentElement.style.paddingRight = `${getScrollbarWidth()}px`;
    return () => {
      parentElement.style.overflow = "unset";
      parentElement.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react.createElement(Overlay, {
    parent: parentElement || void 0,
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react.createElement(Backdrop, {
    onClick: onHide,
    style: backDropStyle
  }), /* @__PURE__ */ react.createElement(ModalContent, OldModal_es_spreadValues({
    size
  }, props), children));
};
const Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  [ds_index_es/* SizeEnum.s */.mO.s]: "400px",
  [ds_index_es/* SizeEnum.m */.mO.m]: "700px",
  [ds_index_es/* SizeEnum.l */.mO.l]: "960px"
};
const ModalContent = emotion_styled_browser_esm["default"].div(({
  theme,
  size,
  width,
  maxHeight,
  borderRadius,
  backgroundColor
}) => `
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.white)};
    display: flex;
    flex-direction: column;
    width: ${width !== void 0 ? pixelParse(width) : sizeMaps[size || "m"]};
    border-radius: ${borderRadius || (theme == null ? void 0 : theme.borderRadius.m)};
    max-height: ${maxHeight || "90%"};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Button/Button.es.js + 2 modules
var Button_es = __webpack_require__(40928);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Modal/Modal.es.js










var Modal_es_defProp = Object.defineProperty;
var Modal_es_defProps = Object.defineProperties;
var Modal_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Modal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Modal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Modal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Modal_es_defNormalProp = (obj, key, value) => key in obj ? Modal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Modal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Modal_es_hasOwnProp.call(b, prop))
      Modal_es_defNormalProp(a, prop, b[prop]);
  if (Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(b)) {
      if (Modal_es_propIsEnum.call(b, prop))
        Modal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Modal_es_spreadProps = (a, b) => Modal_es_defProps(a, Modal_es_getOwnPropDescs(b));
var Modal_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Modal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Modal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal_es_Modal = (_a) => {
  var _b = _a, {
    onClose,
    visible,
    title,
    children,
    footer = true,
    width,
    style,
    contentStyle,
    onOk,
    onCancel,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    showCloseIcon = true,
    centeredTitle = false,
    alignFooter = "right",
    fullWidthFooter = false,
    closable = true
  } = _b, rest = Modal_es_objRest(_b, [
    "onClose",
    "visible",
    "title",
    "children",
    "footer",
    "width",
    "style",
    "contentStyle",
    "onOk",
    "onCancel",
    "okText",
    "cancelText",
    "okButtonProps",
    "cancelButtonProps",
    "showCloseIcon",
    "centeredTitle",
    "alignFooter",
    "fullWidthFooter",
    "closable"
  ]);
  const onCloseModal = () => {
    if (!closable)
      return;
    if (typeof onClose === "function")
      onClose == null ? void 0 : onClose();
  };
  const closeOnEscapeKeyDown = (e) => {
    if (!closable)
      return;
    if ((e.charCode || e.keyCode) === 27) {
      onCloseModal();
    }
  };
  const transitions = (0,react_spring_esm.useTransition)(visible, {
    from: { opacity: 0, transform: "translateY(-40px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-40px)" }
  });
  (0,react.useEffect)(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);
  (0,react.useEffect)(() => {
    if (typeof document !== "undefined") {
      const currentModals = document.querySelectorAll('*[id^="teko-modal"]');
      if (currentModals.length) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [visible]);
  const renderFooter = () => {
    if (footer === false || footer === null || footer === void 0) {
      return null;
    }
    const footerCls = mergeCls("teko-modal-footer", `teko-modal-footer-${alignFooter}`);
    if (footer === true) {
      const style2 = fullWidthFooter ? { flex: 1 } : {};
      return /* @__PURE__ */ react.createElement("div", {
        className: footerCls
      }, cancelText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, Modal_es_spreadProps(Modal_es_spreadValues({
        marginRight: okText !== "" ? "s12" : "s0",
        onClick: () => onCancel == null ? void 0 : onCancel()
      }, cancelButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, cancelButtonProps == null ? void 0 : cancelButtonProps.style), style2)
      }), cancelText || "Cancel"), okText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, Modal_es_spreadProps(Modal_es_spreadValues({
        variant: "primary",
        onClick: () => onOk == null ? void 0 : onOk()
      }, okButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, okButtonProps == null ? void 0 : okButtonProps.style), style2)
      }), okText || "OK"));
    }
    return /* @__PURE__ */ react.createElement("div", {
      className: footerCls
    }, footer);
  };
  const modalCls = mergeCls("teko-modal", visible ? "teko-modal-show" : "", rest.className || "");
  const modalTitleCls = mergeCls("teko-modal-title", centeredTitle ? "teko-modal-title-centered" : "");
  if (typeof (rest == null ? void 0 : rest.show) !== "undefined") {
    const oldModalProps = Modal_es_spreadProps(Modal_es_spreadValues({}, rest), {
      children,
      width
    });
    return /* @__PURE__ */ react.createElement(Modal, Modal_es_spreadValues({}, oldModalProps));
  }
  return /* @__PURE__ */ react.createElement(Overlay, {
    show: !!visible,
    onEscPressed: onCloseModal,
    id: `teko-modal-${uid()}`
  }, /* @__PURE__ */ react.createElement(Modal_es_Backdrop, {
    onClick: onCloseModal
  }), transitions((styles, item) => item && /* @__PURE__ */ react.createElement(AnimatedModal, Modal_es_spreadValues({
    className: modalCls,
    style: Modal_es_spreadValues(Modal_es_spreadValues(Modal_es_spreadValues({}, styles), !!width ? { width } : {}), style)
  }, rest), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-content",
    style: Modal_es_spreadValues({}, contentStyle),
    onClick: (e) => e.stopPropagation()
  }, showCloseIcon && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-modal-close",
    size: 24,
    color: "#000000",
    onClick: onCloseModal
  }), title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Title */.Dx, {
    level: 1,
    className: modalTitleCls
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: modalTitleCls
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-body"
  }, children, renderFooter())))));
};
const Modal_es_Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const StyledModal = emotion_styled_browser_esm["default"].div`
  width: ${({ size }) => modalSizes[size || "m"]};
  max-width: 95%;
  &.teko-modal-show {
    opacity: 1 !important;
    pointer-events: visible;
  }

  &.teko-modal-show .teko-modal-content {
    transform: translateY(0);
    z-index: 1050;
  }

  .teko-modal-content {
    padding: 24px;
    transition: all 0.2s ease-in-out;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
      0px 8px 16px rgba(0, 0, 0, 0.05);
    position: relative;
    border-radius: 8px;
    position: relative;

    .teko-modal-close {
      position: absolute;
      z-index: 1000;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }

    .teko-modal-header {
      .teko-modal-title {
        margin-bottom: 24px;
        color: #1b1d29;
        &.teko-modal-title-centered {
          text-align: center;
        }
      }
    }

    .teko-modal-body {
      font-size: 13px;
      line-height: 20px;
      word-wrap: break-word;
    }

    .teko-modal-footer {
      margin-top: 24px;
      &.teko-modal-footer-right {
        display: flex;
        justify-content: flex-end;
      }
      &.teko-modal-footer-left {
        display: flex;
        justify-content: flex-start;
      }
      &.teko-modal-footer-center {
        display: flex;
        justify-content: center;
      }
    }
  }
`;
const AnimatedModal = (0,react_spring_esm.animated)(StyledModal);
AnimatedModal.defaultProps = {
  size: "m"
};
const modalSizes = {
  xs: "320px",
  s: "420px",
  m: "520px",
  l: "720px"
};



// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/helper.es.js


const LS_POLICIES_CONFIRMED_USER_IDS = "policiesConfirmedUserIds";
const isSacombankmbPartner = (partner) => {
  return partner === "sacombankmb";
};
const checkShowConfirmPolicyModal = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      return !(userIds == null ? void 0 : userIds.includes(userId || ""));
    } catch (e) {
      dist_index_es/* logger.error */.k.error(e);
    }
  }
  return true;
};
const userConfirmedPolicy = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      if (userIds && !userIds.includes(userId)) {
        userIds.push(userId);
        localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, JSON.stringify(userIds));
        return;
      }
    } catch (e) {
      dist_index_es/* logger.error */.k.error(e);
    }
  }
  localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, `["${userId}"]`);
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js









var context_es_defProp = Object.defineProperty;
var context_es_defProps = Object.defineProperties;
var context_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var context_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var context_es_hasOwnProp = Object.prototype.hasOwnProperty;
var context_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var context_es_defNormalProp = (obj, key, value) => key in obj ? context_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var context_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (context_es_hasOwnProp.call(b, prop))
      context_es_defNormalProp(a, prop, b[prop]);
  if (context_es_getOwnPropSymbols)
    for (var prop of context_es_getOwnPropSymbols(b)) {
      if (context_es_propIsEnum.call(b, prop))
        context_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var context_es_spreadProps = (a, b) => context_es_defProps(a, context_es_getOwnPropDescs(b));
var context_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (context_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && context_es_getOwnPropSymbols)
    for (var prop of context_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && context_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IBANKING_LOGIN_DATA = "ibanking_login_data";
const FEDERATION_PARTNER = "federation";
const CONSUMERAPP_PARTNER = "consumerapp";
const LOCALSTORAGE_REFRESH_TOKEN = "REFRESH_TOKEN";
const LOCALSTORAGE_BACK_APP_URL = "BACK_APP_URL";
const mergeInfo = (login, profile) => {
  return context_es_spreadProps(context_es_spreadValues(context_es_spreadValues({}, login), profile), {
    userId: login.userId || profile.userId,
    name: profile.name || login.name,
    telephone: profile.telephone || login.phone,
    avatar: login.picture || profile.avatar
  });
};
const AuthContext = react.createContext(null);
const AuthContextProvider = ({
  children,
  userService,
  authService,
  partner,
  scopes,
  router,
  showConfirmModalAfterLogin = false
}) => {
  const [loading, setLoading] = (0,react.useState)(true);
  const [user, setUser] = (0,react.useState)(null);
  const [show, setShow] = (0,react.useState)(false);
  const lastRenewTokenTime = (0,react.useRef)(0);
  const [agreePrivacyAndPolicy, setAgreePrivacyAndPolicy] = (0,react.useState)(isSacombankmbPartner(partner) ? true : false);
  const updateProfile = async (profileInput) => {
    const profile = await userService.updateProfile(profileInput);
    const updatedProfile = context_es_spreadValues(context_es_spreadValues({}, user), (0,index_es/* cleanObject */.sW)(profile));
    setUser(updatedProfile);
    return updatedProfile;
  };
  const fetchProfile = async (params = {}, infoToMerged) => {
    if (!!user_es/* userManager.getAccessToken */.Z.getAccessToken()) {
      try {
        setLoading(true);
        const profile = await userService.myProfile(params);
        setUser(mergeInfo(infoToMerged || authService.getLoginInfo() || {}, profile));
      } catch (e) {
        setUser(null);
        dist_index_es/* logger.error */.k.error(e);
      } finally {
        setLoading(false);
      }
    }
  };
  const _loginWithConsumerApp = async (userInfo) => {
    const loginInfo = await authService.loginWithTerra(userInfo);
    await fetchProfile({}, loginInfo);
  };
  const _loginWithIBanking = async (queries) => {
    const isSacombankMb = partner === "sacombankmb";
    if (isSacombankMb) {
      queries.signature = queries.signature || queries.data;
      queries.partner_code = queries.partner_code || "12901";
    }
    const body = await authService.loginWithIBanking(queries);
    const { partner_code, token: partner_token } = body.ibanking_info || {};
    await fetchProfile(partner_code && partner_token ? {
      partnerCode: partner_code,
      partnerToken: partner_token
    } : {});
  };
  const _loginWithFederation = async (queries) => {
    const terraIdToken = queries.terraIdToken;
    const authorizer = queries.authorizer;
    if (!terraIdToken || !authorizer) {
      throw new Error("Missing federarion login config");
    }
    const { refresh_token } = await authService.loginWithFederation(terraIdToken, authorizer);
    localStorage == null ? void 0 : localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, refresh_token);
    await fetchProfile({});
  };
  const _refreshToken = async () => {
    const refreshToken = localStorage == null ? void 0 : localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN);
    if (!refreshToken) {
      return;
    }
    const { refresh_token } = await authService.refreshToken(refreshToken);
    localStorage == null ? void 0 : localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, refresh_token);
    await fetchProfile({});
  };
  const _getPartnerType = (partnerType) => {
    switch (partnerType) {
      case CONSUMERAPP_PARTNER:
        return Partner.CONSUMERAPP;
      case FEDERATION_PARTNER:
        return Partner.FEDERATION;
      default:
        return Partner.IBANKING;
    }
  };
  (0,react.useEffect)(() => {
    window.addEventListener("storage", async ({ key, newValue, oldValue }) => {
      if (key == null ? void 0 : key.includes("tekoid.user")) {
        if (!newValue && oldValue) {
          setUser(null);
        } else if (newValue && !oldValue) {
          await fetchProfile();
        }
      }
    });
    return () => {
      window.removeEventListener("storage", () => null);
    };
  }, [user == null ? void 0 : user.userId]);
  const loginWithPartner = async (queries, autoRenew = true, autoRedirect = true) => {
    const _a = queries, { redirect_uri, backAppUrl } = _a, storeData = context_es_objRest(_a, ["redirect_uri", "backAppUrl"]);
    sessionStorage.setItem(IBANKING_LOGIN_DATA, JSON.stringify(storeData));
    if (backAppUrl) {
      localStorage.setItem(LOCALSTORAGE_BACK_APP_URL, backAppUrl);
    }
    const _loginWithPartner = async () => {
      var _a2;
      try {
        const partnerType = _getPartnerType(queries.partnerType);
        switch (partnerType) {
          case Partner.FEDERATION: {
            await _loginWithFederation(queries);
            break;
          }
          case Partner.IBANKING: {
            await _loginWithIBanking(queries);
            break;
          }
          case Partner.CONSUMERAPP: {
            await _loginWithConsumerApp(queries.userInfo);
            break;
          }
        }
        if (router) {
          if (queries == null ? void 0 : queries.redirect_uri) {
            const extractLink = (0,url_es/* extractFromPath */.F)(queries.redirect_uri);
            typeof extractLink === "object" ? router.push(extractLink, queries.redirect_uri) : router.push(extractLink);
            return;
          }
          if (autoRedirect) {
            if (partnerType === Partner.IBANKING && checkShowConfirmPolicyModal((_a2 = authService.getLoginInfo()) == null ? void 0 : _a2.userId) && (!isSacombankmbPartner(partner) && !agreePrivacyAndPolicy && showConfirmModalAfterLogin || isSacombankmbPartner(partner))) {
              return setShow(true);
            } else {
              router.push("/");
            }
          }
        } else {
          dist_index_es/* logger.error */.k.error("auth-react: router is not set");
        }
      } catch (e) {
        dist_index_es/* logger.error */.k.error(e);
        window.track("customEvent", "loginWithPartnerFailed", {
          action: "loginWithPartnerFailed",
          category: "customer",
          label: JSON.stringify({
            errorStacktrace: (e == null ? void 0 : e.stacktrace) || "unknown",
            errorMessage: (e == null ? void 0 : e.message) || "unknown"
          })
        });
        if (window.location.pathname.includes("/login"))
          alert("\u0110\u0103ng nh\u1EADp th\u1EA5t b\u1EA1i!");
      }
    };
    await _loginWithPartner();
    if (autoRenew) {
      const startTime = new Date().getTime();
      lastRenewTokenTime.current = startTime;
      setInterval(async () => {
        const now = new Date().getTime();
        const diff = now - lastRenewTokenTime.current;
        if (diff > 3e6) {
          lastRenewTokenTime.current = now;
          const partnerType = _getPartnerType(queries.partnerType);
          switch (partnerType) {
            case Partner.FEDERATION: {
              await _refreshToken();
              break;
            }
            case Partner.IBANKING: {
              await _loginWithPartner();
              break;
            }
          }
        }
      }, 3e3);
    }
  };
  const initIam = async () => {
    if (partner)
      return;
    await authService.initialize(scopes);
    const loggedInUser = authService.getLoginInfo();
    if (loggedInUser == null ? void 0 : loggedInUser.userId) {
      await fetchProfile();
    } else {
      setLoading(false);
    }
  };
  (0,react.useEffect)(() => {
    const queries = sessionStorage.getItem(IBANKING_LOGIN_DATA);
    if (queries) {
      const reloginWithPartner = async () => {
        try {
          const queriesObj = JSON.parse(queries);
          if (!window.location.pathname.includes("/login") && Object.keys(queriesObj).length) {
            if (queriesObj.partnerType === FEDERATION_PARTNER) {
              await _refreshToken();
            } else {
              await loginWithPartner(queriesObj, true, false);
            }
          }
        } catch (e) {
          dist_index_es/* logger.error */.k.error("Relogin ibanking false", e);
        } finally {
          setLoading(false);
        }
      };
      reloginWithPartner();
    } else {
      initIam().finally(() => {
        setLoading(false);
      });
    }
  }, []);
  return /* @__PURE__ */ react.createElement(AuthContext.Provider, {
    value: {
      user,
      loading,
      loginWithPartner,
      authService,
      userService,
      updateProfile,
      initIam,
      setUser,
      isShowConfirmModal: show
    }
  }, /* @__PURE__ */ react.createElement(context_es_StyledModal, {
    visible: show,
    onCancel: () => {
      if (isSacombankmbPartner(partner)) {
        window.location.href = "/?action=backtoapp";
      } else {
        window.location.href = "/vnpayshop/backapp";
      }
    },
    onOk: () => {
      var _a;
      const userId = (_a = authService.getLoginInfo()) == null ? void 0 : _a.userId;
      if (userId) {
        userConfirmedPolicy(userId);
      }
      router == null ? void 0 : router.push("/");
      setShow(false);
    },
    okButtonProps: {
      disabled: !agreePrivacyAndPolicy
    },
    okText: "\u0110\u1ED3ng \xFD",
    cancelText: "Quay l\u1EA1i",
    showCloseIcon: false,
    title: partner !== "sacombankmb" && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
      level: 1,
      color: "textTitle"
    }, "Th\xF4ng b\xE1o x\u1EED l\xFD d\u1EEF li\u1EC7u"), /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
      level: 1,
      color: "textPrimary",
      marginTop: "s8"
    }, "Vui l\xF2ng \u0111\u1ED3ng \xFD v\u1EDBi c\xE1c \u0111i\u1EC1u kho\u1EA3n v\xE0 \u0111i\u1EC1u ki\u1EC7n d\u1ECBch v\u1EE5 \u0111\u1EC3 ti\u1EBFp t\u1EE5c")),
    centeredTitle: true
  }, /* @__PURE__ */ react.createElement(ModalBody, {
    padding: ["s0", "s0"]
  }, isSacombankmbPartner(partner) ? /* @__PURE__ */ react.createElement(react.Fragment, null, "D\u1ECBch v\u1EE5 Mua s\u1EAFm VNSHOP \u0111\u01B0\u1EE3c cung c\u1EA5p b\u1EDFi VNPAY. Chi ti\u1EBFt li\xEAn h\u1EC7 hotline VNPAY: 1900555577 \u0111\u1EC3 \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3.") : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(context_es_CheckboxWrapper, null, /* @__PURE__ */ react.createElement(Checkbox, context_es_spreadProps(context_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "ConfirmationPrivacy",
    contentName: "checkboxAgreePrivacy"
  })), {
    checked: agreePrivacyAndPolicy,
    onChange: setAgreePrivacyAndPolicy
  }), /* @__PURE__ */ react.createElement(StyledPrivacyAndPolicyText, null, "B\u1EB1ng vi\u1EC7c \u0111\xE1nh d\u1EA5u v\xE0o \xF4 n\xE0y, t\xF4i \u0111\xE3 bi\u1EBFt r\xF5 v\xE0 \u0111\u1ED3ng \xFD to\xE0n b\u1ED9 v\u1EDBi", " ", /* @__PURE__ */ react.createElement("a", {
    href: "/chinh-sach-bao-mat-thong-tin-ca-nhan"
  }, "N\u1ED9i dung th\xF4ng b\xE1o x\u1EED l\xFD d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a C\xF4ng ty VNIS (VNSHOP)"), " ", "li\xEAn quan t\u1EDBi vi\u1EC7c x\u1EED l\xFD d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a t\xF4i, bao g\u1ED3m c\u1EA3 c\xE1c ho\u1EA1t \u0111\u1ED9ng ch\u1EC9nh s\u1EEDa, ti\u1EBFt l\u1ED9, x\xF3a, h\u1EE7y d\u1EEF li\u1EC7u c\xE1 nh\xE2n.")))))), children);
};
function useAuth() {
  const context = (0,react.useContext)(AuthContext);
  if (!context) {
    throw new Error("useAuth must be inside a AuthContextProvider with a state value");
  }
  return context;
}
const context_es_StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es_Modal)`
  width: 400px;
  @media (max-width: 576px) {
    width: 80%;
  }
`;
const context_es_CheckboxWrapper = emotion_styled_browser_esm["default"].div`
  text-align: center;
  .check-box {
    display: flex;
    align-items: flex-start;
    column-gap: 0.375rem;
    .checkbox-inner {
      top: 4px;
    }
    .checkbox-label {
      -webkit-line-clamp: unset;
    }
  }
`;
const StyledPrivacyAndPolicyText = emotion_styled_browser_esm["default"].div`
  text-align: justify;
`;




/***/ }),

/***/ 41713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ cookFilter; },
/* harmony export */   "jG": function() { return /* binding */ getKeyAPI; },
/* harmony export */   "nS": function() { return /* binding */ normalizePageBuilderToDiscoveryParams; }
/* harmony export */ });
/* unused harmony exports getObjFromQueryString, paramToUrl */
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31260);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93369);



var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const paramToUrl = (params, baseUrl, key) => {
  const url = new URL(`${baseUrl}/${key || "search"}`);
  if (params) {
    Object.keys(params).forEach((key2) => {
      if (Array.isArray(params[key2]) && !params[key2].length)
        return;
      return url.searchParams.append(key2, params[key2]);
    });
  }
  return url;
};
const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const cookFilterOption = (el, filterCode, filterName, params) => {
  var _a, _b, _c;
  const optionName = el.name || el.value || "";
  const optionCode = el.code || ((_a = el.optionId) == null ? void 0 : _a.toString()) || ((_b = el.id) == null ? void 0 : _b.toString()) || "";
  if (!params || !((_c = params[filterCode]) == null ? void 0 : _c.toString().split(",").includes(optionCode))) {
    return {
      optionName,
      optionCode,
      filterCode,
      filterName
    };
  }
  return {
    optionName: "",
    optionCode: "",
    filterCode: "",
    filterName: ""
  };
};
const cookFilter = (filter, params, categories) => {
  var _a, _b, _c;
  const newFilter = [];
  if (!filter)
    return newFilter;
  if (categories == null ? void 0 : categories.length) {
    newFilter.push({
      code: "masterCategories",
      name: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m",
      options: categories.map((val) => cookFilterOption(val, "masterCategories", "Danh m\u1EE5c s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  if ((_a = filter == null ? void 0 : filter.brands) == null ? void 0 : _a.length) {
    newFilter.push({
      code: "brands",
      name: "Th\u01B0\u01A1ng hi\u1EC7u",
      options: filter.brands.map((val) => cookFilterOption(val, "brands", "Th\u01B0\u01A1ng hi\u1EC7u", params)).filter(Boolean)
    });
  }
  if ((_b = filter == null ? void 0 : filter.clearanceTypes) == null ? void 0 : _b.length) {
    newFilter.push({
      code: "clearanceTypeIds",
      name: "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m",
      options: filter.clearanceTypes.map((val) => cookFilterOption(val, "clearanceTypeIds", "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  (_c = filter == null ? void 0 : filter.attributes) == null ? void 0 : _c.forEach((el) => {
    newFilter.push({
      code: `attributes.${el.code}`,
      name: el.name,
      options: el.values.map((val) => cookFilterOption(val, `attributes.${el.code}`, el.name, params)).filter(Boolean)
    });
  });
  return newFilter.filter((filter2) => !!filter2.options.length);
};
const normalizePageBuilderToDiscoveryParams = (params) => {
  var _a, _b, _c, _d;
  if (!params)
    return {};
  const attributes = params["attributes"] || [];
  const priceGteFromPageBuilder = (_b = (_a = params == null ? void 0 : params.prices) == null ? void 0 : _a[0]) == null ? void 0 : _b.from;
  const priceLteFromPageBuilder = (_d = (_c = params == null ? void 0 : params.prices) == null ? void 0 : _c[0]) == null ? void 0 : _d.to;
  if (!params["price_gte"] && priceGteFromPageBuilder)
    params["price_gte"] = priceGteFromPageBuilder;
  if (!params["price_lte"] && priceLteFromPageBuilder)
    params["price_lte"] = priceLteFromPageBuilder;
  attributes.forEach((element) => {
    const key = `attributes.${element.code}`;
    const value = element.optionIds && element.optionIds.toString();
    params[key] = value;
  });
  params["attributes"] = [];
  return (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)(params);
};
const getKeyAPI = (params, baseUrl) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const normalizedParams = normalizePageBuilderToDiscoveryParams(searchParams);
  const terminalCode = normalizedParams == null ? void 0 : normalizedParams.terminalCode;
  const pos365StoreCode = normalizedParams == null ? void 0 : normalizedParams.pos365StoreCode;
  return (0,swr__WEBPACK_IMPORTED_MODULE_0__/* .unstable_serialize */ .wE)(params && Object.keys(params).length && (!!terminalCode || !pos365StoreCode) ? [normalizedParams, baseUrl + "/search"] : null);
};




/***/ }),

/***/ 89172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ PageTypeEnum; },
/* harmony export */   "Nc": function() { return /* binding */ BlockItemType; },
/* harmony export */   "kH": function() { return /* binding */ BlockType; }
/* harmony export */ });
var PageTypeEnum = /* @__PURE__ */ ((PageTypeEnum2) => {
  PageTypeEnum2["HOME"] = "PAGE_TYPE_HOME";
  PageTypeEnum2["CATEGORY"] = "PAGE_TYPE_CATEGORY";
  PageTypeEnum2["NOTIFICATION"] = "PAGE_TYPE_NOTIFICATION";
  PageTypeEnum2["SELLER"] = "PAGE_TYPE_SELLER";
  PageTypeEnum2["BRAND"] = "PAGE_TYPE_BRAND";
  return PageTypeEnum2;
})(PageTypeEnum || {});
var BlockItemType = /* @__PURE__ */ ((BlockItemType2) => {
  BlockItemType2["BANNER"] = "BANNER";
  BlockItemType2["MENU"] = "MENU";
  BlockItemType2["SKU"] = "SKU";
  BlockItemType2["LOCAL"] = "LOCAL";
  return BlockItemType2;
})(BlockItemType || {});
var BlockType = /* @__PURE__ */ ((BlockType2) => {
  BlockType2["SLIDE_BANNER"] = "SLIDE_BANNER";
  BlockType2["WIDE_THIN_BANNER"] = "WIDE_THIN_BANNER";
  BlockType2["WIDE_THICK_BANNER"] = "WIDE_THICK_BANNER";
  BlockType2["VERTICAL_2_BANNER"] = "VERTICAL_2_BANNER";
  BlockType2["HORIZONTAL_4_BANNER"] = "HORIZONTAL_4_BANNER";
  BlockType2["HORIZONTAL_BODY_BANNER"] = "HORIZONTAL_BODY_BANNER";
  BlockType2["HORIZONTAL_BODY_2_BANNER"] = "HORIZONTAL_BODY_2_BANNER";
  BlockType2["HORIZONTAL_BODY_3_BANNER"] = "HORIZONTAL_BODY_3_BANNER";
  BlockType2["HORIZONTAL_2_BANNER_MOBILE"] = "HORIZONTAL_2_BANNER_MOBILE";
  BlockType2["POPUP_BANNER"] = "POPUP_BANNER";
  BlockType2["POPUP_BANNER_MOBILE"] = "POPUP_BANNER_MOBILE";
  BlockType2["LEFT_STICKY_BANNER"] = "LEFT_STICKY_BANNER";
  BlockType2["RIGHT_STICKY_BANNER"] = "RIGHT_STICKY_BANNER";
  BlockType2["PROMOTE_CATEGORY_MENU"] = "PROMOTE_CATEGORY_MENU";
  BlockType2["RECOMMENDED_BRANDS"] = "RECOMMENDED_BRANDS";
  BlockType2["RECOMMENDED_CATEGORY"] = "RECOMMENDED_CATEGORY";
  BlockType2["LISTING_TAB"] = "LISTING_TAB";
  BlockType2["HORIZONTAL_HIGHLIGHTED_BANNER"] = "HORIZONTAL_HIGHLIGHTED_BANNER";
  BlockType2["COUNT_DOWN_PROMO_BIG_SKU"] = "COUNT_DOWN_PROMO_BIG_SKU";
  BlockType2["COUNT_DOWN_PROMO_TAB_MOBILE"] = "COUNT_DOWN_PROMO_TAB_MOBILE";
  BlockType2["MIX_BANNER"] = "MIX_BANNER";
  BlockType2["MEDIUM_ICON_MENU_MOBILE"] = "MEDIUM_ICON_MENU_MOBILE";
  BlockType2["NAVIGATION_BAR"] = "NAVIGATION_BAR";
  BlockType2["PROMOTE_SELLER"] = "PROMOTE_SELLER";
  BlockType2["BEST_SELLING_PRODUCT"] = "BEST_SELLING_PRODUCT";
  BlockType2["FLASH_SALE"] = "FLASH_SALE";
  BlockType2["COUNT_DOWN_PROMO_SKU"] = "COUNT_DOWN_PROMO_SKU";
  BlockType2["HORIZONTAL_SKU_LIST"] = "HORIZONTAL_SKU_LIST";
  BlockType2["MAIN_SKU_LIST"] = "MAIN_SKU_LIST";
  BlockType2["LIST_SKU_MOBILE"] = "LIST_SKU_MOBILE";
  BlockType2["POS365_LIST_SKU"] = "POS365_LIST_SKU";
  BlockType2["PRODUCT_LINE_MENU"] = "PRODUCT_LINE_MENU";
  BlockType2["LOCATION"] = "LOCATION";
  BlockType2["PENDING_PAYMENT"] = "PENDING_PAYMENT";
  BlockType2["LEFT_OFF_ITEMS"] = "LEFT_OFF_ITEMS";
  BlockType2["RECENT_PRODUCT"] = "RECENT_PRODUCT";
  BlockType2["RECENT_SEARCH"] = "RECENT_SEARCH";
  BlockType2["MEGA_MENU"] = "MEGA_MENU";
  BlockType2["YOUTUBE"] = "YOUTUBE";
  BlockType2["PERSONALIZATION_PLACEHOLDER"] = "PERSONALIZATION_PLACEHOLDER";
  BlockType2["SMALL_MIX_NEWS"] = "SMALL_MIX_NEWS";
  return BlockType2;
})(BlockType || {});




/***/ }),

/***/ 31813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jk": function() { return /* binding */ ARRAY_OF_STRING_PAYLOAD_FILTER; },
/* harmony export */   "O4": function() { return /* binding */ ARRAY_OF_NUMBER_PAYLOAD_FILTER; },
/* harmony export */   "ct": function() { return /* binding */ PRIMITIVE_PAYLOAD_FILTER; },
/* harmony export */   "hI": function() { return /* binding */ RETURN_FILTERABLE; },
/* harmony export */   "rA": function() { return /* binding */ ORDER_PAYLOAD_SORTING; }
/* harmony export */ });
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93433);


const RETURN_FILTERABLE = [
  "FILTER_TYPE_ATTRIBUTE",
  "FILTER_TYPE_BRAND",
  "FILTER_TYPE_PRICE",
  "FILTER_TYPE_CLEARANCE"
];
const PRIMITIVE_PAYLOAD_FILTER = [
  "hasPromotions",
  "inStockOnly",
  "returnAllVariants",
  "priceLte",
  "priceGte"
];
const ARRAY_OF_NUMBER_PAYLOAD_FILTER = [
  "clearanceTypeIds",
  "masterCategoryIds"
];
const ARRAY_OF_STRING_PAYLOAD_FILTER = [
  "skus",
  "excludedSkus",
  "tags",
  "providerIds",
  "sellerIds",
  "brands"
];
const ORDER_PAYLOAD_SORTING = {
  desc: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_DESCENDING */ .l.ORDER_BY_DESCENDING,
  asc: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_ASCENDING */ .l.ORDER_BY_ASCENDING,
  DESC: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_DESCENDING */ .l.ORDER_BY_DESCENDING,
  ASC: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_ASCENDING */ .l.ORDER_BY_ASCENDING
};




/***/ }),

/***/ 93433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SortEnum; },
/* harmony export */   "l": function() { return /* binding */ OrderEnum; }
/* harmony export */ });
var SortEnum = /* @__PURE__ */ ((SortEnum2) => {
  SortEnum2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SortEnum2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SortEnum2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SortEnum2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SortEnum2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SortEnum2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  SortEnum2["SORT_BY_SCORE"] = "SORT_BY_SCORE";
  SortEnum2["SORT_BY_NAME"] = "SORT_BY_NAME";
  return SortEnum2;
})(SortEnum || {});
var OrderEnum = /* @__PURE__ */ ((OrderEnum2) => {
  OrderEnum2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  OrderEnum2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  OrderEnum2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return OrderEnum2;
})(OrderEnum || {});




/***/ }),

/***/ 27103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ListContent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71323);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContentWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return [
    _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
    `
  background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  padding: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12} ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
  display: flex;
  align-items: center;
  position: relative;
  ${props.hover ? `
    background-color: ${(_d = props.theme) == null ? void 0 : _d.colors.background};
  ` : ""}
  ${props.active && !props.hover ? `
      background-color: ${(_e = props.theme) == null ? void 0 : _e.colors.primary500};
      color: ${(_f = props.theme) == null ? void 0 : _f.colors.white};
      ` : ""}
 ${props.hasDivider ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${(_g = props.theme) == null ? void 0 : _g.spacing.s16};
      bottom: 0;
      left: ${(_h = props.theme) == null ? void 0 : _h.spacing.s16};
      border-bottom: ${(_i = props.theme) == null ? void 0 : _i.borderWeight.m} solid ${(_j = props.theme) == null ? void 0 : _j.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }` : ``}
`
  ];
});
const ListContent = (_a) => {
  var _b = _a, {
    label,
    icon,
    hasDivider = false,
    active = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "label",
    "icon",
    "hasDivider",
    "active",
    "onClick"
  ]);
  var _a2, _b2;
  const [hover, setHover] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListContentWrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    },
    hasDivider,
    active,
    hover,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, rest), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b, {
    marginRight: "s12"
  }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, __spreadValues({
    size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? 24 : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size
  }, active && !hover ? { color: "white" } : {}))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    level: 1,
    line: 1
  }, label));
};




/***/ }),

/***/ 35790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1808);



const useToast = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .ToastContextDesktop */ .hX);
};




/***/ }),

/***/ 25989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CommonStyles; },
/* harmony export */   "L": function() { return /* binding */ getDimension; }
/* harmony export */ });
const getDimension = (value, prefix = "", suffix = "") => {
  if (!value)
    return "";
  return prefix + (typeof value === "number" ? `${value}px` : value) + suffix;
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getSpacing = (props) => {
  const dimension = [
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft"
  ];
  return dimension.reduce((prev, curr) => {
    var _a;
    const currentProp = props[curr];
    if (currentProp) {
      if (typeof currentProp === "string") {
        return `${prev}
${jsToCss(curr)}: ${(_a = props.theme) == null ? void 0 : _a.spacing[currentProp]};`;
      }
      return `${prev}
${jsToCss(curr)}: ${currentProp.map((c) => {
        var _a2;
        return (_a2 = props.theme) == null ? void 0 : _a2.spacing[c];
      }).join(" ")};`;
    }
    return prev;
  }, "");
};
const getItemSpacing = (props) => {
  var _a, _b;
  return `
    ${props.itemHorizontalSpacing ? `
      > *:not(:first-of-type) {
        margin-left: ${(_a = props.theme) == null ? void 0 : _a.spacing[props.itemHorizontalSpacing]};
      }
    ` : ""}
    ${props.itemVerticalSpacing ? `
      > *:not(:first-of-type) {
        margin-top: ${(_b = props.theme) == null ? void 0 : _b.spacing[props.itemVerticalSpacing]};
      }
    ` : ""}`;
};
const replaceColor = (value, colors) => {
  const values = value.split(" ").map((i) => colors[i] ? colors[i] : i);
  return values.join(" ");
};
const CommonStyles = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return `
  border-style: ${props.borderStyle ? props.borderStyle : "none"};
  ${!!props.borderRadius && ` border-radius: ${props.borderRadius ? (_a = props.theme) == null ? void 0 : _a.borderRadius[props.borderRadius] : "0px"};`};

  border-width: ${props.borderWeight ? (_b = props.theme) == null ? void 0 : _b.borderWeight[props.borderWeight] : "1px"};
  border-color: ${props.borderColor ? (_c = props.theme) == null ? void 0 : _c.colors[props.borderColor] : "unset"};
  ${props.border ? `border: ${replaceColor(props.border, ((_d = props.theme) == null ? void 0 : _d.colors) || {})};` : ""};
  ${props.borderTop ? `border-top: ${replaceColor(props.borderTop, ((_e = props.theme) == null ? void 0 : _e.colors) || {})};` : ""};
  ${props.borderRight ? `border-right: ${replaceColor(props.borderRight, ((_f = props.theme) == null ? void 0 : _f.colors) || {})};` : ""};
  ${props.borderBottom ? `border-bottom: ${replaceColor(props.borderBottom, ((_g = props.theme) == null ? void 0 : _g.colors) || {})};` : ""};
  ${props.borderLeft ? `border-left: ${replaceColor(props.borderLeft, ((_h = props.theme) == null ? void 0 : _h.colors) || {})};` : ""};
  opacity: ${props.opacity ? (_i = props.theme) == null ? void 0 : _i.opacity[props.opacity] : 1};
  box-shadow: ${(p) => {
    var _a2;
    return (_a2 = p.theme) == null ? void 0 : _a2.shadow(p, props.shadow || "", props.shadowColor);
  }};
  ${props.backgroundColor && `background-color: ${((_j = props.theme) == null ? void 0 : _j.colors[props.backgroundColor]) || props.backgroundColor};
  `};
  ${getDimension(props.width || "", "width: ", ";")}
  ${getDimension(props.maxWidth || "", "max-width: ", ";")}
  ${getDimension(props.height || "", "height: ", ";")}
  ${getDimension(props.maxHeight || "", "max-height: ", ";")}
  ${getSpacing(props)}
  ${getItemSpacing(props)}

`;
};




/***/ }),

/***/ 24122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(25989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/helpers/IconBase.es.js
var IconBase_es = __webpack_require__(32600);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(1902);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/constant.es.js


const BUTTON_CONFIG = {
  height: {
    xs: constants_index_es/* CORE_SIZE.s24 */.y.s24,
    s: constants_index_es/* CORE_SIZE.s32 */.y.s32,
    m: constants_index_es/* CORE_SIZE.s40 */.y.s40,
    l: constants_index_es/* CORE_SIZE.s48 */.y.s48
  },
  textColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textPrimary",
    link: "link500",
    "white-ghost": "primary500"
  },
  iconColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textSecondary",
    link: "link500",
    "white-ghost": "primary500"
  },
  disabled: {
    textColor: {
      primary: "placeholder",
      secondary: "placeholder",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    },
    iconColor: {
      primary: "border",
      secondary: "border",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    }
  }
};



// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(85212);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(34363);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Ripple/Ripple.es.js
var Ripple_es = __webpack_require__(8178);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js











var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonStyleByVariant = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  switch (props.variant) {
    case "default": {
      return emotion_react_browser_esm.css`
        background-color: transparent;
        border: 1px solid
          ${props.disabled ? (_a = props.theme) == null ? void 0 : _a.colors.disable : (_b = props.theme) == null ? void 0 : _b.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_c = props.theme) == null ? void 0 : _c.colors.textSecondary};
        }
        &:active {
          border-color: ${(_d = props.theme) == null ? void 0 : _d.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_e = props.theme) == null ? void 0 : _e.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_f = props.theme) == null ? void 0 : _f.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
        border: 1px solid
          ${props.disabled ? (_h = props.theme) == null ? void 0 : _h.colors.disable : (_i = props.theme) == null ? void 0 : _i.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_j = props.theme) == null ? void 0 : _j.colors.textSecondary};
        }
        &:active {
          border-color: ${(_k = props.theme) == null ? void 0 : _k.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_l = props.theme) == null ? void 0 : _l.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_m = props.theme) == null ? void 0 : _m.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "secondary": {
      return emotion_react_browser_esm.css`
        background-color: ${(_n = props.theme) == null ? void 0 : _n.colors.white};
        border: 1px solid
          ${props.disabled ? (_o = props.theme) == null ? void 0 : _o.colors.disable : (_p = props.theme) == null ? void 0 : _p.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            border-color: ${(_q = props.theme) == null ? void 0 : _q.colors.primary600};
            div[type=body] {
              color: ${(_r = props.theme) == null ? void 0 : _r.colors.primary600};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_s = props.theme) == null ? void 0 : _s.colors.primary600};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_t = props.theme) == null ? void 0 : _t.colors.primary600};
            }
          }
          &:active {
            border-color: ${(_u = props.theme) == null ? void 0 : _u.colors.primary700};
            div[type=body] {
              color: ${(_v = props.theme) == null ? void 0 : _v.colors.primary700};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_w = props.theme) == null ? void 0 : _w.colors.primary700};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_x = props.theme) == null ? void 0 : _x.colors.primary700};
            }
          }
        ` : ""}
      `;
    }
    case "white-ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_y = props.theme) == null ? void 0 : _y.colors.white};
        border: none;
        ${props.disabled ? `
          background-color: ${(_z = props.theme) == null ? void 0 : _z.colors.disable};
          ` : `
          &:hover {
            background-color: ${(_A = props.theme) == null ? void 0 : _A.colors.tableHeader};
          }
          &:active {
            background-color: ${(_B = props.theme) == null ? void 0 : _B.colors.background};
          }
        `}
      `;
    }
    case "primary":
    default:
      return emotion_react_browser_esm.css`
        background-color: ${props.disabled ? (_C = props.theme) == null ? void 0 : _C.colors.disable : (_D = props.theme) == null ? void 0 : _D.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            background-color: ${(_E = props.theme) == null ? void 0 : _E.colors.primary600};
          }
          &:active {
            background-color: ${(_F = props.theme) == null ? void 0 : _F.colors.primary700};
          }
        ` : ""}
      `;
  }
};
const buttonShapeStyle = ({ theme, shape, size }) => {
  switch (shape) {
    case ds_index_es/* ButtonShapeEnum.round */.Vz.round:
      return emotion_react_browser_esm.css`
        border-radius: ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem
          ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem;
      `;
    case ds_index_es/* ButtonShapeEnum.circle */.Vz.circle:
      return emotion_react_browser_esm.css`
        border-radius: 50%;
      `;
    default:
      return emotion_react_browser_esm.css`
        border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
      `;
  }
};
const Button = (_a) => {
  var _b = _a, {
    children,
    block = false,
    shape,
    size: customizeSize,
    variant = "default",
    prefix,
    suffix,
    disabled,
    onClick,
    className,
    href,
    type = "button",
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "shape",
    "size",
    "variant",
    "prefix",
    "suffix",
    "disabled",
    "onClick",
    "className",
    "href",
    "type",
    "backgroundColor"
  ]);
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  if (variant === "link") {
    return /* @__PURE__ */ react.createElement(StyledLink, __spreadValues({
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className,
      itemHorizontalSpacing: "s4",
      color: disabled ? BUTTON_CONFIG.disabled.iconColor.link : BUTTON_CONFIG.iconColor.link,
      onClick: handleClick,
      disabled: !!disabled
    }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? mergeSize === "m" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0);
  }
  return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
    height: BUTTON_CONFIG.height[mergeSize],
    padding: shape !== "circle" ? ["s0", "s20"] : void 0,
    itemHorizontalSpacing: "s8",
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.iconColor[variant] : BUTTON_CONFIG.iconColor[variant],
    backgroundColor,
    variant,
    disabled: !!disabled,
    block,
    shape,
    size: mergeSize,
    onClick: handleClick,
    className,
    type
  }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    className: "button-text",
    level: mergeSize === "s" ? 2 : 1,
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.textColor[variant] : BUTTON_CONFIG.textColor[variant]
  }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0, /* @__PURE__ */ react.createElement("span", {
    style: { marginLeft: 0 }
  }, /* @__PURE__ */ react.createElement(Ripple_es/* Ripple */.H, null)));
};
const Spacer = emotion_styled_browser_esm["default"].span`
  width: 0.5rem;
`;
const StyledButton = emotion_styled_browser_esm["default"].button(({
  height,
  theme,
  color,
  block,
  disabled,
  backgroundColor
}) => [
  index_es/* CommonStyles */.F,
  IconBase_es/* SvgCss */.uL,
  buttonShapeStyle,
  buttonStyleByVariant,
  `position: relative;
display: flex;
align-items: center;
justify-content: center;
outline: none;
min-width: ${height};
${color ? `color: ${(theme == null ? void 0 : theme.colors[color]) || color};` : ""}
${block ? `width: 100%;` : ""}
cursor: ${disabled ? "not-allowed" : "pointer"};
${backgroundColor ? `background-color: ${(theme == null ? void 0 : theme.colors[backgroundColor]) || backgroundColor} !important;` : ""}
transition-duration: 80ms;
transition-property: background-color;
&:focus {
  outline: none;
}
`
]);
const StyledLink = emotion_styled_browser_esm["default"].a`
  ${index_es/* CommonStyles */.F}
  ${IconBase_es/* SvgCss */.uL}
  display: inline;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  ${(p) => {
  var _a;
  return p.color ? `color: ${((_a = p.theme) == null ? void 0 : _a.colors[p.color]) || p.color}!important;` : "";
}}
  text-decoration: none;
  ${(p) => !p.disabled ? `
    &:hover {
      text-decoration: underline;
    }

  div {
    display: inline;
  }
  ` : ""}
`;




/***/ }),

/***/ 96413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43609);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69433);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayColor = props.checked || props.partSelected;
  switch (type) {
    case "border": {
      if (props.disabled) {
        if (displayColor)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.divider;
      } else {
        if (displayColor)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.border;
      }
    }
    case "inner":
    default: {
      if (props.disabled) {
        if (displayColor)
          return (_e = props.theme) == null ? void 0 : _e.colors.primary100;
        return (_f = props.theme) == null ? void 0 : _f.colors.background;
      } else {
        if (displayColor)
          return (_g = props.theme) == null ? void 0 : _g.colors.primary500;
        return (_h = props.theme) == null ? void 0 : _h.colors.white;
      }
    }
  }
};
const Checkbox = (_a) => {
  var _b = _a, {
    checked = false,
    partSelected,
    disabled,
    onChange,
    children,
    className
  } = _b, rest = __objRest(_b, [
    "checked",
    "partSelected",
    "disabled",
    "onChange",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxWrapper, __spreadProps(__spreadValues({}, rest), {
    className: "check-box"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckbox, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "checkbox",
    checked,
    disabled,
    partSelected,
    onChange: () => !disabled && onChange && onChange(!checked),
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxInner, {
    checked,
    partSelected,
    disabled,
    className: "checkbox-inner"
  }, partSelected ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledMinusIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }))), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    line: 1,
    marginLeft: "s4",
    level: 1,
    weight: "regular",
    style: { flex: 1 },
    className: "checkbox-label"
  }, children));
};
const CheckboxWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].label`
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
`;
const StyledCheckIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CheckOutlined */ .b)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .MinusOutlined */ .l)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const StyledCheckbox = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, "border")};
  border-radius: 2px;
  background-color: ${(p) => getColor(p, "inner")};
`;
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${(p) => !p.disabled && !p.checked && !p.partSelected ? `
      &:hover + .checkbox-inner {
        border-color: ${p.theme.colors.placeholder};
      }
    ` : ""}
`;




/***/ }),

/***/ 4680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "tk": function() { return /* binding */ thoundsandDelimiter; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(value) {
  if (!value) {
    return "0";
  } else {
    const valueInNumber = typeof value === "number" ? value : parseInt(value);
    if (isNaN(valueInNumber)) {
      return "";
    } else {
      return valueInNumber.toLocaleString("de-DE", { maximumFractionDigits: 2 }).toString();
    }
  }
}
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const StyledCurrency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  width: max-content;
  display: inline-block;
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => p.weight ? FONT_WEIGHT_MAP[p.weight] : "inherit"};
`;
const formatCurrency = (value, {
  hideCurrencySymbol,
  space,
  underline
}) => {
  const formatted = thoundsandDelimiter(value);
  return hideCurrencySymbol ? formatted : `${formatted}${space ? " " : ""}${underline ? "\u20AB" : "\u0111"}`;
};
const Currency = (_a) => {
  var _b = _a, {
    value,
    hideCurrency = false,
    space = false,
    underline = false
  } = _b, props = __objRest(_b, [
    "value",
    "hideCurrency",
    "space",
    "underline"
  ]);
  if (!value && value !== 0) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), formatCurrency(value, {
    space,
    underline,
    hideCurrencySymbol: hideCurrency
  }));
};




/***/ }),

/***/ 88384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CustomLink = (_a) => {
  var _b = _a, {
    href,
    children,
    passHref = true,
    target = "_self",
    prefetch = false
  } = _b, others = __objRest(_b, [
    "href",
    "children",
    "passHref",
    "target",
    "prefetch"
  ]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement((next_link__WEBPACK_IMPORTED_MODULE_0___default()), __spreadProps(__spreadValues({
    href
  }, others), {
    passHref,
    legacyBehavior: true,
    prefetch
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Anchor, {
    target,
    className: others.className
  }, children));
};
const Anchor = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].a`
  text-decoration: none;
  color: unset;
  &:hover {
    color: unset;
  }
  cursor: pointer;
`;




/***/ }),

/***/ 8081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12977);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96098);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const fallbackImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    src,
    height,
    objectFit,
    width,
    alt,
    onClick,
    borderRadius,
    thumbnail,
    hover,
    decoding = "async",
    className,
    lazy = true,
    tracking,
    fetchPriority,
    aspectRatio,
    googleImageParams
  } = _a, others = __objRest(_a, [
    "src",
    "height",
    "objectFit",
    "width",
    "alt",
    "onClick",
    "borderRadius",
    "thumbnail",
    "hover",
    "decoding",
    "className",
    "lazy",
    "tracking",
    "fetchPriority",
    "aspectRatio",
    "googleImageParams"
  ]);
  const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, googleImageParams || {}));
  const imgError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setImgSrc((prevImgSrc) => {
      var _a2;
      if (((_a2 = prevImgSrc.params) == null ? void 0 : _a2.format) === "webp") {
        return (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, __spreadProps(__spreadValues({}, googleImageParams), { format: "png" }));
      } else if (!prevImgSrc.error) {
        return { src: fallbackImage, error: true };
      }
      return prevImgSrc;
    });
  }, [src]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setImgSrc((0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, googleImageParams || {}));
  }, [src, setImgSrc, aspectRatio, JSON.stringify(googleImageParams)]);
  const imgElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", __spreadValues({
    ref,
    style: __spreadValues({
      width: width === "auto" ? width : "100%",
      height: height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)}` : aspectRatio ? "100%" : "auto",
      objectFit
    }, aspectRatio ? { position: "absolute", top: "0px", left: "0px" } : {}),
    src: imgSrc.src || fallbackImage,
    loading: lazy ? "lazy" : "eager",
    hover,
    decoding,
    alt,
    fetchpriority: fetchPriority,
    onError: imgError
  }, others));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadValues({
    height,
    width: width || "100%",
    onClick,
    borderRadius,
    thumbnail,
    className,
    hover,
    aspectRatio
  }, tracking), imgElement);
});
Image.displayName = "Image";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({
  onClick,
  borderRadius,
  height,
  thumbnail,
  width,
  aspectRatio,
  hover
}) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? "cursor: pointer;" : ""}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(borderRadius)};` : ""}
  ${borderRadius ? "1px solid #e0e0e0;" : ""}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)};` : ""}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(width)};` : aspectRatio ? "width: 100%;" : ""}
  ${aspectRatio && !height ? `padding-bottom: ${100 / aspectRatio}%;` : ""}
  ${thumbnail ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;` : ""}
  ${hover ? "transition: transform 0.3s ease 0s; &:hover { transform: scale(1.05); };" : ""}
`);




/***/ }),

/***/ 12977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "XI": function() { return /* binding */ imageLoader; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const baseParams = url.indexOf("=") >= 0 ? url.substring(url.indexOf("=") + 1).split("-") : [];
  const mergedParams = {};
  baseParams.forEach((param) => {
    var _a;
    if (["rw", "rp", "rj"].includes(param)) {
      mergedParams["format"] = param;
    } else {
      const prefix = (_a = param.match(/^([a-z]+)(\w*)$/)) == null ? void 0 : _a[1];
      if (prefix) {
        mergedParams[prefix] = param;
      }
    }
  });
  if (config.width && !config.height) {
    delete mergedParams["h"];
    delete mergedParams["s"];
  }
  if (config.height && !config.width) {
    delete mergedParams["w"];
    delete mergedParams["s"];
  }
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value !== "boolean" && !value)
      return;
    if (key === "format") {
      const gcsArg = imgAttributeMapping[value];
      mergedParams["format"] = gcsArg;
      return;
    }
    const gcsArgPrefix = imgAttributeMapping[key];
    if (key === "size" && value) {
      mergedParams[gcsArgPrefix] = `${gcsArgPrefix}0`;
      return;
    }
    if (gcsArgPrefix) {
      if (typeof value === "boolean") {
        mergedParams[gcsArgPrefix] = value ? gcsArgPrefix : void 0;
      } else {
        mergedParams[gcsArgPrefix] = `${gcsArgPrefix}${value}`;
      }
    }
  });
  const filterParams = Object.values(mergedParams).filter((param) => param);
  return filterParams.some((param) => param) ? `${baseUrl}=${filterParams.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};
const imageLoader = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    const googleParams = __spreadProps(__spreadValues({}, config || {}), {
      format: (config == null ? void 0 : config.format) || "webp"
    });
    return {
      src: constructGoogleImageParams(imageUrl, googleParams),
      params: googleParams
    };
  }
  return { src: imageUrl };
};




/***/ }),

/***/ 13863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8081);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LazyImage = (_a) => {
  var _b = _a, {
    src,
    onClick,
    className,
    contain = false,
    cover = false,
    aspectRatio = 1,
    height,
    width,
    alt = "",
    hover = "",
    borderRadius = 0,
    imageWidth,
    thumbnail,
    decoding = "async",
    lazy = true,
    fetchPriority = "low"
  } = _b, props = __objRest(_b, [
    "src",
    "onClick",
    "className",
    "contain",
    "cover",
    "aspectRatio",
    "height",
    "width",
    "alt",
    "hover",
    "borderRadius",
    "imageWidth",
    "thumbnail",
    "decoding",
    "lazy",
    "fetchPriority"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues({
    src,
    decoding,
    alt,
    hover,
    onClick,
    className,
    height,
    aspectRatio,
    width,
    thumbnail,
    borderRadius,
    objectFit: cover ? "cover" : contain ? "contain" : "inherit",
    googleImageParams: { width: imageWidth },
    fetchpriority: fetchPriority,
    lazy
  }, props));
};




/***/ }),

/***/ 12433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89368);
/* harmony import */ var _LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13863);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Loading = ({
  children,
  style,
  isLoading = false,
  size = 80,
  roundColor = "primary",
  className
}) => {
  const { logo } = (0,_context_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useLoadingContext */ .d$)();
  const inline = !children;
  const Outermost = inline ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : ContainerLoadingWrapper;
  style = style || {};
  style = __spreadValues(__spreadValues({}, style), inline ? {} : { top: 0, left: 0, position: "fixed", zIndex: 9999 });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Outermost, null, isLoading && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadingContainer, {
    style,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    size
  }, logo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    width: size / 2,
    height: size / 2,
    src: logo,
    contain: true
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spinner, {
    roundColor,
    size
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "teko-spinner"
  })))), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    className: isLoading ? "loading-blur" : ""
  }, children));
};
const ContainerLoadingWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const LoadingContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
  transition: opacity 0.3s;
  &.loading-blur {
    clear: both;
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  }
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ size }) => `
  width: ${size}px;
  height: ${size}px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`);
const Spinner = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ size, roundColor, theme }) => {
  var _a;
  return `
  background: none;
  position: absolute;
  @keyframes teko-spinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .teko-spinner {    
    margin: auto;
    animation: teko-spinner 1s linear infinite;
    width: ${size * 0.95}px;
    height: ${size * 0.95}px;
    border-radius: 50%;
    box-shadow: 0 2px 0 0 ${((_a = theme.colors) == null ? void 0 : _a[roundColor]) || roundColor};
    box-sizing: content-box;
  }
`;
});




/***/ }),

/***/ 89368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PK": function() { return /* binding */ LoadingProvider; },
/* harmony export */   "d$": function() { return /* binding */ useLoadingContext; },
/* harmony export */   "r$": function() { return /* binding */ useLoading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _Loading_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12433);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96098);




const LoaderContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  isLoading: () => false,
  setLoading: () => false,
  loaderStateMap: /* @__PURE__ */ new Map(),
  logo: ""
});
const useLoadingContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LoaderContext);
const LoadingProvider = ({
  children,
  customLoader: CustomLoader,
  logo
}) => {
  const [loaderStateMap, setLoadingStateMap] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(/* @__PURE__ */ new Map());
  const isLoading = (id) => {
    return (loaderStateMap.get(id) || 0) > 0;
  };
  const setLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((id, value) => {
    setLoadingStateMap((oldState) => {
      const newState = new Map(oldState);
      let loadingTime = newState.get(id) || 0;
      if (value) {
        loadingTime += 1;
      } else {
        loadingTime -= 1;
      }
      if (loadingTime <= 0) {
        newState.delete(id);
      } else {
        newState.set(id, loadingTime);
      }
      return newState;
    });
  }, [setLoadingStateMap]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoaderContext.Provider, {
    value: { isLoading, setLoading, loaderStateMap, logo: logo || "" }
  }, CustomLoader ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLoader, {
    isLoading: loaderStateMap.size > 0
  }, children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Loading_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .g, {
    isLoading: loaderStateMap.size > 0
  }, children));
};
function useLoading(prefix = "") {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LoaderContext);
  if (!context) {
    throw new Error("useLoading must be inside a LoadingProvider with a state value");
  }
  const [id] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => prefix ? `${prefix}_${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .uid */ .hQ)()}` : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .uid */ .hQ)());
  const { isLoading, setLoading: setLoadingBase } = context;
  const setLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((state) => {
    return setLoadingBase(id, state);
  }, [id, setLoadingBase]);
  return [isLoading(id), setLoading, id];
}




/***/ }),

/***/ 48441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal_es_Modal; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(10232);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js
var Overlay_es = __webpack_require__(45838);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(55878);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(85212);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(96098);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/OldModal.es.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    show,
    onHide,
    children,
    size = ds_index_es/* SizeEnum.m */.mO.m,
    backDropStyle,
    parent
  } = _b, props = __objRest(_b, [
    "show",
    "onHide",
    "children",
    "size",
    "backDropStyle",
    "parent"
  ]);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!parentElement || !show) {
      return;
    }
    parentElement.style.overflow = "hidden";
    parentElement.style.paddingRight = `${(0,utils_es/* getScrollbarWidth */.np)()}px`;
    return () => {
      parentElement.style.overflow = "unset";
      parentElement.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react.createElement(Overlay_es/* Overlay */.a, {
    parent: parentElement || void 0,
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react.createElement(Backdrop, {
    onClick: onHide,
    style: backDropStyle
  }), /* @__PURE__ */ react.createElement(ModalContent, __spreadValues({
    size
  }, props), children));
};
const Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  [ds_index_es/* SizeEnum.s */.mO.s]: "400px",
  [ds_index_es/* SizeEnum.m */.mO.m]: "700px",
  [ds_index_es/* SizeEnum.l */.mO.l]: "960px"
};
const ModalContent = emotion_styled_browser_esm["default"].div(({
  theme,
  size,
  width,
  maxHeight,
  borderRadius,
  backgroundColor
}) => `
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.white)};
    display: flex;
    flex-direction: column;
    width: ${width !== void 0 ? (0,utils_es/* pixelParse */.oJ)(width) : sizeMaps[size || "m"]};
    border-radius: ${borderRadius || (theme == null ? void 0 : theme.borderRadius.m)};
    max-height: ${maxHeight || "90%"};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/Modal.es.js










var Modal_es_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Modal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Modal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Modal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Modal_es_defNormalProp = (obj, key, value) => key in obj ? Modal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Modal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Modal_es_hasOwnProp.call(b, prop))
      Modal_es_defNormalProp(a, prop, b[prop]);
  if (Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(b)) {
      if (Modal_es_propIsEnum.call(b, prop))
        Modal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var Modal_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Modal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Modal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal_es_Modal = (_a) => {
  var _b = _a, {
    onClose,
    visible,
    title,
    children,
    footer = true,
    width,
    style,
    contentStyle,
    onOk,
    onCancel,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    showCloseIcon = true,
    centeredTitle = false,
    alignFooter = "right",
    fullWidthFooter = false,
    closable = true
  } = _b, rest = Modal_es_objRest(_b, [
    "onClose",
    "visible",
    "title",
    "children",
    "footer",
    "width",
    "style",
    "contentStyle",
    "onOk",
    "onCancel",
    "okText",
    "cancelText",
    "okButtonProps",
    "cancelButtonProps",
    "showCloseIcon",
    "centeredTitle",
    "alignFooter",
    "fullWidthFooter",
    "closable"
  ]);
  const onCloseModal = () => {
    if (!closable)
      return;
    if (typeof onClose === "function")
      onClose == null ? void 0 : onClose();
  };
  const closeOnEscapeKeyDown = (e) => {
    if (!closable)
      return;
    if ((e.charCode || e.keyCode) === 27) {
      onCloseModal();
    }
  };
  const transitions = (0,react_spring_esm.useTransition)(visible, {
    from: { opacity: 0, transform: "translateY(-40px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-40px)" }
  });
  (0,react.useEffect)(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);
  (0,react.useEffect)(() => {
    if (typeof document !== "undefined") {
      const currentModals = document.querySelectorAll('*[id^="teko-modal"]');
      if (currentModals.length) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${(0,utils_es/* getScrollbarWidth */.np)()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [visible]);
  const renderFooter = () => {
    if (footer === false || footer === null || footer === void 0) {
      return null;
    }
    const footerCls = (0,utils_es/* mergeCls */.c8)("teko-modal-footer", `teko-modal-footer-${alignFooter}`);
    if (footer === true) {
      const style2 = fullWidthFooter ? { flex: 1 } : {};
      return /* @__PURE__ */ react.createElement("div", {
        className: footerCls
      }, cancelText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(Modal_es_spreadValues({
        marginRight: okText !== "" ? "s12" : "s0",
        onClick: () => onCancel == null ? void 0 : onCancel()
      }, cancelButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, cancelButtonProps == null ? void 0 : cancelButtonProps.style), style2)
      }), cancelText || "Cancel"), okText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(Modal_es_spreadValues({
        variant: "primary",
        onClick: () => onOk == null ? void 0 : onOk()
      }, okButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, okButtonProps == null ? void 0 : okButtonProps.style), style2)
      }), okText || "OK"));
    }
    return /* @__PURE__ */ react.createElement("div", {
      className: footerCls
    }, footer);
  };
  const modalCls = (0,utils_es/* mergeCls */.c8)("teko-modal", visible ? "teko-modal-show" : "", rest.className || "");
  const modalTitleCls = (0,utils_es/* mergeCls */.c8)("teko-modal-title", centeredTitle ? "teko-modal-title-centered" : "");
  if (typeof (rest == null ? void 0 : rest.show) !== "undefined") {
    const oldModalProps = __spreadProps(Modal_es_spreadValues({}, rest), {
      children,
      width
    });
    return /* @__PURE__ */ react.createElement(Modal, Modal_es_spreadValues({}, oldModalProps));
  }
  return /* @__PURE__ */ react.createElement(Overlay_es/* Overlay */.a, {
    show: !!visible,
    onEscPressed: onCloseModal,
    id: `teko-modal-${(0,utils_es/* uid */.hQ)()}`
  }, /* @__PURE__ */ react.createElement(Modal_es_Backdrop, {
    onClick: onCloseModal
  }), transitions((styles, item) => item && /* @__PURE__ */ react.createElement(AnimatedModal, Modal_es_spreadValues({
    className: modalCls,
    style: Modal_es_spreadValues(Modal_es_spreadValues(Modal_es_spreadValues({}, styles), !!width ? { width } : {}), style)
  }, rest), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-content",
    style: Modal_es_spreadValues({}, contentStyle),
    onClick: (e) => e.stopPropagation()
  }, showCloseIcon && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-modal-close",
    size: 24,
    color: "#000000",
    onClick: onCloseModal
  }), title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(index_es/* Title */.Dx, {
    level: 1,
    className: modalTitleCls
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: modalTitleCls
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-body"
  }, children, renderFooter())))));
};
const Modal_es_Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const StyledModal = emotion_styled_browser_esm["default"].div`
  width: ${({ size }) => modalSizes[size || "m"]};
  max-width: 95%;
  &.teko-modal-show {
    opacity: 1 !important;
    pointer-events: visible;
  }

  &.teko-modal-show .teko-modal-content {
    transform: translateY(0);
    z-index: 1050;
  }

  .teko-modal-content {
    padding: 24px;
    transition: all 0.2s ease-in-out;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
      0px 8px 16px rgba(0, 0, 0, 0.05);
    position: relative;
    border-radius: 8px;
    position: relative;

    .teko-modal-close {
      position: absolute;
      z-index: 1000;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }

    .teko-modal-header {
      .teko-modal-title {
        margin-bottom: 24px;
        color: #1b1d29;
        &.teko-modal-title-centered {
          text-align: center;
        }
      }
    }

    .teko-modal-body {
      font-size: 13px;
      line-height: 20px;
      word-wrap: break-word;
    }

    .teko-modal-footer {
      margin-top: 24px;
      &.teko-modal-footer-right {
        display: flex;
        justify-content: flex-end;
      }
      &.teko-modal-footer-left {
        display: flex;
        justify-content: flex-start;
      }
      &.teko-modal-footer-center {
        display: flex;
        justify-content: center;
      }
    }
  }
`;
const AnimatedModal = (0,react_spring_esm.animated)(StyledModal);
AnimatedModal.defaultProps = {
  size: "m"
};
const modalSizes = {
  xs: "320px",
  s: "420px",
  m: "520px",
  l: "720px"
};




/***/ }),

/***/ 60049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 45838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26759);



const Overlay = ({
  show,
  children,
  parent,
  onEscPressed,
  id
}) => {
  const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    if (id)
      elm.id = id;
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1051";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    parentElement == null ? void 0 : parentElement.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      parentElement == null ? void 0 : parentElement.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef.current);
};




/***/ }),

/***/ 40062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ModalProvider; },
/* harmony export */   "s": function() { return /* binding */ ModalStateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _Modal_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48441);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96098);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initialState = { showModal: () => "" };
const ModalStateContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const ModalProvider = ({
  children
}) => {
  const [configModals, setConfigModals] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const showModal = (options) => {
    const _a = options, { onCancel: baseOnCancel, onOk: baseOnOk } = _a, rest = __objRest(_a, ["onCancel", "onOk"]);
    const modalId = (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_1__/* .uid */ .hQ)();
    const onClose = () => {
      setConfigModals((prev) => {
        const newConfigs = prev.map((m) => {
          if (m.modalId === modalId)
            return __spreadProps(__spreadValues({}, m), { visible: false });
          return m;
        });
        if (newConfigs.every((m) => !m.visible))
          return [];
        return newConfigs;
      });
    };
    const onCancel = () => {
      baseOnCancel == null ? void 0 : baseOnCancel();
      onClose();
    };
    const onOk = async () => {
      await (baseOnOk == null ? void 0 : baseOnOk());
      onClose();
    };
    setConfigModals((prev) => [
      ...prev,
      __spreadValues({
        modalId,
        visible: true,
        onClose,
        onCancel,
        onOk
      }, rest)
    ]);
    return modalId;
  };
  const closeAllModals = () => {
    setConfigModals([]);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalStateContext.Provider, {
    value: {
      showModal,
      closeAllModals
    }
  }, children, configModals.map((modal) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Modal_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, __spreadValues({
    key: modal.modalId
  }, modal))));
};




/***/ }),

/***/ 98992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40062);



function useModal() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ModalStateContext */ .s);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}




/***/ }),

/***/ 8178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Ripple; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26854);





const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
  const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
  useIsomorphicLayoutEffect(() => {
    let bounce;
    if (rippleCount > 0) {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanUpFunction();
        clearTimeout(bounce);
      }, duration * 4);
    }
    return () => clearTimeout(bounce);
  }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({
  duration = 600,
  color = "rgba(255,255,255,0.6)"
}) => {
  const [rippleArray, setRippleArray] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
    setRippleArray([]);
  });
  const addRipple = (event) => {
    const rippleContainer = event.currentTarget.getBoundingClientRect();
    const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
    const x = event.clientX - rippleContainer.x - size / 2;
    const y = event.clientY - rippleContainer.y - size / 2;
    const newRipple = {
      x,
      y,
      size
    };
    setRippleArray([...rippleArray, newRipple]);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    onMouseDown: addRipple
  }, rippleArray.map((ripple, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      key: "span" + index,
      style: {
        top: ripple.y,
        left: ripple.x,
        width: ripple.size,
        height: ripple.size,
        backgroundColor: color,
        animationDuration: `${duration}ms`
      }
    });
  }));
};




/***/ }),

/***/ 88123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Shape; }
/* harmony export */ });
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21483);



const Shape = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .CommonStyles */ .F};
`;




/***/ }),

/***/ 1808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hX": function() { return /* binding */ ToastContextDesktop; },
  "QI": function() { return /* binding */ ToastProviderDesktop; }
});

// UNUSED EXPORTS: toastPlacement

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(55878);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/SuccessColored.es.js
var SuccessColored_es = __webpack_require__(18370);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(69967);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(23259);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(10232);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Toast/desktop/Toast.es.js





const toastIcon = {
  success: /* @__PURE__ */ react.createElement(SuccessColored_es/* SuccessColored */.K, {
    size: 30
  }),
  info: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  warning: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  error: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, {
    size: 30
  })
};
const Toast = ({
  type,
  title,
  message,
  onClose,
  duration = 5e3,
  closeable = true,
  icon
}) => {
  (0,react.useEffect)(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  return /* @__PURE__ */ react.createElement(StyledToast, null, closeable && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-toast-close",
    size: 24,
    color: "#000000",
    onClick: onClose
  }), /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-content"
  }, (icon || type) && /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ react.createElement("div", null, title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 2,
    className: "teko-toast-title"
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-title"
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-message"
  }, message))));
};
const StyledToast = emotion_styled_browser_esm["default"].div`
  width: 384px;
  max-width: calc(100vw - 24px * 2);
  position: relative;
  .teko-toast-icon {
    margin-right: 20px;
  }
  .teko-toast-close {
    position: absolute;
    z-index: 1000;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
  .teko-toast-content {
    position: relative;
    display: flex;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
    background: white;
    & .teko-toast-header {
      margin-right: 16px;
    }
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(96098);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Toast/desktop/context.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextDesktop = react.createContext({});
const toastPlacement = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight"
];
const ToastProviderDesktop = ({
  children
}) => {
  const [toastPlacementState, setToastPlacementState] = (0,react.useState)({
    topLeft: [],
    topRight: [],
    bottomLeft: [],
    bottomRight: []
  });
  const transitionConfig = { tension: 125, friction: 20, precision: 0.1 };
  const toastTransitions = {
    topRight: (0,react_spring_esm.useTransition)(toastPlacementState.topRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomRight: (0,react_spring_esm.useTransition)(toastPlacementState.bottomRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    }),
    topLeft: (0,react_spring_esm.useTransition)(toastPlacementState.topLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomLeft: (0,react_spring_esm.useTransition)(toastPlacementState.bottomLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    })
  };
  const open = (props) => {
    const toastPlacement2 = props.placement || "topRight";
    if (toastPlacement2 === "topLeft" || toastPlacement2 === "topRight") {
      setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
        [toastPlacement2]: [...state[toastPlacement2], __spreadProps(__spreadValues({}, props), { id: (0,utils_es/* uid */.hQ)() })]
      }));
      return;
    }
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [toastPlacement2]: [__spreadProps(__spreadValues({}, props), { id: (0,utils_es/* uid */.hQ)() }), ...state[toastPlacement2]]
    }));
  };
  const onClose = (placement, item) => {
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [placement]: state[placement].filter((e) => e.id !== item.id)
    }));
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  return /* @__PURE__ */ react.createElement(ToastContextDesktop.Provider, {
    value: toast
  }, children, toastPlacement.map((place) => {
    var _a;
    if (!((_a = toastPlacementState[place]) == null ? void 0 : _a.length))
      return;
    const placementCls = `teko-toast teko-toast-${place}`;
    return /* @__PURE__ */ react.createElement(ToastPositionGroup, {
      key: place,
      className: placementCls
    }, toastTransitions[place]((style, item) => {
      return /* @__PURE__ */ react.createElement(AnimatedDiv, {
        key: item.id,
        style
      }, /* @__PURE__ */ react.createElement(Toast, __spreadProps(__spreadValues({}, item), {
        onClose: () => onClose(place, item)
      })));
    }));
  }));
};
const ToastPositionGroup = emotion_styled_browser_esm["default"].div`
  &.teko-toast {
    position: fixed;
    z-index: 1070;
    &.teko-toast-topRight {
      right: 24px;
      top: 24px;
    }
    &.teko-toast-topLeft {
      left: 24px;
      top: 24px;
    }
    &.teko-toast-bottomLeft {
      left: 24px;
      bottom: 24px;
    }
    &.teko-toast-bottomRight {
      right: 24px;
      bottom: 24px;
    }
  }
`;
const AnimatedDiv = (0,emotion_styled_browser_esm["default"])(react_spring_esm.animated.div)`
  margin-bottom: 16px;
`;




/***/ }),

/***/ 89635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ ToastContextMobile; },
  "E": function() { return /* binding */ ToastProviderMobile; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/SuccessColored.es.js
var SuccessColored_es = __webpack_require__(18370);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(69967);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(23259);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Toast/mobile/Toast.es.js




const toastIcon = {
  success: /* @__PURE__ */ react.createElement(SuccessColored_es/* SuccessColored */.K, {
    size: 30
  }),
  info: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  warning: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  error: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, {
    size: 30
  })
};
const Toast = ({
  message,
  icon,
  placement = "middle",
  type,
  duration = 5e3,
  onClose
}) => {
  (0,react.useEffect)(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  const positionClass = `teko-mobile-toast teko-mobile-toast-${placement}`;
  return /* @__PURE__ */ react.createElement(StyledToast, {
    className: positionClass
  }, (icon || type) && /* @__PURE__ */ react.createElement("div", {
    className: "teko-mobile-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ react.createElement("div", {
    className: "teko-mobile-toast-message"
  }, message));
};
const StyledToast = emotion_styled_browser_esm["default"].div`
  &.teko-mobile-toast {
    display: flex;
    z-index: 1070;
    position: fixed;
    left: 50%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 70%;
    padding: 8px 16px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-break: break-word;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    transform: translate3d(-50%, -50%, 0);
    &.teko-mobile-toast-top {
      top: 20%;
    }
    &.teko-mobile-toast-middle {
      top: 50%;
    }
    &.teko-mobile-toast-bottom {
      top: 80%;
    }
    .teko-mobile-toast-icon {
      margin-bottom: 4px;
    }
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(55878);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Toast/mobile/context.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextMobile = react.createContext({});
const ToastProviderMobile = ({
  children
}) => {
  const [toastProps, setToastProps] = (0,react.useState)(null);
  const open = (props) => {
    if (toastProps && JSON.stringify(toastProps) === JSON.stringify(props)) {
      return;
    }
    setToastProps(props);
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  const onClose = () => setToastProps(null);
  const transitions = (0,react_spring_esm.useTransition)(toastProps, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 125, friction: 20, precision: 0.1 }
  });
  return /* @__PURE__ */ react.createElement(ToastContextMobile.Provider, {
    value: toast
  }, children, toastProps && transitions((style, item) => item && /* @__PURE__ */ react.createElement(react_spring_esm.animated.div, {
    style
  }, /* @__PURE__ */ react.createElement(Toast, __spreadProps(__spreadValues({}, item), {
    onClose
  })))));
};




/***/ }),

/***/ 71323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* binding */ Body; },
  "YS": function() { return /* binding */ Caption; },
  "X6": function() { return /* binding */ Heading; },
  "DK": function() { return /* binding */ SubTitle; },
  "Dx": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/helper.es.js
const TYPOGRAPHY_SIZE = {
  heading: [
    {
      fontSize: "48px",
      lineHeight: "64px",
      fontWeight: "bold"
    },
    {
      fontSize: "40px",
      lineHeight: "56px",
      fontWeight: "medium"
    },
    {
      fontSize: "36px",
      lineHeight: "48px",
      fontWeight: "medium"
    },
    {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: "bold"
    }
  ],
  title: [
    {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "bold"
    },
    {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: "bold"
    },
    {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  subtitle: [
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "medium"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  body: [
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "regular"
    },
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "medium"
    }
  ],
  caption: [
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "regular"
    },
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "medium"
    },
    {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "medium"
    }
  ]
};
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const getTypographySize = (type, level = 1, attr) => {
  const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
  return tagAttrs[attr];
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(25989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTypography = emotion_styled_browser_esm["default"].div`
  margin: 0;
  padding: 0;
  ${index_es/* CommonStyles */.F}
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => (p.weight ? FONT_WEIGHT_MAP[p.weight] : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, "fontWeight")]) || 500};
  text-decoration: ${(p) => p.decoration || "unset"};
  font-size: ${(p) => getTypographySize(p.type, p.level, "fontSize")};
  line-height: ${(p) => getTypographySize(p.type, p.level, "lineHeight")};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || "unset"};
  max-width: ${(p) => p.maxWidth ? `${p.maxWidth}px` : "unset"};
  min-width: ${(p) => p.minWidth ? `${p.minWidth}px` : "unset"};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }` : ""};
  ${(p) => p.textTransform ? `
        text-transform: ${p.textTransform};
      ` : ""}
`;
const Heading = (_a) => {
  var _b = _a, { level = 4 } = _b, props = __objRest(_b, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "heading",
    as: `h${level}`,
    level
  }, props));
};
const Title = (_c) => {
  var _d = _c, { level = 2 } = _d, props = __objRest(_d, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "title",
    level
  }, props));
};
const SubTitle = (_e) => {
  var _f = _e, { level = 4 } = _f, props = __objRest(_f, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "subtitle",
    level
  }, props));
};
const Body = (_g) => {
  var _h = _g, { level = 2 } = _h, props = __objRest(_h, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "body",
    level
  }, props));
};
const Caption = (_i) => {
  var _j = _i, { level = 3 } = _j, props = __objRest(_j, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "caption",
    level
  }, props));
};




/***/ }),

/***/ 36940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ hex2Rgb; }
/* harmony export */ });
const hexCharacters = "a-f\\d";
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, "gi");
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, "i");
function hex2Rgb(hex, options = {}) {
  if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError("Expected a valid hex string");
  }
  hex = hex.replace(/^#/, "");
  let alpha = 1;
  if (hex.length === 8) {
    alpha = Number.parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }
  if (hex.length === 4) {
    alpha = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
    hex = hex.slice(0, 3);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const number = Number.parseInt(hex, 16);
  const red = number >> 16;
  const green = number >> 8 & 255;
  const blue = number & 255;
  if (options.format === "array") {
    return [red, green, blue, alpha];
  }
  if (options.format === "css") {
    const alphaString = alpha === 1 ? "" : ` / ${Number((alpha * 100).toFixed(2))}%`;
    return `rgb(${red} ${green} ${blue}${alphaString})`;
  }
  return { red, green, blue, alpha };
}




/***/ }),

/***/ 88993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ generate; }
});

// EXTERNAL MODULE: ../../.yarn/cache/color-name-npm-1.1.4-025792b0ea-b044585952.zip/node_modules/color-name/index.js
var color_name = __webpack_require__(35410);
var color_name_default = /*#__PURE__*/__webpack_require__.n(color_name);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/regexes/index.es.js
const index_es_float = "-?\\d*(?:\\.\\d+)";
const number = `(${index_es_float}?)`;
const percentage = `(${index_es_float}?%)`;
const numberOrPercentage = `(${index_es_float}?%?)`;
const pattern1 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/;
const hexRe = new RegExp(pattern1, "i");
const pattern2 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl3Re = new RegExp(pattern2);
const pattern3 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl4Re = new RegExp(pattern3);
const pattern4 = `^
  rgba?\\(
    \\s*${number}\\s*,
    \\s*${number}\\s*,
    \\s*${number}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3NumberRe = new RegExp(pattern4);
const pattern5 = `^
  rgba?\\(
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3PercentageRe = new RegExp(pattern5);
const pattern6 = `^
  rgba?\\(
    \\s*${number}
    \\s+${number}
    \\s+${number}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4NumberRe = new RegExp(pattern6);
const pattern7 = `^
  rgba?\\(
    \\s*${percentage}
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4PercentageRe = new RegExp(pattern7);
const pattern8 = /^transparent$/;
const transparentRe = new RegExp(pattern8, "i");



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/utils/hex-rgb.es.js
var hex_rgb_es = __webpack_require__(36940);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/utils/index.es.js


const clamp = (num, min, max) => Math.min(Math.max(min, num), max);
const parseRGB = (num) => {
  let n = num;
  if (typeof n !== "number")
    n = n.endsWith("%") ? parseFloat(n) * 255 / 100 : parseFloat(n);
  return clamp(Math.round(n), 0, 255);
};
const parsePercentage = (percentage) => clamp(parseFloat(percentage), 0, 100);
function parseAlpha(alpha) {
  let a = alpha;
  if (typeof a !== "number")
    a = a.endsWith("%") ? parseFloat(a) / 100 : parseFloat(a);
  return clamp(a, 0, 1);
}
function getHEX(hex) {
  const [r, g, b, a] = (0,hex_rgb_es/* hex2Rgb */.r)(hex, { format: "array" });
  return getRGB([null, r, g, b, a]);
}
function getHSL([, h, s, l, a = 1]) {
  let hh = h;
  if (hh.endsWith("turn")) {
    hh = parseFloat(hh) * 360 / 1;
  } else if (hh.endsWith("rad")) {
    hh = Math.round(parseFloat(hh) * 180 / Math.PI);
  } else {
    hh = parseFloat(hh);
  }
  return {
    type: "hsl",
    values: [hh, parsePercentage(s), parsePercentage(l)],
    alpha: parseAlpha(a === null ? 1 : a)
  };
}
function getRGB([, r, g, b, a = 1]) {
  return {
    type: "rgb",
    values: [r, g, b].map(parseRGB),
    alpha: parseAlpha(a === null ? 1 : a)
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/index.es.js




const parseCSSColor = (str) => {
  if (typeof str !== "string")
    return null;
  const hex = hexRe.exec(str);
  if (hex)
    return getHEX(hex[0]);
  const hsl = hsl4Re.exec(str) || hsl3Re.exec(str);
  if (hsl)
    return getHSL(hsl);
  const rgb = rgb4NumberRe.exec(str) || rgb4PercentageRe.exec(str) || rgb3NumberRe.exec(str) || rgb3PercentageRe.exec(str);
  if (rgb)
    return getRGB(rgb);
  if (transparentRe.exec(str))
    return getRGB([null, 0, 0, 0, 0]);
  const cn = (color_name_default())[str.toLowerCase()];
  if (cn)
    return getRGB([null, cn[0], cn[1], cn[2], 1]);
  return null;
};
var parse = parseCSSColor;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/pure-color/index.es.js
function index_es_clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
function hsl2rgb(hsl) {
  const h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100;
  let t2, t3, val;
  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  const t1 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;
    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;
    rgb[i] = val * 255;
  }
  return rgb;
}
function componentToHex(c) {
  const value = Math.round(index_es_clamp(c, 0, 255));
  const hex = value.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgb2hex(rgb) {
  const alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
}
function rgb2hsl(rgb) {
  const r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min;
  let h, s;
  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;
  h = Math.min((h || 0) * 60, 360);
  if (h < 0)
    h += 360;
  const l = (min + max) / 2;
  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);
  return [h, s * 100, l * 100];
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/mix-css-color/index.es.js



function parseColor(color) {
  const res = parse(color);
  if (res === null)
    return null;
  if (res.type === "hsl")
    res.values = hsl2rgb(res.values);
  return res;
}
function mix(color1, color2, percentage = 50) {
  const c1 = parseColor(color1);
  const c2 = parseColor(color2);
  if (!c1 || !c2)
    return null;
  const p = Math.min(Math.max(0, percentage), 100) / 100;
  const w = p * 2 - 1;
  const a = c1.alpha - c2.alpha;
  const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
  const w2 = 1 - w1;
  const [r, g, b] = c1.values.map((c, i) => Math.round(c1.values[i] * w1 + c2.values[i] * w2));
  const alpha = parseFloat((c1.alpha * p + c2.alpha * (1 - p)).toFixed(8));
  return {
    hex: rgb2hex([r, g, b]),
    hexa: rgb2hex([r, g, b, alpha]),
    rgba: [r, g, b, alpha],
    hsla: [...rgb2hsl([r, g, b]).map(Math.round), alpha]
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/core/index.es.js




const defaultNumberParam = (v, d) => v === null || isNaN(v) || typeof v === "string" ? d : v;
class ColorCore {
  constructor(color = "#000", type = "base", weight = 0) {
    [this.rgb, this.alpha, this.type, this.weight] = [
      [0, 0, 0],
      1,
      type,
      weight
    ];
    const c = color === null ? "#000" : color;
    if (typeof c !== "string")
      throw new TypeError(`Input should be a string: ${c}`);
    const parsed = parse(c);
    if (!parsed)
      throw new Error(`Unable to parse color from string: ${c}`);
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  get hex() {
    return this.hexString().replace(/^#/, "");
  }
  setColor(color) {
    const parsed = parse(color);
    if (!parsed)
      return null;
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  tint(weight, w = defaultNumberParam(weight, 50)) {
    var _a;
    return new ColorCore(`rgb(${(_a = mix("#fff", this.rgbString(), w)) == null ? void 0 : _a.rgba})`, "tint", w);
  }
  shade(weight, w = defaultNumberParam(weight, 50)) {
    var _a;
    return new ColorCore(`rgb(${(_a = mix("#000", this.rgbString(), w)) == null ? void 0 : _a.rgba})`, "shade", w);
  }
  tints(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.tint((i + 1) * w));
  }
  shades(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.shade((i + 1) * w));
  }
  all(weight = 10) {
    return [
      ...this.tints(weight).reverse(),
      Object.assign(this),
      ...this.shades(weight)
    ];
  }
  hexString() {
    return rgb2hex(this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]);
  }
  rgbString() {
    const channels = (this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]).join(", ");
    return `${this.alpha >= 1 ? "rgb" : "rgba"}(${channels})`;
  }
  getBrightness() {
    return Math.round(this.rgb.reduce((a, b) => a + b) / (255 * 3) * 100);
  }
  _setFromRGB([r, g, b, a]) {
    [this.rgb, this.alpha] = [[r, g, b], a];
    return this;
  }
  _setFromHSL([h, s, l, a]) {
    [this.rgb, this.alpha] = [hsl2rgb([h, s, l]).map(Math.round), a];
    return this;
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/configs/Colors/generate.es.js


const DEFAULT_WEIGHT = 5;
const valueOptions = {
  50: 1,
  100: 2,
  200: 4,
  500: 20,
  600: 22,
  700: 24
};
function generate(color, type) {
  const patterns = { [type]: color };
  const pColors = new ColorCore(color).all(DEFAULT_WEIGHT);
  Object.keys(valueOptions).forEach((key) => {
    patterns[`${type}${key}`] = pColors[valueOptions[key]].hexString();
  });
  return patterns;
}




/***/ }),

/***/ 70521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ themeColor; }
/* harmony export */ });
/* harmony import */ var _generate_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88993);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const functionalColors = {
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343"
};
const defaultColors = {
  white: "#FFFFFF",
  tableHeader: "#F8F8FC",
  background: "#F3F3F7",
  divider: "#E4E5F0",
  inputBorder: "#e0e0e0",
  disable: "#DCDEE9",
  border: "#BCBFD6",
  placeholder: "#A7ABC3",
  textSecondary: "#82869E",
  textPrimary: "#434657",
  textTitle: "#1B1D29",
  black: "#000000",
  neutral: "#848788",
  text: "#434657",
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343"
};
let presetPalettes = {};
Object.keys(functionalColors).forEach((key) => {
  presetPalettes = __spreadValues(__spreadValues({}, presetPalettes), (0,_generate_es_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(functionalColors[key], key));
});
const themeColor = __spreadValues(__spreadValues({}, defaultColors), presetPalettes);




/***/ }),

/***/ 46053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getRgbaFromHex; }
/* harmony export */ });
/* harmony import */ var _core_parse_css_color_utils_hex_rgb_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36940);


function getRgbaFromHex(hex, alpha = 1) {
  const rgb = (0,_core_parse_css_color_utils_hex_rgb_es_js__WEBPACK_IMPORTED_MODULE_0__/* .hex2Rgb */ .r)(hex);
  if (!rgb) {
    return null;
  }
  return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
}




/***/ }),

/***/ 52905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1902);
/* harmony import */ var _Colors_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70521);
/* harmony import */ var _Colors_util_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46053);




const getBoxShadow = (props, shadow, shadowColor = "black") => {
  var _a, _b, _c;
  const css = ((_a = props.theme) == null ? void 0 : _a.shadowValue[shadow]) || "none";
  return css.replace(/{{color}}/gi, (0,_Colors_util_es_js__WEBPACK_IMPORTED_MODULE_0__/* .getRgbaFromHex */ .p)(((_b = props.theme) == null ? void 0 : _b.colors[shadowColor]) || "", (_c = props.theme) == null ? void 0 : _c.shadowAlphaValue[shadow]) || "");
};
const defaultTheme = {
  colors: _Colors_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .themeColor */ .E,
  borderRadius: {
    s: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s4 */ .y.s4,
    m: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s8 */ .y.s8,
    l: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s12 */ .y.s12,
    xl: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s16 */ .y.s16
  },
  borderWeight: {
    s: "0.5px",
    m: "1px",
    l: "1.5px"
  },
  opacity: {
    s: 0,
    m: 0.3,
    l: 0.5,
    xl: 0.7
  },
  shadowValue: {
    "down-xs": "0 2px 2px {{color}}",
    "down-s": "0 2px 4px {{color}}",
    "down-m": "0 4px 8px {{color}}",
    "down-l": "0 4px 16px {{color}}, 0 8px 16px {{color}}",
    "up-s": "0 -2px 4px {{color}}",
    "up-m": "0 -4px 8px {{color}}",
    "up-l": "0px -4px 16px {{color}}, 0px -8px 16px {{color}};"
  },
  shadowAlphaValue: {
    "down-xs": 0.1,
    "down-s": 0.075,
    "down-m": 0.05,
    "down-l": 0.05,
    "up-s": 0.075,
    "up-m": 0.05,
    "up-l": 0.05
  },
  spacing: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE */ .y,
  shadow: getBoxShadow
};




/***/ }),

/***/ 1902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MAPPING_SIZE; },
/* harmony export */   "y": function() { return /* binding */ CORE_SIZE; }
/* harmony export */ });
const CORE_SIZE = {
  s0: "0rem",
  s4: "0.25rem",
  s8: "0.5rem",
  s12: "0.75rem",
  s16: "1rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s44: "2.75rem",
  s48: "3rem",
  s52: "3.25rem",
  s56: "3.5rem",
  s60: "3.75rem",
  s64: "4rem",
  s68: "4.25rem",
  s72: "4.5rem",
  s76: "4.75rem",
  s80: "5rem"
};
const MAPPING_SIZE = {
  s: 32,
  m: 40,
  l: 48,
  xl: 56
};




/***/ }),

/***/ 34363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SizeContext; },
/* harmony export */   "q": function() { return /* binding */ SizeContextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const SizeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0);
const SizeContextProvider = ({
  children,
  size
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Consumer, null, (originSize) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Provider, {
  value: size || originSize
}, children));




/***/ }),

/***/ 1688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93387);
/* harmony import */ var _components_Modal_context_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40062);
/* harmony import */ var _components_Toast_desktop_context_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1808);
/* harmony import */ var _components_Toast_mobile_context_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89635);
/* harmony import */ var _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52905);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ThemeProvider = (_a) => {
  var _b = _a, {
    children,
    theme = _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultTheme */ .u,
    customTheme
  } = _b, rest = __objRest(_b, [
    "children",
    "theme",
    "customTheme"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__.a, __spreadValues({
    theme: __spreadValues(__spreadValues({}, theme), customTheme)
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Modal_context_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ModalProvider */ .D, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Toast_desktop_context_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ToastProviderDesktop */ .QI, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Toast_mobile_context_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ToastProviderMobile */ .E, null, children))));
};
function useTheme() {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return theme;
}




/***/ }),

/***/ 96098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": function() { return /* binding */ isNotNullOrUndefinedElement; },
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "I0": function() { return /* binding */ generateTheme; },
/* harmony export */   "O8": function() { return /* binding */ useClickOutside; },
/* harmony export */   "c8": function() { return /* binding */ mergeCls; },
/* harmony export */   "hQ": function() { return /* binding */ uid; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "oJ": function() { return /* binding */ pixelParse; },
/* harmony export */   "pW": function() { return /* binding */ getElementOffset; },
/* harmony export */   "qo": function() { return /* binding */ toArray; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88993);
/* harmony import */ var _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70521);
/* harmony import */ var _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52905);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const formatDateTime = (date, type) => {
  const dateStr = date.toLocaleDateString("en-GB");
  const timeStr = date.toLocaleTimeString("vi-VN").slice(0, 5);
  switch (type) {
    case "date":
      return dateStr;
    case "time":
      return timeStr;
    default:
      return `${dateStr} ${timeStr}`;
  }
};
const useClickOutside = (ref, handler) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const listener = (event) => {
      const refs = Array.isArray(ref) ? ref : [ref];
      if (!refs.some((ref2) => ref2.current) || refs.some((e) => {
        var _a;
        return (_a = e.current) == null ? void 0 : _a.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    document.addEventListener("click", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};
const generateTheme = (baseColor) => {
  return __spreadProps(__spreadValues({}, _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultTheme */ .u), {
    colors: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor */ .E), (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.primary, "primary")), (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.secondary, "secondary")), baseColor.link && (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.link, "link"))
  });
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const getScrollbarWidth = () => {
  var _a;
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    (_a = outer.parentNode) == null ? void 0 : _a.removeChild(outer);
  }
  return width;
};
const toArray = (candidate) => {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
  const clone = __spreadValues({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach((key) => {
      delete clone[key];
    });
  }
  return clone;
};
const mergeCls = (...cls) => {
  return cls.filter(Boolean).join(" ");
};
const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const isNotNullOrUndefinedElement = (val) => !!val;




/***/ }),

/***/ 4769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CommonStyles; }
/* harmony export */ });
/* unused harmony export getDimension */
const getDimension = (value, prefix = "", suffix = "") => {
  if (!value)
    return "";
  return prefix + (typeof value === "number" ? `${value}px` : value) + suffix;
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getSpacing = (props) => {
  const dimension = [
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft"
  ];
  return dimension.reduce((prev, curr) => {
    var _a;
    const currentProp = props[curr];
    if (currentProp) {
      if (typeof currentProp === "string") {
        return `${prev}
${jsToCss(curr)}: ${(_a = props.theme) == null ? void 0 : _a.spacing[currentProp]};`;
      }
      return `${prev}
${jsToCss(curr)}: ${currentProp.map((c) => {
        var _a2;
        return (_a2 = props.theme) == null ? void 0 : _a2.spacing[c];
      }).join(" ")};`;
    }
    return prev;
  }, "");
};
const getItemSpacing = (props) => {
  var _a, _b;
  return `
    ${props.itemHorizontalSpacing ? `
      > *:not(:first-of-type) {
        margin-left: ${(_a = props.theme) == null ? void 0 : _a.spacing[props.itemHorizontalSpacing]};
      }
    ` : ""}
    ${props.itemVerticalSpacing ? `
      > *:not(:first-of-type) {
        margin-top: ${(_b = props.theme) == null ? void 0 : _b.spacing[props.itemVerticalSpacing]};
      }
    ` : ""}`;
};
const replaceColor = (value, colors) => {
  const values = value.split(" ").map((i) => colors[i] ? colors[i] : i);
  return values.join(" ");
};
const CommonStyles = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return `
  border-style: ${props.borderStyle ? props.borderStyle : "none"};
  ${!!props.borderRadius && ` border-radius: ${props.borderRadius ? (_a = props.theme) == null ? void 0 : _a.borderRadius[props.borderRadius] : "0px"};`};

  border-width: ${props.borderWeight ? (_b = props.theme) == null ? void 0 : _b.borderWeight[props.borderWeight] : "1px"};
  border-color: ${props.borderColor ? (_c = props.theme) == null ? void 0 : _c.colors[props.borderColor] : "unset"};
  ${props.border ? `border: ${replaceColor(props.border, ((_d = props.theme) == null ? void 0 : _d.colors) || {})};` : ""};
  ${props.borderTop ? `border-top: ${replaceColor(props.borderTop, ((_e = props.theme) == null ? void 0 : _e.colors) || {})};` : ""};
  ${props.borderRight ? `border-right: ${replaceColor(props.borderRight, ((_f = props.theme) == null ? void 0 : _f.colors) || {})};` : ""};
  ${props.borderBottom ? `border-bottom: ${replaceColor(props.borderBottom, ((_g = props.theme) == null ? void 0 : _g.colors) || {})};` : ""};
  ${props.borderLeft ? `border-left: ${replaceColor(props.borderLeft, ((_h = props.theme) == null ? void 0 : _h.colors) || {})};` : ""};
  opacity: ${props.opacity ? (_i = props.theme) == null ? void 0 : _i.opacity[props.opacity] : 1};
  box-shadow: ${(p) => {
    var _a2;
    return (_a2 = p.theme) == null ? void 0 : _a2.shadow(p, props.shadow || "", props.shadowColor);
  }};
  ${props.backgroundColor && `background-color: ${((_j = props.theme) == null ? void 0 : _j.colors[props.backgroundColor]) || props.backgroundColor};
  `};
  ${getDimension(props.width || "", "width: ", ";")}
  ${getDimension(props.maxWidth || "", "max-width: ", ";")}
  ${getDimension(props.height || "", "height: ", ";")}
  ${getDimension(props.maxHeight || "", "max-height: ", ";")}
  ${getSpacing(props)}
  ${getItemSpacing(props)}

`;
};




/***/ }),

/***/ 40928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(4769);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/helpers/IconBase.es.js
var IconBase_es = __webpack_require__(32600);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(50128);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Button/constant.es.js


const BUTTON_CONFIG = {
  height: {
    xs: constants_index_es/* CORE_SIZE.s24 */.y.s24,
    s: constants_index_es/* CORE_SIZE.s32 */.y.s32,
    m: constants_index_es/* CORE_SIZE.s40 */.y.s40,
    l: constants_index_es/* CORE_SIZE.s48 */.y.s48
  },
  textColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textPrimary",
    link: "link500",
    "white-ghost": "primary500"
  },
  iconColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textSecondary",
    link: "link500",
    "white-ghost": "primary500"
  },
  disabled: {
    textColor: {
      primary: "placeholder",
      secondary: "placeholder",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    },
    iconColor: {
      primary: "border",
      secondary: "border",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    }
  }
};



// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(85212);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(12450);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(13980);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-cache-npm-11.5.0-713285e054-8b3fac281e.zip/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(26854);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Ripple/Ripple.es.js





const Wrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
  const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
  useIsomorphicLayoutEffect(() => {
    let bounce;
    if (rippleCount > 0) {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanUpFunction();
        clearTimeout(bounce);
      }, duration * 4);
    }
    return () => clearTimeout(bounce);
  }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({
  duration = 600,
  color = "rgba(255,255,255,0.6)"
}) => {
  const [rippleArray, setRippleArray] = (0,react.useState)([]);
  useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
    setRippleArray([]);
  });
  const addRipple = (event) => {
    const rippleContainer = event.currentTarget.getBoundingClientRect();
    const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
    const x = event.clientX - rippleContainer.x - size / 2;
    const y = event.clientY - rippleContainer.y - size / 2;
    const newRipple = {
      x,
      y,
      size
    };
    setRippleArray([...rippleArray, newRipple]);
  };
  return /* @__PURE__ */ react.createElement(Wrapper, {
    onMouseDown: addRipple
  }, rippleArray.map((ripple, index) => {
    return /* @__PURE__ */ react.createElement("span", {
      key: "span" + index,
      style: {
        top: ripple.y,
        left: ripple.x,
        width: ripple.size,
        height: ripple.size,
        backgroundColor: color,
        animationDuration: `${duration}ms`
      }
    });
  }));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Button/Button.es.js











var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonStyleByVariant = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  switch (props.variant) {
    case "default": {
      return emotion_react_browser_esm.css`
        background-color: transparent;
        border: 1px solid
          ${props.disabled ? (_a = props.theme) == null ? void 0 : _a.colors.disable : (_b = props.theme) == null ? void 0 : _b.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_c = props.theme) == null ? void 0 : _c.colors.textSecondary};
        }
        &:active {
          border-color: ${(_d = props.theme) == null ? void 0 : _d.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_e = props.theme) == null ? void 0 : _e.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_f = props.theme) == null ? void 0 : _f.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
        border: 1px solid
          ${props.disabled ? (_h = props.theme) == null ? void 0 : _h.colors.disable : (_i = props.theme) == null ? void 0 : _i.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_j = props.theme) == null ? void 0 : _j.colors.textSecondary};
        }
        &:active {
          border-color: ${(_k = props.theme) == null ? void 0 : _k.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_l = props.theme) == null ? void 0 : _l.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_m = props.theme) == null ? void 0 : _m.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "secondary": {
      return emotion_react_browser_esm.css`
        background-color: ${(_n = props.theme) == null ? void 0 : _n.colors.white};
        border: 1px solid
          ${props.disabled ? (_o = props.theme) == null ? void 0 : _o.colors.disable : (_p = props.theme) == null ? void 0 : _p.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            border-color: ${(_q = props.theme) == null ? void 0 : _q.colors.primary600};
            div[type=body] {
              color: ${(_r = props.theme) == null ? void 0 : _r.colors.primary600};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_s = props.theme) == null ? void 0 : _s.colors.primary600};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_t = props.theme) == null ? void 0 : _t.colors.primary600};
            }
          }
          &:active {
            border-color: ${(_u = props.theme) == null ? void 0 : _u.colors.primary700};
            div[type=body] {
              color: ${(_v = props.theme) == null ? void 0 : _v.colors.primary700};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_w = props.theme) == null ? void 0 : _w.colors.primary700};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_x = props.theme) == null ? void 0 : _x.colors.primary700};
            }
          }
        ` : ""}
      `;
    }
    case "white-ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_y = props.theme) == null ? void 0 : _y.colors.white};
        border: none;
        ${props.disabled ? `
          background-color: ${(_z = props.theme) == null ? void 0 : _z.colors.disable};
          ` : `
          &:hover {
            background-color: ${(_A = props.theme) == null ? void 0 : _A.colors.tableHeader};
          }
          &:active {
            background-color: ${(_B = props.theme) == null ? void 0 : _B.colors.background};
          }
        `}
      `;
    }
    case "primary":
    default:
      return emotion_react_browser_esm.css`
        background-color: ${props.disabled ? (_C = props.theme) == null ? void 0 : _C.colors.disable : (_D = props.theme) == null ? void 0 : _D.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            background-color: ${(_E = props.theme) == null ? void 0 : _E.colors.primary600};
          }
          &:active {
            background-color: ${(_F = props.theme) == null ? void 0 : _F.colors.primary700};
          }
        ` : ""}
      `;
  }
};
const buttonShapeStyle = ({ theme, shape, size }) => {
  switch (shape) {
    case ds_index_es/* ButtonShapeEnum.round */.Vz.round:
      return emotion_react_browser_esm.css`
        border-radius: ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem
          ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem;
      `;
    case ds_index_es/* ButtonShapeEnum.circle */.Vz.circle:
      return emotion_react_browser_esm.css`
        border-radius: 50%;
      `;
    default:
      return emotion_react_browser_esm.css`
        border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
      `;
  }
};
const Button = (_a) => {
  var _b = _a, {
    children,
    block = false,
    shape,
    size: customizeSize,
    variant = "default",
    prefix,
    suffix,
    disabled,
    onClick,
    className,
    href,
    type = "button",
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "shape",
    "size",
    "variant",
    "prefix",
    "suffix",
    "disabled",
    "onClick",
    "className",
    "href",
    "type",
    "backgroundColor"
  ]);
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  if (variant === "link") {
    return /* @__PURE__ */ react.createElement(StyledLink, __spreadValues({
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className,
      itemHorizontalSpacing: "s4",
      color: disabled ? BUTTON_CONFIG.disabled.iconColor.link : BUTTON_CONFIG.iconColor.link,
      onClick: handleClick,
      disabled: !!disabled
    }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? mergeSize === "m" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0);
  }
  return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
    height: BUTTON_CONFIG.height[mergeSize],
    padding: shape !== "circle" ? ["s0", "s20"] : void 0,
    itemHorizontalSpacing: "s8",
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.iconColor[variant] : BUTTON_CONFIG.iconColor[variant],
    backgroundColor,
    variant,
    disabled: !!disabled,
    block,
    shape,
    size: mergeSize,
    onClick: handleClick,
    className,
    type
  }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    className: "button-text",
    level: mergeSize === "s" ? 2 : 1,
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.textColor[variant] : BUTTON_CONFIG.textColor[variant]
  }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0, /* @__PURE__ */ react.createElement("span", {
    style: { marginLeft: 0 }
  }, /* @__PURE__ */ react.createElement(Ripple, null)));
};
const Spacer = emotion_styled_browser_esm["default"].span`
  width: 0.5rem;
`;
const StyledButton = emotion_styled_browser_esm["default"].button(({
  height,
  theme,
  color,
  block,
  disabled,
  backgroundColor
}) => [
  index_es/* CommonStyles */.F,
  IconBase_es/* SvgCss */.uL,
  buttonShapeStyle,
  buttonStyleByVariant,
  `position: relative;
display: flex;
align-items: center;
justify-content: center;
outline: none;
min-width: ${height};
${color ? `color: ${(theme == null ? void 0 : theme.colors[color]) || color};` : ""}
${block ? `width: 100%;` : ""}
cursor: ${disabled ? "not-allowed" : "pointer"};
${backgroundColor ? `background-color: ${(theme == null ? void 0 : theme.colors[backgroundColor]) || backgroundColor} !important;` : ""}
transition-duration: 80ms;
transition-property: background-color;
&:focus {
  outline: none;
}
`
]);
const StyledLink = emotion_styled_browser_esm["default"].a`
  ${index_es/* CommonStyles */.F}
  ${IconBase_es/* SvgCss */.uL}
  display: inline;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  ${(p) => {
  var _a;
  return p.color ? `color: ${((_a = p.theme) == null ? void 0 : _a.colors[p.color]) || p.color}!important;` : "";
}}
  text-decoration: none;
  ${(p) => !p.disabled ? `
    &:hover {
      text-decoration: underline;
    }

  div {
    display: inline;
  }
  ` : ""}
`;




/***/ }),

/***/ 12450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* binding */ Body; },
  "YS": function() { return /* binding */ Caption; },
  "DK": function() { return /* binding */ SubTitle; },
  "Dx": function() { return /* binding */ Title; }
});

// UNUSED EXPORTS: Heading

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Typography/helper.es.js
const TYPOGRAPHY_SIZE = {
  heading: [
    {
      fontSize: "48px",
      lineHeight: "64px",
      fontWeight: "bold"
    },
    {
      fontSize: "40px",
      lineHeight: "56px",
      fontWeight: "medium"
    },
    {
      fontSize: "36px",
      lineHeight: "48px",
      fontWeight: "medium"
    },
    {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: "bold"
    }
  ],
  title: [
    {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "bold"
    },
    {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: "bold"
    },
    {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  subtitle: [
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "medium"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  body: [
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "regular"
    },
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "medium"
    }
  ],
  caption: [
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "regular"
    },
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "medium"
    },
    {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "medium"
    }
  ]
};
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const getTypographySize = (type, level = 1, attr) => {
  const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
  return tagAttrs[attr];
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(4769);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-eb68fcb88b/1/packages/ds-foundation/dist/components/Typography/index.es.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTypography = emotion_styled_browser_esm["default"].div`
  margin: 0;
  padding: 0;
  ${index_es/* CommonStyles */.F}
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => (p.weight ? FONT_WEIGHT_MAP[p.weight] : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, "fontWeight")]) || 500};
  text-decoration: ${(p) => p.decoration || "unset"};
  font-size: ${(p) => getTypographySize(p.type, p.level, "fontSize")};
  line-height: ${(p) => getTypographySize(p.type, p.level, "lineHeight")};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || "unset"};
  max-width: ${(p) => p.maxWidth ? `${p.maxWidth}px` : "unset"};
  min-width: ${(p) => p.minWidth ? `${p.minWidth}px` : "unset"};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }` : ""};
  ${(p) => p.textTransform ? `
        text-transform: ${p.textTransform};
      ` : ""}
`;
const Heading = (_a) => {
  var _b = _a, { level = 4 } = _b, props = __objRest(_b, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "heading",
    as: `h${level}`,
    level
  }, props));
};
const Title = (_c) => {
  var _d = _c, { level = 2 } = _d, props = __objRest(_d, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "title",
    level
  }, props));
};
const SubTitle = (_e) => {
  var _f = _e, { level = 4 } = _f, props = __objRest(_f, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "subtitle",
    level
  }, props));
};
const Body = (_g) => {
  var _h = _g, { level = 2 } = _h, props = __objRest(_h, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "body",
    level
  }, props));
};
const Caption = (_i) => {
  var _j = _i, { level = 3 } = _j, props = __objRest(_j, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "caption",
    level
  }, props));
};




/***/ }),

/***/ 50128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MAPPING_SIZE; },
/* harmony export */   "y": function() { return /* binding */ CORE_SIZE; }
/* harmony export */ });
const CORE_SIZE = {
  s0: "0rem",
  s4: "0.25rem",
  s8: "0.5rem",
  s12: "0.75rem",
  s16: "1rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s44: "2.75rem",
  s48: "3rem",
  s52: "3.25rem",
  s56: "3.5rem",
  s60: "3.75rem",
  s64: "4rem",
  s68: "4.25rem",
  s72: "4.5rem",
  s76: "4.75rem",
  s80: "5rem"
};
const MAPPING_SIZE = {
  s: 32,
  m: 40,
  l: 48,
  xl: 56
};




/***/ }),

/***/ 13980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SizeContext; }
/* harmony export */ });
/* unused harmony export SizeContextProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const SizeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0);
const SizeContextProvider = ({
  children,
  size
}) => /* @__PURE__ */ React__default.createElement(SizeContext.Consumer, null, (originSize) => /* @__PURE__ */ React__default.createElement(SizeContext.Provider, {
  value: size || originSize
}, children));




/***/ }),

/***/ 43609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CheckOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const CheckOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 12.4545L9.375 17L19 7",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 10232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ CloseOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const CloseOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.81304 5.75263C6.52015 5.45974 6.04528 5.45974 5.75238 5.75263C5.45949 6.04552 5.45949 6.5204 5.75238 6.81329L10.8789 11.9398L5.75241 17.0663C5.45952 17.3592 5.45952 17.8341 5.75241 18.127C6.0453 18.4199 6.52018 18.4199 6.81307 18.127L11.9396 13.0005L17.0661 18.127C17.359 18.4199 17.8339 18.4199 18.1268 18.127C18.4196 17.8341 18.4196 17.3592 18.1268 17.0663L13.0002 11.9398L18.1268 6.81329C18.4197 6.5204 18.4197 6.04552 18.1268 5.75263C17.8339 5.45974 17.359 5.45974 17.0661 5.75263L11.9396 10.8792L6.81304 5.75263Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 23259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DeleteCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const DeleteCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
          fill: "#DFDFE6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.90045 8.64594C9.60755 8.35305 9.13268 8.35305 8.83979 8.64594C8.54689 8.93883 8.54689 9.41371 8.83979 9.7066L11.0765 11.9433L8.83997 14.1798C8.54707 14.4727 8.54707 14.9476 8.83997 15.2405C9.13286 15.5334 9.60773 15.5334 9.90063 15.2405L12.1371 13.004L14.3737 15.2405C14.6666 15.5334 15.1414 15.5334 15.4343 15.2405C15.7272 14.9476 15.7272 14.4727 15.4343 14.1798L13.1978 11.9433L15.4345 9.7066C15.7274 9.41371 15.7274 8.93883 15.4345 8.64594C15.1416 8.35305 14.6667 8.35305 14.3738 8.64594L12.1371 10.8826L9.90045 8.64594Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 69967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ InforOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const InforOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-jyhw769hz", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V21.5C17.2467 21.5 21.5 17.2467 21.5 12H19.5ZM12 4.5C16.1421 4.5 19.5 7.85786 19.5 12H21.5C21.5 6.75329 17.2467 2.5 12 2.5V4.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5V2.5C6.75329 2.5 2.5 6.75329 2.5 12H4.5ZM12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H2.5C2.5 17.2467 6.75329 21.5 12 21.5V19.5ZM12 23C18.0751 23 23 18.0751 23 12H21C21 16.9706 16.9706 21 12 21V23ZM1 12C1 18.0751 5.92487 23 12 23V21C7.02944 21 3 16.9706 3 12H1ZM12 1C5.92487 1 1 5.92487 1 12H3C3 7.02944 7.02944 3 12 3V1ZM23 12C23 5.92487 18.0751 1 12 1V3C16.9706 3 21 7.02944 21 12H23ZM10.25 16.5454C10.25 17.5119 11.0335 18.2954 12 18.2954V16.2954C12.1381 16.2954 12.25 16.4073 12.25 16.5454H10.25ZM10.25 11.0909V16.5454H12.25V11.0909H10.25ZM12 9.34086C11.0335 9.34086 10.25 10.1244 10.25 11.0909H12.25C12.25 11.2289 12.1381 11.3409 12 11.3409V9.34086ZM13.75 11.0909C13.75 10.1244 12.9665 9.34086 12 9.34086V11.3409C11.8619 11.3409 11.75 11.2289 11.75 11.0909H13.75ZM13.75 16.5454V11.0909H11.75V16.5454H13.75ZM12 18.2954C12.9665 18.2954 13.75 17.5119 13.75 16.5454H11.75C11.75 16.4073 11.8619 16.2954 12 16.2954V18.2954ZM12 5.45459C10.8954 5.45459 10 6.35002 10 7.45459H12V5.45459ZM14 7.45459C14 6.35002 13.1046 5.45459 12 5.45459V7.45459H14ZM12 9.45459C13.1046 9.45459 14 8.55916 14 7.45459H12V9.45459ZM10 7.45459C10 8.55916 10.8954 9.45459 12 9.45459V7.45459H10Z",
          fill: "#82869E",
          mask: "url(#icon-jyhw769hz)"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 69433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MinusOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MinusOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 18370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SuccessColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const SuccessColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "9", fill: "#30CD60" } },
      {
        tag: "path",
        attr: {
          d: "M15.371 9.20702L11.047 13.291L9.15068 11.499C8.85739 11.222 8.38306 11.222 8.08977 11.499C7.79755 11.775 7.79755 12.223 8.08977 12.5L10.5186 14.792C10.8098 15.068 11.2841 15.068 11.5774 14.792L16.4319 10.208C16.7242 9.93102 16.7242 9.48302 16.4319 9.20702C16.2858 9.06802 16.0931 8.99902 15.9015 8.99902C15.7098 8.99902 15.5182 9.06802 15.371 9.20702Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 7193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ UsaColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const UsaColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 4C24 3.4475 23.5525 3 23 3H10V13H0V20C0 20.5525 0.4475 21 1 21H23C23.5525 21 24 20.5525 24 20V4Z",
          fill: "#F83142"
        }
      },
      { tag: "path", attr: { d: "M24 5H10V7H24V5Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 9H10V11H24V9Z", fill: "white" } },
      { tag: "path", attr: { d: "M0 13V15H24V13H10H0Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 17H0V19H24V17Z", fill: "white" } },
      {
        tag: "path",
        attr: { d: "M10 13H0V4C0 3.4475 0.4475 3 1 3H10V13Z", fill: "#1435C3" }
      },
      {
        tag: "path",
        attr: {
          d: "M5.00008 6.96094L4.68358 7.64494H3.93158L4.48158 8.21494L4.27858 9.03894L5.00008 8.62994L5.72158 9.03894L5.51858 8.21494L6.06858 7.64494H5.31558L5.00008 6.96094Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 4.5144L2.23741 5.1984H1.48541L2.03491 5.7684L1.83191 6.5924L2.55341 6.1834L3.27541 6.5924L3.07191 5.7684L3.62191 5.1984H2.86891L2.55341 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 4.5144L7.76255 5.1984H8.51455L7.96505 5.7684L8.16805 6.5924L7.44655 6.1834L6.72455 6.5924L6.92805 5.7684L6.37805 5.1984H7.13105L7.44655 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 11.4855L2.23741 10.8015H1.48541L2.03491 10.2315L1.83191 9.40747L2.55341 9.81647L3.27541 9.40747L3.07191 10.2315L3.62191 10.8015H2.86891L2.55341 11.4855Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 11.4855L7.76255 10.8015H8.51455L7.96505 10.2315L8.16805 9.40747L7.44655 9.81647L6.72455 9.40747L6.92805 10.2315L6.37805 10.8015H7.13105L7.44655 11.4855Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 72643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ VietnamColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const VietnamColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V20Z",
          fill: "#F83142"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.1803 10.5205H13.2348L11.9998 7.84204L10.7633 10.5205H7.81885L9.97035 12.747L9.17535 15.9735L11.9998 14.369L14.8238 15.9735L14.0288 12.747L16.1803 10.5205Z",
          fill: "#FFE040"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 32600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ IconBase; },
/* harmony export */   "uL": function() { return /* binding */ SvgCss; },
/* harmony export */   "w_": function() { return /* binding */ GenIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80392);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Tree2Element(tree) {
  return tree && tree.map((node, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(node.tag, __spreadValues({ key: i }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  const IconWrapper = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconBase, __spreadValues({
    attr: __spreadValues({}, data.attr)
  }, props), Tree2Element(data.child));
  return IconWrapper;
}
function IconBase(props) {
  const elem = (conf) => {
    const computedSize = props.size || conf.size || "1em";
    let className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    const _a = props, { attr, color } = _a, svgProps = __objRest(_a, ["attr", "color"]);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSVG, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      fill: "currentColor",
      strokeWidth: props.strokeWidth ? typeof computedSize === "number" && computedSize >= 24 ? computedSize <= 40 ? 1.5 : 2 : 1 : void 0
    }, conf.attr), attr), svgProps), {
      className,
      style: __spreadValues(__spreadValues({}, conf.style), props.style),
      color,
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), props.children);
  };
  return _IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P !== void 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .IconContext.Consumer */ .P.Consumer, null, (conf) => elem(conf)) : elem(_IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DefaultContext */ .x);
}
const SvgCss = ({ color, theme }) => {
  var _a, _b;
  return `
  path[stroke],
  rect[stroke],
  line {
    stroke: ${color ? ((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a[color]) || color : ""};
  }
  path:not([stroke]),
  rect:not([stroke]) {
    fill: ${color ? ((_b = theme == null ? void 0 : theme.colors) == null ? void 0 : _b[color]) || color : ""};
  }
`;
};
const StyledSVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].svg`
  ${SvgCss};
`;




/***/ }),

/***/ 80392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ IconContext; },
/* harmony export */   "x": function() { return /* binding */ DefaultContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
const IconContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext && react__WEBPACK_IMPORTED_MODULE_0__.createContext(DefaultContext);




/***/ }),

/***/ 94648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BottomActionBar; },
/* harmony export */   "S": function() { return /* binding */ BottomNavigationBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavigation = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F};
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: env(safe-area-inset-bottom);
  transition: bottom 0.4s;
  z-index: ${(p) => p.zIndex || 1060};
`;
const BottomNavigationBar = (_a) => {
  var _b = _a, {
    zIndex,
    children
  } = _b, rest = __objRest(_b, [
    "zIndex",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNavigation, __spreadValues({
    zIndex
  }, rest), children);
};
const BottomActionBar = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(BottomNavigationBar)`
  min-height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  border-top: 1px solid #ddd;
  -webkit-backface-visibility: hidden;
  align-items: center;
  justify-content: space-between;
`;




/***/ }),

/***/ 45433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BottomSheet; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55878);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10232);





const BottomSheet = ({
  show,
  title,
  extra,
  closeBottomSheet,
  className,
  children,
  position,
  zIndex,
  contentHeight,
  filterNode,
  keys
}) => {
  const options = {
    top: {
      opacity: 0,
      transform: `translateY(-100%)`,
      height: "100%"
    },
    left: {
      opacity: 0,
      transform: `translateX(-100%)`,
      height: "100%"
    },
    right: {
      opacity: 0,
      transform: `translateX(100%)`,
      height: "100%"
    },
    bottom: {
      opacity: 0,
      transform: `translateY(100%)`,
      height: "100%"
    },
    show: {
      opacity: 1,
      transform: `translateY(0%)`,
      height: "100%"
    }
  };
  const entrancePosition = position || "bottom";
  const transition = (0,react_spring__WEBPACK_IMPORTED_MODULE_1__.useTransition)(show, {
    from: options[entrancePosition],
    enter: options["show"],
    leave: options[entrancePosition],
    keys: !!keys ? keys : null
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    zIndex,
    show
  }, transition((styles, item) => item ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_spring__WEBPACK_IMPORTED_MODULE_1__.animated.div, {
    style: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Mask, {
    onClick: closeBottomSheet
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottomSheet, {
    className: `${className ? ` ${className}` : ""}`
  }, !!title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetHeader, null, closeBottomSheet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSvgIcon, {
    size: 28,
    onClick: closeBottomSheet
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetTitle, null, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetExtra, null, extra), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetFilter, null, filterNode)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetContent, {
    contentHeight,
    className: "bottom-sheet-content"
  }, children)))) : null));
};
const StyledSvgIcon = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .CloseOutlined */ .X)`
  position: absolute;
  top: 12px;
  left: 12px;
`;
const StyledBottomSheet = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  background: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  bottom: 0;
  position: fixed;
`;
const BottomSheetHeader = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: relative;
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
`;
const BottomSheetTitle = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;
const BottomSheetExtra = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  position: absolute;
  right: 15px;
`;
const BottomSheetContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  ${({ contentHeight }) => contentHeight ? `height: ${contentHeight}` : "max-height: 75vh"};
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const Container = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ show, zIndex }) => `
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    pointer-events: none;
    transition: transform 0.3s ease-out;
    ${show ? ` z-index: ${zIndex ? zIndex : 1050};
    background-color: rgba(0, 0, 0, 0.3);
    will-change: transform;
    pointer-events: all;` : ""}

  `);
const BottomSheetFilter = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  width: 100%;
`;
const Mask = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  width: 100vw;
  height: 0vh;
  bottom: 0px;
  position: inherit;
  overflow: auto;
`;




/***/ }),

/***/ 35884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89635);



const useToast = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .ToastContextMobile */ .g);
};




/***/ }),

/***/ 7934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TopbarButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21483);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28247);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopbarButton = (_a) => {
  var _b = _a, {
    children,
    icon,
    href,
    tracking,
    color
  } = _b, rest = __objRest(_b, [
    "children",
    "icon",
    "href",
    "tracking",
    "color"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, {
    href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Button, __spreadValues(__spreadValues({}, tracking && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)(tracking)), rest), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, icon, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spacer, null)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 1,
    color: color || "white"
  }, children)));
};
const Spacer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].span`
  width: 0.5rem;
`;
const Button = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].button`
  padding: 0rem 1.25rem;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  height: 42px;
  &:focus {
    outline: none;
  }
`;




/***/ }),

/***/ 36403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DropdownTheme; },
/* harmony export */   "g": function() { return /* binding */ TopbarDropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27103);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43609);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _TopbarButton_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7934);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var DropdownTheme = /* @__PURE__ */ ((DropdownTheme2) => {
  DropdownTheme2[DropdownTheme2["LANGUAGE"] = 0] = "LANGUAGE";
  DropdownTheme2[DropdownTheme2["MENU"] = 1] = "MENU";
  return DropdownTheme2;
})(DropdownTheme || {});
const TopbarDropdown = ({
  value,
  selectValue,
  options,
  href,
  tracking,
  theme = 0 /* LANGUAGE */,
  icon,
  text
}) => {
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [activeOption, setActiveOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options.find((option) => option.value === value));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setActiveOption(options.find((option) => option.value === value));
  }, [value, options]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, {
    href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    onMouseLeave: () => setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopbarButton_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TopbarButton */ .S, __spreadProps(__spreadValues({
    icon: icon || (activeOption == null ? void 0 : activeOption.icon)
  }, tracking && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)(tracking)), {
    onMouseOver: () => setShow(true)
  }), text || (activeOption == null ? void 0 : activeOption.text)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, {
    show,
    dropdownTheme: theme
  }, options.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledListContent, {
    label: item.text,
    icon: item == null ? void 0 : item.icon,
    dropdownTheme: theme,
    borderRadius: "s",
    onClick: () => selectValue(item.value),
    hasDivider: [1 /* MENU */].includes(theme)
  }), [0 /* LANGUAGE */].includes(theme) && item.value === (activeOption == null ? void 0 : activeOption.value) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CheckOutlined */ .b, {
    size: 24,
    color: "red",
    style: { position: "absolute", right: "8px" }
  }))))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: relative;
`;
const DropdownMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  display: ${(props) => props.show ? "block" : "none"};
  position: absolute;
  background-color: white;
  z-index: 10000;

  ${({ dropdownTheme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return ``;
    default:
      return `
          padding: 4px;
          border-radius: 4px;
          right: 20px;
          top: 35px;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
          min-width: 11rem;
        `;
  }
}}
`;
const Option = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  display: flex;
  align-items: center;
  position: relative;
`;
const StyledListContent = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y)`
  cursor: pointer;

  ${({ dropdownTheme, theme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return `
          background-color: ${theme.colors.primary500};
          color: white;
          border-radius: unset;
          width: max-content;
          min-width: 100%;

          &:hover {
            background-color: ${theme.colors.primary600};
          }

          &:after {
            right: 0;
            left: 0;
          }
        `;
    default:
      return `
          width: 100%;
          padding: 8px 48px 8px 12px;
        `;
  }
}}
`;




/***/ }),

/***/ 69168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDevice; },
/* harmony export */   "Y": function() { return /* binding */ DeviceProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const initialState = {
  isMobile: false
};
const DeviceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const DeviceProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DeviceContext.Provider, {
    value
  }, children);
};
function useDevice() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DeviceContext);
  if (!context) {
    throw new Error("useDevice must be inside a DeviceProvider with a state value");
  }
  return context;
}




/***/ }),

/***/ 3685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
const colors = {
  white: "#FFFFFF",
  blue: "#1435c3",
  light: "#F8F9FA",
  lightblue: "#5fe7ff",
  dark: "#333",
  success: "#53C305",
  successBg: "#F4FFF2",
  success500: "#30CD60",
  error: "#EB2101",
  error500: "#DA4343",
  errorBg: "#FFF2F2",
  neutral: "#848788",
  placeholder: "#A7ABC3",
  border: "#E4E5F0",
  background: "#F6F6F6",
  warning: "#F78212",
  warningBg: "#FCF8E3",
  link: "#047FFF",
  link500: "#1990FF",
  linkBg: "#F0F7FF",
  disable: "#D2D2D2",
  sunYellow: "#FFD125",
  text: "#434657",
  red: "#ef2741",
  black: "#000000",
  gray50: "#FAFAFA",
  gray100: "#F5F5F5",
  gray130: "#82869E",
  gray200: "#EEEEEE",
  gray300: "#E0E0E0",
  gray400: "#BDBDBD",
  gray500: "#9E9E9E",
  gray600: "#757575",
  gray700: "#616161",
  gray800: "#424242",
  gray900: "#212121",
  green50: "#E8F5E9",
  green100: "#C8E6C9",
  green200: "#A5D6A7",
  green300: "#81C784",
  green400: "#66BB6A",
  green500: "#4CAF50",
  green600: "#43A047",
  green700: "#388E3C",
  green800: "#2E7D32",
  green900: "#1B5E20",
  blue50: "#E3F2FD",
  blue100: "#BBDEFB",
  blue200: "#90CAF9",
  blue300: "#64B5F6",
  blue400: "#42A5F5",
  blue500: "#2196F3",
  blue600: "#1E88E5",
  blue700: "#1976D2",
  blue800: "#1565C0",
  blue900: "#0D47A1",
  linear: ""
};
const theme = {
  brand: {
    primary: colors.blue,
    secondary: colors.lightblue,
    tertiary: "#E6EEFF",
    background: "#f1f0f1",
    loading: colors.blue,
    linear: ""
  },
  colors,
  breakpoints: ["576px", "768px", "1024px"],
  borderRadius: "8px"
};




/***/ }),

/***/ 3414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93387);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3685);




const ThemeProvider = ({
  theme: theme$1 = _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_1__/* .theme */ .r,
  children
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__.a, {
    theme: theme$1
  }, children);
};
function useTheme() {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return theme;
}




/***/ }),

/***/ 15064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getMatchRoute = exports.getPreviousFullPath = exports.getLocationFromString = exports.getFullPath = exports.getPathName = exports.getProtocal = void 0;
var matchPath_1 = __webpack_require__(6362);
exports.getProtocal = function (loc) {
    // Protocol may or may not contain a colon
    var protocol = loc.protocol;
    if (protocol.slice(-1) !== ":") {
        protocol += ":";
    }
    return protocol;
};
exports.getPathName = function (href) {
    var loc = exports.getLocationFromString(href);
    return loc.pathname;
};
exports.getFullPath = function (href) {
    var loc = exports.getLocationFromString(href);
    return loc.href;
};
exports.getLocationFromString = function (href) {
    var l = document.createElement("a");
    l.href = href;
    return l;
};
exports.getPreviousFullPath = function (prevLoc, currentLoc) {
    var previousFullPath = null;
    if (!prevLoc) {
        if (!document.referrer) {
            previousFullPath = exports.getFullPath(currentLoc);
        }
        else {
            previousFullPath = document.referrer;
        }
    }
    else {
        previousFullPath = exports.getFullPath(prevLoc);
    }
    return previousFullPath;
};
exports.getMatchRoute = function (path, routes) {
    var pathname = exports.getLocationFromString(path).pathname;
    var matches = routes
        .map(function (route) {
        return { match: matchPath_1.default(pathname, route), route: route };
    })
        .filter(function (_a) {
        var match = _a.match;
        return !!match;
    });
    if (matches && matches.length !== 0) {
        var _a = matches[0], match = _a.match, route = _a.route;
        var others = route.parser ? route.parser(path, match) : {};
        return __assign(__assign({}, route), others);
    }
    return {};
};
//# sourceMappingURL=common.js.map

/***/ }),

/***/ 61226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var router_1 = __webpack_require__(35304);
var common_1 = __webpack_require__(15064);
var defaultOptions = {
    host: "https://dev-tracking.teko.vn",
    urlServeJsFile: "https://dev-tracking.teko.vn/track/libs/tracker.full.min.js",
    routers: [],
    injectScript: false,
};
var init = function (f, b, e, v, i, r, t, s) {
    // Stop if tracker already exists
    if (f[i])
        return;
    // Initialise the 'GlobalTrackerNamespace' array
    f["GlobalTrackerNamespace"] = f["GlobalTrackerNamespace"] || [];
    // Add the new Tracker namespace to the global array so tracker.js can find it
    f["GlobalTrackerNamespace"].push(i);
    // Add endpoint
    f["GlobalTrackerNamespace"].push(r);
    // Create the Snowplow function
    f[i] = function () {
        (f[i].q = f[i].q || []).push(arguments);
    };
    // Initialise the asynchronous queue
    f[i].q = f[i].q || [];
    // Create a new script element
    t = b.createElement(e);
    // The new script should load asynchronously
    t.async = !0;
    // Load Tracker-js
    t.src = v;
    // Get the first script on the page
    s = b.getElementsByTagName(e)[0];
    // Insert the Snowplow script before every other script so it executes as soon as possible
    s.parentNode.insertBefore(t, s);
    // add listener error
    // @ts-ignore
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        f[i]("exception", { msg: msg, error: error });
        return false;
    };
};
var NextTracker = /** @class */ (function () {
    function NextTracker(setupOptions) {
        var _this = this;
        this.routes = [];
        this.onRegister = function () {
            _this.previousFullPath = common_1.getPreviousFullPath(null, document.location);
            window.track("setReferrerUrl", _this.previousFullPath);
            var currentFullPath = document.location.href;
            _this.currentPathName = common_1.getPathName(currentFullPath);
            window.track("trackLoadPageView", __assign({}, _this.getExtraAttr(currentFullPath)));
            _this.previousFullPath = currentFullPath;
            router_1.default.events.on("routeChangeComplete", function (path) {
                if (_this.currentPathName === common_1.getPathName(path)) {
                    return;
                }
                window.track("setCurrentUrl", _this.previousFullPath);
                window.track("trackUnLoadPageView", __assign({}, _this.getExtraAttr(_this.previousFullPath)));
                window.track("setReferrerUrl", _this.previousFullPath);
                window.track("setCurrentUrl", path);
                window.track("trackLoadPageView", __assign({}, _this.getExtraAttr(path)));
                _this.currentPathName = common_1.getPathName(path);
                _this.previousFullPath = path;
            });
        };
        var options = __assign(__assign({}, defaultOptions), setupOptions);
        var host = options.host, urlServeJsFile = options.urlServeJsFile, routes = options.routes;
        this.routes = routes;
        if (!options.injectScript) {
            init(window, document, "script", urlServeJsFile, "track", host);
        }
        if (options.appId) {
            window.track("init", options.appId);
            this.onRegister();
        }
    }
    NextTracker.prototype.getExtraAttr = function (currentPath) {
        if (!this.routes || this.routes.length === 0)
            return {};
        var _a = common_1.getMatchRoute(currentPath, this.routes) || {}, contentType = _a.contentType, screenName = _a.screenName, skuId = _a.skuId, skuName = _a.skuName;
        return JSON.parse(JSON.stringify({ contentType: contentType, screenName: screenName, skuId: skuId, skuName: skuName }));
    };
    return NextTracker;
}());
exports["default"] = NextTracker;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6362:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var path_to_regexp_1 = __webpack_require__(11022);
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache[cacheKey] || (cache[cacheKey] = {});
    if (pathCache[path])
        return pathCache[path];
    var keys = [];
    var regexp = path_to_regexp_1.pathToRegexp(path, keys, options);
    var result = { regexp: regexp, keys: keys };
    if (cacheCount < cacheLimit) {
        pathCache[path] = result;
        cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */
function matchPath(pathname, options) {
    if (options === void 0) { options = {}; }
    if (typeof options === "string" || Array.isArray(options)) {
        options = { path: options };
    }
    var path = options.path, _a = options.exact, exact = _a === void 0 ? false : _a, _b = options.strict, strict = _b === void 0 ? false : _b, _c = options.sensitive, sensitive = _c === void 0 ? false : _c;
    var paths = [].concat(path);
    return paths.reduce(function (matched, path) {
        if (!path && path !== "")
            return null;
        if (matched)
            return matched;
        var _a = compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive,
        }), regexp = _a.regexp, keys = _a.keys;
        var match = regexp.exec(pathname);
        if (!match)
            return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact)
            return null;
        return {
            path: path,
            url: path === "/" && url === "" ? "/" : url,
            isExact: isExact,
            params: keys.reduce(function (memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {}),
        };
    }, null);
}
exports["default"] = matchPath;
//# sourceMappingURL=matchPath.js.map

/***/ }),

/***/ 96289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90523)


/***/ }),

/***/ 27490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63631)


/***/ }),

/***/ 60387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(86100);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 46580:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(50053);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88961:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) {} else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 67777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(38745)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _router = __webpack_require__(38450);
var _addLocale = __webpack_require__(57775);
var _routerContext = __webpack_require__(52170);
var _appRouterContext = __webpack_require__(40203);
var _useIntersection = __webpack_require__(31225);
var _getDomainLocale = __webpack_require__(88961);
var _addBasePath = __webpack_require__(98552);
"client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 31225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(91987);
var _requestIdleCallback = __webpack_require__(36202);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 40203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 63992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(10685)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _loadable = _interop_require_default(__webpack_require__(56098));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 37939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 56098:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(10685)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _loadableContext = __webpack_require__(37939);
const { useSyncExternalStore  } =  true ? __webpack_require__(91987) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 11888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ LanguageSelector; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72643);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7193);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36403);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88813);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34655);







const LanguageSelector = ()=>{
    const { currentLanguage , availableLanguages  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const options = (availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.map((language)=>{
        switch(language){
            case "vi":
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Tiếng Việt"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .VietnamColored */ .m, {})
                };
            case "en":
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("English"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .UsaColored */ .E, {})
                };
            default:
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Ng\xf4n ngữ kh\xe1c"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .VietnamColored */ .m, {})
                };
        }
    })) || [];
    const onSelectLanguage = (value)=>{
        // UX4BUYER-4531
        // make sure passed value is string
        const language = value.toString();
        const currentDate = new Date();
        const date = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDay());
        const expireDate = date.toUTCString();
        const newUrl = new URL(window.location.href);
        (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .setCookieByName */ .Re)("lang", language, expireDate, "/");
        newUrl.searchParams.set("lang", language);
        window.location.href = newUrl.href;
    };
    return !!currentLanguage && !!(availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.length) && availableLanguages.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .TopbarDropdown */ .g, {
        value: currentLanguage,
        selectValue: onSelectLanguage,
        options: options
    }, 3) : null;
};


/***/ }),

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GX": function() { return /* binding */ SESSION_STORAGE_LOCATION_MESSAGE; },
/* harmony export */   "J0": function() { return /* binding */ SESSION_STORAGE_LOCATION_HINT_SHOWED; },
/* harmony export */   "Tp": function() { return /* binding */ userSelectedConstants; },
/* harmony export */   "h8": function() { return /* binding */ LOCALSTORAGE_SELECTED_PAYMENT_METHOD; },
/* harmony export */   "rw": function() { return /* binding */ ARROW_KEY_UP; },
/* harmony export */   "sf": function() { return /* binding */ ARROW_KEY_DOWN; }
/* harmony export */ });
/* unused harmony exports ARROW_KEY_RIGH, ARROW_KEY_LEFT, VNS_ORDER_MANAGEMENT_LOCATION, LOCALSTORAGE_CART_APPLY_COUPON, LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR */
const ARROW_KEY_UP = 38;
const ARROW_KEY_DOWN = 40;
const ARROW_KEY_RIGH = 39;
const ARROW_KEY_LEFT = 37;
const VNS_ORDER_MANAGEMENT_LOCATION = "vns_order_mng_location";
const LOCALSTORAGE_CART_APPLY_COUPON = "CART_APPLY_COUPON";
const LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR = "CART_OPEN_COUPON_SELECTOR";
const userSelectedConstants = {
    /**
   * @deprecated will remove it after ecom-284 live for all platforms
   * as ecom-284 flow ignores this locally stored value
   */ TERMINAL: "terminal",
    /**
   * @deprecated will remove it after ecom-284 live for all platforms
   * as ecom-284 flow ignores this locally stored value
   */ TERMINAL_ID: "terminal_id",
    LOCATION: "LOCATION_CODE",
    /**
   * allow setting a terminal_id from url query param.
   * the new terminal_id will override setting such as that of ecom-284
   * and will be honored even if it's not in the list of configured terminals
   */ OVERRIDE_TERMINAL_ID: "override_terminal_id"
};
const LOCALSTORAGE_SELECTED_PAYMENT_METHOD = "selected-payment-method";
const SESSION_STORAGE_LOCATION_MESSAGE = "location-message";
const SESSION_STORAGE_LOCATION_HINT_SHOWED = "region-picker-suggestion-popover-closed";


/***/ }),

/***/ 51765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY; },
/* harmony export */   "Oc": function() { return /* binding */ LOCAL_STORAGE_PRIVACY_POLICIES; },
/* harmony export */   "i7": function() { return /* binding */ LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES; }
/* harmony export */ });
const LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES = "submit_privacy_policies";
const LOCAL_STORAGE_PRIVACY_POLICIES = "privacy_policies";
const LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY = "allowed_privacy_policy";


/***/ }),

/***/ 85081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE; },
/* harmony export */   "Fl": function() { return /* binding */ LIMIT_ITEM_PER_PAGE_PRODUCT_LIST; },
/* harmony export */   "YH": function() { return /* binding */ MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE; },
/* harmony export */   "_V": function() { return /* binding */ RECENTLY_VIEWED_PRODUCTS_KEY; }
/* harmony export */ });
/* unused harmony export SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE */
const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;
const RECENTLY_VIEWED_PRODUCTS_KEY = "viewed-products";
const MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE = 10;
const DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE = 40;
const SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE = 20;


/***/ }),

/***/ 23357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagProvider; },
  "g": function() { return /* binding */ useFeatureFlags; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ./configs/featureFlags.ts
const FLAG_SUP_FEATURES = {
    WEBAPP_RETURN_REQUEST: true,
    epic_ecom_269: false,
    epic_pb_613: false,
    epic_omni_389: false,
    MML_NO_PAYMENT: false,
    epic_omni_677: false,
    epic_omni_964: true,
    epic_ecom_284: false,
    epic_ecom_460: false,
    omni_848_consumer: true,
    epic_ecom_315: false,
    epic_omni_1058: false,
    epic_omni_1237: false,
    epic_ecom_472: true,
    epic_ecom_479: false,
    epic_ecom_483: false
};

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
;// CONCATENATED MODULE: ./contexts/FeatureFlagProvider.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const FeatureFlagContext = /*#__PURE__*/ (0,react.createContext)({
    flags: FLAG_SUP_FEATURES
});
const FeatureFlagProvider = (param)=>{
    let { children , flags  } = param;
    flags = flags || FLAG_SUP_FEATURES;
    const { disableEpicEcom284 , epicOmni1058  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagContext.Provider, {
        value: {
            flags: _objectSpreadProps(_objectSpread({}, flags), {
                /**
            UX4BUYER-5240 additional platform flag.
            disableEpicEcom284 turns off the epic for a specific platform
          */ epic_ecom_284: flags.epic_ecom_284 && !disableEpicEcom284,
                epic_omni_1058: flags.epic_omni_1058 && !!epicOmni1058
            })
        },
        children: children
    });
};
const useFeatureFlags = ()=>{
    return (0,react.useContext)(FeatureFlagContext);
};


/***/ }),

/***/ 27890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ FrameProvider; },
/* harmony export */   "x": function() { return /* binding */ useFrame; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);



const initialState = {
    frames: []
};
const FrameStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const FrameProvider = (param)=>{
    let { children  } = param;
    const { banners: listFrames  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useBanners */ .U)("frame");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FrameStateContext.Provider, {
        value: {
            frames: listFrames
        },
        children: children
    });
};
function useFrame() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FrameStateContext);
    if (!context) {
        throw new Error("useFrame must be inside a FrameStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 84443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U5": function() { return /* binding */ useGlobalData; },
/* harmony export */   "Uw": function() { return /* binding */ GlobalDataProvider; },
/* harmony export */   "Wx": function() { return /* binding */ useTenantConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);

const GlobalDataContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const GlobalDataProvider = GlobalDataContext.Provider;
function useGlobalData() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GlobalDataContext);
    if (!context) {
        throw new Error("useGlobalData must be inside a GlobalDataProvider with a state value");
    }
    return context;
}
// for backward compatible
const useTenantConfig = ()=>{
    return useGlobalData();
};


/***/ }),

/***/ 29706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useHelper; },
/* harmony export */   "d": function() { return /* binding */ HelperProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60295);



const HelperStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    productHelper: helpers__WEBPACK_IMPORTED_MODULE_2__/* .productHelper */ .gU
});
const HelperProvider = (param)=>{
    let { children , freeShippingThreshold  } = param;
    const { 0: productHelper , 1: setProductHelper  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(helpers__WEBPACK_IMPORTED_MODULE_2__/* .productHelper */ .gU);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (typeof freeShippingThreshold === "number" && freeShippingThreshold >= 0) {
            setProductHelper(new helpers__WEBPACK_IMPORTED_MODULE_2__/* .ProductHelper */ .xZ(freeShippingThreshold));
        }
    }, [
        freeShippingThreshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelperStateContext.Provider, {
        value: {
            productHelper,
            setProductHelper
        },
        children: children
    });
};
function useHelper() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(HelperStateContext);
    if (!context) {
        throw new Error("useHelper must be inside a HelperStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 58610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useLocation; },
/* harmony export */   "v": function() { return /* binding */ LocationProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50923);
/* harmony import */ var _FeatureFlagProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23357);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89368);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48441);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60049);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71323);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53632);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79228);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84443);










const LocationPicker = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(1305), __webpack_require__.e(3667), __webpack_require__.e(400), __webpack_require__.e(3885), __webpack_require__.e(1592), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(9781), __webpack_require__.e(6790), __webpack_require__.e(9254), __webpack_require__.e(5125), __webpack_require__.e(5249), __webpack_require__.e(7506), __webpack_require__.e(3835), __webpack_require__.e(9302), __webpack_require__.e(3709), __webpack_require__.e(2771), __webpack_require__.e(3738), __webpack_require__.e(4312)]).then(__webpack_require__.bind(__webpack_require__, 13738)).then((mod)=>mod.LocationPicker), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13738)
            ]
    }
});
const LocationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    locations: [],
    onCloseRegionPickerSuggestionPopover: ()=>undefined,
    setShowed: ()=>{},
    showRegionPickerSuggestionPopover: false,
    loading: true
});
const useLocation = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LocationContext);
};
const LocationProvider = (param)=>{
    let { children ,  } = param;
    const { isMobile , location: selectedLocationCode , locations =[] ,  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)();
    const [, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .useLoading */ .r$)("location");
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { flags  } = (0,_FeatureFlagProvider__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureFlags */ .g)();
    const regionPickerSuggestionPopoverClosed = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_HINT_SHOWED */ .J0));
    const showRegionPickerSuggestionPopover = !regionPickerSuggestionPopoverClosed && (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_MESSAGE */ .GX) === types__WEBPACK_IMPORTED_MODULE_8__/* .LocationMessageType.Hint */ .t.Hint && (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284);
    const hideSearchBox = locations.length <= 10;
    const onSelectLocation = (location)=>{
        if ((0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)()) {
            (0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_7__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, location.locationCode);
            setLoading(true);
            setShow(false);
            (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .reloadPage */ .sl)();
        }
    };
    const enabled = locations.length > 1 && (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284);
    const loading = !(0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)();
    const onCloseRegionPickerSuggestionPopover = ()=>{
        sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_HINT_SHOWED */ .J0, "true");
    };
    const selectedLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>locations.find((param)=>{
            let { locationCode  } = param;
            return locationCode === selectedLocationCode;
        }), [
        locations,
        selectedLocationCode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LocationContext.Provider, {
        value: {
            locations,
            isShowed: show,
            setShowed: setShow,
            onSelectLocation,
            showRegionPickerSuggestionPopover,
            onCloseRegionPickerSuggestionPopover,
            selectedLocation,
            enabled,
            loading
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u, {
                width: isMobile ? 300 : 400,
                visible: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_MESSAGE */ .GX) === types__WEBPACK_IMPORTED_MODULE_8__/* .LocationMessageType.Error */ .t.Error,
                onOk: ()=>{
                    (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .reloadPage */ .sl)();
                },
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Thử lại"),
                cancelText: "",
                showCloseIcon: false,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                centeredTitle: true,
                alignFooter: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .ModalBody */ .f, {
                    padding: [
                        "s0",
                        "s0"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                        level: 1,
                        style: {
                            textAlign: "center"
                        },
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Hiện tại kh\xf4ng lấy được th\xf4ng tin địa điểm để hiển thị sản phẩm ph\xf9 hợp với bạn. Vui l\xf2ng thử lại hoặc quay lại sau gi\xe2y l\xe1t!")
                    })
                })
            }),
            children,
            show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationPicker, {
                isShowed: show,
                isMobile: isMobile,
                setShowed: setShow,
                locations: locations,
                onSelectLocation: onSelectLocation,
                selectedLocation: selectedLocation,
                hideSearchBox: hideSearchBox
            })
        ]
    });
};


/***/ }),

/***/ 61105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LoyaltyProvider; },
/* harmony export */   "m": function() { return /* binding */ useLoyalty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89368);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46295);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20577);
/* harmony import */ var _ServiceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43015);






const LoyaltyContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const useLoyalty = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LoyaltyContext);
    if (context === undefined) {
        throw new Error("useLoyalty must be used within a LoyaltyProvider");
    }
    return context;
};
const LoyaltyProvider = (param)=>{
    let { children ,  } = param;
    const { 0: loyaltyMemberInfo , 1: setLoyaltyMemberInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { 0: networkConfig , 1: setNetworkConfig  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .useLoading */ .r$)("useLoyalty");
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)();
    const { loyaltyBFFService  } = (0,_ServiceContext__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (user === null || user === void 0 ? void 0 : user.userId) {
            const getLoyaltyInfo = async ()=>{
                try {
                    setLoading(true);
                    const loyaltyClientId = loyaltyBFFService.getClientId();
                    if (loyaltyClientId) {
                        const data = await loyaltyBFFService.getLoyaltyMemberInfo();
                        setLoyaltyMemberInfo(data);
                        setNetworkConfig(await loyaltyBFFService.getNetworkConfig());
                    }
                } catch (e) {
                    _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
                } finally{
                    setLoading(false);
                }
            };
            getLoyaltyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.userId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoyaltyContext.Provider, {
        value: {
            loyaltyMemberInfo,
            networkConfig,
            loading
        },
        children: children
    });
};


/***/ }),

/***/ 68673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PopularKeywordProvider; },
/* harmony export */   "y": function() { return /* binding */ usePopularKeyword; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70334);



const initialState = {
    terms: [],
    setStartCallApi: ()=>{}
};
const PopularKeywordStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const PopularKeywordProvider = (param)=>{
    let { children  } = param;
    const { 0: startCallApi , 1: setStartCallApi  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { result  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRecommendedKeywords */ .o)(startCallApi);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopularKeywordStateContext.Provider, {
        value: {
            terms: result,
            setStartCallApi
        },
        children: children
    });
};
function usePopularKeyword() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PopularKeywordStateContext);
    if (!context) {
        throw new Error("usePopularKeyword must be inside a PopularKeywordStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 66921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ PrivacyPolicyProvider; },
  "q": function() { return /* binding */ usePrivacyPolicy; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(20577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(98992);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Checkbox/Checkbox.es.js
var Checkbox_es = __webpack_require__(96413);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-e626e0ec2a/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(45433);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(88123);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-e626e0ec2a/1/packages/ds-mobile/dist/components/BottomNavigationBar/BottomNavigationBar.es.js
var BottomNavigationBar_es = __webpack_require__(94648);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(48441);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(60049);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(69967);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 8 modules
var context_es = __webpack_require__(46295);
// EXTERNAL MODULE: ./constants/privacyPolicy.ts
var privacyPolicy = __webpack_require__(51765);
// EXTERNAL MODULE: ../../packages/utils/dist/string.es.js
var string_es = __webpack_require__(79376);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ./helpers/teko-oauth.ts
var teko_oauth = __webpack_require__(18042);
;// CONCATENATED MODULE: ./types/policy.ts
var PolicyTypeId;
(function(PolicyTypeId) {
    PolicyTypeId[PolicyTypeId["TYPE_1"] = 1] = "TYPE_1";
    PolicyTypeId[PolicyTypeId["TYPE_2"] = 2] = "TYPE_2";
    PolicyTypeId[PolicyTypeId["TYPE_3"] = 3] = "TYPE_3";
})(PolicyTypeId || (PolicyTypeId = {}));

;// CONCATENATED MODULE: ./contexts/PrivacyPolicyContext.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n  display: flex;\n  gap: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















const initialValues = {
    loading: false,
    policies: [],
    shouldShowSelector: false,
    changePolicyApproval: ()=>{},
    showSelector: ()=>{},
    submitPoliciesApproval: async ()=>{},
    buildPrivacyPolicyList: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
};
const PrivacyPolicyContext = /*#__PURE__*/ (0,react.createContext)(initialValues);
// currently cached submit payload is hardcoded to expire after 3 days.
const submitPayloadTTL = 3;
const PrivacyPolicyProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const { user , loading: authLoading , authService  } = (0,context_es/* useAuth */.a)();
    const { privacyPolicyService , notificationService  } = (0,ServiceContext/* useServices */.Su)();
    const { showModal  } = (0,hook_es/* useModal */.d)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { privacyPolicyCacheTTL =30 , isMobile , currentLanguage , notificationAppId ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: loading , 1: setLoading  } = (0,react.useState)(true);
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    const { 0: policies , 1: setPolicies  } = (0,react.useState)([]);
    const { 0: shouldShowSelector , 1: setShouldShowSelector  } = (0,react.useState)(false);
    const submitCallback = (0,react.useRef)(()=>{});
    const isLoginPage = !!router.pathname.endsWith("/login");
    const submitPoliciesApproval = async (callback)=>{
        if (validateApproval(policies)) {
            try {
                setLoading(true);
                await internalSubmit(authService.isLoggedIn());
            } catch (e) {
            // submit failed, cache saved for retry later so no need to do anything
            } finally{
                setShow(false);
                setLoading(false);
                callback === null || callback === void 0 ? void 0 : callback();
            }
        } else {
            showWarningModal();
        }
    };
    const changePolicyApproval = (0,react.useCallback)((id, state)=>{
        const newPolicies = policies.map((policy)=>{
            if (policy.id === id) {
                return _objectSpreadProps(_objectSpread({}, policy), {
                    isApproved: state
                });
            } else return policy;
        });
        setPolicies(newPolicies);
    }, [
        policies
    ]);
    /**
   * Underlying logic to handle fetch policies from api and save to cache
   * */ const internalGetPolicies = (0,react.useCallback)(async (isAuthed)=>{
        const policies = await privacyPolicyService.getPolicies();
        const isUserAllowed = checkUserAllowed(policies);
        const now = new Date().toString();
        setPolicies(policies);
        setShouldShowSelector(policies.length > 0);
        // Dont cache user specified policies
        if (!isAuthed) {
            localStorage.setItem("".concat(privacyPolicy/* LOCAL_STORAGE_PRIVACY_POLICIES */.Oc, "_").concat(currentLanguage || "vi"), JSON.stringify({
                policies: policies,
                createdAt: now
            }));
        } else {
            localStorage.setItem(privacyPolicy/* LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */.Hg, JSON.stringify({
                isAllowed: isUserAllowed,
                createdAt: now
            }));
        }
    }, [
        currentLanguage,
        privacyPolicyService
    ]);
    /**
   * Underlying logic to submit approval to remote api and handle error
   * */ const internalSubmit = (0,react.useCallback)(async function(isAuthed, customPolicies) {
        let skipSave = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        // policy type 1 is only used to show to user
        const submitPolicies = customPolicies || policies.filter((policy)=>policy.policyTypeId !== PolicyTypeId.TYPE_1).map((param)=>{
            let { id , version , language , isApproved  } = param;
            return {
                id,
                version,
                language,
                isApproved: isApproved || false
            };
        });
        try {
            // only submit when accessToken is available
            if (isAuthed) {
                await privacyPolicyService.submitPolicies(submitPolicies);
                localStorage.removeItem(privacyPolicy/* LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */.i7);
            } else !skipSave && saveSubmitPolicies(submitPolicies);
        } catch (e) {
            index_es/* logger.error */.k.error(e);
            // saved for retry later
            if (!skipSave) saveSubmitPolicies(submitPolicies);
            throw e;
        }
    }, [
        policies,
        privacyPolicyService
    ]);
    /**
   * Submit if payload cached
   * @param {boolean} isAuthed - authenticate status
   * @param {LocalStorageSubmitPolicies} [savedSubmitPolicies] - saved submit payload in cached
   * */ const validateSubmitPolicies = (0,react.useCallback)(async (isAuthed, savedSubmitPolicies)=>{
        if (isAuthed && savedSubmitPolicies) {
            const { policies , isSubmitted  } = savedSubmitPolicies;
            if (!!policies && isSubmitted === false) {
                await internalSubmit(isAuthed, savedSubmitPolicies.policies, true);
            }
        }
    }, [
        internalSubmit
    ]);
    /**
   * Decide to using cache or fetch from api depend on authenticate status and saved values
   * @param {boolean} isAuthed - authenticate status
   * @param {LocalStoragePolicies} [savedGetPolicies] - saved GetPolicies response.
   * @param {LocalStorageAllowedStatus} [savedAllowedStatus] - saved user allow status.
   * */ const validatePolicies = (0,react.useCallback)(async (isAuthed, savedGetPolicies, savedAllowedStatus)=>{
        try {
            if (!isAuthed) {
                if (savedGetPolicies) {
                    const savedPolicies = savedGetPolicies.policies || [];
                    setPolicies(savedPolicies);
                    setShouldShowSelector(savedPolicies.length > 0);
                } else {
                    internalGetPolicies();
                }
            } else if (!savedAllowedStatus || savedAllowedStatus && !savedAllowedStatus.isAllowed) {
                // fetch privacy policies specify to this user then skip cache step
                internalGetPolicies(true);
            }
        } catch (e) {
        // do nothing for now
        }
    }, [
        internalGetPolicies
    ]);
    const showSelector = (0,react.useCallback)(async (callback)=>{
        submitCallback.current = callback;
        setShow(true);
    }, []);
    /**
   * check for cache validation then remove it if expired and return it.
   * @return 3 saved value in form of array
   * */ const validateCaches = ()=>{
        return [
            [
                privacyPolicy/* LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */.i7,
                submitPayloadTTL
            ],
            [
                "".concat(privacyPolicy/* LOCAL_STORAGE_PRIVACY_POLICIES */.Oc, "_").concat(currentLanguage || "vi"),
                privacyPolicyCacheTTL, 
            ],
            [
                privacyPolicy/* LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */.Hg,
                privacyPolicyCacheTTL
            ]
        ].map((param)=>{
            let [key, duration] = param;
            const value = (0,string_es/* parseJsonStringSafely */.O)(localStorage.getItem(key));
            if (!value || checkCacheExpired(value.createdAt, duration)) {
                localStorage.removeItem(key);
                return undefined;
            }
            return value;
        });
    };
    /**
   * this effect only run once auth loaded.
   * 1. validate caches (return cached values if valid or remove otherwise).
   * 2. validate submit (submit to api if a submit payload saved which retrived in previous step)
   * 3. if step 3 success (submitted or nothing to submit yet) then validate policies (decide using cache or fetch from api)
   * */ (0,react.useEffect)(()=>{
        if (!authLoading && flags.epic_ecom_483) {
            const isAuthed = authService.isLoggedIn();
            const [savedSubmitPolicies, savedPolicies, savedAllowedStatus] = validateCaches();
            validateSubmitPolicies(isAuthed, savedSubmitPolicies).then(()=>validatePolicies(isAuthed, savedPolicies, savedAllowedStatus)).catch(()=>{}); // error handled
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        authLoading
    ]);
    const showWarningModal = ()=>{
        showModal === null || showModal === void 0 ? void 0 : showModal({
            title: (0,i18n.t)("Th\xf4ng b\xe1o"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                children: (0,i18n.t)("Vui l\xf2ng x\xe1c nhận đồng \xfd với c\xe1c điều khoản v\xe0 điều kiện dịch vụ để tiếp tục")
            }),
            okText: (0,i18n.t)("Đ\xf3ng"),
            cancelButtonProps: {
                style: {
                    display: "none"
                }
            },
            showCloseIcon: false,
            closable: false
        });
    };
    const buildPrivacyPolicyList = (0,react.useCallback)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                textAlign: "left"
            },
            children: policies.map((policy)=>{
                // find the outermost html tag of in the string
                const HTMLTag = policy.description[0] === "<" ? policy.description// start at 1 since we don't want to include '<'
                .substring(1, policy.description.indexOf(">"))// split by space in case html tag has attributes in it
                .split(" ") : "";
                return policy.policyTypeId === PolicyTypeId.TYPE_1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WarningPolicyWrapper, {
                    isMobile: isMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InforOutlined_es/* InforOutlined */.l, {
                            size: 24,
                            color: "pending600",
                            style: {
                                flex: "0 0 auto"
                            }
                        }),
                        authService.isLoggedIn() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,i18n.t)("Ch\xfang t\xf4i c\xf3 c\xe1c cập nhật li\xean quan đến việc xử l\xfd dữ liệu c\xe1 nh\xe2n. Vui l\xf2ng kiểm tra v\xe0 x\xe1c nhận. C\xe1c ch\xednh s\xe1ch c\xf3 đ\xe1nh dấu * l\xe0 bắt buộc x\xe1c nhận để tiếp tục sử dụng dịch vụ.")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLContentContainer, {
                            dangerouslySetInnerHTML: {
                                __html: policy.description
                            }
                        })
                    ]
                }, policy.id) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectablePolicyWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_es/* Checkbox */.X, {
                            height: "min-content",
                            checked: policy.isApproved,
                            onChange: (state)=>changePolicyApproval(policy.id, state)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLContentContainer, {
                            isRequire: policy.isApprovalRequired,
                            HTMLTag: HTMLTag[0],
                            dangerouslySetInnerHTML: {
                                __html: !!HTMLTag ? policy.description : "<div>".concat(policy.description, "</div>")
                            }
                        })
                    ]
                }, policy.id);
            })
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        policies,
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivacyPolicyContext.Provider, {
        value: {
            loading,
            policies,
            shouldShowSelector,
            changePolicyApproval,
            showSelector,
            submitPoliciesApproval,
            buildPrivacyPolicyList
        },
        children: [
            children,
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet_es/* BottomSheet */.R, {
                show: show,
                title: (0,i18n.t)("Th\xf4ng b\xe1o"),
                closeBottomSheet: isLoginPage ? ()=>setShow(false) : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
                    width: "100%",
                    padding: "s16",
                    style: {
                        marginBottom: "64px",
                        width: "100%"
                    },
                    children: [
                        buildPrivacyPolicyList(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomNavigationBar_es/* BottomActionBar */.G, {
                            style: {
                                display: "absolute",
                                gap: "8px"
                            },
                            children: [
                                !isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    width: "100%",
                                    variant: "secondary",
                                    onClick: ()=>{
                                        setShow(false);
                                        setShouldShowSelector(false);
                                        if (policies.some((policy)=>policy.isApprovalRequired)) {
                                            (0,teko_oauth/* onSignOut */.U3)(authService, notificationService, notificationAppId);
                                        }
                                    },
                                    children: policies.some((policy)=>policy.isApprovalRequired) ? (0,i18n.t)("Đăng xuất") : (0,i18n.t)("Bỏ qua")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    width: "100%",
                                    variant: "primary",
                                    onClick: ()=>submitPoliciesApproval(submitCallback.current),
                                    children: (0,i18n.t)("X\xe1c nhận")
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                width: "600px",
                visible: show,
                showCloseIcon: false,
                closable: false,
                okText: (0,i18n.t)("X\xe1c nhận"),
                onOk: ()=>{
                    submitPoliciesApproval();
                },
                cancelText: (0,i18n.t)("Đăng xuất"),
                onCancel: ()=>{
                    setShow(false);
                    (0,teko_oauth/* onSignOut */.U3)(authService, notificationService, notificationAppId);
                },
                title: (0,i18n.t)("Th\xf4ng b\xe1o"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                    style: {
                        padding: 0
                    },
                    children: buildPrivacyPolicyList()
                })
            })
        ]
    });
};
const usePrivacyPolicy = ()=>{
    const context = (0,react.useContext)(PrivacyPolicyContext);
    return context;
};
const validateApproval = (policies)=>{
    return !policies.some((policy)=>policy.isApprovalRequired && !policy.isApproved);
};
const saveSubmitPolicies = (policies, customCreatedAt)=>{
    localStorage.setItem(privacyPolicy/* LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */.i7, JSON.stringify({
        policies: policies,
        isSubmitted: false,
        createdAt: customCreatedAt || new Date().toString()
    }));
};
const checkCacheExpired = (date, duration)=>{
    return !((new Date().getTime() - new Date(date).getTime()) / (24 * 3600 * 1000) <= duration);
};
const checkUserAllowed = (policies)=>!policies.some((policy)=>policy.isApprovalRequired);
const WarningPolicyWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme , isMobile  } = param;
    return "\n    padding: 8px 12px;\n    background-color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.pending100, ";\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.pending600, ";\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: ").concat(isMobile ? "8px" : "16px", ";\n");
});
const SelectablePolicyWrapper = emotion_styled_browser_esm["default"].div(_templateObject());
const HTMLContentContainer = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme , isRequire , HTMLTag  } = param;
    return "\n  display: inline-block;\n  & > p {\n    margin: 0px;\n  }\n  ".concat(isRequire ? !!HTMLTag ? "& > ".concat(HTMLTag, ':first-child::before {\n        content: "*";\n        margin-right: 0.5rem;\n        color: ').concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n      }") : '& > div:first-child::before {\n        content: "*";\n        margin-right: 0.5rem;\n        color: '.concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n      }") : "", "\n");
});


/***/ }),

/***/ 79469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useRegionPicker; },
/* harmony export */   "k": function() { return /* binding */ RegionPickerProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53632);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88813);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84443);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79228);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71323);







const RegionPickerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    showPopup: false,
    setShowPopup: ()=>{},
    onOpenPopup: ()=>{},
    onClosePopup: ()=>{},
    selected: 0,
    setSelected: ()=>{},
    terminals: [],
    locationOptions: [],
    onSubmitNewLocation: ()=>{},
    useDropdownPicker: false,
    title: null
});
// TODO: replace useRegionPicker in ./hooks/useRegionPicker.tsx by this hook
const useRegionPicker = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RegionPickerContext);
};
const RegionPickerProvider = (param)=>{
    let { children  } = param;
    var ref;
    const { isMobile , originalTerminal  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const terminals = originalTerminal || [];
    const selectedTerminal = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, isMobile);
    const selectedLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, isMobile);
    const selectedTerminalId = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, isMobile);
    const enableLocationFeature = terminals.every((item)=>!!item.locationCode);
    const confirmedOptionIndex = terminals.findIndex((item)=>{
        if (enableLocationFeature) {
            return item.code === selectedTerminal && item.locationCode === selectedLocation;
        }
        return item.code === selectedTerminal;
    });
    const { 0: showRegionPopup , 1: setShowRegionPopup  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: selected , 1: setSelected  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    const selectTerminal = (terminal)=>{
        var ref;
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, terminal.code, isMobile);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.id) === null || ref === void 0 ? void 0 : ref.toString(), isMobile);
        enableLocationFeature && (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, // remove after 284 --> ignore now
        // @ts-ignore
        terminal.locationCode, isMobile);
    };
    const onSubmitNewLocation = ()=>{
        selectTerminal(terminals[selected]);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .reloadPage */ .sl)();
    };
    const activeLocation = confirmedOptionIndex || confirmedOptionIndex === 0 ? terminals[confirmedOptionIndex] : undefined;
    const textMsg = "Vui l\xf2ng chọn khu vực để ch\xfang t\xf4i sắp xếp giao h\xe0ng cho bạn nhanh nhất.";
    // temporarily rely on the location object present terminal
    const useDropdownPicker = !!((ref = terminals[0]) === null || ref === void 0 ? void 0 : ref.location);
    const onClosePopup = ()=>{
        if (activeLocation) {
            setShowRegionPopup(false);
            setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // terminalId is a new key added later
        // we want to deprecate terminalCode
        // so for site without terminalId, prompt region picker
        const isTerminalSelected = !!selectedTerminal && !!selectedTerminalId && // ensure id and code are included in the workload configuration
        !!terminals.find((param)=>{
            let { code , id  } = param;
            return code === selectedTerminal && id === parseInt(selectedTerminalId);
        });
        // if terminals include just one element --> auto set this element
        if (terminals.length === 1 && !isTerminalSelected) {
            selectTerminal(terminals[0]);
        } else {
            // add check !activeLocation in case the list of locations changes
            // on server-side, and user
            setShowRegionPopup(enableLocationFeature ? !isTerminalSelected || !selectedLocation || !activeLocation : !isTerminalSelected);
        }
    }, [
        selectedTerminal,
        selectedLocation,
        selectedTerminalId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegionPickerContext.Provider, {
        value: {
            showPopup: showRegionPopup,
            setShowPopup: setShowRegionPopup,
            onOpenPopup: ()=>setShowRegionPopup(true),
            onClosePopup,
            selected,
            setSelected,
            terminals,
            locationOptions: terminals.map((el, index)=>({
                    text: el.label,
                    value: index
                })),
            onSubmitNewLocation,
            activeLocation,
            useDropdownPicker,
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
                level: 1,
                children: textMsg
            })
        },
        children: children
    });
};


/***/ }),

/***/ 33756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EV": function() { return /* binding */ useScreen; },
/* harmony export */   "nX": function() { return /* binding */ ScreenProvider; },
/* harmony export */   "uE": function() { return /* binding */ PRODUCT_DETAIL_PAGE; }
/* harmony export */ });
/* unused harmony exports BRAND_PAGE, MASTER_CATEGORY_PAGE, SELLER_PAGE, TRACKING_SCREEN_MAPPING */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84443);




const HOME_PAGE = "";
const SEARCH_PAGE = "/search";
const CATEGORY_PAGE = "/categories/[categoryId]";
const PRODUCT_DETAIL_PAGE = "/products/[sku]";
const LANDING_PAGE = "/landing/[id]";
const BRAND_PAGE = "/brands/[brandId]";
const MASTER_CATEGORY_PAGE = "/block-categories/[categoryId]";
const SELLER_CATEGORY_PAGE = "/seller-categories/[categoryId]";
const SELLER_PAGE = "/sellers/[sellerId]";
const COMBO_LIST = "/products/[sku]/combos";
const COMBO_DETAIL = "/products/[sku]/combos/[id]";
const PROVIDER_PAGE = "/cua-hang/[providerId]";
const LANDING_BUILDER_PAGE = "/p/[slug]";
const TRACKING_SCREEN_MAPPING = {
    [HOME_PAGE]: "homePage",
    [SEARCH_PAGE]: "searchProductResult",
    [CATEGORY_PAGE]: "category",
    [BRAND_PAGE]: "brandPage",
    [PRODUCT_DETAIL_PAGE]: "productDetail",
    [LANDING_PAGE]: "landingPage",
    [MASTER_CATEGORY_PAGE]: "masterCategoryPage",
    [SELLER_CATEGORY_PAGE]: "sellerCategoryPage",
    [SELLER_PAGE]: "sellerPage",
    [COMBO_LIST]: "comboList",
    [COMBO_DETAIL]: "comboDetail",
    [PROVIDER_PAGE]: "providerPage",
    [LANDING_BUILDER_PAGE]: "landingPage"
};
const getTrackingScreenName = (tenant, isMobile, pathname)=>{
    const platform = isMobile ? "mobile" : "desktop";
    const tenantPrefix = "/".concat(tenant, "/").concat(platform);
    const tenantPrefixDefault = "/default/".concat(platform);
    let actualRoute;
    if (pathname.includes(tenantPrefix)) actualRoute = pathname.replace(tenantPrefix, "");
    else actualRoute = pathname.replace(tenantPrefixDefault, "");
    return TRACKING_SCREEN_MAPPING[actualRoute];
};
const ScreenStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createContext({});
const ScreenProvider = (param)=>{
    let { children  } = param;
    const { 0: trackingScreenName , 1: setTrackingScreenName  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { tenant , isMobile  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setTrackingScreenName(getTrackingScreenName(tenant, isMobile, router.pathname));
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScreenStateContext.Provider, {
        value: {
            trackingScreenName,
            setTrackingScreenName
        },
        children: children
    });
};
function useScreen() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(ScreenStateContext);
    if (!context) {
        throw new Error("useScreen must be inside a ScreenStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 43015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Su": function() { return /* binding */ useServices; },
/* harmony export */   "UT": function() { return /* binding */ ServiceProvider; },
/* harmony export */   "bl": function() { return /* binding */ initializeServices; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var helpers_service_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49284);



const ServiceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
let serviceContainer = null;
// initialize services here
const initializeServices = (tenantConfig)=>{
    if (!serviceContainer) {
        serviceContainer = new helpers_service_provider__WEBPACK_IMPORTED_MODULE_2__/* .ServiceContainer */ .h(tenantConfig);
    }
    return serviceContainer;
};
const ServiceProvider = (param)=>{
    let { children , services  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServiceContext.Provider, {
        value: services,
        children: children
    });
};
const useServices = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ServiceContext);
    if (!context) {
        throw new Error("useServices must be inside a ServiceProvider with a state value");
    }
    return context;
};


/***/ }),

/***/ 4133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ checkPathEqual; },
/* harmony export */   "GH": function() { return /* binding */ isHomepage; },
/* harmony export */   "I6": function() { return /* binding */ isAndroidDevice; },
/* harmony export */   "NL": function() { return /* binding */ checkPathInclude; },
/* harmony export */   "Z2": function() { return /* binding */ checkExpiryDateTimestamp; },
/* harmony export */   "au": function() { return /* binding */ isIOSDevice; },
/* harmony export */   "l3": function() { return /* binding */ saveRecentlyProduct; },
/* harmony export */   "t1": function() { return /* binding */ filterBlockItems; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; },
/* harmony export */   "xq": function() { return /* binding */ getBaseDomain; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79376);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4680);
/* eslint-disable @typescript-eslint/no-explicit-any */ 


const formatCurrency = function(money) {
    let isFull = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(money, {
        hideCurrencySymbol: !isFull
    });
};
const saveRecentlyProduct = (sku, localKey)=>{
    const historyStorage = localStorage.getItem(localKey);
    if (!historyStorage) {
        localStorage.setItem(localKey, JSON.stringify([
            sku
        ]));
        return;
    }
    let histories = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .parseJsonStringSafely */ .O)(historyStorage, []);
    histories = histories.filter((item)=>item !== sku);
    histories = [
        sku,
        ...histories
    ];
    if (histories.length > 20) {
        histories.pop();
    }
    localStorage.setItem(localKey, JSON.stringify(histories));
};
const isIOSDevice = ()=>{
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
};
const isAndroidDevice = ()=>{
    const android = /(android)/i.test(navigator.userAgent);
    return android;
};
// Check if path equals ...
const checkPathEqual = (router, path)=>{
    let pathname = router.asPath || router.pathname;
    pathname === "" ? "/" : pathname;
    const searchParam = pathname.indexOf("?");
    pathname = searchParam >= 0 ? pathname.substring(0, searchParam) : pathname;
    const rawPath = path.indexOf("?") >= 0 ? path.substring(0, path.indexOf("?")) : path;
    return pathname === rawPath;
};
// Check if path includes ...
const checkPathInclude = (router, acceptedPaths)=>{
    const pathName = router.asPath || router.pathname;
    return acceptedPaths.some((path)=>pathName.includes(path));
};
const checkExpiryDateTimestamp = (startDate, endDate)=>{
    const today = new Date().getTime();
    if (today - new Date(parseInt(startDate) * 1000).getTime() > 0 && new Date(parseInt(endDate) * 1000).getTime() - today > 0) return true;
    return false;
};
const isHomepage = (pathname)=>{
    // Old version
    // return ['', '/'].includes(pathname);
    // This's added for supporting multi-languages
    return !pathname || /^\/(\?lang=[a-zA-Z-]{2,5})?$/.test(pathname);
};
const filterBlockItems = (item, blockList)=>{
    const matchFormat = item.url.match(/^#\d+$/);
    if (!matchFormat) return false;
    const blockId = item.url.substring(1);
    const block = blockList.find((e)=>e.id === blockId);
    if (!block) return false;
    return true;
};
const getBaseDomain = ()=>{
    var ref, ref1;
    if (false) {}
    return "".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.protocol, "/").concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.host);
};


/***/ }),

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ isAdultCategoryProduct; },
/* harmony export */   "P1": function() { return /* binding */ markUserIsOver18; },
/* harmony export */   "av": function() { return /* binding */ needConfirm18YearsOld; },
/* harmony export */   "bO": function() { return /* binding */ requiredConfirm18YearsOld; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53028);
/* harmony import */ var _datetime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5709);


const IS_LOGGED_USER_KEY = "is_logged_user";
const IS_OVER_18_KEY = "is_over_18";
const needConfirm18YearsOld = (isAlcoholicCategory)=>{
    const isOver18YearsOld = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookieOver18YearOld */ .Iv)();
    return !isOver18YearsOld && isAlcoholicCategory;
};
/**
 * @param productCategories
 * @description https://jira.teko.vn/browse/UX4BUYER-5311
 * @returns true if lastest category has isAdult = true. Else return false
 */ const isAdultCategoryProduct = (productCategories)=>{
    var ref;
    return (ref = productCategories === null || productCategories === void 0 ? void 0 : productCategories.at(-1)) === null || ref === void 0 ? void 0 : ref.isAdult;
};
/**
 * @param user
 * @description ECOM-315
 * @returns true if user confirmed their age > 18. Else return false
 */ const requiredConfirm18YearsOld = (user)=>{
    if (!!user) {
        // set is_logged_user = true
        // check user_age >= 18 => over 18 flow
        // else set is_over_18 = false => under 18 flow
        localStorage.setItem(IS_LOGGED_USER_KEY, "true");
        if (user.dob && (0,_datetime__WEBPACK_IMPORTED_MODULE_1__/* .isOver18YearOld */ .xW)(user === null || user === void 0 ? void 0 : user.dob)) {
            return false;
        } else {
            localStorage.setItem(IS_OVER_18_KEY, "false");
            return true;
        }
    } else {
        // check is_logged_user
        if (localStorage.getItem(IS_LOGGED_USER_KEY) === "true") {
            // set is_logged_user = false
            // set is_over_18 = false
            // => under 18 flow
            localStorage.setItem(IS_LOGGED_USER_KEY, "false");
            localStorage.setItem(IS_OVER_18_KEY, "false");
            return true;
        } else {
            //  check is_over_18 = true => over 18 flow
            //  else => under 18 flow
            if (localStorage.getItem(IS_OVER_18_KEY) === "true") {
                return false;
            } else {
                return true;
            }
        }
    }
};
const markUserIsOver18 = ()=>{
    localStorage.setItem(IS_OVER_18_KEY, "true");
};


/***/ }),

/***/ 5709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ getMinimumTime; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "xW": function() { return /* binding */ isOver18YearOld; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89060);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69802);

const getTime = (timeStampSec)=>{
    return new Date(parseInt(timeStampSec) * 1000);
};
/**
 * Get the minimum time from an array of timestamp second
 *
 * @returns The minimum time: Date | null (if array is empty)
 *
 * @param timestampSecList: Array<number as string>
 */ const getMinimumTime = (timestampSecList)=>{
    if (timestampSecList.length === 0) return null;
    let minimumTime = new Date();
    minimumTime.setHours(23, 59, 59);
    timestampSecList.forEach((timestampSec)=>{
        // convert to Date format
        const currentTime = new Date(parseInt(timestampSec) * 1000);
        if (currentTime < minimumTime) minimumTime = currentTime;
    });
    return minimumTime;
};
/**
 *
 * @param birthday The birthday in string format (YYYY-MM-DD)
 */ const isOver18YearOld = (birthday)=>{
    const currentDate = new Date();
    return !(0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(birthday), (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentDate, 18));
};


/***/ }),

/***/ 60295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LB": function() { return /* binding */ DiscoveryHelper; },
  "xZ": function() { return /* binding */ ProductHelper; },
  "k6": function() { return /* binding */ convertCommonPromotion; },
  "px": function() { return /* binding */ convertDiscoveryFilter; },
  "Kx": function() { return /* binding */ convertGift; },
  "NP": function() { return /* binding */ convertProductDetail; },
  "JR": function() { return /* binding */ convertToPayloadFilter; },
  "EN": function() { return /* binding */ convertToPayloadSorting; },
  "r0": function() { return /* binding */ getSearchVariables; },
  "gU": function() { return /* binding */ productHelper; }
});

// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/types.es.js
var types_es = __webpack_require__(91004);
;// CONCATENATED MODULE: ./types/discovery.ts
var PromotionApplyOnEnum;
(function(PromotionApplyOnEnum) {
    PromotionApplyOnEnum["product"] = "product";
    PromotionApplyOnEnum["partOrder"] = "part-order";
})(PromotionApplyOnEnum || (PromotionApplyOnEnum = {}));

// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(4133);
// EXTERNAL MODULE: ./helpers/products.ts
var products = __webpack_require__(46130);
// EXTERNAL MODULE: ./contexts/ScreenContext.tsx
var ScreenContext = __webpack_require__(33756);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(96098);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(85081);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/v2/constants.es.js
var constants_es = __webpack_require__(31813);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var index_es = __webpack_require__(31260);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(53632);
;// CONCATENATED MODULE: ./helpers/discovery.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












const isExpired = (endTimestampSec)=>{
    const end = new Date(parseInt(endTimestampSec) * 1000).getTime();
    const now = new Date().getTime();
    return end < now;
};
const convertGift = (gift)=>{
    return _objectSpreadProps(_objectSpread({}, gift), {
        image: {
            alt: gift.name,
            src: gift.imageUrl || "/api/products/".concat(gift.sku, "/default_image")
        }
    });
};
const getRemainingTime = (endDate)=>{
    const remainingTime = (new Date(endDate).valueOf() - new Date().valueOf()) / 86400000;
    if (remainingTime < 6 && remainingTime >= 0) {
        if (remainingTime >= 1) {
            return "".concat(Math.floor(remainingTime), " ").concat((0,i18n.t)("ng\xe0y"));
        } else {
            const hours = Math.floor((new Date(endDate).valueOf() - new Date().valueOf()) / 3600000);
            if (hours >= 1) {
                return "".concat(hours, " ").concat((0,i18n.t)("giờ"));
            } else {
                return "1 ".concat((0,i18n.t)("giờ"));
            }
        }
    }
    return undefined;
};
const convertCommonPromotion = (promotion, price)=>{
    var ref, ref1, ref2, ref3;
    let milestoneMoney = price;
    const promo = {
        id: promotion.id,
        endedAt: new Date(parseInt(promotion.endTimestampSec) * 1000).toISOString(),
        description: promotion.description,
        name: promotion.name,
        remainingTime: getRemainingTime(parseInt(promotion.endTimestampSec) * 1000),
        type: (promotion === null || promotion === void 0 ? void 0 : (ref = promotion.condition) === null || ref === void 0 ? void 0 : ref.coupon) ? "coupon" : promotion.applyOn === "product" ? "product" : "order",
        condition: {
            orderValueMax: promotion.condition.orderValueMax,
            orderValueMin: promotion.condition.orderValueMin,
            coupon: promotion.condition.coupon,
            blockSize: promotion.condition.blockSize,
            minQuantity: promotion.condition.minQuantity,
            blockSizeDecimal: promotion.condition.blockSizeDecimal || 0,
            minQuantityDecimal: promotion.condition.minQuantityDecimal || 0
        },
        benefit: {
            money: [],
            items: [],
            voucher: promotion === null || promotion === void 0 ? void 0 : (ref1 = promotion.benefit) === null || ref1 === void 0 ? void 0 : ref1.voucher
        }
    };
    const gifts = promotion.benefit.gifts;
    if (gifts && Array.isArray(gifts)) {
        promo.benefit.items = gifts.map(convertGift);
    }
    const discount = promotion.benefit.discount;
    if (discount) {
        let discountMoney = 0;
        if (discount.percent) {
            if (milestoneMoney * discount.percent / 100 > discount.maxAmount) {
                discountMoney = discount.maxAmount;
            } else {
                discountMoney = milestoneMoney * discount.percent / 100;
            }
        } else {
            discountMoney = discount.flat;
        }
        const itemMoney = {
            discountType: discount.percent ? "percent" : "money",
            maxDiscount: discount.maxAmount,
            id: promotion.id,
            percent: discount.percent,
            money: Math.round(discountMoney)
        };
        milestoneMoney = milestoneMoney - discountMoney;
        promo.benefit.money = [
            itemMoney
        ];
    }
    promo.price = (promotion === null || promotion === void 0 ? void 0 : (ref2 = promotion.price) === null || ref2 === void 0 ? void 0 : ref2.sellPrice) ? +(promotion === null || promotion === void 0 ? void 0 : (ref3 = promotion.price) === null || ref3 === void 0 ? void 0 : ref3.sellPrice) : milestoneMoney;
    return {
        promotion: promo,
        price: milestoneMoney
    };
};
const convertProductStatus = (status)=>{
    switch(status === null || status === void 0 ? void 0 : status.sellingCode){
        case "hang_trung_bay":
            return {
                status: (0,i18n.t)("H\xe0ng trưng b\xe0y"),
                color: "#b4b4b4"
            };
        case "hang_khac":
            return {
                status: (0,i18n.t)("H\xe0ng qu\xe0 tặng"),
                color: "#b4b4b4"
            };
        default:
            return undefined;
    }
};
const sortVariant = (variants, configurations)=>{
    if (!variants || !configurations) {
        return [];
    }
    const configurationCodes = configurations.map((obj)=>obj.code);
    const sortedVariants = [];
    variants.forEach((variant)=>{
        const temp = {
            sku: variant.sku,
            attributeValues: []
        };
        configurationCodes.forEach((code)=>{
            const tmp = variant.attributeValues.findIndex((att)=>att.code === code);
            if (tmp !== -1) {
                temp.attributeValues.push(variant.attributeValues[tmp]);
            }
        });
        sortedVariants.push(temp);
    });
    return sortedVariants;
};
const convertConfigurations = (variants, configurations, sku)=>{
    if (!variants || !configurations) return [];
    const newVariants = [];
    const newConfigurations = [];
    variants.forEach((variant)=>{
        (variant.attributeValues || []).forEach((attributeValue)=>{
            newVariants.push(attributeValue);
        });
    });
    const productVariant = variants.find((variant)=>variant.sku === sku);
    configurations.forEach((item)=>{
        const optionsTmp = [];
        (item.options || []).forEach((option)=>{
            const tmp = newVariants.findIndex((variant)=>option.optionId === variant.optionId);
            if (tmp !== -1) {
                const defaultVariant = productVariant && productVariant.attributeValues.findIndex((att)=>att.optionId === option.optionId);
                optionsTmp.push({
                    value: option.value,
                    optionId: option.optionId,
                    visible: true,
                    selected: defaultVariant !== -1,
                    thumbnailUrl: option.thumbnailUrl || ""
                });
            }
        });
        // simple sort by values
        const sortedOptionsTmp = optionsTmp.sort((a, b)=>a.value < b.value ? -1 : 1);
        newConfigurations.push(_objectSpreadProps(_objectSpread({}, item), {
            options: sortedOptionsTmp
        }));
    });
    return newConfigurations;
};
const validateVisibleVariant = (selectedVariant, variants, configurations)=>{
    if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.length) || !(variants === null || variants === void 0 ? void 0 : variants.length) || !(configurations === null || configurations === void 0 ? void 0 : configurations.length)) {
        return [];
    }
    variants.forEach((variant)=>{
        var ref;
        if ((variant === null || variant === void 0 ? void 0 : (ref = variant.attributeValues) === null || ref === void 0 ? void 0 : ref[0]) && variant.attributeValues[0].optionId === selectedVariant[0].optionId) {
            let count = 0;
            variant.attributeValues.forEach((att, index)=>{
                var ref;
                if (att.optionId === ((ref = selectedVariant[index]) === null || ref === void 0 ? void 0 : ref.optionId)) {
                    count++;
                }
            });
            if (count >= variant.attributeValues.length - 1) {
                variant.attributeValues.forEach((att, index)=>{
                    const temp = configurations[index].options.find((config)=>config.optionId === att.optionId);
                    if (temp && !temp.visible) {
                        const pos = configurations[index].options.findIndex((config)=>config.optionId === att.optionId);
                        if (pos !== -1) configurations[index].options.splice(pos, 1, _objectSpreadProps(_objectSpread({}, temp), {
                            visible: true
                        }));
                    }
                });
            }
        }
    });
    return configurations;
};
const convertFlashSale = (flashSales)=>{
    const flashSale = !!flashSales.length && flashSales.find((fls)=>{
        return (0,common/* checkExpiryDateTimestamp */.Z2)(fls === null || fls === void 0 ? void 0 : fls.startTimestampSec, fls === null || fls === void 0 ? void 0 : fls.endTimestampSec) && ((fls === null || fls === void 0 ? void 0 : fls.type) === "HOT_DEAL" || (fls === null || fls === void 0 ? void 0 : fls.type) === "GOLDEN_TIME");
    });
    if (flashSale) return {
        total: flashSale.totalCount,
        used: flashSale.usedCount,
        endAt: new Date(parseInt(flashSale.endTimestampSec) * 1000).toISOString(),
        type: flashSale.type,
        endTimestampSec: flashSale.endTimestampSec
    };
    return undefined;
};
const getDefaultPromotions = (product)=>{
    var ref;
    const couponProductPromotion = (ref = (product.promotions || []).filter((promo)=>{
        const isTypeCoupon = promo.type === "coupon";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const hasCoupon = !!promo.condition.coupon;
        return isTypeCoupon && isApplyOnProduct && hasCoupon;
    })) === null || ref === void 0 ? void 0 : ref[0];
    const defaultPromotions = (product.promotions || []).filter((promo)=>{
        const isTypeProduct = promo.type === "product";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const isDefault = promo.isDefault;
        return isTypeProduct && isApplyOnProduct && isDefault;
    });
    return [
        ...defaultPromotions,
        couponProductPromotion
    ].filter(Boolean).filter((promo)=>{
        if (promo.endTimestampSec) {
            return !isExpired(promo.endTimestampSec);
        }
        return true;
    });
};
const getSelectionPromotions = (product)=>{
    // blockSizeDecimal and rounding float number
    // only divide when blockSizeDecimal is between 0 and 1 (not include 0 and 1)
    const promotions = (product.promotions || []).map((el)=>{
        var ref, ref1;
        const blockSizeDecimal = el === null || el === void 0 ? void 0 : (ref = el.condition) === null || ref === void 0 ? void 0 : ref.blockSizeDecimal;
        if (blockSizeDecimal === 0 || !blockSizeDecimal || blockSizeDecimal >= 1) return el;
        const discount = el === null || el === void 0 ? void 0 : (ref1 = el.benefit) === null || ref1 === void 0 ? void 0 : ref1.discount;
        let flat = discount === null || discount === void 0 ? void 0 : discount.flat;
        if (flat) {
            flat = flat / blockSizeDecimal;
        }
        return _objectSpreadProps(_objectSpread({}, el), {
            benefit: _objectSpreadProps(_objectSpread({}, el.benefit), {
                discount: discount && _objectSpreadProps(_objectSpread({}, discount), {
                    flat
                })
            })
        });
    });
    return promotions.filter((promo)=>{
        const isTypeProduct = promo.type === "product";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const isDefault = promo.isDefault;
        return isTypeProduct && isApplyOnProduct && !isDefault;
    }).filter((promo)=>{
        if (promo.endTimestampSec) {
            return !isExpired(promo.endTimestampSec);
        }
        return true;
    });
};
const getImagesFromProduct = (product)=>{
    var ref, ref1;
    if (!!(product === null || product === void 0 ? void 0 : (ref = product.productDetail) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return product.productDetail.images.map((image)=>{
            var ref;
            return {
                src: image.url || "",
                alt: image.label || ((ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.displayName) || ""
            };
        });
    }
    if (!!product.productInfo.imageUrl) {
        var ref2;
        return [
            {
                src: product.productInfo.imageUrl,
                alt: ((ref2 = product.productInfo) === null || ref2 === void 0 ? void 0 : ref2.displayName) || ""
            }, 
        ];
    }
    return [];
};
//#region
const convertProductDetail = (product)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    const status = convertProductStatus((product === null || product === void 0 ? void 0 : product.status) || {
        sellingCode: "",
        sellable: false
    });
    const productGroup = product.productDetail.productGroup || {};
    const variants = productGroup.variants || [];
    const configurations = productGroup.configurations || [];
    const sortedVariants = sortVariant(variants, configurations);
    const selected = ((ref = sortedVariants.find((variant)=>variant.sku === product.productInfo.sku)) === null || ref === void 0 ? void 0 : ref.attributeValues) || [];
    const convertedConfiguration = sortedVariants && convertConfigurations(variants, configurations, product.productInfo.sku);
    const validatedConfiguration = convertedConfiguration && validateVisibleVariant(selected, sortedVariants, convertedConfiguration);
    let selectionPromotions = product.selectionPromotions || [];
    if (!(product === null || product === void 0 ? void 0 : (ref1 = product.selectionPromotions) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        selectionPromotions = product.promotions.filter((el)=>{
            var ref;
            return !el.isDefault && el.applyOn === "product" && !(el === null || el === void 0 ? void 0 : (ref = el.condition) === null || ref === void 0 ? void 0 : ref.coupon);
        });
    }
    const attributes = [];
    const newProduct = {
        sku: product.productInfo.sku,
        sellerSku: product.productInfo.sellerSku,
        flashSale: convertFlashSale(product.flashSales || []),
        status: product.status,
        images: getImagesFromProduct(product),
        title: _objectSpread({
            name: product.productInfo.displayName || product.productInfo.name
        }, status && {
            status: {
                value: status.status,
                color: status.color
            }
        }),
        name: product.productInfo.displayName || product.productInfo.name,
        displayName: product.productInfo.displayName || product.productInfo.name,
        price: _objectSpread({
            terminalPrice: product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.terminalPrice,
            supplierRetailPrice: product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.supplierRetailPrice,
            sellPrice: product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.sellPrice,
            priceWithoutSelectionPromotion: product.priceWithoutSelectionPromotion,
            discountAmount: +(product === null || product === void 0 ? void 0 : (ref8 = product.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.discountAmount)
        }, convertPrice(product)),
        seoInfo: product === null || product === void 0 ? void 0 : (ref10 = product.productDetail) === null || ref10 === void 0 ? void 0 : ref10.seoInfo,
        brand: product.productInfo.brand,
        attributeGroups: product.productDetail.attributeGroups,
        attributes,
        needManageStock: product.totalAvailable !== null,
        totalAvailable: product.totalAvailable,
        selectionPromotions: product.selectionPromotions || getSelectionPromotions(product),
        categories: product.productInfo.categories,
        masterCategories: product.productInfo.masterCategories,
        attributeSet: product.productDetail.attributeSet,
        defaultPromotions: product.defaultPromotions || getDefaultPromotions(product),
        productGroup: !!product.productDetail.productGroup ? _objectSpreadProps(_objectSpread({}, product.productDetail.productGroup), {
            variants: sortedVariants || [],
            configurations: validatedConfiguration || []
        }) : undefined,
        orderCouponPromotions: (product.promotions || []).filter((el)=>el.applyOn === "order" && !el.isDefault),
        partOrderPromotions: (product.promotions || []).filter((el)=>el.applyOn === "part_order" && el.isDefault && !!el.condition.coupon),
        provider: product.provider,
        seller: product.productInfo.seller,
        selected,
        isBundle: false,
        tags: product.productInfo.tags,
        save: Number(product === null || product === void 0 ? void 0 : (ref11 = product.prices) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.discountAmount) || 0,
        saveWithoutSelectionPromotion: product.priceWithoutSelectionPromotion ? Number((product === null || product === void 0 ? void 0 : (ref13 = product.prices) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.supplierRetailPrice) || 0) - product.priceWithoutSelectionPromotion : Number(product === null || product === void 0 ? void 0 : (ref15 = product.prices) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : ref16.discountAmount),
        selectPromotionId: selectionPromotions === null || selectionPromotions === void 0 ? void 0 : (ref17 = selectionPromotions[0]) === null || ref17 === void 0 ? void 0 : ref17.id,
        isAlcoholicCategory: product.isAlcoholicCategory,
        uomName: product.productInfo.uomName,
        uomRatio: product.productInfo.uomRatio,
        uomCode: product.productInfo.uomCode,
        clearanceTypeDescription: product === null || product === void 0 ? void 0 : (ref18 = product.productDetail) === null || ref18 === void 0 ? void 0 : ref18.clearanceTypeDescription,
        productOptions: product.productOptions,
        barcode: product.productInfo.barcode
    };
    if (newProduct.price.price === newProduct.price.listedPrice) {
        newProduct.price.listedPrice = undefined;
    }
    return newProduct;
};
///#endregion
const isValidPrice = (product)=>{
    var ref, ref1, ref2, ref3;
    const sellPrice = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sellPrice;
    const latestPrice = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.latestPrice;
    if (sellPrice === null || latestPrice === null) return false;
    const sellPriceNumber = Number(sellPrice);
    const latestPriceNumber = Number(latestPrice);
    if (isNaN(sellPriceNumber) || isNaN(latestPriceNumber)) return false;
    return sellPriceNumber > 0 && latestPriceNumber >= 0;
};
const getDisplayPrice = (discoveryPrice, isFlashSale)=>{
    let priceRange;
    const minLatestPrice = parseFloat(discoveryPrice.minLatestPrice);
    const maxLatestPrice = parseFloat(discoveryPrice.maxLatestPrice);
    const latestPrice = parseFloat(discoveryPrice.latestPrice);
    if (!isNaN(minLatestPrice) && !isNaN(maxLatestPrice) && !isNaN(latestPrice)) {
        if (minLatestPrice !== 0 && maxLatestPrice !== 0 && (minLatestPrice !== latestPrice || maxLatestPrice !== latestPrice)) {
            priceRange = {
                min: minLatestPrice,
                max: maxLatestPrice
            };
        }
    }
    return (0,index_es/* cleanObject */.sW)({
        latestPrice: +discoveryPrice.latestPrice,
        supplierRetailPrice: discoveryPrice.discountPercent ? +discoveryPrice.supplierRetailPrice : undefined,
        discountPercent: discoveryPrice.discountPercent && !isFlashSale ? "-".concat(discoveryPrice.discountPercent, "%") : undefined,
        discountAmount: +discoveryPrice.discountAmount > 0 && !isFlashSale ? +discoveryPrice.discountAmount : undefined,
        priceRange
    });
};
class ProductHelper {
    hasGift(promotions) {
        let items = [];
        promotions.forEach((promotion)=>{
            if (Array.isArray(promotion.benefit.gifts)) {
                var ref;
                items = items.concat((promotion === null || promotion === void 0 ? void 0 : (ref = promotion.benefit) === null || ref === void 0 ? void 0 : ref.gifts) || []);
            }
        });
        return !!items.length;
    }
    convertProductDetail(product) {
        return convertProductDetail(product);
    }
    constructor(milestoneShippingFee){
        this.convertNewProductCard = (product, options)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const { productInfo , promotions , totalAvailable , prices , flashSales , status , pos365StockInfo ,  } = product;
            const { frames , cartV2 , showUom , contactLink , showCtaButton  } = options || {};
            const gifts = [];
            let hasGift = false;
            let freeship = false;
            const productPrice = prices.length ? prices === null || prices === void 0 ? void 0 : prices[0] : undefined;
            // Hiển thị icon freeship nếu đơn hàng lớn hơn hoặc bằng milestoneShippingFee
            if (typeof this.milestoneShippingFee === "number" && this.milestoneShippingFee >= 0 && (productPrice === null || productPrice === void 0 ? void 0 : productPrice.latestPrice) && Number(productPrice === null || productPrice === void 0 ? void 0 : productPrice.latestPrice) >= this.milestoneShippingFee) freeship = true;
            promotions.forEach((el)=>{
                var ref;
                if (el.isDefault && el.applyOn === PromotionApplyOnEnum.product && ((el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : ref.gifts) || []).length) {
                    var ref1;
                    hasGift = true;
                    gifts.push(...((el === null || el === void 0 ? void 0 : (ref1 = el.benefit) === null || ref1 === void 0 ? void 0 : ref1.gifts) || []).map((item)=>({
                            src: item.imageUrl,
                            alt: item.name,
                            sku: item.sku
                        })));
                }
            });
            const optionPromotions = promotions.filter((el)=>!el.isDefault && el.applyOn === PromotionApplyOnEnum.product);
            const selectPromotionId = (ref = optionPromotions[0]) === null || ref === void 0 ? void 0 : ref.id;
            if (optionPromotions.length && optionPromotions[0] && ((ref1 = optionPromotions[0].benefit) === null || ref1 === void 0 ? void 0 : ref1.gifts.length)) {
                var ref8;
                hasGift = true;
                gifts.push(...(((ref8 = optionPromotions[0].benefit) === null || ref8 === void 0 ? void 0 : ref8.gifts) || []).map((item)=>({
                        src: item.imageUrl,
                        alt: item.name,
                        sku: item.sku
                    })));
            }
            let flashSale;
            let isFlashSale = false;
            const flSale = flashSales[0];
            if (flashSales.length) {
                isFlashSale = true;
                const availableToFlSale = product.totalAvailable === null ? flSale.totalCount - flSale.usedCount : Math.min(flSale.totalCount - flSale.usedCount, product.totalAvailable);
                flashSale = (0,index_es/* cleanObject */.sW)({
                    endAt: parseInt(flSale.endTimestampSec) * 1000,
                    text: availableToFlSale > 0 ? (0,i18n.t)("C\xf2n lại {{var0}}", {
                        var0: availableToFlSale
                    }) : (0,i18n.t)("Ch\xe1y h\xe0ng"),
                    discountPercent: typeof (productPrice === null || productPrice === void 0 ? void 0 : productPrice.discountPercent) === "number" ? Math.round(productPrice === null || productPrice === void 0 ? void 0 : productPrice.discountPercent) : undefined
                });
            }
            const showContact = product.totalAvailable === 0 || !isValidPrice(product) || !(product === null || product === void 0 ? void 0 : (ref2 = product.status) === null || ref2 === void 0 ? void 0 : ref2.sellable);
            let addToCart;
            let ctaButton;
            let contactButton;
            if (cartV2) {
                const currentOrderLine = cartV2.flattenItems.find((item)=>{
                    var ref;
                    return item.sku === productInfo.sku && ((ref = item.allowedUserActions) === null || ref === void 0 ? void 0 : ref.includes(types_es/* AllowedUserActionItem.CHANGE_QUANTITY */.rV.CHANGE_QUANTITY));
                });
                const optionPromotions1 = promotions.filter((el)=>!el.isDefault && el.applyOn === PromotionApplyOnEnum.product && el.type === "product");
                const quantityInCart = currentOrderLine && currentOrderLine.quantity || 0;
                addToCart = {
                    onAddToCart: async function() {
                        let quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                        var ref, ref1;
                        const res = await cartV2.onAddSingleItem({
                            sku: productInfo.sku,
                            sellerSku: productInfo.sellerSku,
                            quantity: quantity,
                            promotionId: (ref = optionPromotions1[0]) === null || ref === void 0 ? void 0 : ref.id
                        }, true);
                        const { trackAddToCart , AddToCartType  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
                        const trackAddToCartParams = {
                            product: {
                                sku: productInfo.sellerSku,
                                name: productInfo.name,
                                brand: productInfo.brand,
                                categories: productInfo.categories,
                                price: parseInt(prices === null || prices === void 0 ? void 0 : prices[0].supplierRetailPrice),
                                addToCartPrice: parseFloat(product.prices[0].latestPrice || "")
                            },
                            selectedPromotionId: (ref1 = optionPromotions1[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
                            type: AddToCartType.ADDTOCART
                        };
                        if (res) {
                            trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                                status: "success",
                                cartId: res.id
                            }));
                        } else {
                            trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                                status: "failed"
                            }));
                        }
                    },
                    onIncrease: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onIncrease(currentOrderLine);
                        }
                    },
                    onDecrease: async ()=>{
                        if (currentOrderLine) {
                            if (quantityInCart <= 1) {
                                await cartV2.onRemoveItem(currentOrderLine);
                            } else {
                                await cartV2.onDecrease(currentOrderLine);
                            }
                        }
                    },
                    onRemoveItem: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onRemoveItem(currentOrderLine);
                        }
                    },
                    onChangeQuantity: async (newQuantity)=>{
                        if (currentOrderLine) {
                            await cartV2.onChangeQuantity(currentOrderLine, newQuantity);
                        }
                    },
                    quantityInCart
                };
            }
            if (!showContact) {
                ctaButton = _objectSpread({
                    children: (0,i18n.t)("Th\xeam v\xe0o giỏ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
                    }
                } : {});
            } else {
                if (contactLink) contactButton = _objectSpread({
                    children: (0,i18n.t)("Li\xean hệ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        window.open(contactLink);
                    }
                } : {});
                else ctaButton = {
                    children: (0,i18n.t)("Hết h\xe0ng"),
                    disabled: true
                };
            }
            let titleTag;
            const isOutOfStock = product.totalAvailable === 0;
            if (isOutOfStock) {
                titleTag = {
                    variant: "link",
                    content: (0,i18n.t)("Li\xean hệ đặt h\xe0ng")
                };
            }
            const price = convertPrice(product);
            if (!(price === null || price === void 0 ? void 0 : price.price)) {
                titleTag = {
                    variant: "pending",
                    content: (0,i18n.t)("Li\xean hệ")
                };
            }
            const infoTags = [];
            if (status && status.sellingCode === "hang_khac") {
                infoTags.push({
                    content: (0,i18n.t)("H\xe0ng qu\xe0 tặng"),
                    variant: "default"
                });
            }
            const quantity = totalAvailable === null ? 1000 : isFlashSale ? Math.min(flSale.totalCount - flSale.usedCount, totalAvailable) : totalAvailable;
            const { name , code  } = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.brand) || {
                name: "",
                code: ""
            };
            return _objectSpreadProps(_objectSpread(_objectSpreadProps(_objectSpread({
                sku: productInfo.sku,
                sellerSku: productInfo.sellerSku,
                name: productInfo.displayName || productInfo.name,
                imageUrl: productInfo.imageUrl,
                price: productPrice ? getDisplayPrice(productPrice, isFlashSale) : undefined,
                stockQuantity: quantity,
                warranty: ((ref3 = productInfo.warranty) === null || ref3 === void 0 ? void 0 : ref3.months) ? {
                    months: (ref4 = productInfo.warranty) === null || ref4 === void 0 ? void 0 : ref4.months
                } : undefined,
                freeship,
                flashSale: flashSale,
                addToCart,
                frame: (frames === null || frames === void 0 ? void 0 : frames.length) ? (0,products/* getFrame */.$)(productInfo.tags, frames || []) : undefined,
                hasGift,
                titleTag,
                infoTags,
                link: {
                    as: {
                        pathname: "/".concat(product === null || product === void 0 ? void 0 : (ref5 = product.productInfo) === null || ref5 === void 0 ? void 0 : ref5.canonical),
                        query: (product === null || product === void 0 ? void 0 : (ref6 = product.productInfo) === null || ref6 === void 0 ? void 0 : ref6.canonical) && (0,products/* isVariantUrlGrouped */.X)(product.productInfo.canonical) ? {
                            sku: productInfo.sku
                        } : {}
                    },
                    href: {
                        pathname: ScreenContext/* PRODUCT_DETAIL_PAGE */.uE,
                        query: {
                            sku: productInfo.sku
                        }
                    },
                    passHref: true
                },
                brand: {
                    name: name,
                    code
                },
                ctaButton: showCtaButton ? ctaButton : undefined,
                contactButton
            }, showUom && {
                uom: productInfo.uomName
            }, pos365StockInfo), {
                showContact: isOutOfStock || !isValidPrice(product) || !(product === null || product === void 0 ? void 0 : (ref7 = product.status) === null || ref7 === void 0 ? void 0 : ref7.sellable)
            }), gifts.length > 0 && {
                gifts: {
                    label: (0,i18n.t)("QU\xc0 TẶNG"),
                    images: gifts
                }
            }), {
                selectPromotionId,
                categories: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.categories) || [],
                isAlcoholicCategory: (product === null || product === void 0 ? void 0 : product.isAlcoholicCategory) || (0,confirm18YearsOld/* isAdultCategoryProduct */.C2)(productInfo === null || productInfo === void 0 ? void 0 : productInfo.categories)
            });
        };
        this.milestoneShippingFee = milestoneShippingFee;
    }
}
const productHelper = new ProductHelper();
const getSearchVariables = (param)=>{
    let { isMobile , isBot =false , query , pos365StoreCode , location , returnFilter =true  } = param;
    const defaultVariables = _objectSpreadProps(_objectSpread({
        itemsPerPage: isMobile && !isBot ? search/* MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE */.YH : search/* DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE */.BW,
        location
    }, query), {
        page: query.page || 1
    });
    if (pos365StoreCode) {
        defaultVariables.pos365StoreCode = pos365StoreCode;
    }
    if (returnFilter) {
        defaultVariables.returnFilterable = [
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_ATTRIBUTE",
            "FILTER_TYPE_CLEARANCE", 
        ];
    }
    return defaultVariables;
};
const convertPrice = (product)=>{
    var ref, ref1;
    const { prices  } = product;
    const price = parseInt(prices === null || prices === void 0 ? void 0 : (ref = prices[0]) === null || ref === void 0 ? void 0 : ref.latestPrice);
    const supplierRetailPrice = parseInt(prices === null || prices === void 0 ? void 0 : (ref1 = prices[0]) === null || ref1 === void 0 ? void 0 : ref1.supplierRetailPrice);
    const listedPrice = price > supplierRetailPrice ? null : supplierRetailPrice;
    const discount = listedPrice ? getDiscountPercent(price, listedPrice) : undefined;
    return {
        price: isNaN(price) ? undefined : price,
        listedPrice: listedPrice !== null && listedPrice !== void 0 ? listedPrice : undefined,
        discount: discount
    };
};
const getDiscountPercent = (finalPrice, oldPrice)=>{
    let discount = 0;
    if (oldPrice) {
        discount = 100 - Math.round(finalPrice * 100 / oldPrice);
    }
    return discount;
};
class DiscoveryHelper {
    /**
   * @discovery_v2
   *- clean discovery search product data
   *- convert to product card props
   */ cleanupDiscoveryV2SearchProduct(product, configs, omitKeys) {
        var ref, ref1, ref2, ref3;
        const { frames , cartV2  } = configs || {};
        const { isDisplayUom: showUom , allowAddToCartFromListing: showCtaButton , contactLink ,  } = this.tenantConfig;
        const getProductPrice = ()=>{
            const minLatestPrice = product.minLatestPrice ? parseFloat(product.minLatestPrice) : undefined;
            const maxLatestPrice = product.maxLatestPrice ? parseFloat(product.maxLatestPrice) : undefined;
            return (0,index_es/* cleanObject */.sW)(_objectSpread({
                latestPrice: Number(product.latestPrice) || undefined,
                supplierRetailPrice: parseInt(product.supplierRetailPrice || "0"),
                discountAmount: // not display save... incase there is config flash sale
                !parseInt(product.promotionEndTime || "0") && product.discountAmount ? parseInt(product.discountAmount) : undefined,
                discountPercent: product.discountPercent ? "-".concat(product.discountPercent, "%") : ""
            }, minLatestPrice && maxLatestPrice && minLatestPrice !== maxLatestPrice ? {
                priceRange: {
                    min: minLatestPrice,
                    max: maxLatestPrice
                }
            } : {}));
        };
        const price = getProductPrice();
        const getTitleTag = ()=>{
            const isOutOfStock = product.totalAvailable === 0;
            if (isOutOfStock) {
                return {
                    variant: "link",
                    content: (0,i18n.t)("Li\xean hệ đặt h\xe0ng")
                };
            }
            if (!price.latestPrice) {
                return {
                    variant: "pending",
                    content: (0,i18n.t)("Li\xean hệ")
                };
            }
        };
        var _totalAvailable;
        const quantity = (_totalAvailable = product.totalAvailable) !== null && _totalAvailable !== void 0 ? _totalAvailable : 1000;
        const showContact = product.totalAvailable === 0 || !price.latestPrice || !product.sellable;
        const getContactButton = ()=>{
            if (cartV2 && contactLink && showContact) return _objectSpread({
                children: (0,i18n.t)("Li\xean hệ"),
                variant: "secondary"
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    e.preventDefault();
                    window.open(contactLink);
                }
            } : {});
        };
        const result = _objectSpreadProps(_objectSpread({
            sku: product.sku || "",
            sellerSku: product.sellerSku || "",
            name: product.name || "",
            imageUrl: product.imageUrl || "",
            price: price,
            stockQuantity: quantity,
            selectPromotionId: product.selectedPromotionId,
            freeship: typeof this._productHelper.milestoneShippingFee === "number" && this._productHelper.milestoneShippingFee >= 0 && ((price === null || price === void 0 ? void 0 : price.latestPrice) || 0) > 0 && Number(price === null || price === void 0 ? void 0 : price.latestPrice) >= this._productHelper.milestoneShippingFee,
            frame: (frames === null || frames === void 0 ? void 0 : frames.length) ? (0,products/* getFrame */.$)(product.tags || [], frames || []) : undefined,
            hasGift: (((ref = product.gifts) === null || ref === void 0 ? void 0 : ref.length) || 0) > 0,
            titleTag: getTitleTag(),
            link: {
                as: {
                    pathname: "/".concat(product === null || product === void 0 ? void 0 : product.canonical),
                    query: (0,products/* isVariantUrlGrouped */.X)(product.canonical || "") ? {
                        sku: product.sku
                    } : {}
                },
                href: {
                    pathname: ScreenContext/* PRODUCT_DETAIL_PAGE */.uE,
                    query: {
                        sku: product.sku
                    }
                },
                passHref: true
            },
            brand: {
                name: product.brandName || "",
                code: ((ref1 = product.brandCode) === null || ref1 === void 0 ? void 0 : ref1.toString()) || ""
            }
        }, showUom ? {
            uom: product.uomName
        } : {}), {
            contactButton: showCtaButton ? getContactButton() : undefined,
            gifts: ((ref2 = product.gifts) === null || ref2 === void 0 ? void 0 : ref2.length) ? {
                label: (0,i18n.t)("QU\xc0 TẶNG"),
                images: (ref3 = product.gifts) === null || ref3 === void 0 ? void 0 : ref3.map((gift)=>({
                        src: gift.imageUrl || "",
                        alt: gift.name || "",
                        sku: ""
                    }))
            } : undefined,
            flashSale: parseInt(product.promotionEndTime || "0") ? (0,index_es/* cleanObject */.sW)({
                endAt: parseInt(product.promotionEndTime || "0") * 1000,
                text: (product.totalAvailable || 0) > 0 ? (0,i18n.t)("C\xf2n lại {{var0}}", {
                    var0: product.totalAvailable
                }) : (0,i18n.t)("Ch\xe1y h\xe0ng"),
                discountPercent: Math.round((product === null || product === void 0 ? void 0 : product.discountPercent) || 0),
                endTimestampSec: product.promotionEndTime
            }) : undefined,
            isAlcoholicCategory: product.isAdult,
            showContact: showContact
        });
        const productResult = (0,utils_es/* omit */.CE)(result, omitKeys || []);
        return (0,index_es/* cleanObject */.sW)(productResult);
    }
    /**
   * @discovery_v1
   * - clean discovery search product data
   * - convert to product card props
   */ cleanupDiscoverySearchProduct(product, configs, omitKeys) {
        const { isDisplayUom: showUom , allowAddToCartFromListing: showCtaButton , contactLink ,  } = this.tenantConfig;
        const result = this._productHelper.convertNewProductCard(product, _objectSpread({
            showUom,
            showCtaButton,
            contactLink
        }, configs));
        const productResult = (0,utils_es/* omit */.CE)(result, omitKeys || []);
        return (0,index_es/* cleanObject */.sW)(productResult);
    }
    /**
   * don't use this function in swr fetcher
   * because cartState sometimes be updated
   */ createHandleEventAndCtaButton(product, configs) {
        const { cartV2 , contactLink , showCtaButton  } = configs || {};
        const getAddToCart = ()=>{
            if (cartV2) {
                const currentOrderLine = cartV2.flattenItems.find((item)=>{
                    var ref;
                    return item.sku === product.sku && ((ref = item.allowedUserActions) === null || ref === void 0 ? void 0 : ref.includes(types_es/* AllowedUserActionItem.CHANGE_QUANTITY */.rV.CHANGE_QUANTITY));
                });
                const quantityInCart = currentOrderLine && currentOrderLine.quantity || 0;
                if (!(0,helpers/* isServerless */.ep)()) return;
                const onAddToCart = async (quantity)=>{
                    var ref, ref1, ref2;
                    const res = await cartV2.onAddSingleItem({
                        sku: product.sku || "",
                        sellerSku: product.sellerSku,
                        quantity: quantity,
                        promotionId: product.selectPromotionId !== 0 ? product.selectPromotionId : undefined
                    }, true);
                    const { trackAddToCart , AddToCartType  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
                    const trackAddToCartParams = {
                        product: {
                            sku: product.sellerSku || "",
                            name: product.name || "",
                            price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice,
                            brand: {
                                name: ((ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                            },
                            addToCartPrice: ((ref2 = product.price) === null || ref2 === void 0 ? void 0 : ref2.supplierRetailPrice) || 0
                        },
                        selectedPromotionId: product.selectPromotionId,
                        type: AddToCartType.ADDTOCART
                    };
                    if (res) {
                        trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                            status: "success",
                            cartId: res.id
                        }));
                    } else {
                        trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                            status: "failed"
                        }));
                    }
                };
                return {
                    onAddToCart: async function() {
                        let quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                        if ((0,env/* getEnv */.dU)("USE_OPTIMIZED_METHOD_ADD_TO_CART") === "true") {
                            /*** https://jira.teko.vn/browse/UX4BUYER-6179
               * Use pattern zero delay to make sure that the cartV2?.setLoading?.(true) is called before the onAddToCart
               * This allows other tasks such as rendering and input handling to be completed before the onAddToCart is called
               * As a result, it will reduce the delay time for the user to see the loading state and gain a better experience
               */ setTimeout(async ()=>{
                                var ref, ref1;
                                cartV2 === null || cartV2 === void 0 ? void 0 : (ref = cartV2.setLoading) === null || ref === void 0 ? void 0 : ref.call(cartV2, true);
                                await onAddToCart(quantity);
                                cartV2 === null || cartV2 === void 0 ? void 0 : (ref1 = cartV2.setLoading) === null || ref1 === void 0 ? void 0 : ref1.call(cartV2, false);
                            }, 0);
                        } else {
                            await onAddToCart(quantity);
                        }
                    },
                    onIncrease: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onIncrease(currentOrderLine);
                        }
                    },
                    onDecrease: async ()=>{
                        if (currentOrderLine) {
                            if (quantityInCart <= 1) {
                                await cartV2.onRemoveItem(currentOrderLine);
                            } else {
                                await cartV2.onDecrease(currentOrderLine);
                            }
                        }
                    },
                    onRemoveItem: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onRemoveItem(currentOrderLine);
                        }
                    },
                    onChangeQuantity: async (newQuantity)=>{
                        if (currentOrderLine) {
                            await cartV2.onChangeQuantity(currentOrderLine, newQuantity);
                        }
                    },
                    quantityInCart
                };
            }
        };
        const getCtaButton = ()=>{
            if (!product.showContact) return _objectSpread({
                children: (0,i18n.t)("Th\xeam v\xe0o giỏ"),
                variant: "secondary"
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    e.preventDefault();
                    addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
                }
            } : {});
            else {
                if (contactLink) return _objectSpread({
                    children: (0,i18n.t)("Li\xean hệ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        window.open(contactLink);
                    }
                } : {});
                else return {
                    children: (0,i18n.t)("Hết h\xe0ng"),
                    disabled: true
                };
            }
        };
        const addToCart = showCtaButton ? getAddToCart() : undefined;
        const ctaButton = showCtaButton ? getCtaButton() : undefined;
        const contactButton = showCtaButton ? product.contactButton : undefined;
        return _objectSpreadProps(_objectSpread({}, product), {
            ctaButton,
            addToCart,
            contactButton
        });
    }
    constructor(tenantConfig){
        this.tenantConfig = tenantConfig;
        this._productHelper = new ProductHelper(tenantConfig.freeShippingThreshold);
    }
}
// helpers for search page
const convertDiscoveryFilter = (filters)=>{
    var // attributes
    ref, ref1, ref2, ref3;
    if (!filters) return [];
    const convertedFilters = [];
    (ref = filters.attributes) === null || ref === void 0 ? void 0 : ref.forEach((attribute)=>{
        var ref;
        if ((ref = attribute.values) === null || ref === void 0 ? void 0 : ref.length) {
            convertedFilters.push({
                id: "attributes.id.".concat(attribute.id),
                code: "attributes.".concat(attribute.code),
                name: attribute.name || "",
                options: attribute.values.map((value)=>({
                        filterId: attribute.id !== undefined ? "attributes.id.".concat(attribute.id) : null,
                        filterCode: attribute.code ? "attributes.".concat(attribute.code) : null,
                        optionId: value.optionId || null,
                        optionName: value.value || "",
                        selected: value.selected || false
                    }))
            });
        }
    });
    // brands
    if ((ref1 = filters.brands) === null || ref1 === void 0 ? void 0 : ref1.length) {
        convertedFilters.push({
            code: "brands",
            name: "Thương hiệu",
            options: filters.brands.map((brand)=>({
                    filterId: null,
                    filterCode: "brands",
                    optionId: brand.code || null,
                    optionName: brand.name || "",
                    selected: brand.selected || false
                }))
        });
    }
    // clearanceTypes
    if (filters === null || filters === void 0 ? void 0 : (ref2 = filters.clearanceTypes) === null || ref2 === void 0 ? void 0 : ref2.length) {
        convertedFilters.push({
            code: "clearanceTypeIds",
            name: "T\xecnh trạng sản phẩm",
            options: filters.clearanceTypes.map((clearanceType)=>({
                    filterId: null,
                    filterCode: "clearanceTypeIds",
                    optionId: clearanceType.id === undefined ? null : clearanceType.id,
                    optionName: clearanceType.name || "",
                    selected: clearanceType.selected || false
                }))
        });
    }
    // masterCategories
    if (filters === null || filters === void 0 ? void 0 : (ref3 = filters.masterCategories) === null || ref3 === void 0 ? void 0 : ref3.length) {
        convertedFilters.push({
            code: "masterCategoryIds",
            name: "Danh mục sản phẩm",
            options: filters.masterCategories.map((category)=>({
                    filterId: null,
                    filterCode: "masterCategoryIds",
                    optionId: category.masterCategoryId === undefined ? null : category.masterCategoryId,
                    optionName: category.sellerCategoryName || "",
                    selected: category.selected || false
                }))
        });
    }
    return convertedFilters;
};
const convertToPayloadFilter = (filterParams)=>{
    const result = {};
    const attributes = [];
    const listingAndSearchFieldsMap = {
        price_lte: "priceLte",
        price_gte: "priceGte",
        sellerCategories: "masterCategoryIds"
    };
    Object.keys(filterParams).forEach((key)=>{
        // legacy params
        if (listingAndSearchFieldsMap[key]) {
            result[listingAndSearchFieldsMap[key]] = filterParams[key];
        }
        // attributes
        if (key.startsWith("attributes.")) {
            if (key.startsWith("attributes.id.")) {
                attributes.push({
                    id: parseInt(key.replace("attributes.id.", "")),
                    optionIds: filterParams[key].split(",")
                });
            } else {
                attributes.push({
                    code: key.replace("attributes.", ""),
                    optionIds: filterParams[key].split(",")
                });
            }
        } else if (constants_es/* PRIMITIVE_PAYLOAD_FILTER.includes */.ct.includes(key)) {
            result[key] = filterParams[key];
        } else if (constants_es/* ARRAY_OF_NUMBER_PAYLOAD_FILTER.includes */.O4.includes(key)) {
            result[key] = typeof filterParams[key] === "string" ? filterParams[key].split(",").map((el)=>+el) : filterParams[key].map((el)=>+el);
        } else if (constants_es/* ARRAY_OF_STRING_PAYLOAD_FILTER.includes */.Jk.includes(key)) {
            result[key] = typeof filterParams[key] === "string" ? filterParams[key].split(",") : filterParams[key];
        }
    });
    if (filterParams["attributes"] || attributes.length) {
        result["attributes"] = [
            ...filterParams["attributes"] || [],
            ...attributes, 
        ];
    }
    return result;
};
const convertToPayloadSorting = (sort, order)=>{
    return {
        sort: sort !== null && sort !== void 0 ? sort : "SORT_BY_UNSPECIFIED",
        order: order && constants_es/* ORDER_PAYLOAD_SORTING */.rA[order] ? constants_es/* ORDER_PAYLOAD_SORTING */.rA[order] : "ORDER_BY_UNSPECIFIED"
    };
};


/***/ }),

/***/ 53632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ setSessionStorageIfNotExist; },
/* harmony export */   "MA": function() { return /* binding */ setUserSelectedInfo; },
/* harmony export */   "Sk": function() { return /* binding */ getUserSelectedInfo; },
/* harmony export */   "dU": function() { return /* binding */ getEnv; }
/* harmony export */ });
/* unused harmony export removeUserSelectedInfo */
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31260);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88813);


const getCookieByName = (cname)=>{
    const match = document.cookie.match(new RegExp("(^| )" + cname + "=([^;]+)"));
    if (match) return match[2];
    return null;
};
const getEnv = (variable, defaultValue)=>{
    var ref;
    if (false) {}
    return ((ref = window.env) === null || ref === void 0 ? void 0 : ref[variable]) || defaultValue;
};
/**
 * For some tenant, there are multiple terminal codes (Nam, Bac, Trung ...)
 * Let user select the corresponding terminal
 * save it to localStorage and cookie
 */ const getUserSelectedInfo = function(key) {
    let isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        const dataLS = window.localStorage.getItem(lsKey);
        const dataCookie = getCookieByName(cookieKey);
        // https://jira.teko.vn/browse/CSFRONT-649
        // due Safari not allowing cookie in iframe
        // we will load data from local storage instead
        // and accept that location & terminal of SSR differs from
        // that being stored in localStorage.
        // For vnshop, vietin... there is only one terminal and multiple locations
        // so that won't cause many trouble.
        if ((0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__/* .inIframe */ .yL)()) {
            // check if it's in iframe
            // we don't want to affect existing logic
            return dataCookie || dataLS;
        }
        return dataCookie && dataLS === dataCookie ? dataCookie : null;
    }
    return null;
};
const setUserSelectedInfo = function(key, value) {
    let isMobile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        window.localStorage.setItem(lsKey, value);
        document.cookie = "".concat(cookieKey, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;");
        const isHttps = window.location.protocol === "https:";
        const date = new Date();
        date.setFullYear(date.getFullYear() + 2);
        document.cookie = "".concat(cookieKey, "=").concat(value, ";expires=").concat(date.toUTCString(), ";Path=/;").concat(isHttps ? "SameSite=None;Secure;" : "");
    }
};
const removeUserSelectedInfo = function(key) {
    let isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        window.localStorage.removeItem(lsKey);
        const isHttps = window.location.protocol === "https:";
        const date = new Date();
        date.setFullYear(date.getFullYear() + 2);
        document.cookie = "".concat(cookieKey, "=;expires=").concat(date.toUTCString(), ";Path=/;").concat(isHttps ? "SameSite=None;Secure;" : "");
    }
};
const setSessionStorageIfNotExist = (key, value)=>{
    if ((0,_index__WEBPACK_IMPORTED_MODULE_1__/* .isServerless */ .ep)() && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, value);
    }
};


/***/ }),

/***/ 88813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EU": function() { return /* binding */ isVnpay; },
/* harmony export */   "Hw": function() { return /* binding */ getLocalDomain; },
/* harmony export */   "N6": function() { return /* binding */ checkExpiryDate; },
/* harmony export */   "ON": function() { return /* binding */ checkExpiredOrder; },
/* harmony export */   "Re": function() { return /* binding */ setCookieByName; },
/* harmony export */   "Y2": function() { return /* binding */ transformExtraPromotion; },
/* harmony export */   "ep": function() { return /* binding */ isServerless; },
/* harmony export */   "hH": function() { return /* binding */ buildSlugUrl; },
/* harmony export */   "sl": function() { return /* binding */ reloadPage; }
/* harmony export */ });
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89172);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20577);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















const transformExtraPromotion = (promotion)=>{
    return _objectSpreadProps(_objectSpread({}, promotion), {
        date: {
            endDate: new Date(promotion.date.endDate).toISOString(),
            startDate: new Date(promotion.date.startDate).toISOString()
        }
    });
};
const formatDateString = (date)=>{
    if (date.charAt(date.length - 1) == "Z") {
        return date;
    } else {
        return date.replace(/-/g, "/");
    }
};
const checkExpiryDate = (startDate, endDate)=>{
    const today = new Date().getTime();
    startDate = formatDateString(startDate);
    endDate = formatDateString(endDate);
    try {
        const startTime = new Date(startDate).getTime();
        const endTime = new Date(endDate).getTime();
        if (today - startTime > 0 && endTime - today > 0) return true;
        return false;
    } catch (e) {
        return false;
    }
};
const checkExpiredOrder = (predictCancelAt)=>{
    if (!predictCancelAt) return false;
    if (typeof predictCancelAt === "string") return new Date(/((\+\d{2}:\d{2})|Z)$/.test(predictCancelAt) // unknown timezone 2020-11-03T09:34:45 ???
     ? predictCancelAt : "".concat(predictCancelAt, "Z")) < new Date();
    return predictCancelAt < new Date();
};
const setCookieByName = (cname, cvalue, expireTime, path)=>{
    document.cookie = "".concat(cname, "=").concat(cvalue).concat(expireTime ? ";expires=".concat(expireTime) : "").concat(path ? ";path=".concat(path) : "");
};
const buildSlugUrl = function(pageType, name, id) {
    let isSellerCat = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref;
    const trimmedId = (ref = id === null || id === void 0 ? void 0 : id.toString()) === null || ref === void 0 ? void 0 : ref.trim();
    const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
    if (!trimmedName || !trimmedName) return null;
    switch(pageType){
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY:
            if (isSellerCat) return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-scat.").concat(trimmedId);
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-cat.").concat(trimmedId);
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND:
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-brand.").concat(trimmedId);
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER:
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-sel.").concat(trimmedId);
        default:
            return null;
    }
};
const isVnpay = (partner)=>[
        "vietin",
        "vcb",
        "vnmart",
        "icheck",
        "agri",
        "bidv",
        "vp",
        "ivb",
        "exim",
        "abb",
        // do not change priority of sacombank pay and sacombankmb
        "sacombankmb",
        "sacombank",
        "saigonbank",
        "namabank",
        "bidc",
        "vietabank",
        "kienlongbank",
        "vnptpay", 
    ].includes(partner);
const isServerless = ()=>"object" !== "undefined";
/**
 *
 * @param hostname
 * @param env
 * @returns
 * convert [platform].localhost:3000 => [platform].[env].teko.vn
 */ const getLocalDomain = function(hostname) {
    let env = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dev";
    if (/[^\.]*\.?localhost[^]*/g.test(hostname) === false) return hostname;
    return hostname.replace(/([^\.]*)\.?(localhost[^]*)/g, function(_) {
        let platform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vnshop";
        return (platform || "vnshop") + ".".concat(env, ".teko.vn");
    });
};
const reloadPage = ()=>{
    if ( false || typeof window.location === "undefined") {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("This function seems to be executed on server or not to be supported in the current browser");
        return;
    }
    window.location.href = window.location.origin + window.location.pathname + window.location.search;
};


/***/ }),

/***/ 46130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getFrame; },
/* harmony export */   "X": function() { return /* binding */ isVariantUrlGrouped; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4133);

const getFrame = (tags, frames)=>{
    const ids = [];
    tags.forEach((el)=>{
        const matchReg = el.match(/^frame_(\d+)_.+/);
        if (matchReg && matchReg[1] && !isNaN(parseInt(matchReg[1]))) {
            ids.push(parseInt(matchReg[1]));
        }
    });
    const frame = frames.find((fr)=>ids.includes(parseInt(fr.id)) && fr.startDate && fr.endDate && (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .checkExpiryDateTimestamp */ .Z2)(fr.startDate, fr.endDate));
    return frame ? frame.image : undefined;
};
const isVariantUrlGrouped = (canonical)=>{
    // some product need to group all skus into a single url
    // we don't have that flag returned to client
    // so rely on url pattern for now, which may not be
    // very reliable in the future
    // for such product, canonical is /product-name--p<productId>
    return (canonical === null || canonical === void 0 ? void 0 : canonical.indexOf("--p")) >= 0;
};


/***/ }),

/***/ 49284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ServiceContainer; }
});

// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(99278);
;// CONCATENATED MODULE: ../../packages/auth/dist/jwt.es.js
function jwtDecode(jwtToken) {
  const chunks = jwtToken.split(".");
  return {
    header: JSON.parse(atob(chunks[0])),
    payload: JSON.parse(atob(chunks[1]))
  };
}



// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(47143);
// EXTERNAL MODULE: ../../packages/auth/dist/user.es.js
var user_es = __webpack_require__(99002);
// EXTERNAL MODULE: ../../.yarn/cache/teko-oauth2-npm-1.8.4-889eaf4080-03bb426ce2.zip/node_modules/teko-oauth2/dist/index.js
var dist = __webpack_require__(31069);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(20577);
;// CONCATENATED MODULE: ../../packages/auth/dist/service.es.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
let tekoOAuthPromise = null;
const IAM_ERRORS_MAP = {
  "1019": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c",
  "1020": "\u0110\u1ECBa ch\u1EC9 email \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c.",
  "1021": "\u0110\u1ECBa ch\u1EC9 email kh\xE1c \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho t\xE0i kho\u1EA3n n\xE0y",
  "1040": "M\xE3 OTP kh\xF4ng ch\xEDnh x\xE1c",
  "1015": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "1800": "\u0110\xE3 g\u1EEDi qu\xE1 nhi\u1EC1u y\xEAu c\u1EA7u, vui l\xF2ng quay l\u1EA1i sau"
};
class AuthService {
  constructor(iamUrl, iamClientId, iamOauthDomain) {
    this.initialize = async (scopes) => {
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        if (!tekoOAuthPromise) {
          tekoOAuthPromise = dist/* default.init */.Z.init({
            clientId: this.iamClientId,
            scopes,
            oauthDomain: this.iamOauthDomain,
            postLogoutRedirectUri: window.location.origin
          });
        }
        return tekoOAuthPromise.then(() => {
          var _a, _b, _c, _d, _e, _f, _g;
          tekoOAuthPromise = null;
          (_d = (_c = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.events) == null ? void 0 : _c.addSilentRenewError) == null ? void 0 : _d.call(_c, (err) => {
            var _a2;
            window.track("customEvent", "silentRenewError", {
              action: "silentRenew",
              category: "customer",
              label: JSON.stringify({
                message: err == null ? void 0 : err.message,
                stack: err == null ? void 0 : err.stack
              }),
              property: "tekoid-js"
            });
            (_a2 = this.tekoID.user) == null ? void 0 : _a2.loginSilent().catch((retryErr) => {
              dist_index_es/* logger.error */.k.error(retryErr);
            });
          });
          (_g = (_f = (_e = this.tekoID) == null ? void 0 : _e.user) == null ? void 0 : _f.events) == null ? void 0 : _g.addAccessTokenExpired(() => {
            window.track("customEvent", "accessTokenExpired", {
              action: "silentRenew",
              category: "customer",
              property: "tekoid-js"
            });
          });
        }).catch((error) => {
          dist_index_es/* logger.error */.k.error(error);
          tekoOAuthPromise = null;
        });
      } else {
        return Promise.resolve();
      }
    };
    this.requestLogin = async (challenge) => {
      try {
        const { data } = await this.authApi.get(`/v1/requests/login/${challenge}`, {});
        return data;
      } catch (er) {
        dist_index_es/* logger.error */.k.error(er);
        if (typeof window !== "undefined")
          window.location.href = "/";
      }
    };
    this.login = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.login(redirectUrl || (window.location.pathname === "/" ? void 0 : window.location.href));
    };
    this.logout = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.logout(redirectUrl);
      user_es/* userManager.onLoggedOut */.Z.onLoggedOut();
    };
    this.requestLogout = async (challenge) => {
      const {
        data: { redirect_to: redirectTo }
      } = await this.authApi.post(`/v1/requests/logout/${challenge}`, {
        challenge,
        confirmed: true
      });
      user_es/* userManager.onLoggedOut */.Z.onLoggedOut();
      if (redirectTo)
        window.location.assign(redirectTo);
    };
    this.loginSocialIAM = async (challenge, accessToken, authorizer) => {
      return await this.authApi.post("/v1/social/login", {
        challenge,
        access_token: accessToken,
        authorizer
      });
    };
    this.sendOTP = async (challenge, phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/passwordless/send", __spreadValues({
        challenge,
        phone_number: phone,
        client_id: this.iamClientId
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.sendOTPUpdatePhone = async (phone) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phone
      });
      return data;
    };
    this.register = async (phone, name) => {
      const { data } = await this.authApi.post(`/v1/users/register`, {
        username: phone,
        password: Math.random().toString(36).slice(-16),
        name
      });
      return data;
    };
    this.loginIAMWithPhone = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/passwordless/login", {
        challenge,
        phone_number: phone,
        code: otp
      });
      return data;
    };
    this.activeIAMPhoneAccount = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/users/confirm", {
        challenge,
        username: phone,
        code: otp
      });
      return data;
    };
    this.resendOTP = async (phone, mode, challenge = "", recaptchaToken) => {
      if (mode === "login")
        return await this.sendOTP(challenge, phone, recaptchaToken);
      const { data } = await this.authApi.post("/v1/users/activation/resend", {
        username: phone
      });
      return data;
    };
    this.refreshToken = async (refreshToken) => {
      const queries = `grant_type=refresh_token&client_id=${this.iamClientId}&refresh_token=${refreshToken}`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithFederation = async (idToken, authorizer) => {
      const queries = `grant_type=federated_idp&client_id=${this.iamClientId}&jwt_token=${idToken}&authorizer=${authorizer}&scope=openid profile read:permissions us ps ppm om`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithIBanking = async (data) => {
      const { partner_code } = data;
      let queries = `grant_type=ibanking&client_id=${this.iamClientId}&data=${data.data}&signature=${data.signature}&scope=openid profile read:permissions us ps ppm om`;
      if (partner_code) {
        queries = `${queries}&partner_code=${partner_code}`;
      }
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      const { ibanking_info } = responseData;
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub,
        bankCode: ibanking_info == null ? void 0 : ibanking_info.bankcode,
        phone: ibanking_info == null ? void 0 : ibanking_info.mobile
      });
      return responseData;
    };
    this.loginWithTerra = (loginInfo) => {
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        userId: loginInfo.userId,
        name: loginInfo.name,
        accessToken: loginInfo.accessToken,
        phone: loginInfo.phone,
        picture: loginInfo.picture,
        email: loginInfo.email
      });
      return user_es/* userManager.getLSInfo */.Z.getLSInfo();
    };
    this.getLoginInfo = () => {
      return user_es/* userManager.getInfo */.Z.getInfo();
    };
    this.isLoggedIn = () => {
      return !!user_es/* userManager.getAccessToken */.Z.getAccessToken();
    };
    this.verifyPhone = async (phoneNumber) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phoneNumber
      });
      return data;
    };
    this.verifyEmail = async (email) => {
      const { data } = await this.authApi.post("/v1/me/email/verify", { email });
      return data;
    };
    this.updatePhone = async (phoneNumber, otp) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/update", {
        phone_number: phoneNumber,
        code: otp
      });
      return data;
    };
    this.updateEmail = async (email, otp) => {
      const { data } = await this.authApi.post("/v1/me/email/update", {
        email,
        code: otp
      });
      return data;
    };
    this.errorMsg = (err) => {
      var _a;
      const errorCode = typeof err === "string" ? err : (_a = err == null ? void 0 : err.error) == null ? void 0 : _a.code;
      return IAM_ERRORS_MAP[errorCode];
    };
    this.iamUrl = iamUrl;
    this.iamClientId = iamClientId;
    this.iamOauthDomain = iamOauthDomain;
    this.authApi = new index_es/* default */.ZP(iamUrl);
    this.authApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
  }
  get tekoID() {
    return window.TekoID;
  }
}



;// CONCATENATED MODULE: ../../packages/user/dist/error.es.js


const getError = (res) => {
  return new index_es/* ApiError */.MS("", 400, res);
};



;// CONCATENATED MODULE: ../../packages/user/dist/service.es.js




var service_es_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var service_es_defNormalProp = (obj, key, value) => key in obj ? service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (service_es_hasOwnProp.call(b, prop))
      service_es_defNormalProp(a, prop, b[prop]);
  if (service_es_getOwnPropSymbols)
    for (var prop of service_es_getOwnPropSymbols(b)) {
      if (service_es_propIsEnum.call(b, prop))
        service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizeData = (responseAddresses) => {
  return responseAddresses.map((addr) => __spreadProps(service_es_spreadValues({}, addr), { addressId: addr.id }));
};
class UserService {
  constructor(userServiceUrl, platformCode, platformId, getCustomAccessToken) {
    this.myProfile = async (params = {}) => {
      var _a;
      const { data } = await this.userApi.get("/profiles", {
        params: this.getParams(params)
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.updateProfile = async (body) => {
      var _a;
      const { data } = await this.userApi.patch("/profiles", body, {
        params: this.getParams({})
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.getClient = async () => {
      var _a;
      const { data } = await this.userApi.get(`/clients?platformIds=${this.platformId}`);
      return (_a = data.result) == null ? void 0 : _a.clients;
    };
    this.updateBillings = async (body) => {
      const { data } = await this.userApi.post("/billings", body, {
        params: this.getParams({})
      });
      return data;
    };
    this.getMyAddresses = async () => {
      const {
        data: {
          result: { addresses }
        }
      } = await this.userApi.get("/addresses", {
        params: this.getParams({})
      });
      return normalizeData(addresses);
    };
    this.createAddress = async (address) => {
      const {
        data: {
          result: { address: addressResp }
        }
      } = await this.userApi.post("/addresses", __spreadProps(service_es_spreadValues({}, address), {
        platformId: this.platformId
      }));
      return addressResp;
    };
    this.updateAddress = async (addressId, address) => {
      await this.userApi.patch(`/addresses/${addressId}`, __spreadProps(service_es_spreadValues({}, address), {
        platformId: this.platformId
      }));
    };
    this.getAddress = async (addressId) => {
      const {
        data: {
          result: { address }
        }
      } = await this.userApi.get(`/addresses/${addressId}`);
      return address;
    };
    this.deleteAddress = async (addressId) => {
      const { data } = await this.userApi.delete(`/addresses/${addressId}`);
      return data;
    };
    this.viewPoint = async () => {
      return await this.userApi.get("/loyalty/viewpoint", {
        params: this.getParams({})
      });
    };
    this.registerLoyaltyMember = async (data) => {
      return await this.userApi.post("/loyalty/members", data, {
        params: this.getParams({})
      });
    };
    this.getRefCodeInfo = async (refCode) => {
      return this.userApi.get(`/dealer_farmer/ref/${refCode}`).then((res) => res.data);
    };
    this.confirmFarmer = async (refCode) => {
      return this.userApi.post("/dealer_farmer/confirm", {
        referenceCode: refCode
      });
    };
    this.upsertProfile = async (profileUpsertObject) => {
      const { data } = await this.userApi.post("/profiles/upsert", profileUpsertObject, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.searchProfile = async (params = {}) => {
      const { data } = await this.userApi.get("/profiles/search", {
        params: this.getParams(params)
      });
      return data == null ? void 0 : data.data;
    };
    this.customerTypes = async (params = {}) => {
      const { data } = await this.userApi.get("/customer-types", {
        params: this.getParams(params)
      });
      return data;
    };
    this.getProfileDetail = async (profileId) => {
      const { data } = await this.userApi.get(`/profiles/${profileId}`, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.userApi = new index_es/* default */.ZP(userServiceUrl, getError);
    this.platformCode = platformCode;
    this.platformId = platformId;
    if (typeof getCustomAccessToken === "function") {
      this.userApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.userApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    }
  }
  getParams(params) {
    return service_es_spreadValues(service_es_spreadValues(service_es_spreadValues({}, !!this.platformCode ? { platformCode: this.platformCode } : {}), !!this.platformId ? { platformId: this.platformId } : {}), params);
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/constants.es.js
var SORT_TYPE = /* @__PURE__ */ ((SORT_TYPE2) => {
  SORT_TYPE2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SORT_TYPE2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SORT_TYPE2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SORT_TYPE2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SORT_TYPE2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SORT_TYPE2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  return SORT_TYPE2;
})(SORT_TYPE || {});
var SORT_ORDER = /* @__PURE__ */ ((SORT_ORDER2) => {
  SORT_ORDER2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  SORT_ORDER2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  SORT_ORDER2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return SORT_ORDER2;
})(SORT_ORDER || {});



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(41713);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/service.es.js





var dist_service_es_defProp = Object.defineProperty;
var service_es_defProps = Object.defineProperties;
var service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var dist_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var dist_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var dist_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var dist_service_es_defNormalProp = (obj, key, value) => key in obj ? dist_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var dist_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (dist_service_es_hasOwnProp.call(b, prop))
      dist_service_es_defNormalProp(a, prop, b[prop]);
  if (dist_service_es_getOwnPropSymbols)
    for (var prop of dist_service_es_getOwnPropSymbols(b)) {
      if (dist_service_es_propIsEnum.call(b, prop))
        dist_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var service_es_spreadProps = (a, b) => service_es_defProps(a, service_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (dist_service_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && dist_service_es_getOwnPropSymbols)
    for (var prop of dist_service_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && dist_service_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class DiscoveryService {
  constructor(discoveryApiUrl, terminalId, terminalCode, language, getCustomAccessToken) {
    this._isArrayValue = [
      "sellerCodes",
      "brands",
      "categories",
      "categoryIds",
      "tags",
      "providerIds",
      "sellerIds",
      "skus",
      "masterCategories",
      "masterCategoryIds",
      "excludedSkus",
      "returnFilterable",
      "excludedSkus",
      "clearanceTypeIds"
    ];
    this._discoveryPayloadKeys = [
      "terminalCode",
      "terminalId",
      "query",
      "filter",
      "pagination",
      "sorting",
      "userId",
      "phoneNumber",
      "location",
      "returnFilterable",
      "block",
      "pos365StoreCode",
      "slug",
      "terminalId"
    ];
    this._discoveryBlockKeys = ["blockId", "itemId"];
    this._discoveryFilterKeys = [
      "sellingCodes",
      "priceLte",
      "priceGte",
      "brands",
      "categories",
      "categoryIds",
      "tags",
      "hasPromotions",
      "attributes",
      "providerIds",
      "sellerIds",
      "skus",
      "flashSaleType",
      "masterCategories",
      "masterCategoryIds",
      "excludedSkus",
      "clearanceTypeIds",
      "returnAllVariants"
    ];
    this._isBooleanValue = ["hasPromotions", "returnAllVariants"];
    this._isNumberValue = ["clearanceTypeIds", "categoryIds"];
    this._discoverySortingKeys = ["sort", "order"];
    this._discoveryPaginationKeys = ["pageNumber", "itemsPerPage"];
    this._orderValuesMap = {
      desc: SORT_ORDER.ORDER_BY_DESCENDING,
      asc: SORT_ORDER.ORDER_BY_ASCENDING,
      DESC: SORT_ORDER.ORDER_BY_DESCENDING,
      ASC: SORT_ORDER.ORDER_BY_ASCENDING
    };
    this._sortValuesMap = {
      new: "SORT_BY_PUBLISH_AT",
      bestPrice: "SORT_BY_PRICE",
      "view.last_3_day": SORT_TYPE.SORT_BY_MOST_VIEW,
      "view.last_7_day": SORT_TYPE.SORT_BY_MOST_VIEW_7_DAYS,
      "view.last_30_day": SORT_TYPE.SORT_BY_MOST_VIEW_30_DAYS,
      "view.last_90_day": SORT_TYPE.SORT_BY_MOST_VIEW_90_DAYS,
      "quantity.last_3_day": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY,
      "quantity.last_1_week": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_7_DAYS,
      "quantity.last_1_month": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_30_DAYS,
      "quantity.last_3_month": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_90_DAYS,
      discountPercent: SORT_TYPE.SORT_BY_DISCOUNT_PERCENT,
      discount: SORT_TYPE.SORT_BY_DISCOUNT_PERCENT
    };
    this.discoveryApi = new index_es/* default */.ZP(discoveryApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.discoveryApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.discoveryApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    }
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.terminalId = terminalId;
    this.terminalCode = terminalCode;
  }
  _cookPayload(params) {
    const payload = service_es_spreadProps(dist_service_es_spreadValues(dist_service_es_spreadValues({
      filter: {},
      pagination: {},
      query: "",
      sorting: {},
      returnFilterable: [],
      block: {},
      slug: ""
    }, this.terminalCode ? { terminalCode: this.terminalCode } : {}), this.terminalId ? { terminalId: this.terminalId } : {}), {
      fieldMask: []
    });
    const normalizedParams = normalizeDiscoveryApiParams((0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(params));
    const attributes = [];
    Object.keys(normalizedParams).forEach((key) => {
      let data = this._isArrayValue.includes(key) ? convertArrayValue(normalizedParams[key], this._isNumberValue.includes(key) ? "number" : "string") : normalizedParams[key];
      if (key.startsWith("attributes.")) {
        attributes.push({
          code: key.replace("attributes.", ""),
          optionIds: data.split(",")
        });
      }
      if (this._isBooleanValue.includes(key)) {
        data = data === "true" || data === true;
      }
      if (this._discoveryPayloadKeys.includes(key)) {
        payload[key] = data;
      }
      if (this._discoveryBlockKeys.includes(key)) {
        payload.block[key] = data;
      }
      if (this._discoveryFilterKeys.includes(key)) {
        payload.filter = service_es_spreadProps(dist_service_es_spreadValues({}, payload.filter), {
          [key]: data
        });
      }
      if (this._discoverySortingKeys.includes(key)) {
        payload.sorting = dist_service_es_spreadValues(dist_service_es_spreadValues({}, payload.sorting), {
          [key]: key === "order" ? this._orderValuesMap[data] || data || "ORDER_BY_UNSPECIFIED" : this._sortValuesMap[data] || data || "SORT_BY_UNSPECIFIED"
        });
      }
      if (this._discoveryPaginationKeys.includes(key)) {
        payload.pagination = dist_service_es_spreadValues(dist_service_es_spreadValues({}, payload.pagination), {
          [key]: data
        });
      }
    });
    payload["filter"]["attributes"] = [
      ...payload["filter"]["attributes"] || [],
      ...attributes
    ];
    if (!!params.fieldMask) {
      payload.fieldMask = params.fieldMask;
    }
    return payload;
  }
  setTerminal({
    terminalCode,
    terminalId
  }) {
    this.terminalCode = terminalCode;
    this.terminalId = terminalId;
  }
  getBaseUrl() {
    return this.discoveryApi.baseURL;
  }
  async search(params) {
    const searchParams = this._cookPayload(params);
    const { data } = await this.discoveryApi.post("/search", searchParams);
    return data;
  }
  async internalSearch(terminalCode, siteId, query, limit, sorting) {
    var _a;
    const { data } = await this.discoveryApi.post("/internal/search", {
      terminalCode,
      siteId,
      query,
      sorting,
      limit
    });
    if ((data == null ? void 0 : data.code) !== "0" || !((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.products)) {
      return [];
    }
    return data.data.products;
  }
  async getProductDetailBySkus(params) {
    const LIMIT_SKUS = 50;
    const promises = [];
    const _a = params, { skus } = _a, rest = __objRest(_a, ["skus"]);
    const skuArray = typeof skus === "string" ? skus.split(",") : skus;
    for (let index = 0; index < skuArray.length; index += LIMIT_SKUS) {
      const subSkus = skuArray.slice(index, index + LIMIT_SKUS);
      promises.push(this.discoveryApi.get("/products", {
        params: service_es_spreadProps(dist_service_es_spreadValues({
          skus: subSkus
        }, rest), {
          terminalCode: this.terminalCode || params.terminalCode,
          terminalId: this.terminalId || params.terminalId
        })
      }).then((response) => {
        var _a2, _b;
        return ((_b = (_a2 = response.data) == null ? void 0 : _a2.result) == null ? void 0 : _b.products) || [];
      }));
    }
    const products = await Promise.all(promises).then((values) => values.reduce((acc, curr) => [...acc, ...curr], []));
    return products;
  }
  async getProduct(params) {
    var _a;
    const { data } = await this.discoveryApi.get(`/product`, {
      params: service_es_spreadProps(dist_service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.product;
  }
  async getKeyword(params) {
    const { data } = await this.discoveryApi.get("/keywords", {
      params: service_es_spreadProps(dist_service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getBlock(params, timeout) {
    const { data } = await this.discoveryApi.get(`/blocks`, {
      params: service_es_spreadProps(dist_service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      }),
      timeout
    });
    return data;
  }
  async getPopularKeyword(params) {
    const { data } = await this.discoveryApi.get(`/recommended-search-terms`, {
      params: service_es_spreadProps(dist_service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getRecommendationProducts(sku) {
    const { data } = await this.discoveryApi.get(`/products/${sku}/recommendations`, {
      params: {
        terminalId: this.terminalId,
        terminalCode: this.terminalCode
      }
    });
    return data;
  }
  async getRecommendationCombos(sku, params) {
    const { data } = await this.discoveryApi.get(`/products/${sku}/combos`, {
      params: service_es_spreadProps(dist_service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getDetailComboRecommendation(params) {
    const { data } = await this.discoveryApi.post(`/combos`, service_es_spreadProps(dist_service_es_spreadValues({}, params), {
      terminalId: this.terminalId,
      terminalCode: this.terminalCode
    }));
    return data;
  }
  async getMenuItems(zone) {
    const result = await this.discoveryApi.get(`/menu-items`, {
      params: {
        terminalId: this.terminalId,
        terminal: this.terminalCode,
        zone,
        _limit: 1e3,
        _sort: "priority",
        _order: "asc",
        fieldMask: [
          "id",
          "name",
          "parentId",
          "icon",
          "isTargetBlank",
          "url",
          "targetPath",
          "urlType",
          "configs",
          "banners.{isActive|startDate|endDate|image|targetPath|urlType}",
          "level"
        ]
      }
    });
    return result.data;
  }
  async getMenuItemById(categoryId) {
    const { data } = await this.discoveryApi.get(`/menu-item/${categoryId}`);
    return data;
  }
  async searchProductsByBarcode(reqParams) {
    const { sku, barcode, sellerId, terminalCode } = reqParams;
    const params = {
      identifiers: [
        {
          sellerSkuIdentifier: {
            sellerId,
            sellerSku: sku
          }
        },
        {
          sellerBarcodeIdentifier: {
            barcode,
            sellerId
          }
        }
      ],
      terminalCode
    };
    const { data } = await this.discoveryApi.post(`/products`, params);
    return data;
  }
  async getCollectionsByPlatformId(params) {
    const { data } = await this.discoveryApi.get("/collections", { params: dist_service_es_spreadValues({}, params) });
    return data;
  }
}
const normalizeDiscoveryApiParams = (params) => {
  const listingAndDiscoveryFieldsMap = {
    _sort: "sort",
    _order: "order",
    bestPrice_gte: "priceGte",
    bestPrice_lte: "priceLte",
    price_lte: "priceLte",
    price_gte: "priceGte",
    _limit: "itemsPerPage",
    limit: "itemsPerPage",
    sellerCategories: "masterCategories",
    _page: "pageNumber",
    page: "pageNumber",
    q: "query",
    keyword: "query",
    skus_ne: "excludedSkus",
    providerId: "providerIds"
  };
  const normalizedParams = {};
  Object.keys(params).forEach((field) => {
    if (listingAndDiscoveryFieldsMap[field]) {
      normalizedParams[listingAndDiscoveryFieldsMap[field]] = params[field];
    } else {
      normalizedParams[field] = params[field];
    }
  });
  return normalizedParams;
};
const convertArrayValue = (value, returnType = "string") => {
  if (typeof value === "string") {
    if (returnType === "string")
      return value.split(",");
    return value.split(",").map((el) => +el);
  }
  if (returnType === "string")
    return value;
  return value.map((el) => +el);
};



// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var utils_dist_index_es = __webpack_require__(31260);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/v2/service.es.js




var v2_service_es_defProp = Object.defineProperty;
var v2_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var v2_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var v2_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var v2_service_es_defNormalProp = (obj, key, value) => key in obj ? v2_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var v2_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (v2_service_es_hasOwnProp.call(b, prop))
      v2_service_es_defNormalProp(a, prop, b[prop]);
  if (v2_service_es_getOwnPropSymbols)
    for (var prop of v2_service_es_getOwnPropSymbols(b)) {
      if (v2_service_es_propIsEnum.call(b, prop))
        v2_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SEARCH_DATA = {
  page: 0,
  pageSize: 0,
  total: 0
};
class service_es_DiscoveryService {
  constructor(discoveryApiUrl, terminalId, language, location) {
    this.location = location;
    this.discoveryApi = new index_es/* default */.ZP(discoveryApiUrl);
    this.terminalId = terminalId;
    this.discoveryApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
  }
  getTerminalId() {
    return this.terminalId;
  }
  get baseParams() {
    return (0,utils_dist_index_es/* cleanObject */.sW)({
      terminalId: this.terminalId,
      location: this.location
    });
  }
  async search(payload) {
    const { data } = await this.discoveryApi.post("/search-skus-v2", v2_service_es_spreadValues(v2_service_es_spreadValues({}, this.baseParams), payload));
    return (data == null ? void 0 : data.data) || DEFAULT_SEARCH_DATA;
  }
}



// EXTERNAL MODULE: ../../packages/cart/dist/service.es.js + 1 modules
var service_es = __webpack_require__(84154);
;// CONCATENATED MODULE: ../../packages/cart/dist/v2/error.es.js


const error_es_getError = (resp) => {
  const message = resp.message;
  return new index_es/* ApiError */.MS(message, resp.code, resp);
};



// EXTERNAL MODULE: ../../packages/cart/dist/v2/utils.es.js
var utils_es = __webpack_require__(16476);
;// CONCATENATED MODULE: ../../packages/cart/dist/v2/service.es.js







var dist_v2_service_es_defProp = Object.defineProperty;
var v2_service_es_defProps = Object.defineProperties;
var v2_service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var dist_v2_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var dist_v2_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var dist_v2_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var dist_v2_service_es_defNormalProp = (obj, key, value) => key in obj ? dist_v2_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var dist_v2_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (dist_v2_service_es_hasOwnProp.call(b, prop))
      dist_v2_service_es_defNormalProp(a, prop, b[prop]);
  if (dist_v2_service_es_getOwnPropSymbols)
    for (var prop of dist_v2_service_es_getOwnPropSymbols(b)) {
      if (dist_v2_service_es_propIsEnum.call(b, prop))
        dist_v2_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var v2_service_es_spreadProps = (a, b) => v2_service_es_defProps(a, v2_service_es_getOwnPropDescs(b));
const cartTokenHeaderKey = "x-cart-token";
const resolveValue = (value) => {
  return typeof value === "function" ? value() : value;
};
class CartService {
  constructor(apiUrl, options) {
    this.cartApi = new index_es/* default */.ZP(apiUrl, error_es_getError);
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    }
    this.cartApi.addInterceptor((req) => {
      if (typeof window === "undefined" || req.headers.get(cartTokenHeaderKey) !== null)
        return;
      if (options == null ? void 0 : options.cartToken) {
        req.headers.set(cartTokenHeaderKey, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = typeof this.getCartToken === "function" ? this.getCartToken() : (0,utils_es/* getCartToken */.i)();
        if (cartToken) {
          req.headers.set(cartTokenHeaderKey, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", (options == null ? void 0 : options.language) || "*");
    });
    this.location = (options == null ? void 0 : options.location) || void 0;
    this.terminal = (options == null ? void 0 : options.terminal) || void 0;
    this.terminalId = (options == null ? void 0 : options.terminalId) || void 0;
    this.getFullCart = (options == null ? void 0 : options.getFullCart) || void 0;
    this.v1 = new service_es/* CartService */.Ni(apiUrl);
  }
  getParams() {
    return {
      getFullCart: this.getFullCart,
      location: this.location,
      terminal: resolveValue(this.terminal),
      terminalId: resolveValue(this.terminalId)
    };
  }
  setParams({
    getFullCart,
    location,
    terminal,
    terminalId,
    getCartToken: getCartToken2
  }) {
    this.getFullCart = typeof getFullCart !== "undefined" ? getFullCart : this.getFullCart;
    this.location = typeof location !== "undefined" ? location : this.location;
    this.terminal = typeof terminal !== "undefined" ? terminal : this.terminal;
    this.terminalId = typeof terminalId !== "undefined" ? terminalId : this.terminalId;
    this.getCartToken = typeof getCartToken2 !== "undefined" ? getCartToken2 : this.getCartToken;
  }
  async getCart() {
    var _a;
    const res = await this.cartApi.get("/api/v2/carts", {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async applyPromotion(applyPromotionRequest) {
    const { ppmPromotionId, ppmCode, itemId } = applyPromotionRequest;
    const res = await this.cartApi.put("/api/v2/carts/promotions", { ppmPromotionId, ppmCode, itemId }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async removePromotion(removePromotionRequest) {
    const { cartPromotionId } = removePromotionRequest;
    const res = await this.cartApi.delete("/api/v2/carts/promotions", {
      cartPromotionId
    }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async recordOrder(recordOrderRequest, cartToken) {
    const res = await this.cartApi.post("/api/v2/carts/record", recordOrderRequest, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return res == null ? void 0 : res.data;
  }
  async getAllCartTokens() {
    var _a, _b;
    const res = await this.cartApi.get("/api/v2/cart-tokens", {
      params: this.getParams()
    });
    if (!Array.isArray((_a = res.data) == null ? void 0 : _a.data)) {
      return [];
    }
    return (_b = res.data) == null ? void 0 : _b.data;
  }
  async createNewCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts", {}, {
      params: v2_service_es_spreadProps(dist_v2_service_es_spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    const data = ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || { cart: utils_es/* defaultCart */.UH, cartToken: "" };
    return data;
  }
  async deleteCart(cartToken) {
    await this.cartApi.delete("/api/v2/carts", void 0, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
  }
  async loadConfirmationCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.get("/api/v2/carts/confirmation", {
      params: v2_service_es_spreadProps(dist_v2_service_es_spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async getDeliveryOptions({
    deliveryType,
    customerProfileId
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/delivery-options", { deliveryType, customerProfileId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || {};
  }
  async setDeliveryInfo({
    address,
    addressId,
    deliveryType,
    districtId,
    districtName,
    email,
    fullAddress,
    name,
    phone,
    provinceId,
    provinceName,
    siteId,
    wardId,
    wardName,
    getAllApplicablePromotions
  }) {
    var _a;
    const generatedFullAddress = [address, wardName, districtName, provinceName].filter(Boolean).join(", ");
    const res = await this.cartApi.put("/api/v2/carts/delivery-info", (0,utils_dist_index_es/* cleanObject */.sW)({
      addressId,
      deliveryType,
      districtId,
      fullAddress: fullAddress || generatedFullAddress,
      name,
      phone,
      provinceId,
      siteId,
      wardId,
      email
    }), {
      params: dist_v2_service_es_spreadValues({
        getAllApplicablePromotions
      }, this.getParams())
    });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async changeItemPrice({
    itemId,
    consultationFee,
    onDemandDiscount,
    onDemandDiscountReason,
    onDemandDiscountReasonId
  }) {
    var _a;
    const data = await this.cartApi.put("/api/v2/carts/items/price-manual", {
      itemId,
      consultationFee,
      onDemandDiscount,
      onDemandDiscountReason,
      onDemandDiscountReasonId
    }, {
      params: this.getParams()
    });
    return (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.data;
  }
  async applyDeliveryService({
    serviceId
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/delivery-services", { serviceId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async applyAdditionalService({
    serviceId,
    isEnable
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/additional-services", { serviceId, isEnable }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async applyPaymentMethodToCart({
    paymentMethodCode
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-methods", { paymentMethodCode }, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async requestItemSku({
    name,
    quantity
  }) {
    const { data, headers } = await this.cartApi.post("api/v2/carts/items/sku-request", { name, quantity }, {
      params: this.getParams()
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token) {
      (0,utils_es/* setCartToken */.rx)(token);
    }
    return (data == null ? void 0 : data.data) || utils_es/* defaultCart */.UH;
  }
  async checkoutOrder({
    order
  }, cartToken) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/checkout", { order }, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async removeItem(removeItemRequest) {
    var _a;
    const { itemId } = removeItemRequest;
    const params = this.getParams();
    const res = await this.cartApi.delete("/api/v2/carts/items", { itemId }, { params });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async updateItemQuantity(updateItemQuantityRequest) {
    var _a;
    const { itemId, quantity } = updateItemQuantityRequest;
    const body = {
      itemId,
      quantity
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/quantity", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async selectItems(selectItemsRequest) {
    var _a;
    const { itemIds, isSelected } = selectItemsRequest;
    const body = {
      itemIds,
      isSelected
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/selection", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async addItems(addItemsRequest) {
    const { groups, override } = addItemsRequest;
    const body = {
      groups,
      override
    };
    const params = this.getParams();
    const { data, headers } = await this.cartApi.post("/api/v2/carts/items", body, {
      params
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token) {
      (0,utils_es/* setCartToken */.rx)(token);
    }
    return (data == null ? void 0 : data.data) || utils_es/* defaultCart */.UH;
  }
  async recordToPayment({
    payments,
    orderId
  }) {
    const body = { payments, orderId };
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/record-to-payment", body, {
      params
    });
    return data.data;
  }
  async reCheckout(orderToken) {
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/checkout-to-payment", { orderToken }, { params });
    return data.data;
  }
  async getOrderPaymentMethod(orderId) {
    var _a;
    const res = await this.cartApi.get("api/v2/orders/payment-info", {
      params: v2_service_es_spreadProps(dist_v2_service_es_spreadValues({}, this.getParams()), { orderId })
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async updateCartGeneralInfo(payload) {
    const res = await this.cartApi.put("/api/v2/carts", payload, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data.data;
  }
  async applyPaymentAmount(payload) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-amount", payload, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async getPriceAndPromotion(sku, params) {
    const { data } = await this.cartApi.get(`/api/v2/products/${sku}`, {
      params: dist_v2_service_es_spreadValues(dist_v2_service_es_spreadValues({}, this.getParams()), params)
    });
    return data.data;
  }
  async calculatePrice(body) {
    const { data } = await this.cartApi.post("/api/v2/products/calculate-price", body, { params: this.getParams() });
    return data.data;
  }
}



;// CONCATENATED MODULE: ../../packages/location/dist/service.es.js



class LocationService {
  constructor(locationApiUrl, defaultConfig, getCustomAccessToken) {
    this.getProvinces = async () => {
      return this.locationApi.get("/location/provinces").then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.provinces);
      });
    };
    this.getDistrictsByProvinceCode = async (provinceCode) => {
      return this.locationApi.get(`/location/districts?provinceCode=${provinceCode}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.districts);
      });
    };
    this.getWardsByDistrictCode = async (districtCode) => {
      return this.locationApi.get(`/location/wards?districtCode=${districtCode}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.wards);
      });
    };
    this.getAddressSuggestions = async (params) => {
      return this.locationApi.get("/location/addresses/suggest", { params }).then((res) => {
        var _a, _b;
        return ((_b = (_a = res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.addresses) || [];
      });
    };
    this.locationApi = new index_es/* default */.ZP(locationApiUrl, void 0, defaultConfig);
    if (typeof getCustomAccessToken === "function") {
      this.locationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.locationApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    }
  }
}



;// CONCATENATED MODULE: ../../packages/location/dist/index.es.js


;// CONCATENATED MODULE: ../../packages/notification/dist/services.es.js



var services_es_defProp = Object.defineProperty;
var services_es_defProps = Object.defineProperties;
var services_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var services_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var services_es_hasOwnProp = Object.prototype.hasOwnProperty;
var services_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var services_es_defNormalProp = (obj, key, value) => key in obj ? services_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var services_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (services_es_hasOwnProp.call(b, prop))
      services_es_defNormalProp(a, prop, b[prop]);
  if (services_es_getOwnPropSymbols)
    for (var prop of services_es_getOwnPropSymbols(b)) {
      if (services_es_propIsEnum.call(b, prop))
        services_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var services_es_spreadProps = (a, b) => services_es_defProps(a, services_es_getOwnPropDescs(b));
const getJson = (str) => {
  try {
    return !!str && JSON.parse(str);
  } catch (e) {
    return null;
  }
};
class NotificationService {
  constructor(notificationApiUrl) {
    this.getNotification = async (params) => {
      var _a;
      const { data } = await this.notificationApi.get(`/notifications`, {
        params: services_es_spreadValues({}, params)
      });
      const formattedNotis = ((_a = data.data.notifications) == null ? void 0 : _a.map((noti) => {
        var _a2;
        const parsedLink = getJson(noti.link);
        const link = parsedLink ? parsedLink : "";
        if (link && ["order", "noti"].includes(link.type)) {
          return services_es_spreadProps(services_es_spreadValues({}, noti), {
            order: link.type === "order" ? link == null ? void 0 : link.data : null,
            deepLink: link.type === "noti" ? (_a2 = link == null ? void 0 : link.data) == null ? void 0 : _a2.deeplink : null
          });
        }
      }).filter((noti) => !!noti)) || [];
      return services_es_spreadProps(services_es_spreadValues({}, data.data), {
        notifications: formattedNotis
      });
    };
    this.markNotificationAsRead = async (notificationId, token) => {
      const { data } = await this.notificationApi.put(`/notification/${notificationId}/mark-read`, {
        token
      });
      return data;
    };
    this.unreadCount = async (params) => {
      const { data } = await this.notificationApi.get("/notification/count-unread", {
        params: services_es_spreadValues({}, params)
      });
      return data == null ? void 0 : data.data;
    };
    this.registerToken = async (params) => {
      await this.notificationApi.post("notification/register-token", params);
    };
    this.unRegisterToken = async (params) => {
      await this.notificationApi.post("notification/unregister-token", params);
    };
    this.markReadAll = async (params) => {
      await this.notificationApi.put("notification/mark-read-all", params);
    };
    this.notificationApi = new index_es/* default */.ZP(notificationApiUrl);
    this.notificationApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
  }
}



;// CONCATENATED MODULE: ../../packages/warehouse/dist/service.es.js



var warehouse_dist_service_es_defProp = Object.defineProperty;
var dist_service_es_defProps = Object.defineProperties;
var dist_service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var warehouse_dist_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var warehouse_dist_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var warehouse_dist_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var warehouse_dist_service_es_defNormalProp = (obj, key, value) => key in obj ? warehouse_dist_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var warehouse_dist_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (warehouse_dist_service_es_hasOwnProp.call(b, prop))
      warehouse_dist_service_es_defNormalProp(a, prop, b[prop]);
  if (warehouse_dist_service_es_getOwnPropSymbols)
    for (var prop of warehouse_dist_service_es_getOwnPropSymbols(b)) {
      if (warehouse_dist_service_es_propIsEnum.call(b, prop))
        warehouse_dist_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var dist_service_es_spreadProps = (a, b) => dist_service_es_defProps(a, dist_service_es_getOwnPropDescs(b));
class WarehouseService {
  constructor(apiUrl) {
    this.getReturnRequests = async ({
      orderId,
      terminalCode,
      discoveryService,
      platformId
    }) => {
      const { data } = await this.warehouseApi.get(`/return-requests`, {
        params: {
          orderIds: orderId,
          sortLatest: true,
          platformId
        }
      });
      const res = data == null ? void 0 : data.request;
      const allItemSkus = (res == null ? void 0 : res.reduce((skus, req) => {
        skus.push(...req.items.map((item) => item.sku));
        return skus;
      }, [])) || [];
      if (allItemSkus.length > 0) {
        const products = await discoveryService.getProductDetailBySkus({
          skus: Array.from(new Set(allItemSkus)),
          terminalCode
        });
        return res.map((req) => {
          return dist_service_es_spreadProps(warehouse_dist_service_es_spreadValues({}, req), {
            items: req.items.map((item) => {
              var _a;
              const product = products.find((product2) => product2.productInfo.sku === item.sku);
              return dist_service_es_spreadProps(warehouse_dist_service_es_spreadValues({}, item), {
                imageUrl: ((_a = product == null ? void 0 : product.productInfo) == null ? void 0 : _a.imageUrl) || ""
              });
            })
          });
        });
      }
      return res;
    };
    this.getReturnReasons = async (platformId, isStaffOnly) => {
      const { data } = await this.warehouseApi.get(`/return-reasons`, {
        params: {
          platformId,
          status: "RETURN_REASON_STATUS_ACTIVE",
          isStaffOnly,
          limit: 200
        }
      });
      return (data == null ? void 0 : data.reasons) || [];
    };
    this.addReturnRequest = async (orderId, requestPayload) => {
      const payload = warehouse_dist_service_es_spreadValues({
        orderId
      }, requestPayload);
      return await this.warehouseApi.post(`/return-request`, {
        data: payload
      });
    };
    this.warehouseApi = new index_es/* default */.ZP(apiUrl);
    this.warehouseApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
  }
}



;// CONCATENATED MODULE: ../../packages/warehouse/dist/index.es.js


;// CONCATENATED MODULE: ../../packages/privacy-policy/dist/service.es.js



class PrivacyPolicyService {
  constructor(privacyPolicyApiUrl, platformId, language) {
    this.privacyPolicyApi = new index_es/* default */.ZP(privacyPolicyApiUrl);
    this.platformId = platformId;
    this.privacyPolicyApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    this.privacyPolicyApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
  }
  async getPolicies() {
    var _a;
    const { data } = await this.privacyPolicyApi.get("/users/policies", { params: { sellerPlatformId: this.platformId } });
    return ((_a = data.data) == null ? void 0 : _a.policies) || [];
  }
  async submitPolicies(policies) {
    await this.privacyPolicyApi.post("/users/policies", {
      submitPolicies: policies
    });
  }
}



;// CONCATENATED MODULE: ./lazy-modules/order.ts
class OrderServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            this.servicePromise = __webpack_require__.e(/* import() */ 6100).then(__webpack_require__.bind(__webpack_require__, 56100)).then((mod)=>new mod.OrderService(this.baseUrl, this.language));
        }
        return this.servicePromise;
    }
    async getOrder(params) {
        const service = await this.initializeService();
        return service.getOrder(params);
    }
    async getOrders(params) {
        const service = await this.initializeService();
        return service.getOrders(params);
    }
    async getOrderDetail(params) {
        const service = await this.initializeService();
        return service.getOrderDetail(params);
    }
    async importOrder(orderId) {
        const service = await this.initializeService();
        return service.importOrder(orderId);
    }
    async updateVatInfo(orderId, vatInfo) {
        const service = await this.initializeService();
        return service.updateVatInfo(orderId, vatInfo);
    }
    async updateOrderVatInfo(orderId, vatInfo) {
        const service = await this.initializeService();
        return service.updateOrderVatInfo(orderId, vatInfo);
    }
    async getPromotions(params) {
        const service = await this.initializeService();
        return service.getPromotions(params);
    }
    async getOrderDetailV2(orderId, platformId) {
        const service = await this.initializeService();
        return service.getOrderDetailV2(orderId, platformId);
    }
    async getOrdersV2(params) {
        const service = await this.initializeService();
        return service.getOrdersV2(params);
    }
    constructor(baseUrl, language){
        this.baseUrl = baseUrl;
        this.language = language;
    }
}
/* harmony default export */ var order = (OrderServiceWrapper);

;// CONCATENATED MODULE: ./lazy-modules/payment.ts
class PaymentBffServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            const baseUrl = this.baseUrl;
            this.servicePromise = Promise.all(/* import() */[__webpack_require__.e(7426), __webpack_require__.e(8285), __webpack_require__.e(8554), __webpack_require__.e(6687)]).then(__webpack_require__.bind(__webpack_require__, 86687)).then((mod)=>new mod.PaymentBffService(baseUrl));
        }
        return this.servicePromise;
    }
    async createPaymentAIO(request) {
        const service = await this.initializeService();
        return service.createPaymentAIO(request);
    }
    async getInstallmentTerms(merchantMethodCode, amount) {
        const service = await this.initializeService();
        return service.getInstallmentTerms(merchantMethodCode, amount);
    }
    constructor(baseUrl){
        this.baseUrl = baseUrl;
    }
}
class PaymentServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            const params = this.constructorParams;
            this.servicePromise = Promise.all(/* import() */[__webpack_require__.e(7426), __webpack_require__.e(8285), __webpack_require__.e(8554), __webpack_require__.e(6687)]).then(__webpack_require__.bind(__webpack_require__, 86687)).then((mod)=>new mod.PaymentService(params.baseUrl, params.secretKey, params.paymentSettingUrl));
        }
        return this.servicePromise;
    }
    async initPaymentAIOOffline(body) {
        const service = await this.initializeService();
        return service.initPaymentAIOOffline(body);
    }
    async initPaymentAIOnline(body) {
        const service = await this.initializeService();
        return service.initPaymentAIOnline(body);
    }
    async getBanks() {
        const service = await this.initializeService();
        return service.getBanks();
    }
    async getBankAccounts() {
        const service = await this.initializeService();
        return service.getBankAccounts();
    }
    async requestCreateToken(merchantCode, userId, cartType, successUrl, cancelUrl) {
        const service = await this.initializeService();
        return service.requestCreateToken(merchantCode, userId, cartType, successUrl, cancelUrl);
    }
    async requestRemoveToken(merchantMethodCode, userId, token) {
        const service = await this.initializeService();
        return service.requestRemoveToken(merchantMethodCode, userId, token);
    }
    constructor(params){
        this.constructorParams = params;
    }
}


;// CONCATENATED MODULE: ./lazy-modules/loyalty.ts
class LoyaltyBFFServiceWrapper {
    async initializeService() {
        if (!this.service) {
            const { LoyaltyBFFService  } = await __webpack_require__.e(/* import() */ 9277).then(__webpack_require__.bind(__webpack_require__, 19277));
            this.service = new LoyaltyBFFService(this.baseUrl, this.clientId);
        }
        this.service.setClientId(this.clientId);
    }
    async setClientId(clientId) {
        this.clientId = clientId;
        if (!this.service) {
            await this.initializeService();
        } else {
            this.service.setClientId(clientId);
        }
    }
    getClientId() {
        return this.clientId;
    }
    async createMember(params) {
        await this.initializeService();
        return this.service.createMember(params);
    }
    async linkExistedMembership(params) {
        await this.initializeService();
        return this.service.linkExistedMembership(params);
    }
    async getLoyaltyMemberInfo() {
        await this.initializeService();
        return this.service.getLoyaltyMemberInfo();
    }
    async getTransactionsHistory(txnType, pageNumber, pageSize, fromTime, toTime) {
        await this.initializeService();
        return this.service.getTransactionsHistory(txnType, pageNumber, pageSize, fromTime, toTime);
    }
    async getNetworkConfig() {
        await this.initializeService();
        return this.service.getNetworkConfig();
    }
    constructor(baseUrl, clientId){
        this.baseUrl = baseUrl;
        this.clientId = clientId;
    }
}
/* harmony default export */ var loyalty = (LoyaltyBFFServiceWrapper);

;// CONCATENATED MODULE: ./lazy-modules/quotation.ts
class QuotationServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            this.servicePromise = __webpack_require__.e(/* import() */ 1493).then(__webpack_require__.bind(__webpack_require__, 61493)).then((mod)=>new mod.QuotationService());
        }
        return this.servicePromise;
    }
    async getOrderDetailByToken(params) {
        const service = await this.initializeService();
        return service.getOrderDetailByToken(params);
    }
}
/* harmony default export */ var quotation = (QuotationServiceWrapper);

// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
// EXTERNAL MODULE: ./helpers/discovery.ts + 1 modules
var discovery = __webpack_require__(60295);
;// CONCATENATED MODULE: ./helpers/service-provider.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}












class ServiceContainer {
    get authService() {
        if (!this._authService) {
            const iamApiUrl = this.tenantConfig.getProcessEnv("IAM_API_URL");
            const iamClientId = this.tenantConfig.iamClientId || this.tenantConfig.getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
            const iamOauthDomain = this.tenantConfig.iamOauthDomain || this.tenantConfig.getProcessEnv("NEXT_PUBLIC_IAM_OAUTH_DOMAIN");
            this._authService = new AuthService(iamApiUrl, iamClientId, iamOauthDomain);
        }
        return this._authService;
    }
    get userService() {
        if (!this._userService) {
            this._userService = new UserService(this.tenantConfig.getProcessEnv("NEXT_PUBLIC_BASE_USER_SERVICE_URL"), undefined, this.tenantConfig.platformId);
        }
        return this._userService;
    }
    get discoveryService() {
        if (!this._discoveryService) {
            const publicDiscoveryEndpoint = this.tenantConfig.getProcessEnv("BASE_DISCOVERY_URL");
            const internalDiscoveryEndpoint = this.tenantConfig.getProcessEnv("INTERNAL_DISCOVERY_URL");
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            // use internal discovery endpoint
            // for server side rendering
            this._discoveryService = new DiscoveryService( false ? 0 : publicDiscoveryEndpoint, useTerminalId ? this.tenantConfig.terminalId : undefined, !useTerminalId ? this.tenantConfig.terminal : undefined, this.tenantConfig.currentLanguage);
        }
        return this._discoveryService;
    }
    get discoveryServiceV2() {
        if (!this._disicoveryServiceV2) {
            const publicDiscoveryEndpoint = this.tenantConfig.getProcessEnv("BASE_DISCOVERY_V2_URL");
            const internalDiscoveryEndpoint = this.tenantConfig.getProcessEnv("INTERNAL_DISCOVERY_V2_URL");
            // use internal discovery endpoint
            // for server side rendering
            this._disicoveryServiceV2 = new service_es_DiscoveryService( false ? 0 : publicDiscoveryEndpoint, this.tenantConfig.terminalId, this.tenantConfig.currentLanguage, this.tenantConfig.location);
        }
        return this._disicoveryServiceV2;
    }
    get discoveryPos365Service() {
        if (!this._discoveryPos365Service) {
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            this._discoveryPos365Service = new DiscoveryService(this.tenantConfig.getProcessEnv("BASE_POS365_DISCOVERY_URL"), useTerminalId ? this.tenantConfig.terminalId : undefined, !useTerminalId ? this.tenantConfig.terminal : undefined, this.tenantConfig.currentLanguage);
        }
        return this._discoveryPos365Service;
    }
    get cartService() {
        if (!this._cartService) {
            this._cartService = new service_es/* CartService */.Ni(this.tenantConfig.getProcessEnv("BASE_CART_API_URL"), undefined, this.tenantConfig.currentLanguage);
        }
        return this._cartService;
    }
    get cartServiceV2() {
        if (!this._cartServiceV2) {
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            const endpoint = (0,helpers/* isServerless */.ep)() ? this.tenantConfig.getProcessEnv("BASE_CART_API_URL") : this.tenantConfig.getProcessEnv("INTERNAL_CART_API_URL");
            this._cartServiceV2 = new CartService(endpoint, _objectSpread({
                language: this.tenantConfig.currentLanguage,
                location: this.tenantConfig.location
            }, useTerminalId ? {
                terminalId: this.tenantConfig.terminalId
            } : {
                terminal: this.tenantConfig.terminal
            }));
        }
        return this._cartServiceV2;
    }
    get locationService() {
        if (!this._locationService) {
            this._locationService = new LocationService(this.tenantConfig.getProcessEnv("BASE_LOCATION_URL"));
        }
        return this._locationService;
    }
    get orderService() {
        if (!this._orderService) {
            this._orderService = new order(this.tenantConfig.getProcessEnv("BASE_COV_URL"), this.tenantConfig.currentLanguage);
        }
        return this._orderService;
    }
    get notificationService() {
        if (!this._notificationService) {
            this._notificationService = new NotificationService(this.tenantConfig.getProcessEnv("BASE_NOTIFICATIONS_API"));
        }
        return this._notificationService;
    }
    get warehouseService() {
        if (!this._warehouseService) {
            this._warehouseService = new WarehouseService(this.tenantConfig.getProcessEnv("BASE_WAREHOUSE_CONSUMER_API_URL"));
        }
        return this._warehouseService;
    }
    get paymentService() {
        if (!this._paymentService) {
            this._paymentService = new PaymentServiceWrapper({
                baseUrl: this.tenantConfig.getProcessEnv("BASE_PAYMENT_API_URL"),
                secretKey: this.tenantConfig.paymentSecretKey || this.tenantConfig.getProcessEnv("PAYMENT_SECRET_KEY"),
                paymentSettingUrl: this.tenantConfig.getProcessEnv("BASE_MAIN_PAYMENT_API_URL")
            });
        }
        return this._paymentService;
    }
    get paymentBffService() {
        if (!this._paymentBffService) {
            this._paymentBffService = new PaymentBffServiceWrapper(this.tenantConfig.getProcessEnv("BASE_PAYMENT_BFF_API_URL"));
        }
        return this._paymentBffService;
    }
    get loyaltyBFFService() {
        if (!this._loyaltyBFFService) {
            this._loyaltyBFFService = new loyalty(this.tenantConfig.getProcessEnv("BASE_LOYALTY_BFF_API_URL"), this.tenantConfig.getProcessEnv("LOYALTY_CLIENT_ID"));
        }
        return this._loyaltyBFFService;
    }
    get publicQuotataionOrderService() {
        if (!this._publicQuotationOrderService) {
            this._publicQuotationOrderService = new quotation();
        }
        return this._publicQuotationOrderService;
    }
    get discoveryHelper() {
        if (!this._discoveryHelper) {
            this._discoveryHelper = new discovery/* DiscoveryHelper */.LB(this.tenantConfig);
        }
        return this._discoveryHelper;
    }
    get privacyPolicyService() {
        if (!this._privacyPolicyService) {
            this._privacyPolicyService = new PrivacyPolicyService(this.tenantConfig.getProcessEnv("BASE_PRIVACY_POLICY_API_URL"), this.tenantConfig.platformId, this.tenantConfig.currentLanguage);
        }
        return this._privacyPolicyService;
    }
    constructor(tenantConfig){
        this.tenantConfig = tenantConfig;
    }
}


/***/ }),

/***/ 18042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U3": function() { return /* binding */ onSignOut; },
/* harmony export */   "hP": function() { return /* binding */ getAccessToken; },
/* harmony export */   "hh": function() { return /* binding */ clearStorageOnSignout; }
/* harmony export */ });
/* unused harmony export getIdToken */
/* harmony import */ var _modules_notification_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7276);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51765);


// THIS FUNCTION IS TO BE DEPRECATED
// DO NOT USE THIS IN NEW CODE
// TO REMOVE IT SOON
const LOCALSTORAGE_ACCESS_TOKEN = "ACCESS_TOKEN";
function getAccessToken() {
    var ref, ref1;
    let accessToken, isLoggedIn = false;
    accessToken = window === null || window === void 0 ? void 0 : (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.getAccessToken();
    if (!accessToken) {
        // for ibanking flow
        // accessToken is stored in localStorage
        // hence IAM sdk would not return proper result
        // when check expiry via user.isLoggedIn();
        // thus, we always assume it's not yet expired.
        accessToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
        isLoggedIn = true;
    } else {
        var ref2, ref3;
        isLoggedIn = !!(window === null || window === void 0 ? void 0 : (ref2 = window.TekoID) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.isLoggedIn());
    }
    if (accessToken && isLoggedIn) return accessToken;
}
function getIdToken() {
    // not support ibanking flow
    // should support later
    // TODO: should check carefully with ibanking
    if (true) {
        var ref, ref1, ref2;
        return (ref2 = window === null || window === void 0 ? void 0 : (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.loadUser()) === null || ref2 === void 0 ? void 0 : ref2.idToken;
    }
    return;
}
const clearStorageOnSignout = ()=>{
    [
        _constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */ .i7,
        _constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */ .Hg, 
    ].forEach((lsKey)=>localStorage.removeItem(lsKey));
};
const onSignOut = async (authService, notificationService, notificationAppId, redirectUrl)=>{
    (0,_modules_notification_helper__WEBPACK_IMPORTED_MODULE_1__/* .unregisterUNS */ .$l)(notificationService, notificationAppId);
    authService.logout(redirectUrl);
    clearStorageOnSignout();
};


/***/ }),

/***/ 58045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ translateObject; }
/* harmony export */ });
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34655);

// @ts-ignore
function translateObject(o) {
    if (typeof o === "string" && !ignorePrefixes.some((prefix)=>o.startsWith(prefix))) {
        return (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(o);
    }
    if (typeof o === "object") {
        // handle Array
        if (Array.isArray(o)) {
            // @ts-ignore
            return o.map((item)=>translateObject(item));
        }
        // handle object
        const newObject = {};
        for (const [k, v] of Object.entries(o)){
            newObject[k] = translateObject(v);
        }
        return newObject;
    }
    return o;
}
// if value is string and starts with one of these texts, return original value
const ignorePrefixes = [
    "http",
    "tel:",
    "mailto:"
];


/***/ }),

/***/ 74:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useBanners; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _services_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27342);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84443);



const useBanners = (zone)=>{
    const { 0: banners , 1: setBanners  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { terminal  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!!zone && !!terminal) {
            setLoading(true);
            _services_search__WEBPACK_IMPORTED_MODULE_2__/* .searchService.getBannerByZone */ .u.getBannerByZone(zone, terminal).then((_banners)=>{
                setBanners(_banners);
                setLoading(false);
            });
        }
    }, [
        zone,
        terminal
    ]);
    return {
        banners,
        loading
    };
};


/***/ }),

/***/ 70334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useKeywords; },
  "o": function() { return /* binding */ useRecommendedKeywords; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-63a52198c3/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(93369);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 8 modules
var context_es = __webpack_require__(46295);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ./hooks/useDebounce.ts

const useDebounce = (callback, delay)=>{
    const latestCallback = useRef();
    const latestTimeout = useRef();
    useEffect(()=>{
        latestCallback.current = callback;
    }, [
        callback
    ]);
    return ()=>{
        if (latestTimeout.current) {
            clearTimeout(latestTimeout.current);
        }
        latestTimeout.current = setTimeout(()=>{
            var ref;
            (ref = latestCallback.current) === null || ref === void 0 ? void 0 : ref.call(latestCallback);
        }, delay);
    };
};
// debounce value can be anything
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounceValue = (value, delay)=>{
    const { 0: debouncedValue , 1: setDebouncedValue  } = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};

;// CONCATENATED MODULE: ./hooks/useKeyword.tsx




const SUGGESTION_TYPE = {
    KEYWORD: "SUGGESTION_TYPE_KEYWORD",
    PRODUCT: "SUGGESTION_TYPE_PRODUCT"
};
const useKeywords = function(keyword) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var ref, ref1;
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const debouncedKeyword = useDebounceValue(keyword, 300);
    const params = {
        q: debouncedKeyword === null || debouncedKeyword === void 0 ? void 0 : debouncedKeyword.trim(),
        limit
    };
    const { data , error  } = (0,index_esm/* default */.ZP)(!!(debouncedKeyword === null || debouncedKeyword === void 0 ? void 0 : debouncedKeyword.trim()) ? [
        "".concat(discoveryService.getBaseUrl, "/keywords"),
        JSON.stringify(params)
    ] : null, async (_, paramsJson)=>{
        return await discoveryService.getKeyword(JSON.parse(paramsJson));
    }, {
        revalidateOnFocus: false
    });
    const suggestionsKeyword = ((data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.keywords) || []).filter((el)=>el.type === SUGGESTION_TYPE.KEYWORD);
    const suggestionsProduct = ((data === null || data === void 0 ? void 0 : (ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.keywords) || []).filter((el)=>el.type === SUGGESTION_TYPE.PRODUCT);
    return {
        result: (suggestionsProduct === null || suggestionsProduct === void 0 ? void 0 : suggestionsProduct.length) ? suggestionsProduct : suggestionsKeyword,
        isLoading: !error && !data,
        isError: error,
        isSuggestProduct: !!(suggestionsProduct === null || suggestionsProduct === void 0 ? void 0 : suggestionsProduct.length)
    };
};
const useRecommendedKeywords = (startCallApi)=>{
    var ref;
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { user  } = (0,context_es/* useAuth */.a)();
    const phoneNumber = user === null || user === void 0 ? void 0 : user.telephone;
    const userId = user === null || user === void 0 ? void 0 : user.userId;
    const params = {
        userId,
        phoneNumber,
        limit: 10
    };
    const { data , error  } = (0,index_esm/* default */.ZP)(startCallApi ? [
        "".concat(discoveryService.getBaseUrl, "/recommended-search-terms"),
        JSON.stringify(params), 
    ] : null, async (_, paramsJson)=>{
        return await discoveryService.getPopularKeyword(JSON.parse(paramsJson));
    }, {
        revalidateOnFocus: false
    });
    return {
        result: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.terms) || [],
        isLoading: !error && !data,
        isError: error
    };
};


/***/ }),

/***/ 68055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ usePos365StoreCode; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);


const STORE_KEY = "storeId";
const usePos365StoreCode = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const setPos365StoreCode = ()=>{
        const storeId = router.query[STORE_KEY];
        if (typeof sessionStorage !== "undefined" && storeId) sessionStorage.setItem(STORE_KEY, storeId);
    };
    const getPos365StoreCode = ()=>{
        if (typeof sessionStorage !== "undefined") return sessionStorage.getItem(STORE_KEY);
        return router.query[STORE_KEY];
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setPos365StoreCode();
    // eslint-disable-next-line
    }, [
        JSON.stringify(router.query)
    ]);
    return {
        pos365StoreCode: getPos365StoreCode()
    };
};


/***/ }),

/***/ 46818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zp": function() { return /* binding */ StringParam; },
/* harmony export */   "aM": function() { return /* binding */ useQuery; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; },
/* harmony export */   "yz": function() { return /* binding */ NumberParam; }
/* harmony export */ });
/* unused harmony exports getQueryString, ArrayParams */
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88813);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);



const getQueryString = (params)=>{
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key)=>params[key] && searchParams.append(key, params[key]));
    return searchParams.toString();
};
function paramsToObject(searchParams, config) {
    const result = {};
    for (const [key, value] of searchParams.entries()){
        var ref;
        result[key] = (config === null || config === void 0 ? void 0 : config[key]) ? (ref = config[key]) === null || ref === void 0 ? void 0 : ref.call(config, value) : value;
    }
    return result;
}
const getQueryParams = (searchString, config)=>{
    if (!searchString) {
        return {};
    }
    const urlParams = new URLSearchParams(searchString);
    const params = paramsToObject(urlParams, config);
    return params;
};
/**
 * @fact
 * next-router is cache by nginx and return in `getServerSideProps`, `getInitialProps`
 * when we use useRouter hook, this means `router.query` is fetched from cache
 *
 * @solution
 * get the correct query from current URL instead of cache.
 */ const useQuery = (config)=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(); /** use in server */ 
    const search = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)() ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search : getQueryString(router.query);
    const query = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        try {
            return getQueryParams(search, config);
        } catch (e) {
            return {};
        }
    }, [
        search
    ]);
    return query;
};
const NumberParam = (value)=>{
    try {
        if (!value) return null;
        return Number(value);
    } catch (e) {
        return;
    }
};
const StringParam = (value)=>value;
const ArrayParams = (func)=>function(value) {
        let splitChar = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
        return value.split(splitChar).map(func);
    };


/***/ }),

/***/ 34655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ changeLanguage; },
/* harmony export */   "k$": function() { return /* binding */ DEFAULT_LANGUAGE; },
/* harmony export */   "t": function() { return /* binding */ t; },
/* harmony export */   "zw": function() { return /* binding */ initLanguage; }
/* harmony export */ });
/* unused harmony exports NAMESPACE, loadLanguages */
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96556);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const NAMESPACE = "shopfront";
const DEFAULT_LANGUAGE = "vi";
const t = (keys, options)=>{
    const text = i18next__WEBPACK_IMPORTED_MODULE_0__["default"].t(keys, _objectSpreadProps(_objectSpread({}, options), {
        ns: NAMESPACE,
        interpolation: {
            escapeValue: false
        }
    }));
    return text || keys;
};
const loadLanguages = async (code)=>{
    const modules = await Promise.all([
        __webpack_require__.e(/* import() */ 4762).then(__webpack_require__.bind(__webpack_require__, 4762)),
        Promise.all(/* import() */[__webpack_require__.e(358), __webpack_require__.e(148), __webpack_require__.e(9896), __webpack_require__.e(3366), __webpack_require__.e(9183)]).then(__webpack_require__.bind(__webpack_require__, 86514)),
        __webpack_require__.e(/* import() */ 9689).then(__webpack_require__.bind(__webpack_require__, 79689)),
        __webpack_require__.e(/* import() */ 1953).then(__webpack_require__.bind(__webpack_require__, 11953)),
        Promise.all(/* import() */[__webpack_require__.e(3712), __webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(3667), __webpack_require__.e(1271), __webpack_require__.e(9781), __webpack_require__.e(9540), __webpack_require__.e(34), __webpack_require__.e(595), __webpack_require__.e(4925), __webpack_require__.e(9309)]).then(__webpack_require__.bind(__webpack_require__, 69309)),
        __webpack_require__.e(/* import() */ 8009).then(__webpack_require__.bind(__webpack_require__, 92750)),
        __webpack_require__.e(/* import() */ 6100).then(__webpack_require__.bind(__webpack_require__, 56100)),
        Promise.all(/* import() */[__webpack_require__.e(7426), __webpack_require__.e(8285), __webpack_require__.e(8554), __webpack_require__.e(6687)]).then(__webpack_require__.bind(__webpack_require__, 86687)),
        Promise.all(/* import() */[__webpack_require__.e(3057), __webpack_require__.e(4072)]).then(__webpack_require__.bind(__webpack_require__, 93057)),
        Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(3667), __webpack_require__.e(1026), __webpack_require__.e(4615), __webpack_require__.e(9781), __webpack_require__.e(1585), __webpack_require__.e(4237), __webpack_require__.e(3125), __webpack_require__.e(5574), __webpack_require__.e(9546)]).then(__webpack_require__.bind(__webpack_require__, 5574)),
        Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(1305), __webpack_require__.e(3667), __webpack_require__.e(400), __webpack_require__.e(3885), __webpack_require__.e(1592), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(9781), __webpack_require__.e(6790), __webpack_require__.e(9254), __webpack_require__.e(5125), __webpack_require__.e(5249), __webpack_require__.e(7506), __webpack_require__.e(3835), __webpack_require__.e(9302), __webpack_require__.e(3709), __webpack_require__.e(2771), __webpack_require__.e(3738), __webpack_require__.e(4312)]).then(__webpack_require__.bind(__webpack_require__, 13738)),
        Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(3667), __webpack_require__.e(400), __webpack_require__.e(3885), __webpack_require__.e(4615), __webpack_require__.e(1592), __webpack_require__.e(148), __webpack_require__.e(5035), __webpack_require__.e(8489), __webpack_require__.e(9781), __webpack_require__.e(5531), __webpack_require__.e(2649), __webpack_require__.e(4356)]).then(__webpack_require__.bind(__webpack_require__, 48226)),
        Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(400), __webpack_require__.e(4615), __webpack_require__.e(148), __webpack_require__.e(5035), __webpack_require__.e(8489), __webpack_require__.e(8896), __webpack_require__.e(9781), __webpack_require__.e(5531), __webpack_require__.e(3449)]).then(__webpack_require__.bind(__webpack_require__, 13574)),
        Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(7890), __webpack_require__.e(2280), __webpack_require__.e(7649)]).then(__webpack_require__.bind(__webpack_require__, 87649)),
        Promise.resolve({
            NAMESPACE,
            lang: {
                vi: (await __webpack_require__.e(/* import() */ 7254).then(__webpack_require__.t.bind(__webpack_require__, 17254, 19))).default,
                en: (await __webpack_require__.e(/* import() */ 4798).then(__webpack_require__.t.bind(__webpack_require__, 64798, 19))).default
            }
        }), 
    ]);
    const resources = {};
    if (!code) {
        for (const mod of modules){
            for (const langName of Object.keys(mod.lang)){
                if (!resources[langName]) resources[langName] = {};
                resources[langName] = _objectSpreadProps(_objectSpread({}, resources[langName]), {
                    [mod.NAMESPACE]: mod.lang[langName]
                });
            }
        }
        return resources;
    }
    return {
        [code]: modules.reduce((prev, curr)=>_objectSpreadProps(_objectSpread({}, prev), {
                [curr.NAMESPACE]: curr.lang[code]
            }), {})
    };
};
const changeLanguage = async (lng)=>{
    return i18next__WEBPACK_IMPORTED_MODULE_0__["default"].changeLanguage(lng);
};
const initLanguage = async (resources, lng)=>{
    return i18next__WEBPACK_IMPORTED_MODULE_0__["default"].init({
        lng,
        resources,
        initImmediate: false
    });
};


/***/ }),

/***/ 34090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useCartV2; },
/* harmony export */   "q": function() { return /* binding */ CartProviderV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16476);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91004);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20577);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46295);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35790);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89368);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35884);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33756);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23357);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












const defaultCartContext = {
    loading: false,
    setLoading: ()=>{},
    cart: _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .defaultCart */ .UH,
    flattenItems: [],
    getCart: ()=>Promise.resolve(),
    onAddSingleItem: ()=>Promise.resolve(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .defaultCart */ .UH),
    onAddComboItems: ()=>Promise.resolve(),
    onAddMultipleItems: ()=>Promise.resolve(),
    onRemoveItem: ()=>Promise.resolve(),
    onIncrease: ()=>Promise.resolve(),
    onDecrease: ()=>Promise.resolve(),
    onChangeQuantity: ()=>Promise.resolve(),
    onSelectItem: ()=>Promise.resolve(),
    onSelectSeller: ()=>Promise.resolve(),
    onDeleteCart: ()=>Promise.resolve(),
    onChangeItemPrice: ()=>Promise.resolve(),
    isEmpty: true,
    onApplyPromotion: ()=>Promise.resolve(),
    onRemovePromotion: ()=>Promise.resolve(),
    onApplyVoucher: ()=>Promise.resolve(),
    onRequestItemSku: ()=>Promise.resolve(),
    totalCartItems: 0
};
const CartContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(defaultCartContext);
const CartProviderV2 = (param)=>{
    let { children  } = param;
    const desktopToast = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .useToast */ .p)();
    const mobileToast = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .p)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .useLoading */ .r$)("CartContextV2");
    const { 0: cart , 1: setCart  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .defaultCart */ .UH);
    const tokenPromise = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { cartToken: queryCartToken  } = router.query;
    const { user , loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)();
    const { terminal , isMobile , getProcessEnv , partner , iamClientId , requireLogin ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* .useTenantConfig */ .Wx)();
    const { cartServiceV2 , authService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_11__/* .useServices */ .Su)();
    const { trackingScreenName  } = (0,contexts__WEBPACK_IMPORTED_MODULE_12__/* .useScreen */ .EV)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_13__/* .useFeatureFlags */ .g)();
    const showErrorToast = (message)=>{
        if (isMobile) {
            var ref;
            (ref = mobileToast.error) === null || ref === void 0 ? void 0 : ref.call(mobileToast, {
                message
            });
        } else {
            var ref1;
            (ref1 = desktopToast.error) === null || ref1 === void 0 ? void 0 : ref1.call(desktopToast, {
                title: message,
                message: null
            });
        }
    };
    // common handler for handling Error in most Cart functions
    const logAndThrowError = (error)=>{
        _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(error);
        showErrorToast(error.message);
        throw error;
    };
    const showSuccessToast = (message)=>{
        if (isMobile) {
            var ref;
            (ref = mobileToast.success) === null || ref === void 0 ? void 0 : ref.call(mobileToast, {
                message
            });
        } else {
            var ref1;
            (ref1 = desktopToast.success) === null || ref1 === void 0 ? void 0 : ref1.call(desktopToast, {
                title: message,
                message: null
            });
        }
    };
    // getCart when login success
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const fetchCart = async ()=>{
            const cartToken = _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479 ? await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].cart */ .Z.cart().getCartToken() : queryCartToken;
            if (!!cartToken) {
                (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .setCartToken */ .rx)(cartToken);
            }
            // loadingIAMState somehow doesn't work here
            // use localStorage instead
            const clientId = iamClientId || getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
            const isUserInfoInLS = localStorage.getItem("tekoid.user.".concat(clientId));
            if (authLoading) return;
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479) {
                // alway get cart in embeded webview
                getCart({
                    withLoading: false,
                    removeToken: false
                });
            } else if (user || //user is not logged with partner
            !isUserInfoInLS && !partner && !_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) {
                getCart({
                    withLoading: router.pathname.includes("/cart"),
                    removeToken: false
                });
            }
        };
        fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        queryCartToken,
        authLoading,
        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()
    ]);
    const flattenItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>cart.items.reduce((prev, curr)=>[
                ...prev,
                ...curr.items
            ], []), [
        cart.items
    ]);
    // check for cartToken, if cartToken is empty then create new one.
    const validateCartToken = async ()=>{
        if (!(0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .getCartToken */ .i)() && !tokenPromise.current) {
            tokenPromise.current = createCart().finally(()=>tokenPromise.current = null);
        }
        await tokenPromise.current;
    };
    // create new cart from cart service v2
    const createCart = async ()=>{
        try {
            const { cartToken  } = await cartServiceV2.createNewCart({});
            if (cartToken) {
                (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .setCartToken */ .rx)(cartToken);
            }
        } catch (error) {
            logAndThrowError(error);
        }
    };
    // get Cart from Cart Service V2
    const getCart = async (param)=>{
        let { withLoading =false , removeToken =true ,  } = param;
        try {
            var ref;
            if (!terminal) return;
            if (withLoading) setLoading(true);
            await validateCartToken();
            const cart = await cartServiceV2.getCart();
            setCart(cart);
            if (removeToken && (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) === 0) (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .removeCartToken */ .ng)();
        } catch (error) {
            if (!withLoading) {
                // without explicit loading,
                // do not show the error toast
                // since it cause confusion to users
                // in page such as condition
                _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(error);
                throw error;
            } else {
                logAndThrowError(error);
            }
        } finally{
            setLoading(false);
        }
    };
    const updateNativeAppCart = async (cartResponse)=>{
        try {
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479 && cartResponse) {
                await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].cart */ .Z.cart().updateCartSuccess(JSON.stringify(cartResponse));
            }
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
        }
    };
    const onAddToCart = async function(body) {
        let fromProductCard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // force login when add to card with tenant require login
        if (requireLogin && !user) {
            if (!authLoading) {
                authService.login();
            }
            return null;
        }
        const { groups , override  } = body;
        try {
            setLoading(true);
            const { trackAddToCartManually  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
            if (fromProductCard && trackingScreenName) {
                groups.forEach((group)=>{
                    group.products.forEach((product)=>{
                        trackAddToCartManually(trackingScreenName, product.sellerSku || "");
                    });
                });
            }
            await validateCartToken();
            const res = await cartServiceV2.addItems({
                groups,
                override
            });
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đ\xe3 th\xeam sản phẩm v\xe0o giỏ h\xe0ng"));
            setCart(res);
            updateNativeAppCart(res);
            return res;
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(error);
            showErrorToast(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    // handle user add an item to cart
    const onAddSingleItem = async function(param) {
        let { sku , sellerSku , quantity , promotionId , isPrimary  } = param, fromProductCard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const body = {
            groups: [
                {
                    products: [
                        {
                            sku,
                            sellerSku,
                            quantity,
                            promotionId,
                            isPrimary
                        }
                    ]
                }, 
            ],
            override: false
        };
        return await onAddToCart(body, fromProductCard);
    };
    // handle user add multiple item to cart
    const onAddMultipleItems = async (productList)=>{
        const body = {
            groups: [
                {
                    products: productList
                }
            ],
            override: false
        };
        await onAddToCart(body, false);
    };
    // handle user add combo to cart
    const onAddComboItems = async (body)=>{
        await onAddToCart(body, false);
    };
    // handle when user remove an item
    const onRemoveItem = async (item)=>{
        const { trackRemoveFromCart  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
        try {
            trackRemoveFromCart(item, cart.id);
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.removeItem({
                itemId: item.id
            });
            setCart(res);
            updateNativeAppCart(res);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    // handle when user click add button on an item
    const onIncrease = async (item)=>{
        return onChangeQuantity(item, item.quantity + 1);
    };
    // handle when user click subtract button on an item
    const onDecrease = async (item)=>{
        return onChangeQuantity(item, item.quantity - 1);
    };
    // handle when user change quantity of an item
    const onChangeQuantity = async (item, newQuantity)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const { trackChangeQuantityProduct  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
            trackChangeQuantityProduct(item, newQuantity, cart.id);
            const res = await cartServiceV2.updateItemQuantity({
                itemId: item.id,
                quantity: newQuantity
            });
            setCart(res);
            updateNativeAppCart(res);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    const onSelectItems = async (itemIdList, isSelected)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.selectItems({
                isSelected,
                itemIds: itemIdList
            });
            setCart(res);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    // handle when user click checkbox of an item
    const onSelectItem = async (item)=>{
        const { trackSelectProduct  } = await __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525));
        trackSelectProduct(item, !item.isSelected, cart.id);
        return onSelectItems([
            item.id
        ], !item.isSelected);
    };
    // handle when user click on Checkbox of a seller
    const onSelectSeller = async (sellerItems, selected)=>{
        // only toggle items which its allowedUserActions contains TOGGLE value
        const canToggleCartItems = (sellerItems || []).filter((item)=>(item.allowedUserActions || []).includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_15__/* .AllowedUserActionItem.TOGGLE */ .rV.TOGGLE));
        return onSelectItems(canToggleCartItems.map((item)=>item.id), selected);
    };
    // handle when user click delete all cart
    const onDeleteCart = async ()=>{
        try {
            setLoading(true);
            await validateCartToken();
            await cartServiceV2.deleteCart();
            await getCart({
                withLoading: true
            });
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    const onChangeItemPrice = async (priceEditorData)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const { id , editedPrice , price  } = priceEditorData;
            const newCart = await cartServiceV2.changeItemPrice({
                itemId: id,
                consultationFee: Number(editedPrice) - price
            });
            if (newCart) {
                setCart(newCart);
                showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Sửa gi\xe1 sản phẩm th\xe0nh c\xf4ng"));
            }
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    // function to handle apply promotion
    const onApplyPromotion = async (applyPromotionParams)=>{
        const { productId , promotionCode , promotionId  } = applyPromotionParams;
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.applyPromotion(_objectSpreadProps(_objectSpread({}, !!productId && {
                itemId: productId
            }), {
                ppmPromotionId: promotionId,
                ppmCode: promotionCode
            }));
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("\xc1p dụng khuyến m\xe3i th\xe0nh c\xf4ng"));
            setCart(res.data);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    // function to handle remove promotion
    const onRemovePromotion = async (cartPromotionId)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const req = {
                cartPromotionId
            };
            const res = await cartServiceV2.removePromotion(req);
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Bỏ \xe1p dụng khuyến m\xe3i th\xe0nh c\xf4ng"));
            setCart(res.data);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    const onApplyVoucher = async (ppmCode)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.applyPromotion({
                ppmCode: ppmCode
            });
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("\xc1p dụng m\xe3 giảm gi\xe1/phiếu mua h\xe0ng th\xe0nh c\xf4ng"));
            setCart(res.data);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    const onRequestItemSku = async function(name) {
        let quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        // force login when add to card with tenant require login
        if (requireLogin && !user) {
            if (!authLoading) {
                authService.login();
            }
            return;
        }
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.requestItemSku({
                name,
                quantity
            });
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đ\xe3 th\xeam sản phẩm v\xe0o giỏ h\xe0ng"));
            setCart(res);
        } catch (error) {
            logAndThrowError(error);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartContext.Provider, {
        value: {
            loading,
            setLoading,
            cart,
            flattenItems,
            getCart,
            onAddSingleItem,
            onAddMultipleItems,
            onAddComboItems,
            onRemoveItem,
            onIncrease,
            onDecrease,
            onChangeQuantity,
            onSelectItem,
            onSelectSeller,
            onDeleteCart,
            get isEmpty () {
                var ref;
                return (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) === 0;
            },
            onChangeItemPrice,
            onApplyPromotion,
            onRemovePromotion,
            onApplyVoucher,
            onRequestItemSku,
            get totalCartItems () {
                return (flattenItems || []).length;
            }
        },
        children: children
    });
};
function useCartV2() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CartContext);
    if (!context) {
        throw new Error("useCartV2 must be inside a CartProviderV2 with a state value");
    }
    return context;
}


/***/ }),

/***/ 97338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ NotificationProvider; },
/* harmony export */   "lm": function() { return /* binding */ useNotification; },
/* harmony export */   "ti": function() { return /* binding */ PageStatus; },
/* harmony export */   "uj": function() { return /* binding */ NotificationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46295);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84443);
/* harmony import */ var _teko_notification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71633);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43015);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7276);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20577);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var PageStatus;
(function(PageStatus) {
    PageStatus["LOADING"] = "loading";
    PageStatus["LOADED"] = "loaded";
    PageStatus["EMPTY"] = "empty";
    PageStatus["FAILED"] = "failed";
})(PageStatus || (PageStatus = {}));
const NotificationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const useNotification = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NotificationContext);
    if (context === undefined) {
        throw new Error("useNotification must be used in NotificationProvider");
    }
    return context;
};
const NotificationProvider = (param)=>{
    let { children  } = param;
    const { user , loading: userLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)();
    const { notificationService , discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const { notificationAppId , iamClientId , partner , getProcessEnv  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const { 0: status , 1: setStatus  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(PageStatus.LOADED);
    const { 0: notifications , 1: setNotifications  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: checkpoint , 1: setCheckpoint  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const { 0: markAllReadLoading , 1: setLoadingMarkReadAll  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: unRead , 1: setUnread  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { serviceWorkerScripts  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const getMoreNotifications = async function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, checkpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        if (!notificationAppId) return;
        const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_7__/* .FCM_TOKEN */ .ut);
        const params = {
            app_id: notificationAppId,
            limit: limit,
            ignore_pending_send: 0,
            check_point: checkpoint,
            token: token !== null && token !== void 0 ? token : undefined
        };
        setLoading(true);
        try {
            const notificationData = await notificationService.getNotification(params);
            return (0,_helper__WEBPACK_IMPORTED_MODULE_8__/* .convertNotification */ .Et)(notificationData, discoveryService);
        } catch (err) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(err);
        } finally{
            setLoading(false);
        }
    };
    const getNotifications = async function() {
        let checkpoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, isNew = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const { checkpoint: newCheckpoint , notifications: newNotifications = [] , unRead: newUnread ,  } = await getMoreNotifications(limit, checkpoint) || {};
        if (!isNew) {
            setCheckpoint(()=>newCheckpoint);
            setNotifications((notifications)=>[
                    ...notifications,
                    ...newNotifications, 
                ]);
        } else {
            setNotifications((notifications)=>[
                    ...newNotifications,
                    ...notifications, 
                ]);
        }
        setUnread(()=>newUnread || 0);
    };
    const installWebPushNotification = async ()=>{
        const firebaseOptions = {
            apiKey: getProcessEnv("FIREBASE_CLOUD_MESSAGING_API_KEY"),
            authDomain: getProcessEnv("FIREBASE_CLOUD_MESSAGING_AUTH_DOMAIN"),
            databaseURL: getProcessEnv("FIREBASE_CLOUD_MESSAGING_DATABASE_URL"),
            projectId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_PROJECT_ID"),
            storageBucket: getProcessEnv("FIREBASE_CLOUD_MESSAGING_STORAGE_BUCKET"),
            messagingSenderId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_MESSAGING_SENDER_ID"),
            appId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_APP_ID"),
            measurementId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_MEASUREMENT_ID")
        };
        const vapidKey = getProcessEnv("FIREBASE_VAPID_KEY");
        await (0,_helper__WEBPACK_IMPORTED_MODULE_8__/* .installNotification */ .bL)({
            user,
            unsAppId: notificationAppId,
            notificationService,
            firebaseOptions,
            vapidKey,
            externalScripts: serviceWorkerScripts,
            onMessage: ()=>getNotifications(undefined, 1, true),
            markReadNotification
        });
        getNotifications(checkpoint);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const clientId = iamClientId || getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
        const isUserInfoInLS = localStorage.getItem("tekoid.user.".concat(clientId));
        if (!userLoading && (user || // user is not logged with partner
        !isUserInfoInLS && !partner && !_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isAvailable */ .Z.isAvailable())) {
            installWebPushNotification();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        userLoading
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!loading) {
            if (notifications.length === 0) {
                setStatus(PageStatus.EMPTY);
            } else {
                setStatus(PageStatus.LOADED);
            }
        } else {
            setStatus(PageStatus.LOADING);
        }
    }, [
        loading,
        notifications
    ]);
    const markReadNotification = async (notification)=>{
        if (!notification.is_read) {
            const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_7__/* .FCM_TOKEN */ .ut);
            try {
                const { status  } = await notificationService.markNotificationAsRead(notification.id, token !== null && token !== void 0 ? token : undefined);
                if (status === "success") {
                    setNotifications((prev)=>prev.map((noti)=>{
                            if (noti.id === notification.id) {
                                return _objectSpreadProps(_objectSpread({}, noti), {
                                    is_read: true
                                });
                            }
                            return noti;
                        }));
                    if (!notification.is_read) setUnread((count)=>count ? count - 1 : 0);
                }
            } catch (e) {
                _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
            }
        }
    };
    const markReadAll = async ()=>{
        try {
            if (!notificationAppId) return;
            setLoadingMarkReadAll(true);
            const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_7__/* .FCM_TOKEN */ .ut);
            const params = {
                app_id: notificationAppId,
                token: token !== null && token !== void 0 ? token : undefined
            };
            await notificationService.markReadAll(params);
            setNotifications((notifications)=>notifications.map((noti)=>_objectSpreadProps(_objectSpread({}, noti), {
                        is_read: true
                    })));
            setUnread(0);
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
        } finally{
            setLoadingMarkReadAll(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationContext.Provider, {
        value: {
            status,
            notifications,
            checkpoint,
            loading,
            getNotifications,
            markReadNotification,
            markReadAll,
            markAllReadLoading,
            unRead
        },
        children: children
    });
};


/***/ }),

/***/ 7276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ unregisterUNS; },
/* harmony export */   "Et": function() { return /* binding */ convertNotification; },
/* harmony export */   "bL": function() { return /* binding */ installNotification; },
/* harmony export */   "hC": function() { return /* binding */ onNotificationClick; },
/* harmony export */   "vX": function() { return /* binding */ registerUNS; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20577);
/* harmony import */ var _teko_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71633);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const registerUNS = async (param)=>{
    let { fcmToken , user , unsAppId , notificationService  } = param;
    const lsToken = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut);
    const lsUserId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
    const lsUNSAppId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .UNS_APP_ID */ .Bb);
    const lsRegisterTokenSuccess = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX);
    const registerCondition = // when firebase updates token, when first time users using the app
    fcmToken !== lsToken || // when update notificationAppId config
    unsAppId !== lsUNSAppId || // When the user logs in
    (user === null || user === void 0 ? void 0 : user.userId) && user.userId !== lsUserId || // When registration failed last time
    lsRegisterTokenSuccess === "false";
    if (registerCondition) {
        try {
            var ref, ref1, ref2;
            await notificationService.registerToken({
                app_id: unsAppId,
                user_id: (ref = user === null || user === void 0 ? void 0 : user.userId) !== null && ref !== void 0 ? ref : undefined,
                transport: _teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TRANSPORT */ .n8,
                token: fcmToken,
                email: (ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : undefined,
                phone: (ref2 = user === null || user === void 0 ? void 0 : user.telephone) !== null && ref2 !== void 0 ? ref2 : undefined
            });
            localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX, "true");
            if (user === null || user === void 0 ? void 0 : user.userId) {
                localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz, user.userId);
            }
        } catch (e) {
            localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX, "false");
        }
    }
    localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut, fcmToken);
    localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .UNS_APP_ID */ .Bb, unsAppId);
};
const unregisterUNS = async (notificationService, unsAppId)=>{
    try {
        const lsToken = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut);
        const lsUserId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
        await notificationService.unRegisterToken({
            user_id: lsUserId !== null && lsUserId !== void 0 ? lsUserId : undefined,
            app_id: unsAppId,
            transport: _teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TRANSPORT */ .n8,
            token: lsToken !== null && lsToken !== void 0 ? lsToken : undefined
        });
    } finally{
        localStorage.removeItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
    }
};
const registerServiceWorker = async (param)=>{
    let { firebaseOptions , externalScripts , onMessage , markReadNotification  } = param;
    var ref;
    // Remove pushdy service worker
    try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        const pushdyUrl = location.protocol + "//" + location.host + "/sw.js";
        registrations.forEach((reg)=>{
            var ref;
            if ((reg === null || reg === void 0 ? void 0 : (ref = reg.active) === null || ref === void 0 ? void 0 : ref.scriptURL) === pushdyUrl) {
                reg.unregister();
            }
        });
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
    const configs = new URLSearchParams(_objectSpreadProps(_objectSpread({}, firebaseOptions), {
        externalScripts: (ref = externalScripts || []) === null || ref === void 0 ? void 0 : ref.join(",")
    })).toString();
    const serviceWorker = await navigator.serviceWorker.register("/firebase-messaging-sw.js?".concat(configs));
    // Listener for message comes from service worker
    navigator.serviceWorker.addEventListener("message", (event)=>{
        const { action , msgId , traceId  } = event.data;
        const payload = JSON.stringify({
            msg_id: msgId === null || msgId === void 0 ? void 0 : msgId.toString(),
            trace_id: traceId === null || traceId === void 0 ? void 0 : traceId.toString()
        });
        switch(action){
            case "click":
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackManually */ .gu)("notification", "browserNotification", "notification", payload, msgId);
                markReadNotification === null || markReadNotification === void 0 ? void 0 : markReadNotification({
                    id: parseInt(msgId),
                    is_read: false
                });
                break;
            case "backgroundMessage":
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .trackVisibleManually */ .UC)({
                    regionName: "browserNotification",
                    contentName: "notification",
                    payload: payload,
                    index: msgId
                });
                onMessage === null || onMessage === void 0 ? void 0 : onMessage();
                break;
            default:
                break;
        }
    });
    return serviceWorker;
};
const initFirebaseApp = async (param)=>{
    let { firebaseAppName , firebaseOptions  } = param;
    const { getApp , initializeApp  } = await Promise.all(/* import() */[__webpack_require__.e(8285), __webpack_require__.e(1113)]).then(__webpack_require__.bind(__webpack_require__, 1113));
    let firebaseNotiApp;
    try {
        // try to get app by name
        // it will throw exception otherwise
        firebaseNotiApp = getApp(firebaseAppName);
    } catch (_) {
        // initialize if not exist yet
        firebaseNotiApp = initializeApp(firebaseOptions, firebaseAppName);
    }
    return firebaseNotiApp;
};
const registerFCM = async (firebaseApp, serviceWorker, param)=>{
    let { vapidKey , onMessage  } = param;
    const { getMessaging , getToken , onMessage: addMessageEvent ,  } = await Promise.all(/* import() */[__webpack_require__.e(8285), __webpack_require__.e(9349)]).then(__webpack_require__.bind(__webpack_require__, 49349));
    const messaging = getMessaging(firebaseApp);
    const token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration: serviceWorker !== null && serviceWorker !== void 0 ? serviceWorker : undefined
    });
    if (onMessage) {
        addMessageEvent(messaging, onMessage);
    }
    return token;
};
const installNotification = async (param)=>{
    let { user , unsAppId , notificationService , firebaseOptions , vapidKey , firebaseAppName ="notification" , externalScripts , onMessage , markReadNotification  } = param;
    try {
        if ("serviceWorker" in navigator && typeof window.Notification !== "undefined") {
            const permission = await window.Notification.requestPermission();
            if (permission === "granted") {
                // Step 1: register new Service Worker to handle message in background
                const serviceWorker = await registerServiceWorker({
                    firebaseOptions,
                    externalScripts,
                    onMessage,
                    markReadNotification
                });
                // Step 2: Init firebase app
                const firebaseApp = await initFirebaseApp({
                    firebaseOptions,
                    firebaseAppName
                });
                // Step 3: register firebase cloud messaging
                const fcmToken = await registerFCM(firebaseApp, serviceWorker, {
                    vapidKey,
                    onMessage
                });
                // Step 4: Register FCM token to UNS
                registerUNS({
                    fcmToken,
                    user,
                    unsAppId,
                    notificationService
                });
            }
        }
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
};
const convertNotification = async (notification, discoveryService)=>{
    if (!notification) return;
    const { notifications: data , check_point: checkpoint , unread: unRead ,  } = notification;
    let apiResultNotifications = data;
    if (!!apiResultNotifications.length) {
        // call API discovery to get image of order notification
        // array of order notification's order items
        const notificationOrderItemsArr = apiResultNotifications.filter((noti)=>!!noti.order).map((noti)=>{
            var ref;
            return ((ref = noti.order) === null || ref === void 0 ? void 0 : ref.orderItems) || "";
        });
        if (notificationOrderItemsArr.length) {
            const products = await discoveryService.getProductDetailBySkus({
                skus: notificationOrderItemsArr
            });
            const imageMapping = products.reduce((prev, curr)=>{
                var ref, ref1;
                return _objectSpreadProps(_objectSpread({}, prev), {
                    [(ref = curr.productInfo) === null || ref === void 0 ? void 0 : ref.sku]: (ref1 = curr.productInfo) === null || ref1 === void 0 ? void 0 : ref1.imageUrl
                });
            }, {});
            apiResultNotifications = apiResultNotifications.map((noti)=>{
                return _objectSpread({}, noti, !noti.order ? {} : {
                    order: _objectSpreadProps(_objectSpread({}, noti.order), {
                        imageUrl: imageMapping[noti.order.orderItems] || ""
                    })
                });
            });
        }
    }
    return {
        notifications: apiResultNotifications,
        checkpoint,
        unRead
    };
};
const onNotificationClick = async (notification, router)=>{
    if (notification.deepLink) {
        router.push(notification.deepLink);
    } else if (notification.order) {
        router.push({
            pathname: "/account/orders/[orderId]",
            query: {
                orderId: notification.order.orderId
            }
        }, {
            pathname: "/account/orders/".concat(notification.order.orderId)
        });
    }
};


/***/ }),

/***/ 50053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_app; },
  "reportWebVitals": function() { return /* reexport */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 8 modules
var context_es = __webpack_require__(46295);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(96098);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(1688);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Loading/context.es.js
var Loading_context_es = __webpack_require__(89368);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(20577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(69168);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/contexts/ThemeProvider.es.js
var ThemeProvider_es = __webpack_require__(3414);
// EXTERNAL MODULE: ./components/desktop/organisms/LanguageSelector.tsx
var LanguageSelector = __webpack_require__(11888);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(79894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/mobile/organisms/MetaHead.tsx



function MetaHead(param) {
    let { theme , config , meta  } = param;
    const { tenant , logoUrl , schemaWebsite  } = config;
    const getIconUrl = (size)=>"".concat(logoUrl, "=w").concat(size);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: meta === null || meta === void 0 ? void 0 : meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: logoUrl ? getIconUrl(16) : "/".concat(tenant, "/favicon.ico?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: logoUrl ? getIconUrl(180) : "/".concat(tenant, "/apple-touch-icon.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: logoUrl ? getIconUrl(32) : "/".concat(tenant, "/favicon-32x32.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: logoUrl ? getIconUrl(16) : "/".concat(tenant, "/favicon-16x16.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/".concat(tenant, "/site.webmanifest")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: theme.brand.primary || "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: theme.brand.primary || "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1.0, shrink-to-fit=no"
            }),
            schemaWebsite && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaWebsite)
                }
            })
        ]
    });
}
/* harmony default export */ var organisms_MetaHead = (MetaHead);

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/SmartBanner.tsx




// lazy import
const SmartComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3712), __webpack_require__.e(9405), __webpack_require__.e(8374), __webpack_require__.e(6470), __webpack_require__.e(3971), __webpack_require__.e(1474), __webpack_require__.e(6430), __webpack_require__.e(7323), __webpack_require__.e(9290), __webpack_require__.e(2218), __webpack_require__.e(7926), __webpack_require__.e(140), __webpack_require__.e(2800), __webpack_require__.e(7079), __webpack_require__.e(21), __webpack_require__.e(4015), __webpack_require__.e(6218), __webpack_require__.e(5817), __webpack_require__.e(2603), __webpack_require__.e(6700), __webpack_require__.e(3885), __webpack_require__.e(4615), __webpack_require__.e(5035), __webpack_require__.e(9051), __webpack_require__.e(6985)]).then(__webpack_require__.bind(__webpack_require__, 21199)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21199)
            ]
    }
});
const SmartBanner = ()=>{
    const { getProcessEnv  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { user , loading: profileLoading  } = (0,context_es/* useAuth */.a)();
    // tracking app id
    const trackingAppId = getProcessEnv("TRACKER_APP_ID");
    // env of landing builder
    const landingBuilderEnv = getProcessEnv("LANDING_BUILDER_ENV");
    const { smartActivationConfig  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { appId , sessionPeriodMinutes  } = smartActivationConfig || {};
    // user has to login before show smart banner
    const iamId = user === null || user === void 0 ? void 0 : user.userId;
    const showSmartBanner = !profileLoading && appId;
    if (!showSmartBanner) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartComponent, {
        env: landingBuilderEnv,
        configs: {
            appId,
            trackingAppId,
            iamId,
            sessionPeriodMinutes
        }
    });
};

// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
;// CONCATENATED MODULE: ./helpers/mockStorage.ts
class MockStorage {
    setItem(key, value) {
        this.storage[key] = value;
    }
    getItem(key) {
        return this.storage[key] || null;
    }
    removeItem(key) {
        delete this.storage[key];
    }
    key(index) {
        return Object.keys(this.storage).at(index) || null;
    }
    clear() {
        this.storage = {};
    }
    constructor(){
        this.storage = {};
    }
}
// only used in _app component
const storageAvailable = (type)=>{
    try {
        const storage = type == "localStorage" ? window === null || window === void 0 ? void 0 : window.localStorage : window === null || window === void 0 ? void 0 : window.sessionStorage;
        const key = "__storage_test__";
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    } catch (error) {
        return false;
    }
};

// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(4133);
// EXTERNAL MODULE: ./helpers/translate.ts
var translate = __webpack_require__(58045);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../../.yarn/cache/nprogress-npm-0.2.0-c1c0973624-66b7bec5d5.zip/node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(25290);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
;// CONCATENATED MODULE: ./hooks/useRouterEffect.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const useRouterEffect = function(router) {
    let restorePositionWhenBack = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const { 0: scrollPos , 1: setScrollPos  } = (0,react.useState)({});
    const addScrollPos = (url)=>{
        const newScrollPos = {
            x: window.scrollX,
            y: window.scrollY
        };
        setScrollPos((prev)=>{
            return _objectSpreadProps(_objectSpread({}, prev), {
                [url]: newScrollPos
            });
        });
    };
    const restoreScrollPos = (url)=>{
        if (scrollPos[url]) {
            window.scrollTo(scrollPos[url].x, scrollPos[url].y);
        }
    };
    (0,react.useEffect)(()=>{
        router_default().events.on("routeChangeStart", ()=>{
            nprogress_default().start();
        });
        router_default().events.on("routeChangeComplete", ()=>nprogress_default().done());
        router_default().events.on("routeChangeError", ()=>nprogress_default().done());
    }, []);
    (0,react.useEffect)(()=>{
        if ("scrollRestoration" in window.history && restorePositionWhenBack) {
            let shouldScrollRestore = false;
            window.history.scrollRestoration = "manual";
            restoreScrollPos(router.asPath);
            const onRouteChangeStart = ()=>{
                addScrollPos(router.asPath);
            };
            const onRouteChangeComplete = (url)=>{
                if (shouldScrollRestore) {
                    shouldScrollRestore = false;
                    restoreScrollPos(url);
                }
            };
            router_default().events.on("routeChangeStart", onRouteChangeStart);
            router_default().events.on("routeChangeComplete", onRouteChangeComplete);
            router_default().beforePopState(()=>{
                shouldScrollRestore = true;
                return true;
            });
            return ()=>{
                router_default().events.off("routeChangeStart", onRouteChangeStart);
                router_default().events.off("routeChangeComplete", onRouteChangeComplete);
                router_default().beforePopState(()=>true);
            };
        }
    }, [
        router
    ]);
};

// EXTERNAL MODULE: ./hooks/usePos365StoreCode.ts
var usePos365StoreCode = __webpack_require__(68055);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-tracker-virtual-8eef9107c2/0/cache/next-tracker-npm-1.2.3-c57dd13924-44db98d112.zip/node_modules/next-tracker/dist/index.js
var dist = __webpack_require__(61226);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/app.js
var app = __webpack_require__(96289);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/config.js
var config = __webpack_require__(27490);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./tenants/_template/desktop/_helpers/RightMenu/RightMenu.tsx + 1 modules
var RightMenu = __webpack_require__(94416);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(73717);
// EXTERNAL MODULE: ./modules/notification/NotificationProvider.tsx
var NotificationProvider = __webpack_require__(97338);
// EXTERNAL MODULE: ./contexts/PrivacyPolicyContext.tsx + 1 modules
var PrivacyPolicyContext = __webpack_require__(66921);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(14986);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(8604);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-lazy-hydration-virtual-bff429a9c1/0/cache/react-lazy-hydration-npm-0.1.0-52f4d8c753-1140b9a082.zip/node_modules/react-lazy-hydration/dist/index.browser.esm.js




// React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect =  react.useLayoutEffect ;

function reducer() {
  return true;
}

function LazyHydrate(props) {
  var childRef = (0,react.useRef)(null); // Always render on server

  var _React$useReducer = (0,react.useReducer)(reducer, !(true )),
      hydrated = _React$useReducer[0],
      hydrate = _React$useReducer[1];

  var noWrapper = props.noWrapper,
      ssrOnly = props.ssrOnly,
      whenIdle = props.whenIdle,
      whenVisible = props.whenVisible,
      promise = props.promise,
      _props$on = props.on,
      on = _props$on === void 0 ? [] : _props$on,
      children = props.children,
      didHydrate = props.didHydrate,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["noWrapper", "ssrOnly", "whenIdle", "whenVisible", "promise", "on", "children", "didHydrate"]);

  if (false) {}

  useIsomorphicLayoutEffect(function () {
    // No SSR Content
    if (!childRef.current.hasChildNodes()) {
      hydrate();
    }
  }, []);
  (0,react.useEffect)(function () {
    if (hydrated && didHydrate) {
      didHydrate();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [hydrated]);
  (0,react.useEffect)(function () {
    if (ssrOnly || hydrated) return;
    var rootElement = childRef.current;
    var cleanupFns = [];

    function cleanup() {
      cleanupFns.forEach(function (fn) {
        fn();
      });
    }

    if (promise) {
      promise.then(hydrate, hydrate);
    }

    if (whenVisible) {
      var element = noWrapper ? rootElement : // As root node does not have any box model, it cannot intersect.
      rootElement.firstElementChild;

      if (element && typeof IntersectionObserver !== "undefined") {
        var observerOptions = typeof whenVisible === "object" ? whenVisible : {
          rootMargin: "250px"
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              hydrate();
            }
          });
        }, observerOptions);
        io.observe(element);
        cleanupFns.push(function () {
          io.disconnect();
        });
      } else {
        return hydrate();
      }
    }

    if (whenIdle) {
      // @ts-ignore
      if (typeof requestIdleCallback !== "undefined") {
        // @ts-ignore
        var idleCallbackId = requestIdleCallback(hydrate, {
          timeout: 500
        });
        cleanupFns.push(function () {
          // @ts-ignore
          cancelIdleCallback(idleCallbackId);
        });
      } else {
        var id = setTimeout(hydrate, 2000);
        cleanupFns.push(function () {
          clearTimeout(id);
        });
      }
    }

    var events = [].concat(on);
    events.forEach(function (event) {
      rootElement.addEventListener(event, hydrate, {
        once: true,
        passive: true
      });
      cleanupFns.push(function () {
        rootElement.removeEventListener(event, hydrate, {});
      });
    });
    return cleanup;
  }, [hydrated, on, ssrOnly, whenIdle, whenVisible, didHydrate, promise, noWrapper]);
  var WrapperElement = typeof noWrapper === "string" ? noWrapper : "div";

  if (hydrated) {
    if (noWrapper) {
      return children;
    }

    return /*#__PURE__*/(0,react.createElement)(WrapperElement, (0,esm_extends/* default */.Z)({
      ref: childRef,
      style: {
        display: "contents"
      }
    }, rest), children);
  } else {
    return /*#__PURE__*/(0,react.createElement)(WrapperElement, (0,esm_extends/* default */.Z)({}, rest, {
      ref: childRef,
      suppressHydrationWarning: true,
      dangerouslySetInnerHTML: {
        __html: ""
      }
    }));
  }
}

/* harmony default export */ var index_browser_esm = (LazyHydrate);

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ./contexts/LanguageProvider.tsx





const LanguageProvider = (param)=>{
    let { code , children  } = param;
    const languageResolved = new Promise((resolve)=>i18next["default"].on("initialized", resolve));
    (0,react.useEffect)(()=>{
        const init = async ()=>{
            const { lang  } = window;
            await (0,i18n/* initLanguage */.zw)(lang, code);
            await (0,i18n/* changeLanguage */.D0)(code);
        };
        init();
    }, [
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_browser_esm, {
        promise: languageResolved,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};

// EXTERNAL MODULE: ./contexts/HelperContext.tsx
var HelperContext = __webpack_require__(29706);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(58610);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(27890);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(68673);
// EXTERNAL MODULE: ./contexts/ScreenContext.tsx
var ScreenContext = __webpack_require__(33756);
// EXTERNAL MODULE: ./contexts/LoyaltyProvider.tsx
var LoyaltyProvider = __webpack_require__(61105);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(34090);
;// CONCATENATED MODULE: ./contexts/HistoryContext.tsx



const HistoryContext = /*#__PURE__*/ react.createContext(undefined);
const HistoryProvider = (param)=>{
    let { children  } = param;
    const { 0: prevUrl , 1: setPrevUrl  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const handleRouteChange = ()=>{
            setPrevUrl(window.location.href);
        };
        next_router.Router.events.on("routeChangeStart", handleRouteChange);
        return ()=>{
            next_router.Router.events.off("routeChangeStart", handleRouteChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryContext.Provider, {
        value: {
            prevUrl
        },
        children: children
    });
};
function usePrevUrl() {
    const context = useContext(HistoryContext);
    if (!context) {
        throw new Error("usePrevUrl must be inside a HistoryContext with a state value");
    }
    return context.prevUrl;
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dist/shared/lib/router/utils/remove-trailing-slash.js
var remove_trailing_slash = __webpack_require__(81928);
// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(79228);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(53632);
// EXTERNAL MODULE: ./types/config.ts
var types_config = __webpack_require__(50923);
// EXTERNAL MODULE: ./hooks/useQuery.tsx
var useQuery = __webpack_require__(46818);
// EXTERNAL MODULE: ./utils/iframe.ts
var iframe = __webpack_require__(98116);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var dist_index_es = __webpack_require__(31260);
;// CONCATENATED MODULE: ./tenants/_env.ts






class ClientTenantEnvImpl {
    getProcessEnv(env) {
        var ref;
        return window === null || window === void 0 ? void 0 : (ref = window.env) === null || ref === void 0 ? void 0 : ref[env];
    }
    constructor(config){
        // allow users to set terminalId via query parameter
        // use a new storage key to avoid being overwritten by ecom-284 logic
        const isEcom284 = (0,env/* getEnv */.dU)("EPIC_ECOM_284") === "enabled" && !config.disableEpicEcom284;
        if ((0,helpers/* isServerless */.ep)()) {
            var ref;
            const { terminalCode , locationCode , terminalId  } = (0,useQuery/* getQueryParams */.vl)(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search, {
                terminalCode: useQuery/* StringParam */.Zp,
                locationCode: useQuery/* StringParam */.Zp,
                terminalId: useQuery/* NumberParam */.yz
            });
            // set this value to localstorage
            if (!!terminalCode) {
                (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminalCode, config.isMobile);
            }
            if (!!locationCode) {
                (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, locationCode, config.isMobile);
            }
            if (!!terminalId) {
                // after ecom-284, use the a new storage key
                // as TERMINAL_ID is ignored by the new flow and should be removed
                (0,env/* setUserSelectedInfo */.MA)(isEcom284 ? local/* userSelectedConstants.OVERRIDE_TERMINAL_ID */.Tp.OVERRIDE_TERMINAL_ID : local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminalId.toString(), isEcom284 ? false : config.isMobile);
            }
            if ((0,dist_index_es/* inIframe */.yL)()) {
                const { clientId: iframeIamClientId , oauthDomain: iframeOauthDomain  } = (0,iframe/* getDataFromIframe */.b)();
                // only use these 2 values to init authService if Iframe pass both clientId and oathDomain
                if (!!iframeIamClientId && !!iframeOauthDomain) {
                    config.iamClientId = iframeIamClientId;
                    config.iamOauthDomain = iframeOauthDomain;
                }
            }
        }
        if (isEcom284) {
            // From ecom 284, shop proxy no longer caches responses by terminal or by location,
            // so the terminal and location returned by server are unchanged for every requests.
            // This statement handles re-assigning these configs based on the chosen one of the users.
            // It also sets some variables to storages for showing some necessary popups.
            if ((0,helpers/* isServerless */.ep)()) {
                var ref1;
                if (!((ref1 = config.locations) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                    // Show the error popup when locations aren't found
                    (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Error */.t.Error);
                } else if (config.locations.length === 1 && config.locations[0].locationCode === "0") {
                    // With the above condition, don't show any messages.
                    (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.None */.t.None);
                } else {
                    // Use the location that chose by users and stored in localStorage.
                    const locationCodeFromLS = localStorage.getItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION);
                    if (!locationCodeFromLS) {
                        // If the location in localStorage is not exist, use the default one returned by the server.
                        // Show the hint for this case
                        (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Hint */.t.Hint);
                        var _location;
                        // Set the default location to localStorage
                        localStorage.setItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, (_location = config.location) !== null && _location !== void 0 ? _location : "");
                    } else {
                        // If the user has chosen a location that stored in localStorage, verify it in the list returned by server.
                        const locationOptionFromConfig = config.locations.find((param)=>{
                            let { locationCode  } = param;
                            return locationCode === locationCodeFromLS;
                        });
                        if (!locationOptionFromConfig) {
                            // If the chosen of user is not valid, handle it as the case of the location not being chosen
                            (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Hint */.t.Hint);
                            var _location1;
                            localStorage.setItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, (_location1 = config.location) !== null && _location1 !== void 0 ? _location1 : "");
                        } else {
                            // If the chosen of user is valid, don't show any messages also.
                            // Re-assign the configs by the chosen one of the user.
                            (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.None */.t.None);
                            config.location = locationOptionFromConfig.locationCode;
                            // Ecom 284 do not distinguish terminal between mobile and desktop,
                            // so we still need to hard code the mobile one in workload config.
                            // This step will get the right terminal based on device types.
                            if (!config.isMobile) {
                                config.terminalId = locationOptionFromConfig.terminalId;
                                config.terminal = locationOptionFromConfig.terminalCode;
                            } else {
                                var ref2;
                                const terminalForMobile = (ref2 = config.mobileTerminalIdMapping) === null || ref2 === void 0 ? void 0 : ref2[locationOptionFromConfig.terminalId.toString()];
                                config.terminalId = (terminalForMobile === null || terminalForMobile === void 0 ? void 0 : terminalForMobile.terminalId) || locationOptionFromConfig.terminalId;
                                config.terminal = (terminalForMobile === null || terminalForMobile === void 0 ? void 0 : terminalForMobile.terminalCode) || locationOptionFromConfig.terminalCode;
                            }
                        }
                    }
                }
                var ref3;
                // if there is a overriding terminal id set
                // honor it.
                config.terminalId = parseInt((ref3 = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.OVERRIDE_TERMINAL_ID */.Tp.OVERRIDE_TERMINAL_ID)) !== null && ref3 !== void 0 ? ref3 : "") || config.terminalId;
            }
        } else {
            // Get terminal from cookie in case tenant has terminal by region (ex: karavan, umbala)
            // This help avoid disk cache from browser when change location
            // More detail: https://jira.teko.vn/browse/UX4BUYER-2566
            if (Array.isArray(config.originalTerminal)) {
                config.terminal = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, config.isMobile) || config.terminal;
                var ref4;
                config.terminalId = parseInt((ref4 = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, config.isMobile)) !== null && ref4 !== void 0 ? ref4 : "") || config.terminalId;
                config.location = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, config.isMobile) || config.location;
            }
        }
        Object.assign(this, config);
        // assign the object to window
        // this a trick to persist the
        // config object for client-side only pages
        window.__tenantConfig = config;
    }
}


;// CONCATENATED MODULE: ./tenants/_layouts.ts
/* eslint no-use-before-define: 0 */ /* AUTO GENERATE FILE - DO NOT EDIT */ 
// collections of all tenants' layout
const layouts = new Map();
layouts.set("karavan_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970)]).then(__webpack_require__.bind(__webpack_require__, 54970)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54970)
            ]
    }
}));
layouts.set("karavan_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
layouts.set("meatdeli_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970), __webpack_require__.e(3065)]).then(__webpack_require__.bind(__webpack_require__, 73065)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73065)
            ]
    }
}));
layouts.set("meatdeli_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
layouts.set("phongvu_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970)]).then(__webpack_require__.bind(__webpack_require__, 54970)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54970)
            ]
    }
}));
layouts.set("phongvu_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
layouts.set("soibien_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970)]).then(__webpack_require__.bind(__webpack_require__, 54970)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54970)
            ]
    }
}));
layouts.set("soibien_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
layouts.set("umbala_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970), __webpack_require__.e(4174)]).then(__webpack_require__.bind(__webpack_require__, 64174)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64174)
            ]
    }
}));
layouts.set("umbala_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
layouts.set("vnshop_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(1305), __webpack_require__.e(1026), __webpack_require__.e(532), __webpack_require__.e(8581), __webpack_require__.e(9781), __webpack_require__.e(5125), __webpack_require__.e(9302), __webpack_require__.e(8174), __webpack_require__.e(9432), __webpack_require__.e(2214), __webpack_require__.e(9289), __webpack_require__.e(3881), __webpack_require__.e(4970), __webpack_require__.e(3741)]).then(__webpack_require__.bind(__webpack_require__, 83741)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(83741)
            ]
    }
}));
layouts.set("vnshop_mobile", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(9781), __webpack_require__.e(738)]).then(__webpack_require__.bind(__webpack_require__, 50877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50877)
            ]
    }
}));
/* harmony default export */ var _layouts = (layouts);
const templates = {
    "desktop": [
        {
            "pathname": "/[slug].tsx",
            "query": "slug",
            "regex": "/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/orders/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/orders/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/quotation/[token].tsx",
            "query": "token",
            "regex": "/account/quotation/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/return-order/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/return-order/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/block-categories/[categoryId].tsx",
            "query": "categoryId",
            "regex": "/block-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/brands/[brandId].tsx",
            "query": "brandId",
            "regex": "/brands/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/c/[slug].tsx",
            "query": "slug",
            "regex": "/c/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/confirm-payment/[orderId].tsx",
            "query": "orderId",
            "regex": "/confirm-payment/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/content/[id].tsx",
            "query": "id",
            "regex": "/content/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/cua-hang/[providerId].tsx",
            "query": "providerId",
            "regex": "/cua-hang/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/landing/[id].tsx",
            "query": "id",
            "regex": "/landing/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/p/[slug].tsx",
            "query": "slug",
            "regex": "/p/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/detail/[productId].tsx",
            "query": "productId",
            "regex": "/products/detail/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/seller-categories/[sellerCategoryId].tsx",
            "query": "sellerCategoryId",
            "regex": "/seller-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/sellers/[sellerId].tsx",
            "query": "sellerId",
            "regex": "/sellers/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/tin-tuc/[slug].tsx",
            "query": "slug",
            "regex": "/tin-tuc/([^/\\[\\]]+)$"
        }
    ],
    "mobile": [
        {
            "pathname": "/[slug].tsx",
            "query": "slug",
            "regex": "/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/orders/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/orders/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/quotation/[token].tsx",
            "query": "token",
            "regex": "/account/quotation/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/return-order/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/return-order/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/block-categories/[categoryId].tsx",
            "query": "categoryId",
            "regex": "/block-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/brands/[brandId].tsx",
            "query": "brandId",
            "regex": "/brands/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/c/[slug].tsx",
            "query": "slug",
            "regex": "/c/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/confirm-payment/[orderId].tsx",
            "query": "orderId",
            "regex": "/confirm-payment/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/content/[id].tsx",
            "query": "id",
            "regex": "/content/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/cua-hang/[providerId].tsx",
            "query": "providerId",
            "regex": "/cua-hang/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/landing/[id].tsx",
            "query": "id",
            "regex": "/landing/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/my/address/[id].tsx",
            "query": "id",
            "regex": "/my/address/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/p/[slug].tsx",
            "query": "slug",
            "regex": "/p/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/[sku]/combos/[id].tsx",
            "query": "id",
            "regex": "/products/[sku]/combos/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/detail/[productId].tsx",
            "query": "productId",
            "regex": "/products/detail/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/seller-categories/[sellerCategoryId].tsx",
            "query": "sellerCategoryId",
            "regex": "/seller-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/sellers/[sellerId].tsx",
            "query": "sellerId",
            "regex": "/sellers/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/tin-tuc/[slug].tsx",
            "query": "slug",
            "regex": "/tin-tuc/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/vat/[orderId].tsx",
            "query": "orderId",
            "regex": "/vat/([^/\\[\\]]+)$"
        }
    ]
};

;// CONCATENATED MODULE: ./tenants/_routes.ts
/* harmony default export */ var _routes = ([
    {
        path: "/account/addresses",
        exact: true,
        screenName: "addressManager",
        contentType: "others"
    },
    {
        path: "/my/address-book",
        exact: true,
        screenName: "addressManager",
        contentType: "others"
    },
    {
        path: "/account",
        exact: true,
        screenName: "accountManager",
        contentType: "others"
    },
    {
        path: "/account/orders/:orderId",
        exact: true,
        screenName: "orderDetail",
        contentType: "others"
    },
    {
        path: "/account/orders",
        exact: true,
        screenName: "orderList",
        contentType: "others"
    },
    {
        path: /.*-\d+.cat/,
        exact: true,
        screenName: "categoryListProduct",
        contentType: "product_category"
    },
    {
        path: "/checkout",
        exact: true,
        screenName: "confirmOrder",
        contentType: "checkout"
    },
    {
        path: "/confirm-payment/:orderId",
        exact: true,
        screenName: "confirmPayment",
        contentType: "others"
    },
    {
        path: "/p/:slug",
        exact: true,
        screenName: "landingPage",
        contentType: "others"
    },
    {
        path: "/",
        exact: true,
        screenName: "homePage",
        contentType: "homepage"
    },
    {
        path: "/login",
        exact: true,
        screenName: "loginMethod",
        contentType: "others"
    },
    {
        path: "/order-result",
        exact: true,
        screenName: "orderResult",
        contentType: "checkout"
    },
    {
        path: /.*-s([\w.\-]{1,20})\.html/,
        exact: true,
        screenName: "productDetail",
        parser: (url)=>{
            // extract skuId from url
            const urlArray = url.split("-s");
            const skuPart = urlArray[urlArray.length - 1];
            const result = skuPart.match(/([\w.\-]{1,20})\.html/);
            return {
                skuId: result && result[1] ? result[1] : null
            };
        },
        contentType: "product_detail"
    },
    {
        path: /.*--s([\w.\-]{1,20})/,
        exact: true,
        screenName: "productDetail",
        parser: (url)=>{
            const result = url.match(/--s([\w.\-]{1,20})/);
            return {
                skuId: result && result[1] ? result[1] : null
            };
        },
        contentType: "product_detail"
    },
    {
        path: "/search",
        exact: true,
        screenName: "searchProductResult",
        contentType: "product_category"
    },
    {
        path: "/buildpc",
        exact: true,
        screenName: "buildPCSelfBuild",
        contentType: "others"
    },
    {
        path: "/auth/vnpay/login",
        exact: true,
        screenName: "loginMethod",
        contentType: "others"
    },
    {
        path: "/cart",
        exact: true,
        screenName: "cart",
        contentType: "checkout"
    },
    {
        path: /.*-brand\..*/,
        exact: true,
        screenName: "brandPage",
        contentType: "other"
    },
    {
        path: /.*-sel\.\d+/,
        exact: true,
        screenName: "sellerPage",
        contentType: "other"
    },
    {
        path: "/cua-hang/:providerId",
        exact: true,
        screenName: "providerPage",
        contentType: "other"
    },
    {
        path: /.*-cat\.\d+/,
        exact: true,
        screenName: "masterCategory",
        contentType: "other"
    },
    {
        path: /.*-scat\..*/,
        exact: true,
        screenName: "sellerCategory",
        contentType: "other"
    },
    {
        path: "/landing/:slug",
        exact: true,
        screenName: "landingPage",
        contentType: "other"
    }, 
]);

// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.3.0-ECOM479.2-22c127d2a7-ff3665190f.zip/node_modules/@terra-js/terra-kit/dist/index.js
var terra_kit_dist = __webpack_require__(78246);
// EXTERNAL MODULE: ./contexts/RegionPickerProvider.tsx
var RegionPickerProvider = __webpack_require__(79469);
;// CONCATENATED MODULE: ./tenants/_app.tsx
function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _app_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _app_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        _app_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






























const ProfileWithAddressMobile = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(1303), __webpack_require__.e(6698), __webpack_require__.e(969), __webpack_require__.e(4304)]).then(__webpack_require__.bind(__webpack_require__, 44304)).then((mod)=>mod.ProfileWithAddressMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(44304)
            ]
    }
});
const ProfileWithAddressDesktop = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9690), __webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(1303), __webpack_require__.e(6698), __webpack_require__.e(969), __webpack_require__.e(7301)]).then(__webpack_require__.bind(__webpack_require__, 77301)).then((mod)=>mod.ProfileWithAddressDesktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77301)
            ]
    }
});
const serverless = (0,helpers/* isServerless */.ep)();
const Layout = (_param)=>{
    var { Component  } = _param, props = _objectWithoutProperties(_param, [
        "Component"
    ]);
    var ref, ref1;
    const { children , banners , menuItems , liteLogo , layoutAreas , layoutConfig , pageProps ,  } = props;
    const { isMobile , template , tenant , footerDataConfig ={} , rightMenuTopBarButtonConfigs =[] , leftMenuTopBarButtonConfigs =[] , availableLanguages , requireLogin , profileRequiredAfterLogin ,  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { user  } = (0,context_es/* useAuth */.a)();
    const router = (0,next_router.useRouter)();
    const { shouldShowSelector: shouldShowPrivacyPolicySelector , showSelector: showPrivacyPolicySelector ,  } = (0,PrivacyPolicyContext/* usePrivacyPolicy */.q)();
    // load a language resource on the client
    (0,react.useEffect)(()=>{
        if (serverless && window.track) {
            var ref, ref1, ref2;
            const userId = (user === null || user === void 0 ? void 0 : user.userId) || ((ref2 = (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.getUserInfo()) === null || ref2 === void 0 ? void 0 : ref2.sub);
            if (userId) {
                window.track("setUserId", userId);
            }
        // comment out because link tracking
        // sends duplicate events
        // window.track('enableLinkClick');
        }
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        serverless && !!((ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.getUserInfo())
    ]);
    (0,react.useEffect)(()=>{
        // login page has it's own show pivacy policy logic
        if (shouldShowPrivacyPolicySelector && !router.pathname.endsWith("/login") && !!(user === null || user === void 0 ? void 0 : user.userId)) showPrivacyPolicySelector(()=>{});
    }, [
        shouldShowPrivacyPolicySelector
    ]);
    //@TODO: remove tenant in here
    const tpl = template || tenant;
    const defaultTemplate = "vnshop";
    const footerData = (0,translate/* translateObject */.b)(footerDataConfig);
    const rightMenu = (0,RightMenu/* renderTopBarMenu */.O)((0,translate/* translateObject */.b)(rightMenuTopBarButtonConfigs), !!availableLanguages ? [
        LanguageSelector/* LanguageSelector */.$
    ] : []);
    const leftMenu = (0,RightMenu/* renderTopBarMenu */.O)((0,translate/* translateObject */.b)(leftMenuTopBarButtonConfigs));
    const showProfileWithAddressUpdate = profileRequiredAfterLogin && !!user && (!(user === null || user === void 0 ? void 0 : user.name) || !(user === null || user === void 0 ? void 0 : user.dob) || !(user === null || user === void 0 ? void 0 : user.sex) || !(user === null || user === void 0 ? void 0 : user.address));
    if (isMobile) {
        const MobileLayout = _layouts.get("".concat(tpl, "_mobile")) || _layouts.get("".concat(defaultTemplate, "_mobile"));
        return showProfileWithAddressUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileWithAddressMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLayout, {
            forceLogin: requireLogin,
            layoutAreas: layoutAreas,
            getLayout: Component === null || Component === void 0 ? void 0 : Component.getLayout,
            layoutConfig: layoutConfig,
            pageProps: pageProps,
            children: children
        });
    } else {
        const DesktopLayout = _layouts.get("".concat(tpl, "_desktop")) || _layouts.get("".concat(defaultTemplate, "_desktop"));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "minWidthWrapper",
            style: {
                minWidth: "945px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopLayout, {
                banners: banners,
                menuItems: menuItems,
                liteLogo: liteLogo,
                footerData: footerData,
                rightMenu: rightMenu,
                leftMenu: leftMenu,
                // hotfix the forceLogin for karavan
                // will refractor this in ECOM-362
                forceLogin: requireLogin,
                layoutAreas: layoutAreas,
                layoutConfig: layoutConfig,
                pageProps: pageProps,
                children: [
                    children,
                    showProfileWithAddressUpdate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileWithAddressDesktop, {})
                ]
            })
        });
    }
};
const MyApp = (param)=>{
    let { Component , pageProps , globalData , banners , menuItems , featureFlags , liteLogo , layoutAreas , tempiLayout  } = param;
    var ref, ref1, ref2;
    if (!globalData || Object.keys(globalData).length === 0) {
        // as getInitialProps function now fallback to an empty object
        // we throw exception when object is empty
        index_es/* logger.error */.k.error("Empty global data when render ".concat(Component.name, ". Probably unable to detect tenant from hostname."));
        throw new Error("Missing global data when rendering component");
    }
    // alter localStorage and sessionStorage with a simple storage in case storages are not available
    if ( true && !storageAvailable("localStorage")) {
        Object.defineProperty(window, "localStorage", {
            value: new MockStorage()
        });
    }
    if ( true && !storageAvailable("sessionStorage")) {
        Object.defineProperty(window, "sessionStorage", {
            value: new MockStorage()
        });
    }
    // menuItems, banners and layoutAreas (custom page)
    // are fetched in Document.getInitialProps
    // and passed to MyApp in renderPage function.
    // For client-side transition,
    // get them from window object instead.
    banners = banners || (serverless ? window.banners : []);
    menuItems = menuItems || (serverless ? window.menuItems : []);
    layoutAreas = layoutAreas || (serverless ? window.layoutAreas : []);
    tempiLayout = tempiLayout || (serverless ? window.tempiLayout : undefined);
    pageProps = _app_objectSpreadProps(_app_objectSpread({}, pageProps), {
        menu: (tempiLayout === null || tempiLayout === void 0 ? void 0 : tempiLayout.menu) || []
    });
    featureFlags = featureFlags || (serverless ? window.featureFlags : null);
    const { publicRuntimeConfig  } = config_default()();
    const { tenant , isMobile , scopes , terminal , currentLanguage , trackingId  } = globalData;
    // object fetched by getInitialProps does not
    // preserve function getProcessEnv when comes to client-side
    // re-initialize the object for that
    if (!globalData.getProcessEnv) {
        globalData = new ClientTenantEnvImpl(globalData);
    }
    const languageCode = currentLanguage || i18n/* DEFAULT_LANGUAGE */.k$;
    if (!serverless) {
        (0,i18n/* changeLanguage */.D0)(languageCode);
    }
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const { 0: history , 1: setHistory  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (history[history.length - 1] !== router.asPath) {
            setHistory((prevState)=>[
                    ...prevState,
                    router.asPath
                ]);
        }
    }, [
        router
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (router && !router.intercepted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const customizedRouter = router;
        // the singleton router object created
        // intercept call to this method
        // this code ensure that when a next/link is clicked on the client-side
        // and navigation happens, the actual data fetched is prefixed with <tenant> path
        // Under the hood, next/link calls next/router to trigger page navigation
        // and it populates "as" field by default with the same value as "path";
        [
            "replace",
            "push",
            "prefetch"
        ].forEach((method)=>{
            const originalMethod = customizedRouter[method];
            customizedRouter[method] = function(path, asPath) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var ref;
                // turn off client-side routing for websites embedded in apps
                if (featureFlags.epic_ecom_479 && terra_kit_dist/* default.isAvailable */.Z.isAvailable()) {
                    if ([
                        "replace",
                        "push"
                    ].includes(method)) {
                        window.location.href = (asPath === null || asPath === void 0 ? void 0 : asPath.toString()) || (path === null || path === void 0 ? void 0 : path.toString()) || window.location.href;
                    }
                    return;
                }
                const { buildId  } = window.__NEXT_DATA__;
                const defaultTenant = publicRuntimeConfig.defaultTenantDir;
                const { pathname  } = (0,native_url.parse)(typeof path === "string" ? path : path.pathname);
                if (pathname === null || pathname === void 0 ? void 0 : pathname.match(/\/([\w\d\-]+)\/(mobile|desktop)(.*)/)) {
                    return originalMethod.call(router, path, asPath, ...args);
                }
                const platform = isMobile ? "mobile" : "desktop";
                const pages = ((ref = window.__BUILD_MANIFEST) === null || ref === void 0 ? void 0 : ref.sortedPages) || [];
                const customizedPath = (0,remove_trailing_slash.removeTrailingSlash)("/".concat(tenant, "/").concat(platform).concat(pathname));
                const defaultPath = (0,remove_trailing_slash.removeTrailingSlash)("/".concat(defaultTenant, "/").concat(platform).concat(pathname));
                let finalTenant = "";
                if (buildId === "development") {
                    finalTenant = pages.includes(customizedPath) ? tenant : pages.includes(defaultPath) ? defaultTenant : tenant;
                } else {
                    finalTenant = pages.includes(customizedPath) ? tenant : defaultTenant;
                }
                const param = typeof path === "string" ? (0,remove_trailing_slash.removeTrailingSlash)("/".concat(finalTenant, "/").concat(platform).concat(path)) : _app_objectSpreadProps(_app_objectSpread({}, path), {
                    pathname: (0,remove_trailing_slash.removeTrailingSlash)("/".concat(finalTenant, "/").concat(platform).concat(path.pathname))
                });
                asPath = asPath || path;
                return originalMethod.call(router, param, asPath, ...args);
            };
        });
        const originalMethod = customizedRouter["back"];
        // method call arguments can be anything
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customizedRouter["back"] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (!history.length) return router.push("/");
            return originalMethod.call(...args);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        router.intercepted = true;
    }
    useRouterEffect(router);
    (0,usePos365StoreCode/* usePos365StoreCode */.c)();
    (0,react.useEffect)(()=>{
        const initTracker = (trackerAppId)=>{
            if (trackerAppId) {
                new (dist_default())({
                    host: globalData.getProcessEnv("TRACKER_HOST_URL"),
                    urlServeJsFile: globalData.getProcessEnv("TRACKER_SERVER_JS_URL"),
                    appId: trackerAppId,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    routes: _routes,
                    injectScript: false
                });
                window.track("enableTrackVisibleContentImpressions");
                window.track("setTerminal", terminal);
                /**
         * because tracking is low priority so they should be
         * executed in idle cycle to avoid blocking user handler
         * TEMPORARILY COMMENT OUT BECAUSE IT CAUSING A BUG
         */ // const trackOrigin = window.track;
                // window.track = function (...args: any[]) {
                //   function _track(deadline: IdleDeadline) {
                //     if (deadline.timeRemaining() > 0 || deadline.didTimeout) {
                //       if (args.length === 1) {
                //         const [event] = args;
                //         trackOrigin(event);
                //       } else if (args.length === 2) {
                //         const [event, data] = args;
                //         trackOrigin(event, data);
                //       } else {
                //         const [eventType, eventName, data] = args;
                //         trackOrigin(eventType, eventName, data);
                //       }
                //       return;
                //     }
                //     requestIdleCallback(_track);
                //   }
                //   requestIdleCallback(_track);
                // };
                if (serverless) {
                    const originalFetch = window.fetch;
                    window.fetch = function initTracker() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return originalFetch.apply(this, args).then(async function(data) {
                            if (data.status >= 400) {
                                data.clone().json().then((res)=>{
                                    window.track("error", {
                                        errorSource: "http",
                                        apiCall: data.url,
                                        apiPayload: JSON.stringify(args),
                                        httpResponseCode: "".concat(data.status),
                                        responseJson: JSON.stringify(res),
                                        errorCode: "".concat(res.code) || "unknown",
                                        errorMessage: res.message || "unknown"
                                    });
                                });
                            }
                            return data;
                        });
                    };
                }
            } else {
                if (serverless) {
                    // polyfill with a dummy tracking function
                    // to avoid undefined fn errors somewhere else
                    window.track = ()=>{};
                }
            }
        };
        if (featureFlags.epic_ecom_479 && terra_kit_dist/* default.isAvailable */.Z.isAvailable()) {
            terra_kit_dist/* default.tracker */.Z.tracker().getTrackingAppId().then((trackerAppId)=>initTracker(trackerAppId));
        } else {
            initTracker(globalData.getProcessEnv("TRACKER_APP_ID") || trackingId);
        }
        saveUtmCookie(query);
        if (query === null || query === void 0 ? void 0 : query.referral) {
            (0,helpers/* setCookieByName */.Re)("referral", "".concat(query.referral.toString(), ";SameSite=None;Secure;"));
        }
    }, []);
    const services = (0,ServiceContext/* initializeServices */.bl)(globalData);
    const uiTheme = globalData.theme;
    const dsTheme = (0,utils_es/* generateTheme */.I0)({
        primary: uiTheme.brand.primary,
        secondary: uiTheme.brand.secondary
    });
    dsTheme.colors = _app_objectSpread({}, dsTheme.colors, uiTheme.colors);
    var _partner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageProvider, {
        code: languageCode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider_es/* ThemeProvider */.f, {
            theme: uiTheme,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Theme_es/* ThemeProvider */.f, {
                theme: dsTheme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading_context_es/* LoadingProvider */.PK, {
                    logo: (ref2 = ((ref = globalData.logo) === null || ref === void 0 ? void 0 : ref.loading) || ((ref1 = globalData.logo) === null || ref1 === void 0 ? void 0 : ref1.lite)) === null || ref2 === void 0 ? void 0 : ref2.path,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_MetaHead, {
                            theme: uiTheme,
                            config: globalData,
                            meta: globalData.meta
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalDataContext/* GlobalDataProvider */.Uw, {
                            value: globalData,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceContext/* ServiceProvider */.UT, {
                                services: services,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperContext/* HelperProvider */.d, {
                                    discoveryPos365Service: services.discoveryPos365Service,
                                    freeShippingThreshold: globalData === null || globalData === void 0 ? void 0 : globalData.freeShippingThreshold,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context_es/* AuthContextProvider */.H, {
                                        partner: (_partner = globalData.partner) !== null && _partner !== void 0 ? _partner : "",
                                        scopes: scopes || [
                                            "openid",
                                            "profile",
                                            "us",
                                            "om",
                                            "ppm",
                                            "loyalty-consumer-bff",
                                            "payment-consumer-bff", 
                                        ],
                                        userService: services.userService,
                                        authService: services.authService,
                                        router: router,
                                        showConfirmModalAfterLogin: globalData === null || globalData === void 0 ? void 0 : globalData.showConfirmModalAfterLogin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagProvider/* FeatureFlagProvider */.O, {
                                            flags: featureFlags,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationProvider/* LocationProvider */.v, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameContext/* FrameProvider */.r, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularKeywordContext/* PopularKeywordProvider */.$, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenContext/* ScreenProvider */.nX, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoyaltyProvider/* LoyaltyProvider */.Q, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContextV2/* CartProviderV2 */.q, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider/* NotificationProvider */.JB, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceContext_es/* DeviceProvider */.Y, {
                                                                            value: {
                                                                                isMobile
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicyContext/* PrivacyPolicyProvider */.p, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerProvider/* RegionPickerProvider */.k, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                                                        Component: Component,
                                                                                        banners: banners,
                                                                                        menuItems: menuItems,
                                                                                        liteLogo: liteLogo,
                                                                                        layoutAreas: layoutAreas,
                                                                                        layoutConfig: tempiLayout === null || tempiLayout === void 0 ? void 0 : tempiLayout.layoutConfig,
                                                                                        pageProps: pageProps,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HistoryProvider, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartBanner, {}),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpreadProps(_app_objectSpread({}, pageProps), {
                                                                                                    menuItems: menuItems
                                                                                                }))
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
MyApp.getInitialProps = async (appContext)=>{
    // note this function is called every time
    // page transition happen,
    // so please think twice before adding any data-fetching logic
    // here.
    // Ideally, we would like to remove this function altogether.
    // But Nextjs's static optimization does not call
    // Document.getInitialProps for pages like /404,
    // which prevents the page from getting platform config.
    let globalTenantEnv;
    if (appContext.ctx.req) {
        // for pages that are SSR
        // this function is triggered on server-side
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        globalTenantEnv = appContext.ctx.req.tenantEnv;
        // normally, this should not happen
        // but server log has issues with this otherwise
        // adding log to detect issues
        if (!globalTenantEnv) {
            index_es/* logger.error */.k.error("Could not find tenant config for request " + appContext.ctx.req.url);
        }
    } else {
        // for client-side only page, get this value from window
        // since req object is not set
        //@ts-ignore
        globalTenantEnv = window.__tenantConfig;
    }
    var _asPath;
    const liteLogo = !(0,common/* isHomepage */.GH)((_asPath = appContext.ctx.asPath) !== null && _asPath !== void 0 ? _asPath : "");
    const appProps = await app["default"].getInitialProps(appContext);
    return _app_objectSpreadProps(_app_objectSpread({}, appProps), {
        globalData: omitServerFields(globalTenantEnv),
        liteLogo
    });
};
// omit some fields without using in clients, ex: updatedUrlMap
function omitServerFields(tenantConfig) {
    if (!tenantConfig) {
        return {};
    }
    const serverFields = new Set([
        "updatedUrlMap"
    ]);
    return Object.fromEntries(Object.entries(tenantConfig || {}).filter((param)=>{
        let [k] = param;
        return !serverFields.has(k);
    }));
}
function reportWebVitals(metric) {
    if (!serverless) return;
    if (metric.label === "web-vital") {
        var ref;
        (ref = window.track) === null || ref === void 0 ? void 0 : ref.call(window, "customEvent", "web-vital", {
            category: metric.name,
            label: metric.label,
            value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value)
        });
    }
}
/* harmony default export */ var _app = (MyApp);
const saveUtmCookie = (query)=>{
    const { utm_source ="" , utm_campaign ="" , utm_term ="" , utm_content ="" , utm_medium ="" , gclid ="" , fbclid ="" ,  } = query;
    const currentDate = new Date();
    const date = new Date(currentDate.getFullYear() + 2, currentDate.getMonth(), currentDate.getDay());
    const expireTime = date.toUTCString();
    if (utm_source) {
        (0,helpers/* setCookieByName */.Re)("utmSource", utm_source, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmCampaign", utm_campaign, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmTerm", utm_term, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmContent", utm_content, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmMedium", utm_medium, expireTime);
    }
    if (gclid) (0,helpers/* setCookieByName */.Re)("gclid", gclid, expireTime);
    if (fbclid) (0,helpers/* setCookieByName */.Re)("fbclid", fbclid, expireTime);
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-fd2c7aae77/1/packages/ds-desktop/dist/ds-desktop.css
var ds_desktop = __webpack_require__(84521);
;// CONCATENATED MODULE: ./pages/_app.tsx
// AUTO GENERATED FILE. DO NOT EDIT.



/* harmony default export */ var pages_app = (_app);


/***/ }),

/***/ 44844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ accessTokenInterceptor; },
/* harmony export */   "Gp": function() { return /* binding */ ppmApi; },
/* harmony export */   "I1": function() { return /* binding */ serverApi; },
/* harmony export */   "Ue": function() { return /* binding */ searchApi; },
/* harmony export */   "Wk": function() { return /* binding */ publicSettingApi; },
/* harmony export */   "_6": function() { return /* binding */ magentoApi; },
/* harmony export */   "kc": function() { return /* binding */ normalizeSlashUrl; },
/* harmony export */   "pr": function() { return /* binding */ cosmicApi; }
/* harmony export */ });
/* unused harmony exports orderApi, wordpressApi */
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18042);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const normalizeSlashUrl = function() {
    let baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0;
    const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, baseURL.length - 1) : baseURL;
    const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
    return "".concat(normalizedBaseUrl, "/").concat(normalizedPath);
};
// a wrapper class that allows
// replacement of axios lib used initially
class Api {
    addInterceptor(interceptFn) {
        this.interceptors.push(interceptFn);
    }
    appendParamsToURL(url) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (params) {
            const paramsArr = [];
            for (const k of Object.keys(params)){
                if (params[k] !== null && params[k] !== undefined) {
                    paramsArr.push("".concat(k, "=").concat(encodeURIComponent(params[k])));
                }
            }
            if (paramsArr.length > 0) url = "".concat(url, "?").concat(paramsArr.join("&"));
        }
        return url;
    }
    async request(url, body, method) {
        let config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        let headers = config.headers || {};
        url = this.appendParamsToURL(url, config.params);
        if (body) {
            if (typeof body !== "string") {
                if ("append" in body) {
                // TODO:
                // dealing with FormData
                // should we set Content-Type here?
                } else {
                    body = JSON.stringify(body);
                    headers = _objectSpread({
                        "Content-Type": "application/json"
                    }, headers);
                }
            }
        }
        const requestObj = _objectSpreadProps(_objectSpread({}, this.defaultConfig), {
            method: method,
            headers: new Headers(headers),
            body
        });
        this.interceptors.forEach((fn)=>fn(requestObj));
        const res = await fetch(url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url), requestObj);
        if (res.status >= 400) {
            // sync the original axios reject a promise
            // on error, throw Error here to emulate it
            return Promise.reject(await res.json());
        }
        // get headers obj to return
        // it's used by cart
        const respHeaders = {};
        res.headers.forEach((val, key)=>respHeaders[key] = val);
        const data = await res.json();
        return {
            data,
            headers: respHeaders
        };
    }
    async get(url) {
        let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return await this.request(url, null, "GET", config);
    }
    async post(url, body) {
        let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return await this.request(url, body, "POST", config);
    }
    async patch(url, body) {
        let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return await this.request(url, body, "PATCH", config);
    }
    async put(url, body) {
        let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return await this.request(url, body, "PUT", config);
    }
    async delete(url) {
        let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return await this.request(url, null, "DELETE", config);
    }
    constructor(url, defaultConfig = {}){
        this.baseURL = url;
        this.interceptors = [];
        this.defaultConfig = defaultConfig;
    }
}
const accessTokenInterceptor = (request)=>{
    // some api may get call on the server-side
    if (false) {}
    const accessToken = (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAccessToken */ .hP)();
    if (accessToken) {
        request.headers.set("Authorization", "Bearer ".concat(accessToken));
    }
};
const magentoApi = new Api((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_EXTRA_SERVICE_URL"));
const serverApi = new Api("/api");
const searchApi = new Api( false ? 0 : (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_SEARCH_URL"));
const orderApi = new Api((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_COV_URL"));
const wordpressApi = new Api((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_WORDPRESS_URL"));
const ppmApi = new Api((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_PPM_URL"));
const cosmicApi = new Api("https://api.cosmicjs.com/v1/");
const publicSettingApi = new Api((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_PUBLIC_SETTING_API"));


/***/ }),

/***/ 27342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ searchService; }
/* harmony export */ });
/* harmony import */ var _clients_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44844);
/* harmony import */ var _helpers_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53632);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31260);



const transformBanner = (banner)=>({
        id: banner.id.toString(),
        image: banner.image,
        priority: banner.priority,
        campaignName: banner.campaign_name,
        zone: banner.zone,
        targetPath: banner.target_path,
        urlType: banner.url_type,
        thumbnail: banner.thumbnail,
        description: banner.description,
        startDate: banner.start_date,
        endDate: banner.end_date
    });
const transformNews = (news)=>(0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__/* .cleanObject */ .sW)({
        metaDescription: news.meta_description,
        isActive: news.is_active,
        metaTitle: news.meta_title,
        updateAt: news.updated_at,
        imageUrl: news.image_url,
        isMagazine: news.is_magazine,
        metaKeyword: news.meta_keyword,
        name: news.name,
        id: news.id,
        terminals: news.terminals,
        content: news.content,
        urlKey: news.url_key
    });
const cookBanners = (param)=>{
    let { data  } = param;
    return (data.documents || []).map(transformBanner);
};
const cookNews = (param)=>{
    let { data  } = param;
    return ((data === null || data === void 0 ? void 0 : data.documents) || []).map(transformNews);
};
_clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.addInterceptor */ .Ue.addInterceptor((request)=>{
    request.headers.set("x-tk-access-token", (0,_helpers_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnv */ .dU)("SEARCH_API_ACCESS_TOKEN"));
});
class SearchService {
    async getBanner(body) {
        const res = await _clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.post */ .Ue.post("/v1/banner/search", body);
        return cookBanners(res.data);
    }
    async getBannerByZone(zone, terminal) {
        const filter = {
            filters: [
                {
                    key: "terminals",
                    value: terminal
                },
                {
                    key: "is_active",
                    value: true
                },
                {
                    key: "zone",
                    value: zone
                }, 
            ],
            page_size: 15,
            sorts: [
                {
                    field: "priority",
                    type: "ASC"
                }, 
            ]
        };
        return await this.getBanner(filter);
    }
    async getNewsFeed(terminal, slug) {
        let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, pageSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 15;
        var ref, ref1, ref2, ref3, ref4, ref5;
        const filters = [
            {
                key: "terminals",
                value: terminal
            },
            {
                key: "is_active",
                value: 1
            }, 
        ];
        if (slug) {
            filters.push({
                key: "url_key",
                value: slug
            });
        }
        const res = await _clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.post */ .Ue.post("/v1/pb_news/search", {
            filters,
            page_size: pageSize,
            page: page
        });
        return {
            news: cookNews((res === null || res === void 0 ? void 0 : res.data) || []),
            totalItems: (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.page_response) === null || ref2 === void 0 ? void 0 : ref2.total_items) || 0,
            totalPages: (res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.page_response) === null || ref5 === void 0 ? void 0 : ref5.total_page) || 0
        };
    }
}
const searchService = new SearchService();


/***/ }),

/***/ 94416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ renderTopBarMenu; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/TopbarDropdown.es.js
var TopbarDropdown_es = __webpack_require__(36403);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(7934);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_helpers/RightMenu/TopBarButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const BusinessCustomerOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.BusinessCustomerOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const HeadphoneOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.HeadphoneOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const ShowroomOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.ShowroomOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const TvNewOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.TvNewOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const PromoOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.PromoOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const BuildPcOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.BuildPcOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const MailOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.MailOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const FacebookFilled = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.FacebookFilled), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const ShopOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.ShopOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const PhoneOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.PhoneOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
const BriefCaseOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(595), __webpack_require__.e(1877)]).then(__webpack_require__.bind(__webpack_require__, 31877)).then((mod)=>mod.BriefCaseOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31877)
            ]
    }
});
/* map from iconName to component icon */ const iconMap = new Map([
    [
        "BusinessCustomerOutlined",
        BusinessCustomerOutlined
    ],
    [
        "HeadphoneOutlined",
        HeadphoneOutlined
    ],
    [
        "TvNewOutlined",
        TvNewOutlined
    ],
    [
        "ShowroomOutlined",
        ShowroomOutlined
    ],
    [
        "BuildPcOutlined",
        BuildPcOutlined
    ],
    [
        "PromoOutlined",
        PromoOutlined
    ],
    [
        "MailOutlined",
        MailOutlined
    ],
    [
        "FacebookFilled",
        FacebookFilled
    ],
    [
        "ShopOutlined",
        ShopOutlined
    ],
    [
        "PhoneOutlined",
        PhoneOutlined
    ],
    [
        "BriefCaseOutlined",
        BriefCaseOutlined
    ], 
]);
const renderTopBarIcon = (iconData)=>{
    const { iconName  } = iconData, rest = _objectWithoutProperties(iconData, [
        "iconName"
    ]);
    const Comp = iconMap.get(iconName);
    return Comp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, _objectSpread({}, rest)) : null;
};
/* render top bar button by its config */ const renderTopBarButton = (topBarButtonConfig)=>{
    const { children , key , icon , menu  } = topBarButtonConfig, rest = _objectWithoutProperties(topBarButtonConfig, [
        "children",
        "key",
        "icon",
        "menu"
    ]);
    const props = _objectSpread({}, !!icon ? {
        icon: renderTopBarIcon(icon)
    } : {}, rest);
    if (menu === null || menu === void 0 ? void 0 : menu.length) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarDropdown_es/* TopbarDropdown */.g, _objectSpreadProps(_objectSpread({
            text: children
        }, props), {
            theme: TopbarDropdown_es/* DropdownTheme.MENU */.I.MENU,
            options: menu.map((param)=>{
                let { children , href , icon  } = param;
                return {
                    text: typeof children === "string" ? children : "",
                    value: href || "#",
                    icon: icon ? (ref = renderTopBarIcon(icon)) !== null && ref !== void 0 ? ref : undefined : undefined
                };
            }),
            selectValue: (href)=>{
                if (typeof href === "string") {
                    window.location.href = href;
                }
            }
        }), key);
    }
    return /*#__PURE__*/ (0,react.createElement)(TopbarButton_es/* TopbarButton */.S, _objectSpreadProps(_objectSpread({}, props), {
        key: key
    }), children);
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/_helpers/RightMenu/RightMenu.tsx
function RightMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RightMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RightMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RightMenu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RightMenu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RightMenu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/*
 * render the top bar menu from button configs
 * topBarButtonConfigs: array of button configs to render
 * extras: array of other components
 * */ const renderTopBarMenu = function(topBarButtonConfigs) {
    let extras = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        ...topBarButtonConfigs.map((config, index)=>{
            const data = RightMenu_objectSpreadProps(RightMenu_objectSpread({}, config), {
                key: index
            });
            return renderTopBarButton(data);
        }),
        ...extras.map((Com, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Com, {}, topBarButtonConfigs.length + index)), 
    ];
};


/***/ }),

/***/ 50923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LocationMessageType; }
/* harmony export */ });
var LocationMessageType;
(function(LocationMessageType) {
    LocationMessageType["None"] = "0";
    LocationMessageType["Hint"] = "1";
    LocationMessageType["Error"] = "2";
})(LocationMessageType || (LocationMessageType = {}));


/***/ }),

/***/ 98116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ sendOrderPostMessage; },
/* harmony export */   "b": function() { return /* binding */ getDataFromIframe; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20577);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31260);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88813);



/**
 * Get data passed from container (staff admin) to iframe (current app)
 */ const getDataFromIframe = ()=>{
    try {
        return JSON.parse(window.name);
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("An error occurred when getting data from Iframe", e);
        return {};
    }
};
const sendOrderPostMessage = (param)=>{
    let { orderId  } = param;
    // only send if being on client side and in an iframe
    if (!(0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isServerless */ .ep)() || !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .inIframe */ .yL)() || !orderId) {
        return;
    }
    const existedOrderId = localStorage.getItem(SENT_POST_MESSAGE_ORDER_ID) || "";
    // only send if orderId is different than existed order Id in local storage
    if (existedOrderId === orderId) {
        return;
    }
    const message = JSON.stringify({
        status: OrderStatus.SUCCESS,
        orderId
    });
    // send the message to the parent iframe
    window.parent.postMessage(message, "*");
    // save to local storage (avoid sending multiple postMessage)
    localStorage.setItem(SENT_POST_MESSAGE_ORDER_ID, orderId);
};
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["SUCCESS"] = "ORDER_SUCCESS";
})(OrderStatus || (OrderStatus = {}));
const SENT_POST_MESSAGE_ORDER_ID = "sent-post-message-order-id";


/***/ }),

/***/ 84521:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(61639)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 86100:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 85470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63992)


/***/ }),

/***/ 79894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89237)


/***/ }),

/***/ 35874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(67777)


/***/ }),

/***/ 35304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(74272)


/***/ }),

/***/ 55878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "animated": function() { return /* reexport safe */ _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.animated; }
/* harmony export */ });
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95307);
/* harmony reexport (checked) */ if(__webpack_require__.o(_react_spring_web__WEBPACK_IMPORTED_MODULE_0__, "useTransition")) __webpack_require__.d(__webpack_exports__, { "useTransition": function() { return _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.useTransition; } });



/***/ }),

/***/ 93369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "ZP": function() { return /* binding */ useSWR; },
/* harmony export */   "wE": function() { return /* binding */ unstable_serialize; }
/* harmony export */ });
/* unused harmony exports mutate, useSWRConfig */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () { return (hasWindow() && (typeof window['requestAnimationFrame'] != STR_UNDEFINED)); };

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key)
                ? key.length
                : key)
                ? stableHash(key)
                : '';
    var errorKey = key ? '$err$' + key : '';
    var isValidatingKey = key ? '$req$' + key : '';
    return [key, args, errorKey, isValidatingKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, populateCache) {
    if (populateCache === void 0) { populateCache = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], CONCURRENT_REQUESTS = _a[4];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key] || [];
    // Cache was populated, update states of all hooks.
    if (populateCache && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete CONCURRENT_REQUESTS[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, revalidate, populateCache, _a, key, keyErr, _b, MUTATION_TS, MUTATION_END_TS, data, error, beforeMutationTs, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    revalidate = options.revalidate !== false;
                    populateCache = options.populateCache !== false;
                    _a = serialize(_key), key = _a[0], keyErr = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION_TS = _b[2], MUTATION_END_TS = _b[3];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), cache.get(keyErr), UNDEFINED, revalidate, populateCache)];
                    }
                    data = _data;
                    beforeMutationTs = (MUTATION_TS[key] = getTimestamp());
                    MUTATION_END_TS[key] = 0;
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION_TS[key]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    _c.label = 2;
                case 2:
                    if (populateCache) {
                        if (!error) {
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyErr, error);
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION_END_TS[key] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[5]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    });
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION_TS = _a[2], MUTATION_END_TS = _a[3], CONCURRENT_REQUESTS = _a[4];
    // `key` is the identifier of the SWR `data` state, `keyErr` and
    // `keyValidating` are identifiers of `error` and `isValidating`,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyErr = _b[2], keyValidating = _b[3];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var error = cache.get(keyErr);
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidateOnMount = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (!isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        return suspense
            ? // Under suspense mode, it will always fetch on render if there is no
                // stale data so no need to revalidate immediately on mount again.
                !isUndefined(data)
            : // If there is no stale data, we need to revalidate on mount;
                // If `revalidateIfStale` is set to true, we will always revalidate.
                isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (cache.get(keyValidating))
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return !initialMountedRef.current && shouldRevalidateOnMount();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !CONCURRENT_REQUESTS[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = CONCURRENT_REQUESTS[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete CONCURRENT_REQUESTS[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        cache.set(keyValidating, false);
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    cache.set(keyValidating, true);
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        CONCURRENT_REQUESTS[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = CONCURRENT_REQUESTS[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!CONCURRENT_REQUESTS[key] ||
                        CONCURRENT_REQUESTS[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    cache.set(keyErr, UNDEFINED);
                    newState.error = UNDEFINED;
                    // If there're other mutations(s), overlapped with the current revalidation:
                    // case 1:
                    //   req------------------>res
                    //       mutate------>end
                    // case 2:
                    //         req------------>res
                    //   mutate------>end
                    // case 3:
                    //   req------------------>res
                    //       mutate-------...---------->
                    // we have to ignore the revalidation result (res) because it's no longer fresh.
                    // meanwhile, a new revalidation should be triggered when the mutation ends.
                    if (!isUndefined(MUTATION_TS[key]) &&
                        // case 1
                        (startAt <= MUTATION_TS[key] ||
                            // case 2
                            startAt <= MUTATION_END_TS[key] ||
                            // case 3
                            MUTATION_END_TS[key] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        cache.set(keyErr, err_1);
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if (config.shouldRetryOnError) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyErr`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        // Not the initial render.
        var keyChanged = initialMountedRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidateOnMount()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 26854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

// EXTERNAL MODULE: ../../.yarn/cache/@emotion-sheet-npm-1.0.3-7146f87ed0-43a9b9a0e4.zip/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
var emotion_sheet_browser_esm = __webpack_require__(53656);
;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} value
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string} type
 * @param {string[]} props
 * @param {object[]} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {string} value
 * @param {object} root
 * @param {string} type
 */
function copy (value, root, type) {
	return node(value, root.root, root.parent, type, root.props, root.children, 0)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				return delimiter(type === 34 || type === 39 ? type : character)
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (!element.return)
		switch (element.type) {
			case DECLARATION: element.return = prefix(element.value, element.length)
				break
			case KEYFRAMES:
				return serialize([copy(replace(element.value, '@', '@' + WEBKIT), element, '')], callback)
			case Enum_RULESET:
				if (element.length)
					return Utility_combine(element.props, function (value) {
						switch (match(value, /(::plac\w+|:read-\w+)/)) {
							// :read-(only|write)
							case ':read-only': case ':read-write':
								return serialize([copy(replace(value, /:(read-\w+)/, ':' + MOZ + '$1'), element, '')], callback)
							// :placeholder
							case '::placeholder':
								return serialize([
									copy(replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1'), element, ''),
									copy(replace(value, /:(plac\w+)/, ':' + MOZ + '$1'), element, ''),
									copy(replace(value, /:(plac\w+)/, MS + 'input-$1'), element, '')
								], callback)
						}

						return ''
					})
		}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../.yarn/cache/stylis-npm-4.0.10-4c0fa47ff8-0fecaf5c23.zip/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// " ' [ (
			case 34: case 39: case 91: case 40:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, length, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../.yarn/cache/@emotion-cache-npm-11.5.0-713285e054-8b3fac281e.zip/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
  !element.length) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new emotion_sheet_browser_esm/* StyleSheet */.m({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 81195:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["Z"] = (murmur2);


/***/ }),

/***/ 1252:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 35605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ serializeStyles; }
/* harmony export */ });
/* harmony import */ var _emotion_hash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81195);
/* harmony import */ var _emotion_unitless__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26729);
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1252);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (_emotion_unitless__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,_emotion_hash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 53656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ StyleSheet; }
/* harmony export */ });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();




/***/ }),

/***/ 26729:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 59382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ insertStyles; },
/* harmony export */   "f": function() { return /* binding */ getRegisteredStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModuleWrapper = void 0;
var wrap_global_1 = __webpack_require__(73902);
var ModuleWrapper = /** @class */ (function () {
    function ModuleWrapper(moduleName) {
        this.moduleName = '';
        this.wrappedModuleName = '';
        this.moduleName = moduleName;
        this.wrappedModuleName = (0, wrap_global_1.wrapModuleName)(moduleName);
    }
    ModuleWrapper.prototype.getWrappedModule = function () {
        if (!window[this.wrappedModuleName]) {
            (0, wrap_global_1.wrapModule)(window, this.moduleName);
        }
        return window[this.wrappedModuleName];
    };
    ModuleWrapper.prototype.invoke = function (methodName, params) {
        if (params === void 0) { params = {}; }
        return this.getWrappedModule().invoke(methodName, params);
    };
    return ModuleWrapper;
}());
exports.ModuleWrapper = ModuleWrapper;


/***/ }),

/***/ 25844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TerraAppBasedModuleWrapper = void 0;
var ModuleWrapper_1 = __webpack_require__(60602);
var TerraAppBasedModuleWrapper = /** @class */ (function (_super) {
    __extends(TerraAppBasedModuleWrapper, _super);
    function TerraAppBasedModuleWrapper(appName, moduleName) {
        var _this = _super.call(this, moduleName) || this;
        _this.appName = '';
        _this.appName = appName;
        return _this;
    }
    TerraAppBasedModuleWrapper.prototype.invoke = function (methodName, params) {
        if (params === void 0) { params = {}; }
        return _super.prototype.invoke.call(this, methodName, {
            params: params,
            appName: this.appName,
        });
    };
    return TerraAppBasedModuleWrapper;
}(ModuleWrapper_1.ModuleWrapper));
exports.TerraAppBasedModuleWrapper = TerraAppBasedModuleWrapper;


/***/ }),

/***/ 38971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TerraAppBasedModuleWrapper = exports.Result = exports.toResult = exports.ModuleWrapper = void 0;
var ModuleWrapper_1 = __webpack_require__(60602);
Object.defineProperty(exports, "ModuleWrapper", ({ enumerable: true, get: function () { return ModuleWrapper_1.ModuleWrapper; } }));
var result_1 = __webpack_require__(97242);
Object.defineProperty(exports, "toResult", ({ enumerable: true, get: function () { return result_1.toResult; } }));
Object.defineProperty(exports, "Result", ({ enumerable: true, get: function () { return result_1.Result; } }));
var TerraAppBasedModuleWrapper_1 = __webpack_require__(25844);
Object.defineProperty(exports, "TerraAppBasedModuleWrapper", ({ enumerable: true, get: function () { return TerraAppBasedModuleWrapper_1.TerraAppBasedModuleWrapper; } }));


/***/ }),

/***/ 97242:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toResult = exports.mapResponseToResult = exports.failure = exports.success = exports.Failure = exports.Success = exports.Result = void 0;
var Result = /** @class */ (function () {
    function Result(isSuccess, error, value) {
        this.success = isSuccess;
        this.value = value;
        this.error = error;
    }
    Result.prototype.isSuccess = function () {
        return this.success;
    };
    Result.prototype.isFailure = function () {
        return !this.success;
    };
    Result.prototype.getValue = function () {
        return this.value;
    };
    Result.prototype.getError = function () {
        return this.error;
    };
    return Result;
}());
exports.Result = Result;
var Success = /** @class */ (function (_super) {
    __extends(Success, _super);
    function Success(value) {
        return _super.call(this, true, null, value) || this;
    }
    return Success;
}(Result));
exports.Success = Success;
var Failure = /** @class */ (function (_super) {
    __extends(Failure, _super);
    function Failure(error) {
        return _super.call(this, false, error) || this;
    }
    return Failure;
}(Result));
exports.Failure = Failure;
function success(value) {
    return new Success(value);
}
exports.success = success;
function failure(error) {
    return new Failure(error);
}
exports.failure = failure;
function mapResponseToResult(response) {
    if (response.status_code === 200) {
        return new Success(response.result);
    }
    else {
        return new Failure(new Error(response.error));
    }
}
exports.mapResponseToResult = mapResponseToResult;
function toResult(block) {
    return new Promise(function (resolve) {
        block().then(function (response) {
            if (response.status_code === 200) {
                resolve(new Success(response.result));
            }
            else {
                resolve(new Failure(new Error(response.error)));
            }
        });
    });
}
exports.toResult = toResult;


/***/ }),

/***/ 73902:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapModuleName = exports.wrapModule = void 0;
function wrapModule(global, moduleName) {
    var globalWrapModule = global['wrapModule'];
    if (globalWrapModule != null) {
        return globalWrapModule(global, moduleName);
    }
    else {
        if (typeof document !== 'undefined') {
            throw Error('Please install @terra-js/web-bridge before using any feature of terra-js');
        }
        else if (navigator && navigator.product === 'ReactNative') {
            throw Error('Please install @terra-js/react-native-bridge before using any feature of terra-js');
        }
        else {
            throw new Error('Unsupported environment');
        }
    }
}
exports.wrapModule = wrapModule;
function wrapModuleName(moduleName) {
    return "Wrapped" + moduleName;
}
exports.wrapModuleName = wrapModuleName;


/***/ }),

/***/ 40278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var AuthKitModule_1 = __webpack_require__(17712);
var ErpKitModule_1 = __webpack_require__(375);
var UserKitModule_1 = __webpack_require__(9472);
var ApolloKitModule_1 = __webpack_require__(39531);
var CommonKitModule_1 = __webpack_require__(68738);
var LoyaltyKitModule_1 = __webpack_require__(54412);
var OrderKitModule_1 = __webpack_require__(47293);
var DeviceKitModule_1 = __webpack_require__(51960);
var DiscoveryKitModule_1 = __webpack_require__(40682);
var result_1 = __webpack_require__(97242);
var CartKitModule_1 = __webpack_require__(47944);
var TrackerKitModule_1 = __webpack_require__(37171);
var TerraKit = /** @class */ (function () {
    function TerraKit() {
        var _this = this;
        this.wrappedModule = null;
        this.getInitParams = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, _a, urlParams, result_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = result_1.mapResponseToResult;
                        return [4 /*yield*/, this.wrappedModule.invoke('getInitParams')];
                    case 1:
                        result = _a.apply(void 0, [_b.sent()]);
                        if (result.isSuccess()) {
                            return [2 /*return*/, result];
                        }
                        else {
                            urlParams = new URLSearchParams(window.location.search);
                            result_2 = {};
                            urlParams.forEach(function (value, key, _) {
                                result_2[key] = value;
                            });
                            return [2 /*return*/, (0, result_1.success)(result_2)];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * share content
         * @param content Content to share
         * @returns
         */
        this.share = function (content) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('shareContent', content); })];
            });
        }); };
        this.authKit = new AuthKitModule_1.default();
        this.erpKit = new ErpKitModule_1.default();
        this.userKit = new UserKitModule_1.default();
        this.apolloKit = new ApolloKitModule_1.default();
        this.commonKit = new CommonKitModule_1.default();
        this.loyaltyKit = new LoyaltyKitModule_1.default();
        this.orderKit = new OrderKitModule_1.default();
        this.discoveryKit = new DiscoveryKitModule_1.default();
        this.deviceKit = new DeviceKitModule_1.default();
        this.cartKit = new CartKitModule_1.default();
        this.trackerKit = new TrackerKitModule_1.default();
        this.wrappedModule = new common_1.ModuleWrapper('TerraModule');
    }
    TerraKit.prototype.isAvailable = function () {
        return (__webpack_require__.g['isTerraAvailable'] && __webpack_require__.g['isTerraAvailable']()) || false;
    };
    TerraKit.prototype.finish = function () {
        this.wrappedModule.invoke('finish').then();
    };
    TerraKit.prototype.finishWithResult = function (result) {
        var _this = this;
        this.wrappedModule
            .invoke('sendFinishResult', {
            resultCode: result.resultCode,
            data: JSON.stringify(result.data),
        })
            .then(function () {
            _this.wrappedModule.invoke('finish').then();
        });
    };
    TerraKit.prototype.auth = function () {
        return this.authKit;
    };
    TerraKit.prototype.erp = function () {
        return this.erpKit;
    };
    TerraKit.prototype.user = function () {
        return this.userKit;
    };
    TerraKit.prototype.apollo = function () {
        return this.apolloKit;
    };
    TerraKit.prototype.common = function () {
        return this.commonKit;
    };
    TerraKit.prototype.loyalty = function () {
        return this.loyaltyKit;
    };
    TerraKit.prototype.order = function () {
        return this.orderKit;
    };
    TerraKit.prototype.discovery = function () {
        return this.discoveryKit;
    };
    TerraKit.prototype.device = function () {
        return this.deviceKit;
    };
    TerraKit.prototype.cart = function () {
        return this.cartKit;
    };
    TerraKit.prototype.tracker = function () {
        return this.trackerKit;
    };
    return TerraKit;
}());
exports["default"] = TerraKit;


/***/ }),

/***/ 39531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var ApolloKitModule = /** @class */ (function () {
    function ApolloKitModule() {
        var _this = this;
        this.appName = '';
        this.wrappedModule = null;
        this.getConfig = function () {
            return _this.wrappedModule.invoke('getConfig');
        };
        this.wrappedModule = new common_1.ModuleWrapper('ApolloKitModule');
    }
    return ApolloKitModule;
}());
exports["default"] = ApolloKitModule;


/***/ }),

/***/ 17712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var result_1 = __webpack_require__(97242);
var AuthKitModule = /** @class */ (function () {
    function AuthKitModule() {
        this.wrappedModule = null;
        this.accessToken = null;
        this.user = null;
        this.wrappedModule = new common_1.ModuleWrapper('AuthKitModule');
    }
    AuthKitModule.prototype.isLoggedIn = function () {
        return this.user != null;
    };
    AuthKitModule.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('login'); })];
            });
        });
    };
    AuthKitModule.prototype.logout = function () {
        throw Error('Should not call logout within a WebView scope');
    };
    /**
     * Returns the access token of current user. Returns null if no user has logged in.
     *
     * Please call `getAccessTokenAsync` before.
     */
    AuthKitModule.prototype.getAccessToken = function () {
        return this.accessToken;
    };
    AuthKitModule.prototype.getAccessTokenAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getAccessToken')];
                    case 1:
                        result = (_a.sent()).result;
                        this.accessToken = result === null || result === void 0 ? void 0 : result.accessToken;
                        return [2 /*return*/, this.accessToken];
                }
            });
        });
    };
    /**
     * Refreshes the access token. Returns an result with access token if success, otherwise returns an error result.
     */
    AuthKitModule.prototype.refreshAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, accessToken;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('refreshAccessToken'); })];
                    case 1:
                        result = _a.sent();
                        if (result.isSuccess()) {
                            accessToken = result.getValue().accessToken;
                            this.accessToken = accessToken;
                            return [2 /*return*/, (0, result_1.success)(accessToken)];
                        }
                        else {
                            return [2 /*return*/, (0, result_1.failure)(result.getError())];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current user. Returns null if no user has logged in.
     *
     * Please call `getFullUserInfo` before.
     */
    AuthKitModule.prototype.getUserInfo = function () {
        return this.user;
    };
    AuthKitModule.prototype.getFullUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getUserInfo')];
                    case 1:
                        result = (_a.sent()).result;
                        this.user = result;
                        return [2 /*return*/, this.user];
                }
            });
        });
    };
    return AuthKitModule;
}());
exports["default"] = AuthKitModule;


/***/ }),

/***/ 47944:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var dist_1 = __webpack_require__(38971);
var CartKitModule = /** @class */ (function () {
    function CartKitModule() {
        this.wrappedModule = new dist_1.ModuleWrapper('CartKitModule');
    }
    CartKitModule.prototype.getCartToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getCartToken')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    CartKitModule.prototype.updateCartSuccess = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('updateCartSuccess', { cart: cart })];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return CartKitModule;
}());
exports["default"] = CartKitModule;


/***/ }),

/***/ 68738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScanResultAction = exports.ScanResultCode = exports.SourceGetPhotoType = exports.ScanningType = void 0;
var common_1 = __webpack_require__(38971);
var dist_1 = __webpack_require__(38971);
var ScanningType;
(function (ScanningType) {
    ScanningType["PRODUCT_SERIAL"] = "serial";
    ScanningType["PRODUCT_BARCODE"] = "barcode";
    ScanningType["PRODUCT_QR"] = "qr";
    ScanningType["PRODUCT_ALL_TYPE"] = "allType";
})(ScanningType = exports.ScanningType || (exports.ScanningType = {}));
var SourceGetPhotoType;
(function (SourceGetPhotoType) {
    SourceGetPhotoType["CAMERA"] = "camera";
    SourceGetPhotoType["LIBRARY"] = "library";
    SourceGetPhotoType["BOTH"] = "both";
})(SourceGetPhotoType = exports.SourceGetPhotoType || (exports.SourceGetPhotoType = {}));
var ScanResultCode;
(function (ScanResultCode) {
    ScanResultCode[ScanResultCode["ERROR"] = 0] = "ERROR";
    ScanResultCode[ScanResultCode["SUCCESS"] = 1] = "SUCCESS";
})(ScanResultCode = exports.ScanResultCode || (exports.ScanResultCode = {}));
var ScanResultAction;
(function (ScanResultAction) {
    ScanResultAction["FORCE_CLOSE_SCAN"] = "forceCloseScan";
})(ScanResultAction = exports.ScanResultAction || (exports.ScanResultAction = {}));
// TODO: should move this module to js app because it is too specific for an application.
// TerraKit should provide a `createCustomModule(moduleName)` method in order to js can create
// your own module for specific business
var CommonKitModule = /** @class */ (function () {
    function CommonKitModule() {
        var _this = this;
        this.wrappedModule = null;
        this.deviceID = '';
        this.accessToken = null;
        this.user = null;
        this.getPrintConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('getPrintConfig'); })];
            });
        }); };
        this.printImage = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('printImage', request); })];
            });
        }); };
        this.getPhoto = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('getPhoto', request); })];
            });
        }); };
        this.observeScanResult = function (request) {
            //As required by ticket MOBCOMMON-3084, need to support multiple types of ScanningType when opening screen,
            //and also ensure backward compatibility with older versions, so need to add below code to handle
            var scanningType;
            if (request.scanningTypes == null || request.scanningTypes.length != 1) {
                scanningType = ScanningType.PRODUCT_ALL_TYPE;
            }
            else {
                scanningType = request.scanningTypes[0];
            }
            var internalRequest = {
                continuous: request.continuous,
                scanningType: scanningType,
                scanningTypes: request.scanningTypes,
            };
            return _this.wrappedModule.invoke('observeScanResult', internalRequest);
        };
        this.processScanResult = function (request) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.wrappedModule.invoke('processScanResult', request).then();
                return [2 /*return*/];
            });
        }); };
        this.wrappedModule = new common_1.ModuleWrapper('CommonKitModule');
    }
    CommonKitModule.prototype.scan = function () {
        return {
            observeScanResult: this.observeScanResult,
            processScanResult: this.processScanResult,
        };
    };
    return CommonKitModule;
}());
exports["default"] = CommonKitModule;


/***/ }),

/***/ 51960:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var dist_1 = __webpack_require__(38971);
var DeviceKitModule = /** @class */ (function () {
    function DeviceKitModule() {
        this.wrappedModule = new dist_1.ModuleWrapper('DeviceKitModule');
    }
    DeviceKitModule.prototype.hasPermission = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('hasPermission', request); })];
            });
        });
    };
    DeviceKitModule.prototype.turnOnGps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('turnOnGps'); })];
            });
        });
    };
    DeviceKitModule.prototype.getLocation = function (request) {
        if (request === void 0) { request = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('getLocation', request); })];
            });
        });
    };
    return DeviceKitModule;
}());
exports["default"] = DeviceKitModule;


/***/ }),

/***/ 40682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var DiscoveryKitModule = /** @class */ (function () {
    function DiscoveryKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('DiscoveryKitModule');
    }
    DiscoveryKitModule.prototype.onStockRequestFinish = function (isSuccess) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('onStockRequestFinish', { isSuccess: isSuccess })];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DiscoveryKitModule.prototype.getProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getProduct')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return DiscoveryKitModule;
}());
exports["default"] = DiscoveryKitModule;


/***/ }),

/***/ 375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var ErpModule = /** @class */ (function () {
    function ErpModule() {
        this.terminal = null;
        this.terraConfig = null;
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('ErpKitModule');
    }
    ErpModule.prototype.getSellerId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.sellerID];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.sellerID];
                }
            });
        });
    };
    ErpModule.prototype.getPlatformId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.platformId];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.platformId];
                }
            });
        });
    };
    ErpModule.prototype.getPlatformCode = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.platformCode];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.platformCode];
                }
            });
        });
    };
    ErpModule.prototype.getTerminal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getTerminal')];
                    case 1:
                        result = (_a.sent()).result;
                        this.terminal = result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ErpModule.prototype.getTerraConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getTerraConfig')];
                    case 1:
                        result = (_a.sent()).result;
                        this.terraConfig = result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ErpModule.prototype.getLanguage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getLanguage')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return ErpModule;
}());
exports["default"] = ErpModule;


/***/ }),

/***/ 78246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var TerraKit_1 = __webpack_require__(40278);
var terraKit = new TerraKit_1.default();
__webpack_require__.g['terraKit'] = terraKit;
exports.Z = terraKit;


/***/ }),

/***/ 54412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var types_1 = __webpack_require__(89629);
var LoyaltyKitModule = /** @class */ (function () {
    function LoyaltyKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('LoyaltyKitModule');
    }
    LoyaltyKitModule.prototype.getMemberInfo = function (request) {
        if (request === void 0) { request = types_1.GetMemberInfoRequestFactory.currentUser(); }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getMemberInfo', request); })];
            });
        });
    };
    LoyaltyKitModule.prototype.openAssignMemberCard = function (memberId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () {
                        return _this.wrappedModule.invoke('openAssignMemberCard', { memberId: memberId });
                    })];
            });
        });
    };
    LoyaltyKitModule.prototype.getNetworkConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getNetworkConfig'); })];
            });
        });
    };
    LoyaltyKitModule.prototype.getLoyaltyConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getLoyaltyConfig'); })];
            });
        });
    };
    LoyaltyKitModule.prototype.mapResult = function (block) {
        return new Promise(function (resolve) {
            (0, common_1.toResult)(block).then(function (result) {
                if (result.isSuccess()) {
                    resolve(result.getValue());
                }
                else {
                    resolve({ resultCode: types_1.LoyaltyResultCode.Unexpected, message: result.getError().message });
                }
            });
        });
    };
    return LoyaltyKitModule;
}());
exports["default"] = LoyaltyKitModule;


/***/ }),

/***/ 89629:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoyaltyResultCode = exports.GetMemberInfoRequestFactory = void 0;
exports.GetMemberInfoRequestFactory = {
    currentUser: function () {
        return {
            type: 'currentUser',
        };
    },
    phone: function (phone) {
        return {
            type: 'phone',
            phone: phone,
        };
    },
    memberQrCode: function (memberQrCode) {
        return {
            type: 'memberQrCode',
            memberQrCode: memberQrCode,
        };
    },
};
var LoyaltyResultCode;
(function (LoyaltyResultCode) {
    LoyaltyResultCode["Success"] = "Success";
    LoyaltyResultCode["Cancelled"] = "Cancelled";
    LoyaltyResultCode["CannotCallLoyaltyService"] = "CannotCallLoyaltyService";
    LoyaltyResultCode["DataInactive"] = "DataInactive";
    LoyaltyResultCode["DuplicateMemberCardId"] = "DuplicateMemberCardId";
    LoyaltyResultCode["DuplicatePhone"] = "DuplicatePhone";
    LoyaltyResultCode["InvalidParam"] = "InvalidParam";
    LoyaltyResultCode["InvalidParamFormat"] = "InvalidParamFormat";
    LoyaltyResultCode["MemberInactive"] = "MemberInactive";
    LoyaltyResultCode["MemberQrInactive"] = "MemberQrInactive";
    LoyaltyResultCode["MissingParam"] = "MissingParam";
    LoyaltyResultCode["ParamOutOfRange"] = "ParamOutOfRange";
    LoyaltyResultCode["PermissionDenied"] = "PermissionDenied";
    LoyaltyResultCode["RedemptionCodeExpired"] = "RedemptionCodeExpired";
    LoyaltyResultCode["SubjectNotFound"] = "SubjectNotFound";
    LoyaltyResultCode["SystemError"] = "SystemError";
    LoyaltyResultCode["Unauthorized"] = "Unauthorized";
    LoyaltyResultCode["Unexpected"] = "Unexpected";
    LoyaltyResultCode["MemberNotMatchMerchant"] = "MemberNotMatchMerchant";
})(LoyaltyResultCode = exports.LoyaltyResultCode || (exports.LoyaltyResultCode = {}));


/***/ }),

/***/ 47293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var dist_1 = __webpack_require__(38971);
var OrderKitModule = /** @class */ (function () {
    function OrderKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('OrderKitModule');
    }
    OrderKitModule.prototype.requestReturn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('requestReturn'); })];
            });
        });
    };
    OrderKitModule.prototype.navigateToCart = function (cartToken) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('navigateToCart', { cartToken: cartToken }); })];
            });
        });
    };
    OrderKitModule.prototype.repaymentOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('repaymentOrder', { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.navigateToProductDetail = function (sku) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('navigateToProductDetail', { sku: sku }); })];
            });
        });
    };
    OrderKitModule.prototype.onReturnFinish = function (reload) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('onReturnFinish', { reload: reload }); })];
            });
        });
    };
    OrderKitModule.prototype.printReceipt = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("printReceipt", { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.payForOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("payForOrder", { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.openOrderManagement = function (orderType) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("openOrderManagement", orderType); })];
            });
        });
    };
    OrderKitModule.prototype.reloadOrders = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("reloadOrders", data); })];
            });
        });
    };
    return OrderKitModule;
}());
exports["default"] = OrderKitModule;


/***/ }),

/***/ 37171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var dist_1 = __webpack_require__(38971);
var TrackerKitModule = /** @class */ (function () {
    function TrackerKitModule() {
        this.wrappedModule = new dist_1.ModuleWrapper('TrackerKitModule');
    }
    TrackerKitModule.prototype.getTrackingAppId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getTrackingAppId')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return TrackerKitModule;
}());
exports["default"] = TrackerKitModule;


/***/ }),

/***/ 9472:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var UserModule = /** @class */ (function () {
    function UserModule() {
        var _this = this;
        this.wrappedModule = null;
        /**
         * Get profile of user currently login to the App
         * @returns
         */
        this.getUserProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getUserProfile'); })];
            });
        }); };
        /**
         * Update info of an user
         * @param request profile of the user currently login to the App
         * @returns
         */
        this.updateUserProfile = function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('updateUserProfile', profile); })];
            });
        }); };
        /**
         * Lookup customer based on keyword.
         * @param request
         * @returns
         */
        this.searchProfile = function (request) {
            return (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('searchProfile', request); });
        };
        /**
         * Update info of customer.
         * @param request
         * @returns
         */
        this.upsertProfile = function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('upsertProfile', profile); })];
            });
        }); };
        this.registerProfile = function (request) {
            return (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('registerProfile', request); });
        };
        this.createNewAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('createNewAddress', request); })];
            });
        }); };
        this.updateAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('updateAddress', request); })];
            });
        }); };
        this.deleteAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('deleteAddress', request); })];
            });
        }); };
        /**
         * Get appFlow of the current login user
         * @returns
         */
        this.getOperationFlowConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getOperationFlowConfig'); })];
            });
        }); };
        this.changeDealer = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('changeDealer', request); })];
            });
        }); };
        this.fetchUserAddressList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('fetchUserAddress'); })];
            });
        }); };
        this.getDetailProfile = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getDetailProfile', request); })];
            });
        }); };
        this.publishCustomer = function (customer) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('publishCustomer', customer); })];
            });
        }); };
        this.fetchCustomerTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('fetchCustomerTypes'); })];
            });
        }); };
        this.wrappedModule = new common_1.ModuleWrapper('UserKitModule');
    }
    return UserModule;
}());
exports["default"] = UserModule;


/***/ }),

/***/ 43879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Buffer = (__webpack_require__(82909).Buffer)
var Querystring = __webpack_require__(61639)
var defaultRequest = __webpack_require__(123)

const DEFAULT_URL_BASE = 'https://example.org/'

var btoa
if (typeof Buffer === 'function') {
  btoa = btoaBuffer
} else {
  btoa = window.btoa.bind(window)
}

/**
 * Export `ClientOAuth2` class.
 */
module.exports = ClientOAuth2

/**
 * Default headers for executing OAuth 2.0 flows.
 */
var DEFAULT_HEADERS = {
  Accept: 'application/json, application/x-www-form-urlencoded',
  'Content-Type': 'application/x-www-form-urlencoded'
}

/**
 * Format error response types to regular strings for displaying to clients.
 *
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.1.2.1
 */
var ERROR_RESPONSES = {
  invalid_request: [
    'The request is missing a required parameter, includes an',
    'invalid parameter value, includes a parameter more than',
    'once, or is otherwise malformed.'
  ].join(' '),
  invalid_client: [
    'Client authentication failed (e.g., unknown client, no',
    'client authentication included, or unsupported',
    'authentication method).'
  ].join(' '),
  invalid_grant: [
    'The provided authorization grant (e.g., authorization',
    'code, resource owner credentials) or refresh token is',
    'invalid, expired, revoked, does not match the redirection',
    'URI used in the authorization request, or was issued to',
    'another client.'
  ].join(' '),
  unauthorized_client: [
    'The client is not authorized to request an authorization',
    'code using this method.'
  ].join(' '),
  unsupported_grant_type: [
    'The authorization grant type is not supported by the',
    'authorization server.'
  ].join(' '),
  access_denied: [
    'The resource owner or authorization server denied the request.'
  ].join(' '),
  unsupported_response_type: [
    'The authorization server does not support obtaining',
    'an authorization code using this method.'
  ].join(' '),
  invalid_scope: [
    'The requested scope is invalid, unknown, or malformed.'
  ].join(' '),
  server_error: [
    'The authorization server encountered an unexpected',
    'condition that prevented it from fulfilling the request.',
    '(This error code is needed because a 500 Internal Server',
    'Error HTTP status code cannot be returned to the client',
    'via an HTTP redirect.)'
  ].join(' '),
  temporarily_unavailable: [
    'The authorization server is currently unable to handle',
    'the request due to a temporary overloading or maintenance',
    'of the server.'
  ].join(' ')
}

/**
 * Support base64 in node like how it works in the browser.
 *
 * @param  {string} string
 * @return {string}
 */
function btoaBuffer (string) {
  return Buffer.from(string).toString('base64')
}

/**
 * Check if properties exist on an object and throw when they aren't.
 *
 * @throws {TypeError} If an expected property is missing.
 *
 * @param {Object}    obj
 * @param {...string} props
 */
function expects (obj) {
  for (var i = 1; i < arguments.length; i++) {
    var prop = arguments[i]

    if (obj[prop] == null) {
      throw new TypeError('Expected "' + prop + '" to exist')
    }
  }
}

/**
 * Pull an authentication error from the response data.
 *
 * @param  {Object} data
 * @return {string}
 */
function getAuthError (body) {
  var message = ERROR_RESPONSES[body.error] ||
    body.error_description ||
    body.error

  if (message) {
    var err = new Error(message)
    err.body = body
    err.code = 'EAUTH'
    return err
  }
}

/**
 * Attempt to parse response body as JSON, fall back to parsing as a query string.
 *
 * @param {string} body
 * @return {Object}
 */
function parseResponseBody (body) {
  try {
    return JSON.parse(body)
  } catch (e) {
    return Querystring.parse(body)
  }
}

/**
 * Sanitize the scopes option to be a string.
 *
 * @param  {Array}  scopes
 * @return {string}
 */
function sanitizeScope (scopes) {
  return Array.isArray(scopes) ? scopes.join(' ') : toString(scopes)
}

/**
 * Create a request uri based on an options object and token type.
 *
 * @param  {Object} options
 * @param  {string} tokenType
 * @return {string}
 */
function createUri (options, tokenType) {
  // Check the required parameters are set.
  expects(options, 'clientId', 'authorizationUri')

  const qs = {
    client_id: options.clientId,
    redirect_uri: options.redirectUri,
    response_type: tokenType,
    state: options.state
  }
  if (options.scopes !== undefined) {
    qs.scope = sanitizeScope(options.scopes)
  }

  const sep = options.authorizationUri.includes('?') ? '&' : '?'
  return options.authorizationUri + sep + Querystring.stringify(
    Object.assign(qs, options.query))
}

/**
 * Create basic auth header.
 *
 * @param  {string} username
 * @param  {string} password
 * @return {string}
 */
function auth (username, password) {
  return 'Basic ' + btoa(toString(username) + ':' + toString(password))
}

/**
 * Ensure a value is a string.
 *
 * @param  {string} str
 * @return {string}
 */
function toString (str) {
  return str == null ? '' : String(str)
}

/**
 * Merge request options from an options object.
 */
function requestOptions (requestOptions, options) {
  return {
    url: requestOptions.url,
    method: requestOptions.method,
    body: Object.assign({}, requestOptions.body, options.body),
    query: Object.assign({}, requestOptions.query, options.query),
    headers: Object.assign({}, requestOptions.headers, options.headers)
  }
}

/**
 * Construct an object that can handle the multiple OAuth 2.0 flows.
 *
 * @param {Object} options
 */
function ClientOAuth2 (options, request) {
  this.options = options
  this.request = request || defaultRequest

  this.code = new CodeFlow(this)
  this.token = new TokenFlow(this)
  this.owner = new OwnerFlow(this)
  this.credentials = new CredentialsFlow(this)
  this.jwt = new JwtBearerFlow(this)
}

/**
 * Alias the token constructor.
 *
 * @type {Function}
 */
ClientOAuth2.Token = ClientOAuth2Token

/**
 * Create a new token from existing data.
 *
 * @param  {string} access
 * @param  {string} [refresh]
 * @param  {string} [type]
 * @param  {Object} [data]
 * @return {Object}
 */
ClientOAuth2.prototype.createToken = function (access, refresh, type, data) {
  var options = Object.assign(
    {},
    data,
    typeof access === 'string' ? { access_token: access } : access,
    typeof refresh === 'string' ? { refresh_token: refresh } : refresh,
    typeof type === 'string' ? { token_type: type } : type
  )

  return new ClientOAuth2.Token(this, options)
}

/**
 * Using the built-in request method, we'll automatically attempt to parse
 * the response.
 *
 * @param  {Object}  options
 * @return {Promise}
 */
ClientOAuth2.prototype._request = function (options) {
  var url = options.url
  var body = Querystring.stringify(options.body)
  var query = Querystring.stringify(options.query)

  if (query) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + query
  }

  return this.request(options.method, url, body, options.headers)
    .then(function (res) {
      var body = parseResponseBody(res.body)
      var authErr = getAuthError(body)

      if (authErr) {
        return Promise.reject(authErr)
      }

      if (res.status < 200 || res.status >= 399) {
        var statusErr = new Error('HTTP status ' + res.status)
        statusErr.status = res.status
        statusErr.body = res.body
        statusErr.code = 'ESTATUS'
        return Promise.reject(statusErr)
      }

      return body
    })
}

/**
 * General purpose client token generator.
 *
 * @param {Object} client
 * @param {Object} data
 */
function ClientOAuth2Token (client, data) {
  this.client = client
  this.data = data
  this.tokenType = data.token_type && data.token_type.toLowerCase()
  this.accessToken = data.access_token
  this.refreshToken = data.refresh_token

  this.expiresIn(Number(data.expires_in))
}

/**
 * Expire the token after some time.
 *
 * @param  {number|Date} duration Seconds from now to expire, or a date to expire on.
 * @return {Date}
 */
ClientOAuth2Token.prototype.expiresIn = function (duration) {
  if (typeof duration === 'number') {
    this.expires = new Date()
    this.expires.setSeconds(this.expires.getSeconds() + duration)
  } else if (duration instanceof Date) {
    this.expires = new Date(duration.getTime())
  } else {
    throw new TypeError('Unknown duration: ' + duration)
  }

  return this.expires
}

/**
 * Sign a standardised request object with user authentication information.
 *
 * @param  {Object} requestObject
 * @return {Object}
 */
ClientOAuth2Token.prototype.sign = function (requestObject) {
  if (!this.accessToken) {
    throw new Error('Unable to sign without access token')
  }

  requestObject.headers = requestObject.headers || {}

  if (this.tokenType === 'bearer') {
    requestObject.headers.Authorization = 'Bearer ' + this.accessToken
  } else {
    var parts = requestObject.url.split('#')
    var token = 'access_token=' + this.accessToken
    var url = parts[0].replace(/[?&]access_token=[^&#]/, '')
    var fragment = parts[1] ? '#' + parts[1] : ''

    // Prepend the correct query string parameter to the url.
    requestObject.url = url + (url.indexOf('?') > -1 ? '&' : '?') + token + fragment

    // Attempt to avoid storing the url in proxies, since the access token
    // is exposed in the query parameters.
    requestObject.headers.Pragma = 'no-store'
    requestObject.headers['Cache-Control'] = 'no-store'
  }

  return requestObject
}

/**
 * Refresh a user access token with the supplied token.
 *
 * @param  {Object}  opts
 * @return {Promise}
 */
ClientOAuth2Token.prototype.refresh = function (opts) {
  var self = this
  var options = Object.assign({}, this.client.options, opts)

  if (!this.refreshToken) {
    return Promise.reject(new Error('No refresh token'))
  }

  return this.client._request(requestOptions({
    url: options.accessTokenUri,
    method: 'POST',
    headers: Object.assign({}, DEFAULT_HEADERS, {
      Authorization: auth(options.clientId, options.clientSecret)
    }),
    body: {
      refresh_token: this.refreshToken,
      grant_type: 'refresh_token'
    }
  }, options))
    .then(function (data) {
      return self.client.createToken(Object.assign({}, self.data, data))
    })
}

/**
 * Check whether the token has expired.
 *
 * @return {boolean}
 */
ClientOAuth2Token.prototype.expired = function () {
  return Date.now() > this.expires.getTime()
}

/**
 * Support resource owner password credentials OAuth 2.0 grant.
 *
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.3
 *
 * @param {ClientOAuth2} client
 */
function OwnerFlow (client) {
  this.client = client
}

/**
 * Make a request on behalf of the user credentials to get an access token.
 *
 * @param  {string}  username
 * @param  {string}  password
 * @param  {Object}  [opts]
 * @return {Promise}
 */
OwnerFlow.prototype.getToken = function (username, password, opts) {
  var self = this
  var options = Object.assign({}, this.client.options, opts)

  const body = {
    username: username,
    password: password,
    grant_type: 'password'
  }
  if (options.scopes !== undefined) {
    body.scope = sanitizeScope(options.scopes)
  }

  return this.client._request(requestOptions({
    url: options.accessTokenUri,
    method: 'POST',
    headers: Object.assign({}, DEFAULT_HEADERS, {
      Authorization: auth(options.clientId, options.clientSecret)
    }),
    body: body
  }, options))
    .then(function (data) {
      return self.client.createToken(data)
    })
}

/**
 * Support implicit OAuth 2.0 grant.
 *
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.2
 *
 * @param {ClientOAuth2} client
 */
function TokenFlow (client) {
  this.client = client
}

/**
 * Get the uri to redirect the user to for implicit authentication.
 *
 * @param  {Object} [opts]
 * @return {string}
 */
TokenFlow.prototype.getUri = function (opts) {
  var options = Object.assign({}, this.client.options, opts)

  return createUri(options, 'token')
}

/**
 * Get the user access token from the uri.
 *
 * @param  {string|Object} uri
 * @param  {Object}        [opts]
 * @return {Promise}
 */
TokenFlow.prototype.getToken = function (uri, opts) {
  var options = Object.assign({}, this.client.options, opts)
  var url = typeof uri === 'object' ? uri : new URL(uri, DEFAULT_URL_BASE)
  var expectedUrl = new URL(options.redirectUri, DEFAULT_URL_BASE)

  if (typeof url.pathname === 'string' && url.pathname !== expectedUrl.pathname) {
    return Promise.reject(
      new TypeError('Redirected path should match configured path, but got: ' + url.pathname)
    )
  }

  // If no query string or fragment exists, we won't be able to parse
  // any useful information from the uri.
  if (!url.hash && !url.search) {
    return Promise.reject(new TypeError('Unable to process uri: ' + uri))
  }

  // Extract data from both the fragment and query string. The fragment is most
  // important, but the query string is also used because some OAuth 2.0
  // implementations (Instagram) have a bug where state is passed via query.
  var data = Object.assign(
    {},
    typeof url.search === 'string' ? Querystring.parse(url.search.substr(1)) : (url.search || {}),
    typeof url.hash === 'string' ? Querystring.parse(url.hash.substr(1)) : (url.hash || {})
  )

  var err = getAuthError(data)

  // Check if the query string was populated with a known error.
  if (err) {
    return Promise.reject(err)
  }

  // Check whether the state matches.
  if (options.state != null && data.state !== options.state) {
    return Promise.reject(new TypeError('Invalid state: ' + data.state))
  }

  // Initalize a new token and return.
  return Promise.resolve(this.client.createToken(data))
}

/**
 * Support client credentials OAuth 2.0 grant.
 *
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.4
 *
 * @param {ClientOAuth2} client
 */
function CredentialsFlow (client) {
  this.client = client
}

/**
 * Request an access token using the client credentials.
 *
 * @param  {Object}  [opts]
 * @return {Promise}
 */
CredentialsFlow.prototype.getToken = function (opts) {
  var self = this
  var options = Object.assign({}, this.client.options, opts)

  expects(options, 'clientId', 'clientSecret', 'accessTokenUri')

  const body = {
    grant_type: 'client_credentials'
  }

  if (options.scopes !== undefined) {
    body.scope = sanitizeScope(options.scopes)
  }

  return this.client._request(requestOptions({
    url: options.accessTokenUri,
    method: 'POST',
    headers: Object.assign({}, DEFAULT_HEADERS, {
      Authorization: auth(options.clientId, options.clientSecret)
    }),
    body: body
  }, options))
    .then(function (data) {
      return self.client.createToken(data)
    })
}

/**
 * Support authorization code OAuth 2.0 grant.
 *
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.1
 *
 * @param {ClientOAuth2} client
 */
function CodeFlow (client) {
  this.client = client
}

/**
 * Generate the uri for doing the first redirect.
 *
 * @param  {Object} [opts]
 * @return {string}
 */
CodeFlow.prototype.getUri = function (opts) {
  var options = Object.assign({}, this.client.options, opts)

  return createUri(options, 'code')
}

/**
 * Get the code token from the redirected uri and make another request for
 * the user access token.
 *
 * @param  {string|Object} uri
 * @param  {Object}        [opts]
 * @return {Promise}
 */
CodeFlow.prototype.getToken = function (uri, opts) {
  var self = this
  var options = Object.assign({}, this.client.options, opts)

  expects(options, 'clientId', 'accessTokenUri')

  var url = typeof uri === 'object' ? uri : new URL(uri, DEFAULT_URL_BASE)

  if (
    typeof options.redirectUri === 'string' &&
    typeof url.pathname === 'string' &&
    url.pathname !== (new URL(options.redirectUri, DEFAULT_URL_BASE)).pathname
  ) {
    return Promise.reject(
      new TypeError('Redirected path should match configured path, but got: ' + url.pathname)
    )
  }

  if (!url.search || !url.search.substr(1)) {
    return Promise.reject(new TypeError('Unable to process uri: ' + uri))
  }

  var data = typeof url.search === 'string'
    ? Querystring.parse(url.search.substr(1))
    : (url.search || {})
  var err = getAuthError(data)

  if (err) {
    return Promise.reject(err)
  }

  if (options.state != null && data.state !== options.state) {
    return Promise.reject(new TypeError('Invalid state: ' + data.state))
  }

  // Check whether the response code is set.
  if (!data.code) {
    return Promise.reject(new TypeError('Missing code, unable to request token'))
  }

  var headers = Object.assign({}, DEFAULT_HEADERS)
  var body = { code: data.code, grant_type: 'authorization_code', redirect_uri: options.redirectUri }

  // `client_id`: REQUIRED, if the client is not authenticating with the
  // authorization server as described in Section 3.2.1.
  // Reference: https://tools.ietf.org/html/rfc6749#section-3.2.1
  if (options.clientSecret) {
    headers.Authorization = auth(options.clientId, options.clientSecret)
  } else {
    body.client_id = options.clientId
  }

  return this.client._request(requestOptions({
    url: options.accessTokenUri,
    method: 'POST',
    headers: headers,
    body: body
  }, options))
    .then(function (data) {
      return self.client.createToken(data)
    })
}

/**
 * Support JSON Web Token (JWT) Bearer Token OAuth 2.0 grant.
 *
 * Reference: https://tools.ietf.org/html/draft-ietf-oauth-jwt-bearer-12#section-2.1
 *
 * @param {ClientOAuth2} client
 */
function JwtBearerFlow (client) {
  this.client = client
}

/**
 * Request an access token using a JWT token.
 *
 * @param  {string} token     A JWT token.
 * @param  {Object} [opts]
 * @return {Promise}
 */
JwtBearerFlow.prototype.getToken = function (token, opts) {
  var self = this
  var options = Object.assign({}, this.client.options, opts)
  var headers = Object.assign({}, DEFAULT_HEADERS)

  expects(options, 'accessTokenUri')

  // Authentication of the client is optional, as described in
  // Section 3.2.1 of OAuth 2.0 [RFC6749]
  if (options.clientId) {
    headers.Authorization = auth(options.clientId, options.clientSecret)
  }

  const body = {
    grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
    assertion: token
  }

  if (options.scopes !== undefined) {
    body.scope = sanitizeScope(options.scopes)
  }

  return this.client._request(requestOptions({
    url: options.accessTokenUri,
    method: 'POST',
    headers: headers,
    body: body
  }, options))
    .then(function (data) {
      return self.client.createToken(data)
    })
}


/***/ }),

/***/ 123:
/***/ (function(module) {

/**
 * Make a request using `XMLHttpRequest`.
 *
 * @param   {string}  method
 * @param   {string}  url
 * @param   {string}  body
 * @param   {Object}  headers
 * @returns {Promise}
 */
module.exports = function request (method, url, body, headers) {
  return new Promise(function (resolve, reject) {
    var xhr = new window.XMLHttpRequest()

    xhr.open(method, url)

    xhr.onload = function () {
      return resolve({
        status: xhr.status,
        body: xhr.responseText
      })
    }

    xhr.onerror = xhr.onabort = function () {
      return reject(new Error(xhr.statusText || 'XHR aborted: ' + url))
    }

    Object.keys(headers).forEach(function (header) {
      xhr.setRequestHeader(header, headers[header])
    })

    xhr.send(body)
  })
}


/***/ }),

/***/ 35410:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 54494:
/***/ (function(module, exports) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 98933:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(54494));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 70085:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(54494));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 96687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 22810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4049);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47714);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 70007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4049);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22810);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 12);
}

/***/ }),

/***/ 89060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47714);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 69802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4049);
/* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70007);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addYears_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 47714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 26504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(52744);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 19174:
/***/ (function(module) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ 92281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var atob = __webpack_require__(19174);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ 11260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(92281);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ 25290:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 11022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "compile": function() { return /* binding */ compile; },
/* harmony export */   "match": function() { return /* binding */ match; },
/* harmony export */   "parse": function() { return /* binding */ parse; },
/* harmony export */   "pathToRegexp": function() { return /* binding */ pathToRegexp; },
/* harmony export */   "regexpToFunction": function() { return /* binding */ regexpToFunction; },
/* harmony export */   "tokensToFunction": function() { return /* binding */ tokensToFunction; },
/* harmony export */   "tokensToRegexp": function() { return /* binding */ tokensToRegexp; }
/* harmony export */ });
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at " + i);
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at " + j);
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at " + j);
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern)
                throw new TypeError("Missing pattern at " + i);
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function () {
        var result = "";
        var value;
        // tslint:disable-next-line
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:" + token.pattern + ")$", reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"" + token.name + "\" to not repeat, but got an array");
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"" + token.name + "\" to not be empty");
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"" + token.name + "\" to be " + typeOfMessage);
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            // tslint:disable-next-line
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while (execResult) {
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d;
    var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    }
                    else {
                        route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                    }
                }
                else {
                    route += "(" + token.pattern + ")" + token.modifier;
                }
            }
            else {
                route += "(?:" + prefix + suffix + ")" + token.modifier;
            }
        }
    }
    if (end) {
        if (!strict)
            route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiter.indexOf(endToken[endToken.length - 1]) > -1
            : // tslint:disable-next-line
                endToken === undefined;
        if (!strict) {
            route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        }
        if (!isEndDelimited) {
            route += "(?=" + delimiter + "|" + endsWith + ")";
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66461:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 30931:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 61639:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(66461);
exports.encode = exports.stringify = __webpack_require__(30931);


/***/ }),

/***/ 27999:
/***/ (function(module) {

"use strict";

function tryStringify (o) {
  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
}

module.exports = format

function format(f, args, opts) {
  var ss = (opts && opts.stringify) || tryStringify
  var offset = 1
  if (typeof f === 'object' && f !== null) {
    var len = args.length + offset
    if (len === 1) return f
    var objects = new Array(len)
    objects[0] = ss(f)
    for (var index = 1; index < len; index++) {
      objects[index] = ss(args[index])
    }
    return objects.join(' ')
  }
  if (typeof f !== 'string') {
    return f
  }
  var argLen = args.length
  if (argLen === 0) return f
  var str = ''
  var a = 1 - offset
  var lastPos = -1
  var flen = (f && f.length) || 0
  for (var i = 0; i < flen;) {
    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
      lastPos = lastPos > -1 ? lastPos : 0
      switch (f.charCodeAt(i + 1)) {
        case 100: // 'd'
        case 102: // 'f'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Number(args[a])
          lastPos = i + 2
          i++
          break
        case 105: // 'i'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Math.floor(Number(args[a]))
          lastPos = i + 2
          i++
          break
        case 79: // 'O'
        case 111: // 'o'
        case 106: // 'j'
          if (a >= argLen)
            break
          if (args[a] === undefined) break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          var type = typeof args[a]
          if (type === 'string') {
            str += '\'' + args[a] + '\''
            lastPos = i + 2
            i++
            break
          }
          if (type === 'function') {
            str += args[a].name || '<anonymous>'
            lastPos = i + 2
            i++
            break
          }
          str += ss(args[a])
          lastPos = i + 2
          i++
          break
        case 115: // 's'
          if (a >= argLen)
            break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += String(args[a])
          lastPos = i + 2
          i++
          break
        case 37: // '%'
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += '%'
          lastPos = i + 2
          i++
          a--
          break
      }
      ++a
    }
    ++i
  }
  if (lastPos === -1)
    return f
  else if (lastPos < flen) {
    str += f.slice(lastPos)
  }

  return str
}


/***/ }),

/***/ 90244:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 52744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(90244);
} else {}


/***/ }),

/***/ 82515:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 7560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _constants = __webpack_require__(1281);

var _Timer = _interopRequireDefault(__webpack_require__(41166));

var _utils = __webpack_require__(63266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckSessionIdService = /*#__PURE__*/function () {
  function CheckSessionIdService(userManager, endpoint) {
    var _this = this;

    _classCallCheck(this, CheckSessionIdService);

    this._userManager = userManager;
    this._endpoint = endpoint;

    this._userManager._events.addUserLoaded(this._start.bind(this));

    this._timer = new _Timer["default"]('Check Session ID', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var session, auth;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(_this._endpoint, {
                headers: {
                  'X-Session-Id': _this._sessionId
                }
              }).then(function (res) {
                return res.json();
              });

            case 2:
              session = _context.sent;
              auth = session.is_authenticated;

              if (!auth) {
                _this._userManager._events._raiseUserSessionIdChanged();
              }

              _this._timer.init();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _constants.DEFAULT_CHECK_SESSION_FREQUENCY);

    this._start();
  }

  _createClass(CheckSessionIdService, [{
    key: "_start",
    value: function _start() {
      var user = this._userManager.loadUser();

      if (user.idToken) {
        this._sessionId = (0, _utils.decodeToken)(user.idToken).sid;

        this._timer.init();
      }
    }
  }]);

  return CheckSessionIdService;
}();

exports["default"] = CheckSessionIdService;

/***/ }),

/***/ 75117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _constants = __webpack_require__(1281);

var _Timer = _interopRequireDefault(__webpack_require__(41166));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckSessionServiceBFF = function CheckSessionServiceBFF(userManager, endpoint) {
  var _this = this;

  _classCallCheck(this, CheckSessionServiceBFF);

  this._userManager = userManager;
  this._endpoint = endpoint; // this._userManager._events.addUserLoaded(this._start.bind(this))

  this._timer = new _Timer["default"]('Check Session using BFF', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var session, auth;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(_this._endpoint, {
              credentials: 'include'
            }).then(function (res) {
              return res.json();
            });

          case 2:
            session = _context.sent;
            auth = session.is_authenticated;

            if (_this._userManager.isLoggedIn() && !auth) {
              _this._userManager._events._raiseUserSessionChanged();
            }

            _this._timer.init();

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), _constants.DEFAULT_CHECK_SESSION_FREQUENCY);

  this._timer.init();
};

exports["default"] = CheckSessionServiceBFF;

/***/ }),

/***/ 4288:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _constants = __webpack_require__(1281);

var _IframeWindow = _interopRequireDefault(__webpack_require__(86534));

var _Timer = _interopRequireDefault(__webpack_require__(41166));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckSessionServiceIframe = /*#__PURE__*/function () {
  function CheckSessionServiceIframe(userManager) {
    _classCallCheck(this, CheckSessionServiceIframe);

    this._userManager = userManager;

    this._userManager._events.addUserLoaded(this._start.bind(this));

    this._timer = new _Timer["default"]('Check Session', this._checkSession.bind(this), _constants.DEFAULT_CHECK_SESSION_FREQUENCY);
    this._checkSessionFrame = new _IframeWindow["default"]({
      src: this._userManager._oidc._checkSessionUri,
      callback: this._sessionStatusCallback.bind(this),
      cleanupFrame: false
    });

    this._start();
  }

  _createClass(CheckSessionServiceIframe, [{
    key: "_checkSession",
    value: function _checkSession() {
      var _this = this;

      var message = this._userManager._clientId + ' ' + this._currentSessionState;

      this._checkSessionFrame.listen().then(function (sessionStatus) {
        if (sessionStatus === 'error') {
          throw new Error('Error throw from OP when get session status');
        } else if (sessionStatus === 'changed') {
          _this._userManager._events._raiseUserSessionChanged();
        } else if (sessionStatus === 'unchanged') {
          _this._start();
        } else {
          throw new Error('Invalid OP session status');
        }
      })["catch"](function (err) {
        console.warn(err);

        _this._stop();
      });

      this._checkSessionFrame.postMessage(message, this._userManager._oauthDomain);
    }
  }, {
    key: "_sessionStatusCallback",
    value: function _sessionStatusCallback(e) {
      if (e.origin !== this._userManager._oauthDomain || e.source !== this._checkSessionFrame.frame.contentWindow) {
        return Promise.resolve();
      }

      return Promise.resolve(e.data);
    }
  }, {
    key: "_start",
    value: function _start() {
      var user = this._userManager.loadUser();

      if (user && user.sessionState) {
        this._currentSessionState = user.sessionState;

        this._timer.init();
      }
    }
  }, {
    key: "_stop",
    value: function _stop() {
      this._timer.cancel();
    }
  }]);

  return CheckSessionServiceIframe;
}();

exports["default"] = CheckSessionServiceIframe;

/***/ }),

/***/ 35980:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Event = /*#__PURE__*/function () {
  function Event(name) {
    _classCallCheck(this, Event);

    this._name = name;
    this._callbacks = [];
  }

  _createClass(Event, [{
    key: "addHandler",
    value: function addHandler(cb) {
      this._callbacks.push(cb);
    }
  }, {
    key: "removeHandler",
    value: function removeHandler(cb) {
      var idx = this._callbacks.findIndex(function (item) {
        return item === cb;
      });

      if (idx >= 0) {
        this._callbacks.splice(idx, 1);
      }
    }
  }, {
    key: "raise",
    value: function raise() {
      for (var i = 0; i < this._callbacks.length; i++) {
        var _this$_callbacks;

        (_this$_callbacks = this._callbacks)[i].apply(_this$_callbacks, arguments);
      }
    }
  }]);

  return Event;
}();

exports["default"] = Event;

/***/ }),

/***/ 86534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _constants = __webpack_require__(1281);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// callback should be a promise, which first parameter is the EventMessage.
// It will be executed whenever IframeWindow listens to a new message,
// It should resolve or reject in 3 cases:
// 1. Resolve empty value if the message is not the one the callback wants to listen.
// 2. Resolve data, which is the data IframeWindow wants to return after call navigate.
// 3. Reject error, which is the error IframeWindow wants to throw if there are errors when handles the message.
var IframeWindow = /*#__PURE__*/function () {
  function IframeWindow(options) {
    _classCallCheck(this, IframeWindow);

    options = options || {};
    var _options = options,
        src = _options.src,
        callback = _options.callback,
        _options$cleanupFrame = _options.cleanupFrame,
        cleanupFrame = _options$cleanupFrame === void 0 ? true : _options$cleanupFrame;
    if (!src) throw new Error('No src provided');
    this._callback = callback;
    this._cleanupFrame = cleanupFrame;
    this._frame = window.document.createElement('iframe');
    this._frame.src = src;
    this._frame.style.visibility = 'hidden';
    this._frame.style.position = 'absolute';
    this._frame.style.display = 'none';
    this._frame.style.width = 0;
    this._frame.style.height = 0;
    window.document.body.appendChild(this._frame);
    this._listening = false;
  }

  _createClass(IframeWindow, [{
    key: "postMessage",
    value: function postMessage(message, targetOrigin) {
      if (this._frame) {
        this._frame.contentWindow.postMessage(message, targetOrigin);
      }
    }
  }, {
    key: "listen",
    value: function () {
      var _listen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._listening) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._promise);

              case 2:
                if (this._frame) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Cannot listen message after frame unmounted');

              case 4:
                this._listening = true;
                this._promise = new Promise(function (resolve, reject) {
                  _this._resolve = resolve;
                  _this._reject = reject;
                });
                this._boundMessageEvent = this._onMessage.bind(this);
                window.addEventListener('message', this._boundMessageEvent, false);
                this._timer = window.setTimeout(function () {
                  _this._error(new Error('Frame window timed out'));
                }, _constants.DEFAULT_IFRAME_MESSAGE_TIMEOUT * 1000);
                return _context.abrupt("return", this._promise);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listen() {
        return _listen.apply(this, arguments);
      }

      return listen;
    }()
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      this._listening = false;
      window.removeEventListener('message', this._boundMessageEvent, false);
      window.clearTimeout(this._timer);

      if (this._cleanupFrame && this._frame) {
        window.document.body.removeChild(this._frame);
        this._frame = null;
        this._callback = null;
      }

      this._timer = null;
    }
  }, {
    key: "_success",
    value: function _success(data) {
      this._cleanup();

      this._resolve(data);
    }
  }, {
    key: "_error",
    value: function _error(err) {
      this._cleanup();

      this._reject(err);
    }
  }, {
    key: "_onMessage",
    value: function () {
      var _onMessage2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this._callback(e);

              case 3:
                data = _context2.sent;

                if (!(data !== undefined)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", this._success(data));

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", this._error(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function _onMessage(_x) {
        return _onMessage2.apply(this, arguments);
      }

      return _onMessage;
    }()
  }, {
    key: "frame",
    get: function get() {
      return this._frame;
    }
  }]);

  return IframeWindow;
}();

exports["default"] = IframeWindow;

/***/ }),

/***/ 31541:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _utils = __webpack_require__(63266);

var _clientOauth = _interopRequireDefault(__webpack_require__(43879));

var _jwtDecode = _interopRequireDefault(__webpack_require__(11260));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OidcClient = /*#__PURE__*/function () {
  function OidcClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        clientId = _ref.clientId,
        authorizationUri = _ref.authorizationUri,
        accessTokenUri = _ref.accessTokenUri,
        refreshTokenUri = _ref.refreshTokenUri,
        logoutUri = _ref.logoutUri,
        userInfoUri = _ref.userInfoUri,
        checkSessionUri = _ref.checkSessionUri,
        redirectUri = _ref.redirectUri,
        postLogoutRedirectUri = _ref.postLogoutRedirectUri,
        scopes = _ref.scopes;

    _classCallCheck(this, OidcClient);

    this._client = new _clientOauth["default"]({
      clientId: clientId,
      authorizationUri: authorizationUri,
      accessTokenUri: accessTokenUri,
      redirectUri: redirectUri,
      scopes: scopes
    });
    this._refreshTokenUri = refreshTokenUri;
    this._logoutUri = logoutUri;
    this._userInfoUri = userInfoUri;
    this._checkSessionUri = checkSessionUri;
    this._redirectUri = redirectUri;
    this._postLogoutRedirectUri = postLogoutRedirectUri;
    this._scopes = scopes;
  }

  _createClass(OidcClient, [{
    key: "getAuthorizeUri",
    value: function getAuthorizeUri(inputUri, extraQueryParams) {
      var redirectUri = inputUri || this._redirectUri;
      var state = (0, _utils.randomString)(16);
      var nonce = (0, _utils.randomString)(16);
      var codeVerifier = (0, _utils.randomString)(48);
      var codeChallenge = (0, _utils.createS256CodeChallenge)(codeVerifier);

      var authorizeUri = this._client.code.getUri({
        redirectUri: redirectUri,
        query: _objectSpread({
          code_challenge: codeChallenge,
          code_challenge_method: 'S256',
          state: state,
          nonce: nonce
        }, extraQueryParams)
      });

      var stateInfo = {
        state: state,
        nonce: nonce,
        codeVerifier: codeVerifier,
        redirectUri: redirectUri,
        createdAt: (0, _utils.currentTimestamp)()
      };
      return [authorizeUri, stateInfo];
    }
  }, {
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(authorizeUri) {
        var stateInfo,
            extraOptions,
            state,
            nonce,
            codeVerifier,
            _stateInfo$redirectUr,
            redirectUri,
            newRedirectUri,
            newAuthorizeUri,
            buildAuthUri,
            sessionState,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                stateInfo = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                extraOptions = _args.length > 2 ? _args[2] : undefined;
                state = stateInfo.state, nonce = stateInfo.nonce, codeVerifier = stateInfo.codeVerifier, _stateInfo$redirectUr = stateInfo.redirectUri, redirectUri = _stateInfo$redirectUr === void 0 ? this._redirectUri : _stateInfo$redirectUr;
                newRedirectUri = (0, _utils.removeTrailingSlash)(redirectUri);
                newAuthorizeUri = (0, _utils.removeTrailingSlash)(authorizeUri);
                buildAuthUri = new URL(newAuthorizeUri);
                sessionState = buildAuthUri.searchParams.get('session_state');
                return _context.abrupt("return", this._client.code.getToken(newAuthorizeUri, _objectSpread({
                  state: state,
                  redirectUri: newRedirectUri,
                  body: {
                    code_verifier: codeVerifier
                  }
                }, extraOptions)).then(function (res) {
                  return res.data;
                }).then(this._handleTokenResponse).then(function (authData) {
                  var profile = authData.profile;

                  if (profile && profile.nonce !== nonce) {
                    throw new Error("Invalid nonce: ".concat(nonce));
                  }

                  return _objectSpread({}, authData, {}, sessionState && {
                    sessionState: sessionState
                  });
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getToken(_x) {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "refreshToken",
    value: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", fetch(this._refreshTokenUri, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    scopes: this._scopes.join(' ')
                  }),
                  credentials: 'include'
                }).then(function (res) {
                  return res.json();
                }).then(this._handleTokenResponse));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: "_handleTokenResponse",
    value: function _handleTokenResponse(tokenRes) {
      var accessToken = tokenRes.access_token,
          idToken = tokenRes.id_token,
          expiresIn = tokenRes.expires_in,
          tokenType = tokenRes.token_type,
          scopes = tokenRes.scope;
      var profile = null;

      if (idToken) {
        try {
          profile = (0, _jwtDecode["default"])(idToken);
          var filterClaims = ['at_hash', 'aud', 'exp', 'iat', 'iss', 'sid', 'auth_time'];
          profile = Object.keys(profile).filter(function (claim) {
            return !filterClaims.includes(claim);
          }).reduce(function (obj, key) {
            return _objectSpread({}, obj, _defineProperty({}, key, profile[key]));
          }, {});
        } catch (err) {
          throw new Error("Failed to parse idToken: ".concat(err.message));
        }
      }

      return _objectSpread({
        tokenType: tokenType,
        accessToken: accessToken
      }, idToken && {
        idToken: idToken
      }, {}, profile && {
        profile: profile
      }, {
        expiresIn: expiresIn,
        expiresAt: (0, _utils.currentTimestamp)() + expiresIn,
        scopes: (scopes || '').split(' ').filter(function (item) {
          return !!item;
        })
      });
    }
  }, {
    key: "getUserInfoUri",
    value: function getUserInfoUri(extraQueryParams) {
      var uri = new URL(this._userInfoUri);

      for (var key in extraQueryParams) {
        uri.searchParams.set(key, extraQueryParams[key]);
      }

      return uri.href;
    }
  }, {
    key: "getLogoutUri",
    value: function getLogoutUri(inputUri, extraQueryParams) {
      var postLogoutRedirectUri = inputUri || this._postLogoutRedirectUri;
      var uri = new URL(this._logoutUri);
      extraQueryParams = _objectSpread({}, extraQueryParams, {
        post_logout_redirect_uri: postLogoutRedirectUri
      });

      for (var key in extraQueryParams) {
        uri.searchParams.set(key, extraQueryParams[key]);
      }

      return uri.href;
    }
  }]);

  return OidcClient;
}();

exports["default"] = OidcClient;

/***/ }),

/***/ 28105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _constants = __webpack_require__(1281);

var _utils = __webpack_require__(63266);

var _Timer = _interopRequireDefault(__webpack_require__(41166));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SilentRenewService = /*#__PURE__*/function () {
  function SilentRenewService(userManager) {
    var noticeDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_ACCESS_TOKEN_EXPIRE_NOTICE_TIME;
    var renewDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_RENEW_TOKEN_DELAY;

    _classCallCheck(this, SilentRenewService);

    this._userManager = userManager;
    this._tokenExpiringTimer = new _Timer["default"]('Access token expiring', this._renewToken.bind(this));
    this._tokenExpiredTimer = new _Timer["default"]('Access token expired', this._tokenExpired.bind(this));
    this._noticeDelay = noticeDelay;
    this._renewDelay = renewDelay;
  }

  _createClass(SilentRenewService, [{
    key: "load",
    value: function load(userData) {
      var accessToken = userData.accessToken,
          expiresAt = userData.expiresAt;

      if (accessToken && expiresAt) {
        var duration = expiresAt - (0, _utils.currentTimestamp)();

        this._tokenExpiringTimer.init((duration - this._noticeDelay) * 1000);

        this._tokenExpiredTimer.init(duration * 1000);
      } else {
        this._tokenExpiringTimer.cancel();

        this._tokenExpiredTimer.cancel();
      }
    }
  }, {
    key: "_renewToken",
    value: function _renewToken() {
      var _this = this;

      setTimeout(function () {
        _this._userManager.loginSilent()["catch"](function (err) {
          _this._userManager.events._raiseSilentRenewError(err);
        });
      }, this._renewDelay);

      this._userManager.events._raiseAccessTokenExpiring();
    }
  }, {
    key: "_tokenExpired",
    value: function _tokenExpired() {
      this._userManager.events._raiseAccessTokenExpired();
    }
  }]);

  return SilentRenewService;
}();

exports["default"] = SilentRenewService;

/***/ }),

/***/ 70780:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Storage = /*#__PURE__*/function () {
  function Storage() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === void 0 ? 'tekoid.' : _ref$prefix,
        _ref$store = _ref.store,
        store = _ref$store === void 0 ? sessionStorage : _ref$store;

    _classCallCheck(this, Storage);

    this._store = store;
    this._prefix = prefix;
  }

  _createClass(Storage, [{
    key: "set",
    value: function set(key, value) {
      key = this._prefix + key;
      value = JSON.stringify(value);

      this._store.setItem(key, value);
    }
  }, {
    key: "get",
    value: function get(key) {
      key = this._prefix + key;

      var value = this._store.getItem(key);

      return JSON.parse(value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      key = this._prefix + key;

      var item = this._store.getItem(key);

      this._store.removeItem(key);

      return item;
    }
  }, {
    key: "getAllKeys",
    value: function getAllKeys() {
      var keys = [];

      for (var index = 0; index < this._store.length; index++) {
        var key = this._store.key(index);

        if (key.indexOf(this._prefix) === 0) {
          keys.push(key.substr(this._prefix.length));
        }
      }

      return keys;
    }
  }]);

  return Storage;
}();

exports["default"] = Storage;

/***/ }),

/***/ 41166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(82515);

var _constants = __webpack_require__(1281);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// A count down timer (like setTimeout),
// using interval check to fix limitation of setTimeout
// when computer goes to sleep.
var Timer = /*#__PURE__*/function () {
  function Timer(name, callback) {
    var frequency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_TIMER_CHECK_FREQUENCY;

    _classCallCheck(this, Timer);

    this._name = name;
    this._callback = callback;
    this._frequency = frequency;
    this._timer = null;
    this._expiration = null;
  }

  _createClass(Timer, [{
    key: "init",
    value: function init(duration) {
      this.cancel();
      if (!duration) duration = this._frequency;
      duration = parseInt(Math.max(duration, 0));
      this._expiration = Date.now() + duration;
      var checkFrequency = Math.min(duration, this._frequency);
      this._timer = setInterval(this._checkFire.bind(this), checkFrequency);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }
  }, {
    key: "_checkFire",
    value: function _checkFire() {
      var diff = this._expiration - Date.now();

      if (diff <= 0) {
        this.cancel();

        this._callback();
      }
    }
  }]);

  return Timer;
}();

exports["default"] = Timer;

/***/ }),

/***/ 84712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _constants = __webpack_require__(1281);

var _utils = __webpack_require__(63266);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var User = /*#__PURE__*/function () {
  function User(options) {
    _classCallCheck(this, User);

    options = options || {};
    var _options = options,
        idToken = _options.idToken,
        accessToken = _options.accessToken,
        tokenType = _options.tokenType,
        scopes = _options.scopes,
        profile = _options.profile,
        expiresIn = _options.expiresIn,
        expiresAt = _options.expiresAt,
        sessionState = _options.sessionState;
    this.idToken = idToken;
    this.accessToken = accessToken;
    this.tokenType = tokenType;
    this.scopes = scopes;
    this.profile = profile;
    this.expiresIn = expiresIn;
    this.expiresAt = expiresAt;
    this.sessionState = sessionState;
  }

  _createClass(User, [{
    key: "expired",
    get: function get() {
      if (!this.accessToken) return true;
      if (!this.expiresAt) return true;
      return (0, _utils.isExpired)(this.expiresAt, _constants.DEFAULT_CLOCK_SKEW);
    }
  }]);

  return User;
}();

exports["default"] = User;

/***/ }),

/***/ 9932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _Event = _interopRequireDefault(__webpack_require__(35980));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserEvents = /*#__PURE__*/function () {
  function UserEvents() {
    _classCallCheck(this, UserEvents);

    this._userLoaded = new _Event["default"]('User loaded');
    this._userSessionChanged = new _Event["default"]('User session changed');
    this._userSessionIdChanged = new _Event["default"]('User session changed or user logged in at another location');
    this._silentRenewError = new _Event["default"]('Silent renew error');
    this._accessTokenExpiring = new _Event["default"]('Access token expiring');
    this._accessTokenExpired = new _Event["default"]('Access token expired');
  }

  _createClass(UserEvents, [{
    key: "addUserLoaded",
    value: function addUserLoaded(cb) {
      this._userLoaded.addHandler(cb);
    }
  }, {
    key: "removeUserLoaded",
    value: function removeUserLoaded(cb) {
      this._userLoaded.removeHandler(cb);
    }
  }, {
    key: "_raiseUserLoaded",
    value: function _raiseUserLoaded() {
      this._userLoaded.raise();
    }
  }, {
    key: "addUserSessionChanged",
    value: function addUserSessionChanged(cb) {
      this._userSessionChanged.addHandler(cb);
    }
  }, {
    key: "addUserSessionIdChanged",
    value: function addUserSessionIdChanged(cb) {
      this._userSessionIdChanged.addHandler(cb);
    }
  }, {
    key: "removeUserSessionChanged",
    value: function removeUserSessionChanged(cb) {
      this._userSessionChanged.removeHandler(cb);
    }
  }, {
    key: "removeUserSessionIdChanged",
    value: function removeUserSessionIdChanged(cb) {
      this._userSessionIdChanged.removeHandler(cb);
    }
  }, {
    key: "_raiseUserSessionChanged",
    value: function _raiseUserSessionChanged() {
      this._userSessionChanged.raise();
    }
  }, {
    key: "_raiseUserSessionIdChanged",
    value: function _raiseUserSessionIdChanged() {
      this._userSessionIdChanged.raise();
    }
  }, {
    key: "addSilentRenewError",
    value: function addSilentRenewError(cb) {
      this._silentRenewError.addHandler(cb);
    }
  }, {
    key: "removeSilentRenewError",
    value: function removeSilentRenewError(cb) {
      this._silentRenewError.removeHandler(cb);
    }
  }, {
    key: "_raiseSilentRenewError",
    value: function _raiseSilentRenewError(err) {
      this._silentRenewError.raise(err);
    }
  }, {
    key: "addAccessTokenExpiring",
    value: function addAccessTokenExpiring(cb) {
      this._accessTokenExpiring.addHandler(cb);
    }
  }, {
    key: "removeAccessTokenExpiring",
    value: function removeAccessTokenExpiring(cb) {
      this._accessTokenExpiring.removeHandler(cb);
    }
  }, {
    key: "_raiseAccessTokenExpiring",
    value: function _raiseAccessTokenExpiring() {
      this._accessTokenExpiring.raise();
    }
  }, {
    key: "addAccessTokenExpired",
    value: function addAccessTokenExpired(cb) {
      this._accessTokenExpired.addHandler(cb);
    }
  }, {
    key: "removeAccessTokenExpired",
    value: function removeAccessTokenExpired(cb) {
      this._accessTokenExpired.removeHandler(cb);
    }
  }, {
    key: "_raiseAccessTokenExpired",
    value: function _raiseAccessTokenExpired() {
      this._accessTokenExpired.raise();
    }
  }]);

  return UserEvents;
}();

exports["default"] = UserEvents;

/***/ }),

/***/ 30614:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(37022);

__webpack_require__(82515);

var _CheckSessionIdService = _interopRequireDefault(__webpack_require__(7560));

var _CheckSessionServiceBFF = _interopRequireDefault(__webpack_require__(75117));

var _utils = __webpack_require__(63266);

var _constants = __webpack_require__(1281);

var _CheckSessionServiceIframe = _interopRequireDefault(__webpack_require__(4288));

var _IframeWindow = _interopRequireDefault(__webpack_require__(86534));

var _OidcClient = _interopRequireDefault(__webpack_require__(31541));

var _SilentRenewService = _interopRequireDefault(__webpack_require__(28105));

var _Storage = _interopRequireDefault(__webpack_require__(70780));

var _User = _interopRequireDefault(__webpack_require__(84712));

var _UserEvents = _interopRequireDefault(__webpack_require__(9932));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserManager = /*#__PURE__*/function () {
  function UserManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        clientId = _ref.clientId,
        _ref$oauthDomain = _ref.oauthDomain,
        oauthDomain = _ref$oauthDomain === void 0 ? _constants.DEFAULT_OAUTH_DOMAIN : _ref$oauthDomain,
        _ref$authorizationEnd = _ref.authorizationEndpoint,
        authorizationEndpoint = _ref$authorizationEnd === void 0 ? _constants.DEFAULT_AUTHORIZATION_ENDPOINT : _ref$authorizationEnd,
        _ref$tokenEndpoint = _ref.tokenEndpoint,
        tokenEndpoint = _ref$tokenEndpoint === void 0 ? _constants.DEFAULT_TOKEN_ENDPOINT : _ref$tokenEndpoint,
        _ref$refreshTokenEndp = _ref.refreshTokenEndpoint,
        refreshTokenEndpoint = _ref$refreshTokenEndp === void 0 ? _constants.DEFAULT_REFRESH_TOKEN_ENDPOINT : _ref$refreshTokenEndp,
        _ref$userInfoEndpoint = _ref.userInfoEndpoint,
        userInfoEndpoint = _ref$userInfoEndpoint === void 0 ? _constants.DEFAULT_USERINFO_ENDPOINT : _ref$userInfoEndpoint,
        _ref$logoutEndpoint = _ref.logoutEndpoint,
        logoutEndpoint = _ref$logoutEndpoint === void 0 ? _constants.DEFAULT_LOGOUT_ENDPOINT : _ref$logoutEndpoint,
        _ref$checkSessionEndp = _ref.checkSessionEndpoint,
        checkSessionEndpoint = _ref$checkSessionEndp === void 0 ? _constants.DEFAULT_CHECK_SESSION_ENDPOINT : _ref$checkSessionEndp,
        _ref$checkSessionIdEn = _ref.checkSessionIdEndpoint,
        checkSessionIdEndpoint = _ref$checkSessionIdEn === void 0 ? _constants.DEFAULT_CHECK_SESSION_ID_ENDPOINT : _ref$checkSessionIdEn,
        _ref$redirectUri = _ref.redirectUri,
        redirectUri = _ref$redirectUri === void 0 ? (0, _utils.currentLocation)() : _ref$redirectUri,
        _ref$postLogoutRedire = _ref.postLogoutRedirectUri,
        postLogoutRedirectUri = _ref$postLogoutRedire === void 0 ? (0, _utils.currentLocation)() : _ref$postLogoutRedire,
        _ref$scopes = _ref.scopes,
        scopes = _ref$scopes === void 0 ? [] : _ref$scopes,
        _ref$monitorSession = _ref.monitorSession,
        monitorSession = _ref$monitorSession === void 0 ? false : _ref$monitorSession,
        _ref$monitorSessionMe = _ref.monitorSessionMethod,
        monitorSessionMethod = _ref$monitorSessionMe === void 0 ? _constants.DEFAULT_CHECK_SESSION_METHOD : _ref$monitorSessionMe,
        _ref$silent = _ref.silent,
        silent = _ref$silent === void 0 ? true : _ref$silent,
        _ref$checkTokenRevoke = _ref.checkTokenRevoked,
        checkTokenRevoked = _ref$checkTokenRevoke === void 0 ? false : _ref$checkTokenRevoke,
        _ref$bffDomain = _ref.bffDomain,
        bffDomain = _ref$bffDomain === void 0 ? null : _ref$bffDomain;

    _classCallCheck(this, UserManager);

    if (!clientId) throw new Error('Missing required field `clientId`');
    this._clientId = clientId;
    this._oauthDomain = oauthDomain;
    this._redirectUri = redirectUri;
    this._monitorSession = monitorSession;
    this._monitorSessionMethod = monitorSessionMethod;
    this._silent = !!silent;
    this._checkTokenRevoked = !!checkTokenRevoked;
    this._useBFF = !!bffDomain;
    this._bffDomain = bffDomain;
    var parsedScopes = typeof scopes === 'string' ? scopes.split(' ') : scopes;
    this._scopes = parsedScopes;
    this._oidc = new _OidcClient["default"]({
      clientId: clientId,
      authorizationUri: oauthDomain + authorizationEndpoint,
      accessTokenUri: oauthDomain + tokenEndpoint,
      refreshTokenUri: (bffDomain || oauthDomain) + refreshTokenEndpoint,
      logoutUri: oauthDomain + logoutEndpoint,
      userInfoUri: oauthDomain + userInfoEndpoint,
      checkSessionUri: oauthDomain + checkSessionEndpoint,
      redirectUri: redirectUri,
      postLogoutRedirectUri: postLogoutRedirectUri,
      scopes: parsedScopes
    });
    this._stateStore = new _Storage["default"]({
      prefix: 'tekoid.state.',
      store: sessionStorage
    });
    this._userStore = new _Storage["default"]({
      store: localStorage
    });
    this._userStoreKey = "user.".concat(clientId);
    this._userData = this._userStore.get(this._userStoreKey);
    this._events = new _UserEvents["default"]();
    this._silentRenewService = new _SilentRenewService["default"](this);

    if (this._monitorSession) {
      if (this._useBFF) {
        this._monitorSessionMethod = 'bff';
      }

      if (this._monitorSessionMethod === 'bff') {
        this._checkSessionService = new _CheckSessionServiceBFF["default"](this, this._bffDomain + _constants.DEFAULT_CHECK_SESSION_BFF_ENDPOINT);
      } else if (this._monitorSessionMethod === 'sessionId') {
        this._checkSessionService = new _CheckSessionIdService["default"](this, oauthDomain + checkSessionIdEndpoint);
      } else {
        this._checkSessionService = new _CheckSessionServiceIframe["default"](this);
      }
    }

    if (this.isLoggedIn() && this._silent) {
      var user = this.loadUser();

      this._silentRenewService.load(user);
    }
  }

  _createClass(UserManager, [{
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var user = this.loadUser();
      if (user.expired) return false;
      return true;
    }
  }, {
    key: "login",
    value: function login() {
      var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var additionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _this$_oidc$getAuthor = this._oidc.getAuthorizeUri(redirectUri, additionalParams),
          _this$_oidc$getAuthor2 = _slicedToArray(_this$_oidc$getAuthor, 2),
          loginUri = _this$_oidc$getAuthor2[0],
          stateInfo = _this$_oidc$getAuthor2[1];

      this._stateStore.set(stateInfo.state, stateInfo);

      window.location.assign(loginUri);
    }
  }, {
    key: "loginCallback",
    value: function () {
      var _loginCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(inputAuthUri) {
        var uri, authUri, state, code, stateInfo, codeVerifier, _stateInfo$redirectUr, redirectUri, newRedirectUri, newBFFDomain, userData, _userData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uri = inputAuthUri || window.location.href;
                authUri = new URL(uri);
                state = authUri.searchParams.get('state');
                code = authUri.searchParams.get('code');
                stateInfo = this._stateStore.get(state);

                if (!this._useBFF) {
                  _context.next = 15;
                  break;
                }

                // TODO: Move to OidcClient
                codeVerifier = stateInfo.codeVerifier, _stateInfo$redirectUr = stateInfo.redirectUri, redirectUri = _stateInfo$redirectUr === void 0 ? this._redirectUri : _stateInfo$redirectUr;
                newRedirectUri = (0, _utils.removeTrailingSlash)(redirectUri);
                newBFFDomain = (0, _utils.removeTrailingSlash)(this._bffDomain + _constants.DEFAULT_TOKEN_ENDPOINT);
                _context.next = 11;
                return fetch(newBFFDomain, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    code: code,
                    code_verifier: codeVerifier,
                    redirect_uri: newRedirectUri,
                    client_id: this._clientId
                  }),
                  credentials: 'include'
                }).then(function (res) {
                  return res.json();
                }).then(this._oidc._handleTokenResponse);

              case 11:
                userData = _context.sent;
                return _context.abrupt("return", this._postHandleUserData(userData));

              case 15:
                _context.next = 17;
                return this._oidc.getToken(authUri.href, stateInfo);

              case 17:
                _userData = _context.sent;
                return _context.abrupt("return", this._postHandleUserData(_userData));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginCallback(_x) {
        return _loginCallback.apply(this, arguments);
      }

      return loginCallback;
    }()
  }, {
    key: "loginSilent",
    value: function () {
      var _loginSilent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._useBFF) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return this._refreshTokenByBFF();

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return this._refreshTokenByIframe();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loginSilent() {
        return _loginSilent.apply(this, arguments);
      }

      return loginSilent;
    }()
  }, {
    key: "_refreshTokenByIframe",
    value: function () {
      var _refreshTokenByIframe2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var _this$_oidc$getAuthor3, _this$_oidc$getAuthor4, silentLoginUri, stateInfo, messageCallback, iframeWindow, authResponse, code, state, sessionState, authUri, userData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$_oidc$getAuthor3 = this._oidc.getAuthorizeUri(null, {
                  prompt: 'none',
                  response_mode: 'simple_web_message'
                }), _this$_oidc$getAuthor4 = _slicedToArray(_this$_oidc$getAuthor3, 2), silentLoginUri = _this$_oidc$getAuthor4[0], stateInfo = _this$_oidc$getAuthor4[1];

                messageCallback = function messageCallback(e) {
                  if (e.origin !== _this._oauthDomain || e.source !== iframeWindow.frame.contentWindow) {
                    return Promise.resolve();
                  }

                  var _e$data = e.data,
                      type = _e$data.type,
                      response = _e$data.response;

                  if (!response || type !== 'authorization_response') {
                    return Promise.resolve();
                  }

                  e.source.close();

                  if (response.hasOwnProperty('error')) {
                    var error = response.error;
                    var errorDescription = response.error_description || '';
                    return Promise.reject(new Error("Silent exchange error: ".concat(error, " ").concat(errorDescription)));
                  } else if (response.hasOwnProperty('code') && response.hasOwnProperty('state')) {
                    return Promise.resolve(response);
                  }
                };

                iframeWindow = new _IframeWindow["default"]({
                  src: silentLoginUri,
                  origin: this._oauthDomain,
                  callback: messageCallback
                });
                _context3.next = 5;
                return iframeWindow.listen();

              case 5:
                authResponse = _context3.sent;
                code = authResponse.code, state = authResponse.state, sessionState = authResponse.session_state;
                authUri = new URL(this._redirectUri);
                authUri.searchParams.set('code', code);
                authUri.searchParams.set('state', state);
                sessionState && authUri.searchParams.set('session_state', sessionState);
                _context3.next = 13;
                return this._oidc.getToken(authUri.href, stateInfo);

              case 13:
                userData = _context3.sent;
                return _context3.abrupt("return", this._postHandleUserData(userData));

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _refreshTokenByIframe() {
        return _refreshTokenByIframe2.apply(this, arguments);
      }

      return _refreshTokenByIframe;
    }()
  }, {
    key: "_refreshTokenByBFF",
    value: function () {
      var _refreshTokenByBFF2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userData, _window$location, href, search, url;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._oidc.refreshToken();

              case 2:
                userData = _context4.sent;

                if (!userData.accessToken) {
                  _window$location = window.location, href = _window$location.href, search = _window$location.search;
                  url = new URL(href);

                  if (search.includes('error') && url.searchParams.get('error') === 'login_required') {
                    url.searchParams["delete"]('error');
                    window.history.replaceState(null, document.title, url.href);
                  } else {
                    this.login(null, {
                      prompt: 'none'
                    });
                  }
                }

                return _context4.abrupt("return", this._postHandleUserData(userData));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _refreshTokenByBFF() {
        return _refreshTokenByBFF2.apply(this, arguments);
      }

      return _refreshTokenByBFF;
    }()
  }, {
    key: "_postHandleUserData",
    value: function _postHandleUserData(userData) {
      this._userStore.set(this._userStoreKey, userData);

      this._userData = userData;

      this._events._raiseUserLoaded();

      this._silent && this._silentRenewService.load(userData);
      return new _User["default"](userData);
    }
  }, {
    key: "logout",
    value: function logout() {
      var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var additionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var user = this.loadUser();

      if (!user.idToken) {
        throw new Error('User already logout');
      }

      var logoutUri = this._oidc.getLogoutUri(redirectUri, _objectSpread({
        id_token_hint: user.idToken
      }, additionalParams));

      this.unloadUser();
      if (!user.expired) window.location.assign(logoutUri);
    }
  }, {
    key: "loadUser",
    value: function loadUser() {
      var userData = this._userStore.get(this._userStoreKey);

      var userDataFromMem = this._userData;

      if (userData) {
        return new _User["default"](userData);
      } else {
        return new _User["default"](userDataFromMem);
      }
    }
  }, {
    key: "unloadUser",
    value: function unloadUser() {
      this._userStore.remove(this._userStoreKey);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var user = this.loadUser();
      if (user.expired) return undefined;
      return user.profile;
    }
  }, {
    key: "getFullUserInfo",
    value: function () {
      var _getFullUserInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var adminDomain,
            getUserPermissionsUri,
            accessToken,
            userInfoUri,
            userInfoReq,
            userPermissionsUri,
            userPermissionsReq,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                adminDomain = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;

                getUserPermissionsUri = function getUserPermissionsUri(oauthDomain) {
                  if (adminDomain) {
                    return adminDomain;
                  }

                  console.warn("Calling getFullUserInfo() without specific `adminDomain` may lead to incorrect data. Please use with caution.");
                  var _adminDomain = 'https://id-admin.tekoapis.com';

                  if (oauthDomain.includes('.test-1')) {
                    _adminDomain = 'https://id-admin.test-1.tekoapis.net';
                  } else if (oauthDomain.includes('.dev')) {
                    _adminDomain = 'https://id-admin.develop.tekoapis.net';
                  } else if (oauthDomain.includes('.stag')) {
                    _adminDomain = 'https://id-admin.stage.tekoapis.net';
                  }

                  return "".concat(_adminDomain, "/api/v1.0/users/me/roles_permissions");
                };

                accessToken = this.getAccessToken();

                if (accessToken) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", undefined);

              case 5:
                userInfoUri = this._oidc.getUserInfoUri();
                userInfoReq = fetch(userInfoUri, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken
                  }
                }).then(function (res) {
                  return res.json();
                });
                userPermissionsUri = getUserPermissionsUri(this._oauthDomain);

                userPermissionsReq = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                    var scopes;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            scopes = _this2.getUserScopes();

                            if (!(!scopes || !scopes.includes('read:permissions'))) {
                              _context5.next = 3;
                              break;
                            }

                            return _context5.abrupt("return", Promise.resolve({}));

                          case 3:
                            return _context5.abrupt("return", fetch(userPermissionsUri, {
                              headers: {
                                Authorization: 'Bearer ' + accessToken
                              }
                            }).then(function (res) {
                              if (res.status === 200) return res.json();
                              return {};
                            }));

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function userPermissionsReq() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                return _context6.abrupt("return", Promise.all([userInfoReq, userPermissionsReq()]).then(function (values) {
                  var _values = _slicedToArray(values, 2),
                      userInfoRes = _values[0],
                      userPermissionsRes = _values[1];

                  return _objectSpread({}, userInfoRes, {}, userPermissionsRes);
                }));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFullUserInfo() {
        return _getFullUserInfo.apply(this, arguments);
      }

      return getFullUserInfo;
    }()
  }, {
    key: "getUserScopes",
    value: function getUserScopes() {
      var user = this.loadUser();
      if (user.expired) return undefined;
      return user.scopes;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var user = this.loadUser();
      if (user.expired) return undefined;
      return user.accessToken;
    }
  }, {
    key: "getAccessTokenExpiredAt",
    value: function getAccessTokenExpiredAt() {
      var user = this.loadUser();
      if (user.expired) return undefined;
      return user.expiresAt;
    }
  }, {
    key: "events",
    get: function get() {
      return this._events;
    }
  }]);

  return UserManager;
}();

exports["default"] = UserManager;

/***/ }),

/***/ 1281:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DEFAULT_CHECK_SESSION_FREQUENCY = exports.DEFAULT_TIMER_CHECK_FREQUENCY = exports.DEFAULT_RENEW_TOKEN_DELAY = exports.DEFAULT_IFRAME_MESSAGE_TIMEOUT = exports.DEFAULT_ACCESS_TOKEN_EXPIRE_NOTICE_TIME = exports.DEFAULT_CLOCK_SKEW = exports.DEFAULT_CHECK_SESSION_METHOD = exports.DEFAULT_CHECK_SESSION_BFF_ENDPOINT = exports.DEFAULT_CHECK_SESSION_ID_ENDPOINT = exports.DEFAULT_CHECK_SESSION_ENDPOINT = exports.DEFAULT_USERINFO_ENDPOINT = exports.DEFAULT_LOGOUT_ENDPOINT = exports.DEFAULT_REFRESH_TOKEN_ENDPOINT = exports.DEFAULT_TOKEN_ENDPOINT = exports.DEFAULT_AUTHORIZATION_ENDPOINT = exports.DEFAULT_OAUTH_DOMAIN = void 0;
// Default Teko OAuth information
var DEFAULT_OAUTH_DOMAIN = 'https://oauth.teko.vn';
exports.DEFAULT_OAUTH_DOMAIN = DEFAULT_OAUTH_DOMAIN;
var DEFAULT_AUTHORIZATION_ENDPOINT = '/oauth/authorize';
exports.DEFAULT_AUTHORIZATION_ENDPOINT = DEFAULT_AUTHORIZATION_ENDPOINT;
var DEFAULT_TOKEN_ENDPOINT = '/oauth/token';
exports.DEFAULT_TOKEN_ENDPOINT = DEFAULT_TOKEN_ENDPOINT;
var DEFAULT_REFRESH_TOKEN_ENDPOINT = '/oauth/refresh';
exports.DEFAULT_REFRESH_TOKEN_ENDPOINT = DEFAULT_REFRESH_TOKEN_ENDPOINT;
var DEFAULT_LOGOUT_ENDPOINT = '/oauth/logout';
exports.DEFAULT_LOGOUT_ENDPOINT = DEFAULT_LOGOUT_ENDPOINT;
var DEFAULT_USERINFO_ENDPOINT = '/userinfo';
exports.DEFAULT_USERINFO_ENDPOINT = DEFAULT_USERINFO_ENDPOINT;
var DEFAULT_CHECK_SESSION_ENDPOINT = '/oauth/sessions/iframe';
exports.DEFAULT_CHECK_SESSION_ENDPOINT = DEFAULT_CHECK_SESSION_ENDPOINT;
var DEFAULT_CHECK_SESSION_ID_ENDPOINT = '/oauth/sessions/info';
exports.DEFAULT_CHECK_SESSION_ID_ENDPOINT = DEFAULT_CHECK_SESSION_ID_ENDPOINT;
var DEFAULT_CHECK_SESSION_BFF_ENDPOINT = '/session/info';
exports.DEFAULT_CHECK_SESSION_BFF_ENDPOINT = DEFAULT_CHECK_SESSION_BFF_ENDPOINT;
var DEFAULT_CHECK_SESSION_METHOD = 'iframe'; // These values below are duration for calculate timestamp,
// often use when check if token expired.
// These values are declared in seconds.
// Leeway value for calculate expiration of tokens.

exports.DEFAULT_CHECK_SESSION_METHOD = DEFAULT_CHECK_SESSION_METHOD;
var DEFAULT_CLOCK_SKEW = 60; // Leeway value for renew access token.

exports.DEFAULT_CLOCK_SKEW = DEFAULT_CLOCK_SKEW;
var DEFAULT_ACCESS_TOKEN_EXPIRE_NOTICE_TIME = 300; // Timeout when silent exchange authorization code in iframe.

exports.DEFAULT_ACCESS_TOKEN_EXPIRE_NOTICE_TIME = DEFAULT_ACCESS_TOKEN_EXPIRE_NOTICE_TIME;
var DEFAULT_IFRAME_MESSAGE_TIMEOUT = 45; // These values are duration for timeout,
// often use in setTimeout or setInterval.
// These values are declare in milliseconds.
// Delay when silently renew token.
// Useful when browser wakes up from sleep,
// and not yet ready to resolve DNS.

exports.DEFAULT_IFRAME_MESSAGE_TIMEOUT = DEFAULT_IFRAME_MESSAGE_TIMEOUT;
var DEFAULT_RENEW_TOKEN_DELAY = 2500; // Default interval to check in Timer class.

exports.DEFAULT_RENEW_TOKEN_DELAY = DEFAULT_RENEW_TOKEN_DELAY;
var DEFAULT_TIMER_CHECK_FREQUENCY = 5000; // Default interval to check session in CheckSessionServiceIframe.

exports.DEFAULT_TIMER_CHECK_FREQUENCY = DEFAULT_TIMER_CHECK_FREQUENCY;
var DEFAULT_CHECK_SESSION_FREQUENCY = 10000;
exports.DEFAULT_CHECK_SESSION_FREQUENCY = DEFAULT_CHECK_SESSION_FREQUENCY;

/***/ }),

/***/ 31069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _UserManager = _interopRequireDefault(__webpack_require__(30614));

var _package = __webpack_require__(73342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var instance = {
  user: null,
  version: _package.version,
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(configs) {
      var userManager, accessToken, userInfoUri, _window$location, href, search, url, userScopes, requestScopes, _iterator, _step, requestScope;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              userManager = new _UserManager["default"](configs);
              instance.user = userManager;

              if (!(userManager._checkTokenRevoked && userManager.isLoggedIn() && userManager.getAccessToken())) {
                _context.next = 8;
                break;
              }

              // Introspect token to make sure the token is not revoked
              accessToken = userManager.getAccessToken();
              userInfoUri = userManager._oidc.getUserInfoUri();
              _context.next = 8;
              return fetch(userInfoUri, {
                headers: {
                  Authorization: 'Bearer ' + accessToken
                }
              }).then(function (res) {
                // In case the token is revoked
                if (res.status === 401) {
                  userManager.unloadUser();
                }
              });

            case 8:
              if (userManager.isLoggedIn()) {
                _context.next = 25;
                break;
              }

              _window$location = window.location, href = _window$location.href, search = _window$location.search;

              if (!(search.includes('code') && search.includes('state'))) {
                _context.next = 20;
                break;
              }

              _context.next = 13;
              return userManager.loginCallback();

            case 13:
              url = new URL(href);
              url.searchParams["delete"]('code');
              url.searchParams["delete"]('state');
              url.searchParams["delete"]('session_state');
              window.history.replaceState(null, document.title, url.href);
              _context.next = 23;
              break;

            case 20:
              if (!userManager._silent) {
                _context.next = 23;
                break;
              }

              _context.next = 23;
              return userManager.loginSilent();

            case 23:
              _context.next = 47;
              break;

            case 25:
              if (!userManager._silent) {
                _context.next = 47;
                break;
              }

              userScopes = userManager.getUserScopes();
              requestScopes = configs && configs.scopes || [];
              _iterator = _createForOfIteratorHelper(requestScopes);
              _context.prev = 29;

              _iterator.s();

            case 31:
              if ((_step = _iterator.n()).done) {
                _context.next = 39;
                break;
              }

              requestScope = _step.value;

              if (userScopes.includes(requestScope)) {
                _context.next = 37;
                break;
              }

              _context.next = 36;
              return userManager.loginSilent();

            case 36:
              return _context.abrupt("break", 39);

            case 37:
              _context.next = 31;
              break;

            case 39:
              _context.next = 44;
              break;

            case 41:
              _context.prev = 41;
              _context.t0 = _context["catch"](29);

              _iterator.e(_context.t0);

            case 44:
              _context.prev = 44;

              _iterator.f();

              return _context.finish(44);

            case 47:
              _context.next = 52;
              break;

            case 49:
              _context.prev = 49;
              _context.t1 = _context["catch"](0);
              console.warn(_context.t1);

            case 52:
              _context.prev = 52;
              Promise.resolve();
              return _context.finish(52);

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 49, 52, 55], [29, 41, 44, 47]]);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }()
}; // Add compatible support for import package on server side

if (typeof window !== 'undefined') {
  window.TekoID = instance;
}

var _default = instance;
exports.Z = _default;

/***/ }),

/***/ 63266:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.removeTrailingSlash = exports.currentLocation = exports.createS256CodeChallenge = exports.decodeToken = exports.isExpired = exports.currentTimestamp = exports.randomString = void 0;

var _encBase = _interopRequireDefault(__webpack_require__(98933));

var _sha = _interopRequireDefault(__webpack_require__(70085));

var _jwtDecode = _interopRequireDefault(__webpack_require__(11260));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line sort-imports
var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 48;
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._';

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

exports.randomString = randomString;

var currentTimestamp = function currentTimestamp() {
  return parseInt(Date.now() / 1000);
};

exports.currentTimestamp = currentTimestamp;

var isExpired = function isExpired(timestamp) {
  var leeway = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var now = currentTimestamp();
  return now > timestamp - leeway;
};

exports.isExpired = isExpired;

var decodeToken = function decodeToken(token) {
  return (0, _jwtDecode["default"])(token);
};

exports.decodeToken = decodeToken;

var createS256CodeChallenge = function createS256CodeChallenge(codeVerifier) {
  return _encBase["default"].stringify((0, _sha["default"])(codeVerifier)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

exports.createS256CodeChallenge = createS256CodeChallenge;

var currentLocation = function currentLocation() {
  var _window$location = window.location,
      href = _window$location.href,
      search = _window$location.search;
  var url = new URL(href);

  if (search.includes('error')) {
    url.searchParams["delete"]('error');
  }

  var location = removeTrailingSlash(url.href);
  return location;
};

exports.currentLocation = currentLocation;

var removeTrailingSlash = function removeTrailingSlash(string) {
  try {
    var url = new URL(string);
    var origin = url.origin,
        pathname = url.pathname,
        search = url.search;

    if (pathname.endsWith('/')) {
      return "".concat(origin).concat(pathname.substring(0, pathname.length - 1)).concat(search);
    }

    return url.href;
  } catch (err) {
    return string;
  }
};

exports.removeTrailingSlash = removeTrailingSlash;

/***/ }),

/***/ 99278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MS": function() { return /* reexport */ ApiError; },
  "ZP": function() { return /* reexport */ Api; }
});

// UNUSED EXPORTS: Api, fetchWithTimeout

;// CONCATENATED MODULE: ../../packages/api/dist/error.es.js
class ApiError {
  constructor(message, code, response) {
    this.message = message;
    this.response = response;
    this.code = code;
  }
  get reason() {
    return this.response;
  }
  get statusCode() {
    return this.code;
  }
  get extra() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.extra;
  }
  get error() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.error;
  }
}



;// CONCATENATED MODULE: ../../packages/api/dist/helpers.es.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function fetchWithTimeout(input, init, timeout) {
  init = init || {};
  if (!init.body) {
    init.body = null;
  }
  if (!timeout) {
    return fetch(input, init);
  }
  const controller = new AbortController();
  const fetcher = fetch(input, __spreadProps(__spreadValues({}, init), {
    signal: controller.signal
  }));
  const cancel = new Promise((resolve) => {
    setTimeout(() => {
      controller.abort();
      resolve("Request timeout");
    }, timeout);
  });
  return Promise.race([fetcher, cancel]);
}



;// CONCATENATED MODULE: ../../packages/api/dist/api.es.js





var api_es_defProp = Object.defineProperty;
var api_es_defProps = Object.defineProperties;
var api_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var api_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var api_es_hasOwnProp = Object.prototype.hasOwnProperty;
var api_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var api_es_defNormalProp = (obj, key, value) => key in obj ? api_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var api_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (api_es_hasOwnProp.call(b, prop))
      api_es_defNormalProp(a, prop, b[prop]);
  if (api_es_getOwnPropSymbols)
    for (var prop of api_es_getOwnPropSymbols(b)) {
      if (api_es_propIsEnum.call(b, prop))
        api_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var api_es_spreadProps = (a, b) => api_es_defProps(a, api_es_getOwnPropDescs(b));
const normalizeSlashUrl = (baseURL = "", url) => {
  const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
  const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBaseUrl}/${normalizedPath}`;
};
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.interceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.interceptors.push(interceptFn);
  }
  appendParamsToURL(url, params, flattenArray = false) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          const paramK = params[k];
          if (Array.isArray(paramK) && flattenArray) {
            const flattenArrayString = paramK.map((element) => `${k}=${encodeURIComponent(element)}`).join("&");
            paramsArr.push(flattenArrayString);
          } else {
            paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
          }
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}, flattenArray = false) {
    var _a, _b;
    const {
      headers: configHeaders,
      params: configParams,
      timeout: configTimeout
    } = config;
    let headers = api_es_spreadValues(api_es_spreadValues({}, this.defaultConfig.headers), configHeaders);
    const url = this.appendParamsToURL(path, configParams || {}, flattenArray);
    let serializedBody = null;
    if (body) {
      if (typeof body !== "string") {
        if ("append" in body) ; else {
          serializedBody = JSON.stringify(body);
          headers = api_es_spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      } else {
        serializedBody = body;
      }
    }
    const fetchUrl = url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url);
    const requestObj = api_es_spreadProps(api_es_spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: serializedBody
    });
    this.interceptors.forEach((fn) => fn(requestObj));
    try {
      const res = await fetchWithTimeout(fetchUrl, requestObj, configTimeout);
      if (res && typeof res !== "string") {
        if (res.status >= 400) {
          try {
            const resp = await res.json();
            const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(DEFAULT_ERROR_MESSAGE, res.status, resp);
            return Promise.reject(error);
          } catch (e) {
            const failedRes = {
              code: res.status,
              message: res.statusText
            };
            const error = ((_b = this.getError) == null ? void 0 : _b.call(this, failedRes)) || new ApiError(DEFAULT_ERROR_MESSAGE, res.status, failedRes);
            return Promise.reject(error);
          }
        }
        const respHeaders = {};
        res.headers.forEach((val, key) => respHeaders[key] = val);
        const data = await this._parseJson(res);
        return {
          code: res.status,
          data,
          headers: respHeaders
        };
      }
      return { code: -1, headers: {}, data: {} };
    } catch (e) {
      throw e;
    }
  }
  async get(url, config = {}, flattenArray = false) {
    return await this.request(url, null, "GET", config, flattenArray);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = null, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}



;// CONCATENATED MODULE: ../../packages/api/dist/index.es.js






/***/ }),

/***/ 47143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ accessTokenInterceptor; },
/* harmony export */   "h": function() { return /* binding */ getAccessToken; }
/* harmony export */ });
/* harmony import */ var _user_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99002);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const accessTokenInterceptor = (request) => {
  if (typeof window === "undefined")
    return;
  const accessToken = _user_es_js__WEBPACK_IMPORTED_MODULE_0__/* .userManager.getAccessToken */ .Z.getAccessToken();
  if (accessToken) {
    request.headers.set("Authorization", `Bearer ${accessToken}`);
  } else {
    const user = _user_es_js__WEBPACK_IMPORTED_MODULE_0__/* .userManager.loadUser */ .Z.loadUser();
    if (user == null ? void 0 : user.accessToken) {
      window.track("customEvent", "accessTokenExpired", {
        action: "accessTokenExpired",
        category: "customer",
        label: JSON.stringify(__spreadProps(__spreadValues({}, user), { accessToken: void 0 })),
        property: "tekoid-js"
      });
    }
  }
};
const getAccessToken = () => _user_es_js__WEBPACK_IMPORTED_MODULE_0__/* .userManager.getAccessToken */ .Z.getAccessToken();




/***/ }),

/***/ 99002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ userManager; }
/* harmony export */ });
const LOCALSTORAGE_ACCESS_TOKEN = "ACCESS_TOKEN";
const LOCALSTORAGE_REFRESH_TOKEN = "REFRESH_TOKEN";
const LOCALSTORAGE_USER_PHONE = "userPhone";
const LOCALSTORAGE_USER_ID = "userId";
const LOCALSTORAGE_USER_EMAIL = "userEmail";
const LOCALSTORAGE_SITE_ID = "siteId";
const LOCALSTORAGE_SELLER_ID = "sellerId";
const LOCALSTORAGE_BANK_CODE = "bankCode";
const getLSUserInfo = () => {
  return {
    accessToken: localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN) || void 0,
    userId: localStorage.getItem(LOCALSTORAGE_USER_ID) || "",
    phone: localStorage.getItem(LOCALSTORAGE_USER_PHONE) || void 0,
    bankCode: localStorage.getItem(LOCALSTORAGE_BANK_CODE) || void 0,
    refreshToken: localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN) || void 0,
    email: localStorage.getItem(LOCALSTORAGE_USER_EMAIL) || void 0,
    siteId: localStorage.getItem(LOCALSTORAGE_SITE_ID) || void 0,
    sellerId: localStorage.getItem(LOCALSTORAGE_SELLER_ID) || void 0
  };
};
const setLSUserInfo = (user) => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, user.accessToken || "");
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, user.refreshToken || "");
  localStorage.setItem(LOCALSTORAGE_BANK_CODE, user.bankCode || "");
  localStorage.setItem(LOCALSTORAGE_USER_PHONE, user.phone || "");
  localStorage.setItem(LOCALSTORAGE_USER_ID, user.userId);
  localStorage.setItem(LOCALSTORAGE_USER_EMAIL, user.email || "");
  localStorage.setItem(LOCALSTORAGE_SITE_ID, user.siteId || "");
  localStorage.setItem(LOCALSTORAGE_SELLER_ID, user.sellerId || "");
};
class UserManager {
  get tekoID() {
    return window.TekoID;
  }
  onPartnerLoggedIn(userInfo) {
    setLSUserInfo(userInfo);
  }
  onLoggedOut() {
    [
      LOCALSTORAGE_ACCESS_TOKEN,
      LOCALSTORAGE_REFRESH_TOKEN,
      LOCALSTORAGE_BANK_CODE,
      LOCALSTORAGE_USER_PHONE,
      LOCALSTORAGE_USER_ID,
      LOCALSTORAGE_USER_EMAIL,
      LOCALSTORAGE_SITE_ID,
      LOCALSTORAGE_SELLER_ID
    ].forEach((lsKey) => localStorage.removeItem(lsKey));
  }
  getAccessToken() {
    var _a, _b, _c, _d;
    let accessToken, isLoggedIn = false;
    accessToken = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.getAccessToken();
    if (!accessToken) {
      accessToken = localStorage == null ? void 0 : localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
      isLoggedIn = true;
    } else {
      isLoggedIn = !!((_d = (_c = this.tekoID) == null ? void 0 : _c.user) == null ? void 0 : _d.isLoggedIn());
    }
    if (accessToken && isLoggedIn)
      return accessToken;
  }
  getInfo() {
    if (this.tekoID.user) {
      const userInfo = this.tekoID.user.getUserInfo();
      return (userInfo == null ? void 0 : userInfo.sub) ? {
        userId: userInfo == null ? void 0 : userInfo.sub,
        phone: userInfo == null ? void 0 : userInfo.phone_number,
        name: userInfo == null ? void 0 : userInfo.name,
        picture: userInfo == null ? void 0 : userInfo.picture,
        email: userInfo == null ? void 0 : userInfo.email
      } : null;
    } else {
      const userInfo = getLSUserInfo();
      return (userInfo == null ? void 0 : userInfo.userId) ? {
        userId: userInfo == null ? void 0 : userInfo.userId,
        phone: userInfo == null ? void 0 : userInfo.phone,
        bankCode: userInfo == null ? void 0 : userInfo.bankCode,
        email: userInfo == null ? void 0 : userInfo.email,
        siteId: userInfo == null ? void 0 : userInfo.siteId,
        sellerId: userInfo == null ? void 0 : userInfo.sellerId
      } : null;
    }
  }
  getLSInfo() {
    return getLSUserInfo();
  }
  loadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.loadUser();
  }
  unloadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.unloadUser();
  }
}
const userManager = new UserManager();




/***/ }),

/***/ 84154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ni": function() { return /* binding */ CartService; },
  "vO": function() { return /* binding */ defaultCartValue; },
  "JW": function() { return /* binding */ parseJWT; },
  "rx": function() { return /* binding */ setCartToken; }
});

// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(47143);
// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(99278);
;// CONCATENATED MODULE: ../../packages/cart/dist/error.es.js


const getError = (resp) => {
  const message = resp.message;
  return new index_es/* ApiError */.MS(message, resp.statusCode, resp);
};



;// CONCATENATED MODULE: ../../packages/cart/dist/service.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LS_CART_TOKEN = "cart_token";
const cartTokenHeader = "x-cart-token";
const getCartToken = (localStorageKey) => localStorage.getItem(localStorageKey);
const setCartToken = (token, localStorageKey = LS_CART_TOKEN) => localStorage.setItem(localStorageKey, token);
const defaultCartValue = {
  id: "",
  grandTotal: 0,
  orderCoupons: {
    applicableCoupons: [],
    inapplicableCoupons: []
  },
  orderLines: [],
  promotions: [],
  shippingFee: 0,
  subTotal: 0,
  totalDiscount: 0,
  eVouchers: [],
  allowToRequestOnDemandDiscount: false
};
const parseJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload)["cid"];
  } catch (e) {
    return null;
  }
};
class CartService {
  constructor(cartApiUrl, localStorageKey = LS_CART_TOKEN, language, options) {
    this.getCart = async (params) => {
      const cartToken = getCartToken(this.localStorageKey);
      const accessToken = (0,interceptor_es/* getAccessToken */.h)();
      return !cartToken && !accessToken ? Promise.resolve(defaultCartValue) : this.cartApi.get("/api/v1/cart", { params: __spreadValues({}, params) }).then(({ data }) => data.result);
    };
    this.addToCart = async (params, body) => {
      const { data, headers } = await this.cartApi.post("api/v1/cart/add-to-cart", body, { params: __spreadValues({}, params) });
      const token = headers[cartTokenHeader];
      if (!!token) {
        localStorage.setItem(this.localStorageKey, token);
      }
      return __spreadProps(__spreadValues({}, data.result), { cartId: parseJWT(token) });
    };
    this.applyCoupon = async (params, body) => {
      const { data } = await this.cartApi.post("api/v1/cart/apply-coupon", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.removeCoupon = (params, body) => {
      return this.cartApi.delete("api/v1/cart/clear-coupon", body, { params: __spreadValues({}, params) });
    };
    this.clearCart = (params) => {
      return this.cartApi.delete("api/v1/cart", null, {
        params: __spreadValues({}, params)
      });
    };
    this.updateOrderLine = async (params, id, body) => {
      return this.cartApi.put(`api/v1/cart/order-lines/${id}`, body, {
        params: __spreadProps(__spreadValues({}, params), { graceful: true })
      }).then(({ data }) => Promise.resolve(data.result));
    };
    this.updateSellerItems = (params, sellerId, selected) => {
      return this.cartApi.put("api/v1/cart/order-items", { selected }, { params: __spreadProps(__spreadValues({}, params), { sellerId }) });
    };
    this.removeOrderLine = async (params, id) => {
      return (await this.cartApi.delete)(`api/v1/cart/order-lines/${id}`, null, {
        params: __spreadValues({}, params)
      });
    };
    this.setShippingAddress = (params, selectedAddress) => {
      const fullAddress = [
        selectedAddress.address,
        selectedAddress.wardName,
        selectedAddress.districtName,
        selectedAddress.provinceName
      ].filter(Boolean).join(", ");
      const infoSetShippingAddr = __spreadProps(__spreadValues({
        addressId: selectedAddress.addressId || selectedAddress.id,
        wardCode: (selectedAddress == null ? void 0 : selectedAddress.wardCode) || "",
        districtCode: selectedAddress == null ? void 0 : selectedAddress.districtCode,
        provinceCode: selectedAddress == null ? void 0 : selectedAddress.provinceCode,
        wardName: (selectedAddress == null ? void 0 : selectedAddress.wardName) || "",
        districtName: selectedAddress == null ? void 0 : selectedAddress.districtName,
        provinceName: selectedAddress == null ? void 0 : selectedAddress.provinceName,
        address: selectedAddress == null ? void 0 : selectedAddress.address,
        name: selectedAddress == null ? void 0 : selectedAddress.name
      }, (selectedAddress == null ? void 0 : selectedAddress.email) && { email: selectedAddress.email }), {
        telephone: selectedAddress == null ? void 0 : selectedAddress.telephone,
        addressNote: "",
        fullAddress: selectedAddress.fullAddress || fullAddress
      });
      return this.cartApi.post(`api/v1/cart/shipping-address`, infoSetShippingAddr, { params: __spreadValues({}, params) });
    };
    this.getPaymentMethod = async (params, orderCode) => {
      const { data } = await this.cartApi.get("api/v1/cart/payment-methods-v2", {
        params: __spreadValues(__spreadValues({}, params), orderCode ? { orderCode } : {})
      });
      return data.result;
    };
    this.checkout = async (params, body) => {
      var _a, _b, _c, _d;
      const { data } = await this.cartApi.post("api/v1/cart/checkout", body, {
        params: __spreadValues({}, params)
      });
      return __spreadProps(__spreadValues({}, data.result), {
        orderId: ((_a = data.result) == null ? void 0 : _a.orderIdString) || ((_b = data.result) == null ? void 0 : _b.orderId),
        id: ((_c = data.result) == null ? void 0 : _c.orderIdString) || ((_d = data.result) == null ? void 0 : _d.orderId),
        get remainPayment() {
          return parseFloat(data.result.grandTotal.toString()) - data.result.totalPaid;
        }
      });
    };
    this.getOrderByCode = async (params, code) => {
      const { data } = await this.cartApi.get(`/api/v1/orders/${code}`, {
        params: __spreadValues({}, params)
      });
      const order = data.result;
      return __spreadProps(__spreadValues({}, order), {
        orderId: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        id: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        grandTotal: parseInt(order.grandTotal),
        get remainPayment() {
          var _a;
          const prevPayment = ((_a = order == null ? void 0 : order.payments) == null ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
          return parseFloat(order.grandTotal.toString()) - prevPayment;
        }
      });
    };
    this.getApplicableServices = async (params) => {
      const { data } = await this.cartApi.get("api/v1/cart/applicable-services", {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.findApplicableServices = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/applicable-services", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.getDeliveryOptions = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/delivery-options", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.applyServiceToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-service", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.applyPaymentMethodToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-payment-method", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.importOrder = async (payload, query) => {
      const { data } = await this.cartApi.post("/api/v1/orders", payload, {
        params: __spreadValues({}, query)
      });
      return data.result;
    };
    this.cartApi = new index_es/* default */.ZP(cartApiUrl, getError);
    this.localStorageKey = localStorageKey;
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
    }
    this.cartApi.addInterceptor((request) => {
      var _a;
      if (typeof window === "undefined")
        return;
      if (options == null ? void 0 : options.cartToken) {
        request.headers.set(cartTokenHeader, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = ((_a = this.getCartToken) != null ? _a : getCartToken)(localStorageKey);
        if (cartToken) {
          request.headers.set(cartTokenHeader, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
  }
  setParams({ getCartToken: getCartToken2 }) {
    this.getCartToken = getCartToken2;
  }
}




/***/ }),

/***/ 91004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RN": function() { return /* binding */ CartDeliveryType; },
/* harmony export */   "bQ": function() { return /* binding */ DeliveryTimeSlotType; },
/* harmony export */   "cv": function() { return /* binding */ UserActionType; },
/* harmony export */   "dK": function() { return /* binding */ CheckoutAllowedUserActions; },
/* harmony export */   "rV": function() { return /* binding */ AllowedUserActionItem; }
/* harmony export */ });
var AllowedUserActionItem = /* @__PURE__ */ ((AllowedUserActionItem2) => {
  AllowedUserActionItem2["TOGGLE"] = "TOGGLE";
  AllowedUserActionItem2["DELETE"] = "DELETE";
  AllowedUserActionItem2["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  AllowedUserActionItem2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  AllowedUserActionItem2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  AllowedUserActionItem2["OPEN_PRODUCT_DETAIL"] = "OPEN_PRODUCT_DETAIL";
  return AllowedUserActionItem2;
})(AllowedUserActionItem || {});
var UserActionType = /* @__PURE__ */ ((UserActionType2) => {
  UserActionType2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  UserActionType2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  UserActionType2["USE_DEFERRED_PAYMENT"] = "USE_DEFERRED_PAYMENT";
  UserActionType2["USE_DEPOSIT"] = "USE_DEPOSIT";
  UserActionType2["ADD_CONSULTANT"] = "ADD_CONSULTANT";
  UserActionType2["REQUEST_NEW_SKU"] = "REQUEST_NEW_SKU";
  UserActionType2["CREATE_QUOTATION"] = "CREATE_QUOTATION";
  return UserActionType2;
})(UserActionType || {});
var CartDeliveryType = /* @__PURE__ */ ((CartDeliveryType2) => {
  CartDeliveryType2["DELIVERY_TYPE_UNSPECIFIED"] = "DELIVERY_TYPE_UNSPECIFIED";
  CartDeliveryType2["DELIVERY_TYPE_AT_HOME"] = "DELIVERY_TYPE_AT_HOME";
  CartDeliveryType2["DELIVERY_TYPE_PICKUP"] = "DELIVERY_TYPE_PICKUP";
  CartDeliveryType2["DELIVERY_TYPE_HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
  return CartDeliveryType2;
})(CartDeliveryType || {});
var CheckoutAllowedUserActions = /* @__PURE__ */ ((CheckoutAllowedUserActions2) => {
  CheckoutAllowedUserActions2["PAYMENT"] = "PAYMENT";
  CheckoutAllowedUserActions2["FINISH"] = "FINISH";
  CheckoutAllowedUserActions2["ORDER_LIST"] = "ORDER_LIST";
  CheckoutAllowedUserActions2["QUOTATION_POPUP"] = "QUOTATION_POPUP";
  return CheckoutAllowedUserActions2;
})(CheckoutAllowedUserActions || {});
var DeliveryTimeSlotType = /* @__PURE__ */ ((DeliveryTimeSlotType2) => {
  DeliveryTimeSlotType2["REQUIRED"] = "REQUIRED";
  DeliveryTimeSlotType2["OPTIONAL"] = "OPTIONAL";
  DeliveryTimeSlotType2["NONE"] = "NONE";
  return DeliveryTimeSlotType2;
})(DeliveryTimeSlotType || {});




/***/ }),

/***/ 16476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UH": function() { return /* binding */ defaultCart; },
/* harmony export */   "i": function() { return /* binding */ getCartToken; },
/* harmony export */   "ng": function() { return /* binding */ removeCartToken; },
/* harmony export */   "rx": function() { return /* binding */ setCartToken; }
/* harmony export */ });
const cartTokenLSKey = "cart_token";
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};




/***/ }),

/***/ 20577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ logger; }
});

// EXTERNAL MODULE: ../../.yarn/cache/pino-npm-6.13.3-50e2aceb53-a580decd47.zip/node_modules/pino/browser.js
var browser = __webpack_require__(43238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ../../packages/log/dist/logger.es.js
/* provided dependency */ var process = __webpack_require__(60387);


const logger = browser_default()({
  prettyPrint: "production" === "development",
  level: process.env.LOG_LEVEL || "info",
  serializers: {
    err: (browser_default()).stdSerializers.err,
    req: (browser_default()).stdSerializers.req
  },
  browser: {
    transmit: {
      level: "error",
      send: (_level, logEvent) => {
        if (typeof window !== "undefined" && window.track) {
          let eventDetails = null;
          for (const message of logEvent.messages) {
            if (message.msg && message.stack) {
              eventDetails = {
                message: message.msg,
                stack: message.stack
              };
            }
          }
          eventDetails = eventDetails || {
            message: JSON.stringify(logEvent.messages),
            stack: JSON.stringify(logEvent.bindings)
          };
          window.track("exception", eventDetails);
        }
      }
    }
  }
});



;// CONCATENATED MODULE: ../../packages/log/dist/index.es.js



/***/ }),

/***/ 71633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bb": function() { return /* binding */ UNS_APP_ID; },
/* harmony export */   "n8": function() { return /* binding */ FCM_TRANSPORT; },
/* harmony export */   "pX": function() { return /* binding */ FCM_REGISTER_TOKEN_SUCCESS; },
/* harmony export */   "tz": function() { return /* binding */ FCM_USER_ID; },
/* harmony export */   "ut": function() { return /* binding */ FCM_TOKEN; }
/* harmony export */ });
const FCM_TOKEN = "fcmToken";
const FCM_USER_ID = "fcmUserId";
const FCM_TRANSPORT = "fcm";
const FCM_REGISTER_TOKEN_SUCCESS = "fcmRegisterTokenSuccess";
const UNS_APP_ID = "fcmUNSAppId";




/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slug; }
/* harmony export */ });
const vnRegexes = [
  /à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g,
  /è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g,
  /ì|í|ị|ỉ|ĩ|Ì|Í|Ị|Ỉ|Ĩ/g,
  /ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g,
  /ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g,
  /ỳ|ý|ỵ|ỷ|ỹ|Ỳ|Ý|Ỵ|Ỷ|Ỹ/g,
  /đ|Đ/g,
  /\u0300|\u0301|\u0303|\u0309|\u0323/g,
  /\u02C6|\u0306|\u031B/g,
  /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g
];
const replacement = ["a", "e", "i", "o", "u", "y", "d", "", "", " "];
const slug = (str) => {
  vnRegexes.forEach((value, index) => {
    str = str.replace(value, replacement[index]);
  });
  str = str.toLowerCase().trim();
  return str.replace(/\s+/g, "-");
};




/***/ }),

/***/ 46586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41873);
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28247);
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37618);




const trackAddToCart = (trackAddToCartParams) => {
  var _a;
  const {
    product,
    selectedPromotionId,
    status,
    cartId,
    type = _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART
  } = trackAddToCartParams;
  const { defaultPromotions = [] } = product;
  const trackingData = {
    cartId,
    skuId: product.sku,
    skuName: product.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: product.price,
    promotionPrice: product.addToCartPrice
  };
  if (type === _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART) {
    window.track(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, trackingData);
  } else {
    (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_1__/* .trackCustomEvent */ .I)(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.BUYNOW */ .h.BUYNOW, {
      action: "click",
      category: "cart",
      label: JSON.stringify(trackingData),
      property: "product"
    });
  }
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: type,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.name,
            id: product.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: product.categories,
            brand: product.brand
          }
        ]
      }
    }
  });
  if (!!window.fbq && status === "success") {
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_2__/* .trackMetaPixelAddToCart */ .Ug)({
      content_ids: [product.sku],
      content_name: product.name,
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value: product.price
    });
  }
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a, _b, _c;
  window.track("removeFromCart", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price,
    promotionId: `${(_a = item.promotions) == null ? void 0 : _a.map((promo) => promo.promotions.map((promo2) => promo2.promotionId).join(",")).join(",")}`,
    promotionsCode: `${(_b = item.promotions) == null ? void 0 : _b.map((promo) => promo.promotions.map((promo2) => promo2.promotionCode).join(",")).join(",")}`
  });
  (_c = window.dataLayer) == null ? void 0 : _c.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload, index) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload,
    index
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};




/***/ }),

/***/ 28247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ trackCustomEvent; },
/* harmony export */   "O5": function() { return /* binding */ getTrackingData; },
/* harmony export */   "UC": function() { return /* binding */ trackVisibleManually; },
/* harmony export */   "bo": function() { return /* binding */ trackLinkClicked; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getTrackingData = ({
  isTrackContent,
  contentName,
  index,
  regionName,
  target,
  payload
}) => {
  return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, regionName && { "data-content-region-name": regionName }), isTrackContent && { "data-track-content": true }), contentName && { "data-content-name": contentName }), (index || index === 0) && { "data-content-index": index }), target && { "data-content-target": target }), payload && { "data-content-payload": payload });
};
const trackCustomEvent = (eventName, payload) => {
  return window.track("customEvent", eventName, payload);
};
const trackLinkClicked = (eventName, payload) => {
  return window.track("linkClick", eventName, payload);
};
const trackVisibleManually = ({
  regionName,
  contentName,
  index,
  payload
}) => {
  return window.track("manualTrackVisibleContentImpressions", {
    regionName,
    contentName,
    payload,
    index
  });
};




/***/ }),

/***/ 41873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buy_now";
  return AddToCartType2;
})(AddToCartType || {});




/***/ }),

/***/ 37618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ trackMetaPixelPurchase; },
/* harmony export */   "SI": function() { return /* binding */ trackMetaPixelViewContent; },
/* harmony export */   "Ug": function() { return /* binding */ trackMetaPixelAddToCart; },
/* harmony export */   "tO": function() { return /* binding */ trackMetaPixelCheckout; }
/* harmony export */ });
const trackStandardEvent = (eventName, payload) => {
  var _a;
  (_a = window.fbq) == null ? void 0 : _a.call(window, "track", eventName, payload);
};
const trackMetaPixelAddToCart = (payload) => {
  return trackStandardEvent("AddToCart" /* ADD_TO_CART */, payload);
};
const trackMetaPixelCheckout = (payload) => {
  return trackStandardEvent("InitiateCheckout" /* INITIATE_CHECKOUT */, payload);
};
const trackMetaPixelPurchase = (payload) => {
  return trackStandardEvent("Purchase" /* PURCHASE */, payload);
};
const trackMetaPixelViewContent = (payload) => {
  return trackStandardEvent("ViewContent" /* VIEW_CONTENT */, payload);
};




/***/ }),

/***/ 85212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vz": function() { return /* reexport */ ButtonShapeEnum; },
  "mO": function() { return /* reexport */ SizeEnum; }
});

// UNUSED EXPORTS: LinkType

;// CONCATENATED MODULE: ../../packages/types/dist/ds/button.es.js
var ButtonShapeEnum = /* @__PURE__ */ ((ButtonShapeEnum2) => {
  ButtonShapeEnum2["circle"] = "circle";
  ButtonShapeEnum2["round"] = "round";
  return ButtonShapeEnum2;
})(ButtonShapeEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/link.es.js
var LinkType = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["inPage"] = "inPage";
  LinkType2["external"] = "external";
  LinkType2["email"] = "email";
  LinkType2["phone"] = "phone";
  LinkType2["internal"] = "internal";
  return LinkType2;
})(LinkType || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/common.es.js
var SizeEnum = /* @__PURE__ */ ((SizeEnum2) => {
  SizeEnum2["xs"] = "xs";
  SizeEnum2["s"] = "s";
  SizeEnum2["m"] = "m";
  SizeEnum2["l"] = "l";
  SizeEnum2["xl"] = "xl";
  return SizeEnum2;
})(SizeEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/index.es.js





/***/ }),

/***/ 31260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ customizedMessage; },
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "pM": function() { return /* binding */ roundQuantity; },
/* harmony export */   "ru": function() { return /* binding */ toObject; },
/* harmony export */   "sW": function() { return /* binding */ cleanObject; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; },
/* harmony export */   "yL": function() { return /* binding */ inIframe; }
/* harmony export */ });
/* unused harmony export normalizePhone */











var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizePhone = (rawphone) => {
  const phone = rawphone.trim();
  if (phone.length > 10) {
    if (phone.startsWith("84"))
      return phone.replace("84", "0");
    if (phone.startsWith("+84"))
      return phone.replace("+84", "0");
    return phone;
  }
  return phone;
};
const customizedMessage = (message, fields) => {
  let resultMessage = message;
  fields.forEach(({ name, value }) => {
    const regex = new RegExp(`{${name}}`, "g");
    resultMessage = resultMessage.replace(regex, value);
  });
  return resultMessage;
};
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
const toObject = (arr, keyField) => {
  let newArr = {};
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      const curr = arr[i];
      newArr = __spreadProps(__spreadValues({}, newArr), {
        [curr[keyField]]: curr
      });
    }
  }
  return newArr;
};
const cleanObject = (object) => {
  if (!object) {
    return object;
  }
  const newObj = {};
  const currentKeys = Object.keys(object);
  currentKeys.forEach((key) => {
    if (object[key] || object[key] === false || object[key] === 0) {
      newObj[key] = object[key];
    }
  });
  return newObj;
};
const formatCurrency = (money, isFull = true) => {
  return `${money || money == 0 ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : money}${isFull ? "\u0111" : ""}`;
};
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const roundQuantity = ({
  quantity,
  precision
}) => {
  return Math.round(quantity * Math.pow(10, precision)) / Math.pow(10, precision);
};




/***/ }),

/***/ 53028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ getCookieOver18YearOld; },
/* harmony export */   "zr": function() { return /* binding */ setCookieOver18YearOld; }
/* harmony export */ });
/* unused harmony export COOKIE_OVER_18_YEARS_OLD */
const COOKIE_OVER_18_YEARS_OLD = "over_18_years_old";
const setCookieOver18YearOld = (value, exTime = 720) => {
  if (typeof document !== "undefined") {
    const d = new Date();
    d.setTime(d.getTime() + exTime * 60 * 60 * 1e3);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${COOKIE_OVER_18_YEARS_OLD}=${value};${expires};path=/`;
  }
};
const getCookieOver18YearOld = () => {
  if (typeof document !== "undefined") {
    const name = `${COOKIE_OVER_18_YEARS_OLD}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length) === "true";
      }
    }
  }
  return false;
};




/***/ }),

/***/ 79376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ parseJsonStringSafely; },
/* harmony export */   "b": function() { return /* binding */ normalizeText; }
/* harmony export */ });
const parseJsonStringSafely = (value, fallback) => {
  try {
    if (!value)
      return fallback || void 0;
    return JSON.parse(value);
  } catch (e) {
    return fallback || void 0;
  }
};
const normalizeText = (text, withoutSpaces = false) => {
  let str = text.toLowerCase().trim();
  str = str.replace(/\s+/g, withoutSpaces ? "" : " ");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  return str;
};




/***/ }),

/***/ 87900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ extractFromPath; },
/* harmony export */   "r": function() { return /* binding */ getObjFromQueryString; }
/* harmony export */ });
const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const regexes = [
  {
    regex: /-s([A-Za-z0-9._-]{1,20})\.html/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /--s([A-Za-z0-9._-]{1,20})/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /-(.*)\.cat/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-c([0-9]{1,})/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-cat\.(.*)/,
    pathname: "/block-categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-sel\.(.*)/,
    pathname: "/sellers/[sellerId]",
    paramName: "sellerId"
  },
  {
    regex: /-brand\.(.*)/,
    pathname: "/brands/[brandId]",
    paramName: "brandId"
  }
];
const extractFromPath = (path) => {
  for (const reg of regexes) {
    const matchResult = path.match(reg.regex);
    if (matchResult) {
      return {
        pathname: reg.pathname,
        query: {
          [reg.paramName]: matchResult[1]
        }
      };
    }
  }
  return path;
};




/***/ }),

/***/ 82909:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59292:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 103:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 28644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 20913:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82768:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 81290:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 14986:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 29718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 3777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89044);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 74036:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 76605:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81290);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 8604:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 21023:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12129);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28644);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89044:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 83736:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(103);
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(20618);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(74036);
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 12129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),

/***/ 20618:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59292);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 73342:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"teko-oauth2","version":"1.8.4","description":"Teko Identity OAuth 2 Javascript Library for Web App Client","private":false,"keywords":["teko","oauth2"],"main":"dist/index.js","types":"./teko-oauth2.d.ts","repository":"https://git.teko.vn/user-profile/iam/tekoid-js","license":"MIT","scripts":{"start":"webpack --mode development --output teko-oauth2.js --watch","test":"jest --collect-coverage && eslint src/","compile":"babel src --out-dir dist --ignore \'src/**/*.test.js\'","minify":"webpack --mode production","build":"yarn compile && yarn minify","version":"yarn build && git add ."},"devDependencies":{"@babel/cli":"^7.6.3","@babel/core":"^7.6.2","@babel/preset-env":"^7.4.4","@sinonjs/fake-timers":"^6.0.1","eslint":"^5.16.0","eslint-config-standard":"^12.0.0","eslint-plugin-import":"^2.17.2","eslint-plugin-jest":"^22.5.1","eslint-plugin-node":"^9.0.1","eslint-plugin-promise":"^4.1.1","eslint-plugin-standard":"^4.0.0","jest":"^24.8.0","jsonwebtoken":"^8.5.1","prettier-standard":"^9.1.1","webpack":"^4.30.0","webpack-cli":"^3.3.2"},"dependencies":{"client-oauth2":"^4.2.3","core-js":"^3.4.2","crypto-js":"^3.1.9-1","jwt-decode":"^2.2.0","regenerator-runtime":"^0.13.3"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3712,9774,179], function() { return __webpack_exec__(46580), __webpack_exec__(74272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);